/**
 * クラス名：装置設定詳細画面
 * 作成者：チュー
 * 作成日：2023/06/01
 * バージョン：1.0
 */

import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react';
import { Form, Col, Input, Row, Button, Checkbox, Space, Select, Radio, Image, Tooltip, Modal, Typography } from 'antd';
import { Table as RTable } from 'react-bootstrap';
import {
  CaretUpOutlined,
  CaretDownOutlined,
  SearchOutlined,
  DownSquareFilled,
  UpSquareFilled,
} from '@ant-design/icons';
import CurrencyInput from 'react-currency-input-field';
import { CSVLink } from 'react-csv';

import ChargeAmount from './ChargeAmount';
import SetupSetting from './SetupSetting';
import MachineSpeed from './MachineSpeed';
import KaritsukiTime from './KaritsukiTime';
import TapWelding from './TapWelding';
import ProductSize from './ProductSize';
import Quantity from './Quantity';
import YousetsuDifficulty from './YousetsuDifficulty';
import Pitch from './Pitch';
import ChildPart from './ChildPart';
import WorkAccuracy from './WorkAccuracy';
import ToritsukiJikan_Itaatsu from './ToritsukiJikan_Itaatsu';
import ToritsukiJikan_Size from './ToritsukiJikan_Size';
import Device_Sagyoukeisuu from '../../iq3/devices/Device_Sagyoukeisuu';
import Device_DantoriJikan from '../../iq3/devices/Device_DantoriJikan';
import export_csv_icon from '../../../../assets/images/export_csv_icon.png';
import import_csv_icon from '../../../../assets/images/import_csv_icon.png';

import {
  souchiHandleIncreaseTime,
  souchiHandleDecreaseTime,
  JPYs,
  WorkTypes,
  processTypes,
  ServiceClasses,
  secondsToHms,
  setTimetoSec,
  handleKeyPress,
  formatDateString,
  todayTime,
  getProcessDetailTypesInfo,
  getChargesDetailValues,
  getPrepSettingDetailValues,
  getProcessDetailTypeName,
  toDecimal,
  isDigit,
  isDecimal,
  TimeInputParameterScreen,
} from '../../../common/Common';
import { Customer } from '../../../common/Constant';
import {
  ClientType,
  MaterialSurfaceBillingUnit,
  ServiceClass,
  WorkType,
  WorkTypeGroup,
} from '../../../common/enums.js';
import SearchAndGetCustomerData from '../../../common/SearchAndGetCustomerData.js';
import {
  confirmModalTitle,
  confirmDiscardContent,
  confirmUpdateContent,
  commonModal,
  commonFooter,
  commonResponsiveConfirmModal,
  error,
} from '../../../common/CommonModal';
import Device_Bending from '../../iq3/devices/Device_Bending';
import Device_BendingTimeFactor from '../../iq3/devices/Device_BendingTimeFactor';
import Device_BendingCorrectionTime from '../../iq3/devices/Device_BendingCorrectionTime';
import Device_SetupSetting from '../../iq3/devices/Device_SetupSetting';
import Device_ProcessType from '../../iq3/devices/Device_ProcessType';
import Device_KakouSokudo from '../../iq3/devices/Device_KakouSokudo';
import Device_KakouJikan from '../../iq3/devices/Device_KakouJikan';
import Device_ManualBari from '../../iq3/devices/Device_ManualBari';
import Device_ProductSize from '../../iq3/devices/Device_ProductSize';
import Device_BendingCorrectionTimeFactor from '../../iq3/devices/Device_BendingCorrectionTimeFactor';
import Device_ProcessInspection from '../../iq3/devices/Device_ProcessInspection';
import Device_MaterialHandlingTime from '../../iq3/devices/Device_MaterialHandlingTime';
import Device_MaterialArrangement from '../../iq3/devices/Device_MaterialArrangement';
import Device_Blank_DrillingTime from '../../iq3/devices/Device_Blank_DrillingTime';
import Device_Blank_GasType from '../../iq3/devices/Device_Blank_GasType';
import Device_Blank_Joint from '../../iq3/devices/Device_Blank_Joint';
import Device_Blank_KakouSokudoKeisuu from '../../iq3/devices/Device_Blank_KakouSokudoKeisuu';
import Device_Blank_PiercingProcessTime from '../../iq3/devices/Device_Blank_PiercingProcessTime';
import Device_Blank_GasKeisuu from '../../iq3/devices/Device_Blank_GasKeisuu';
import Device_Blank_Kakousokudo from '../../iq3/devices/Device_Blank_Kakousokudo';
import Device_Blank_PunchCondition from '../../iq3/devices/Device_Blank_PunchCondition';
import Device_Blank_OkuriSokudo from '../../iq3/devices/Device_Blank_OkuriSokudo';
import Device_Blank_RollerSpeed from '../../iq3/devices/Device_Blank_RollerSpeed';
import Device_Blank_ExtractCondition from '../../iq3/devices/Device_Blank_ExtractCondition';
import Device_Blank_PunchProcessTime from '../../iq3/devices/Device_Blank_PunchProcessTime';
import ChargeDetails from './ChargeDetails';
import Device_YousetsuShiage_DifficultyFactor from '../../iq3/devices/Device_YousetsuShiage_DifficultyFactor';
import Device_ShiageFlag from '../../iq3/devices/Device_ShiageFlag';
import { getClientInfo, getProcessId } from '../../../common/CommonAPI';
import checked from '../../../../assets/images/checked.png';
import { ErrorMessage } from '../../../common/Message.js';
import { find, words } from 'lodash';
import IQ5_Device_ProcessTime from '../../iq5/devices/IQ5_Device_ProcessTime.js';
import IQ5_Device_DisplaySetting from '../../iq5/devices/IQ5_Device_DisplaySetting.js';
import {
  getIQ5CoeffDetailValues,
  getIQ5IdByName,
  getMaterialTypeIq5Nm,
  getProcessingShapeCoeffNm,
  getProcessingShapeCoeffShapeNo,
  getWeightDetailNm,
} from '../../../common/CommonIQ5.js';

const RadioGroup = Radio.Group;
const iconWidth = 35;

const DevicesDetails = forwardRef((props, ref) => {
  const csvImportRef = useRef(null);
  const csvExportRef = useRef(null);
  const messageRef = useRef([]);

  const [isBaritoriShurui, setIsBaritoriShurui] = useState(false);
  const [isCharge, setIsCharge] = useState(false);
  const [isDantoriJikan, setIsDantoriJikan] = useState(false);
  const [isSetupSetting, setIsSetupSetting] = useState(false);
  const [isKouteiNaikensa, setIsKouteiNaikensa] = useState(false);
  const [isMagekakouJikan, setIsMagekakouJikan] = useState(false);
  const [isArrangeMaterial, setIsArrangeMaterial] = useState(false);
  const [isPunch, setIsPunch] = useState(false);
  const [isPiercingProcess, setIsPiercingProcess] = useState(false);
  const [isPunchProcess, setIsPunchProcess] = useState(false);
  const [isMageHoseiJikan, setIsMageHoseiJikan] = useState(false);
  const [isMageHoseiJikanFactor, setIsMageHoseiJikanFactor] = useState(false);
  const [isProcessSizeFactor, setIsProcessSizeFactor] = useState(false);
  const [isBendingTimeFactor, setIsBendingTimeFactor] = useState(false);
  const [isProcessSpeed, setIsProcessSpeed] = useState(false);
  const [isSagyouSokudo, setIsSagyouSokudo] = useState(false);
  const [isSagyouKeisuu, setIsSagyouKeisuu] = useState(false);
  const [isiq3DantoriJikan, setIsiq3DantoriJikan] = useState(false);
  const [isiq3KakouJikan, setIsiq3KakouJikan] = useState(false);
  const [isBlankKakouSokudo, setIsBlankKakouSokudo] = useState(false);
  const [isBlankKakouSokudoKeisuu, setIsBlankKakouSokudoKeisuu] = useState(false);
  const [isBlankGasuKeisuu, setIsBlankGasuKeisuu] = useState(false);
  const [isExtractCondition, setIsExtractCondition] = useState(false);
  const [isBlankGasuType, setIsBlankGasuType] = useState(false);
  const [isBlankDrillingTime, setIsBlankDrillingTime] = useState(false);
  const [isOkuriSokudo, setIsOkuriSokudo] = useState(false);
  const [isRollerKakouSokudo, setIsRollerKakouSokudo] = useState(false);
  const [isBlankJoint, setIsBlankJoint] = useState(false);
  const [isiq3KakouSokudo, setIsiq3KakouSokudo] = useState(false);
  const [isiq3ManualBari, setIsiq3ManualBari] = useState(false);
  const [isProcessTime, setIsProcessTime] = useState(false);
  const [isAttach, setIsAttach] = useState(false);
  const [isToritsukiJikanItaatsu, setIsToritsukiJikanItaatsu] = useState(false);
  const [isToritsukiJikanSize, setIsToritsukiJikanSize] = useState(false);
  const [isWelding, setIsWelding] = useState(false);
  const [isDeviceDetails, setIsDeviceDetails] = useState(false);
  const [isTapWelding, setIsTapWelding] = useState(false);
  const [isPitch, setIsPitch] = useState(false);
  const [isProductSize, setIsProductSize] = useState(false);
  const [isProductQuantity, setIsProductQuantity] = useState(false);
  const [isChildPart, setIsChildPart] = useState(false);
  const [isDifficultyFactor, setIsDifficultyFactor] = useState(false);
  const [isShiageFlag, setIsShiageFlag] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [updateConfirm, setUpdateConfirm] = useState(false);
  const [deviceType, setDeviceType] = useState(processTypes.standard);
  const [dantoriCharge, setDantoriChange] = useState('');
  const [detailsProcess, setDetailProcess] = useState([]);

  const [detailsData, setDetailsData] = useState([]);
  const initialValues = [8, 11, 13, 16, 17];
  // データ表示
  const [code, setCode] = useState('');
  const [detailId, setDetailId] = useState(0);
  const [processName, setProcessName] = useState('');
  const [workType, setWorkType] = useState();
  const [deviceCode, setDeviceCode] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [remarks, setRemarks] = useState('');
  const [isUsed, setIsUsed] = useState(true);
  // 追加工程種類情報
  const [kouteiName, setKouteiName] = useState('');
  const [kouteiCode, setKouteiCode] = useState('');
  const [customerId, setCustomerId] = useState();
  const [customerName, setCustomerName] = useState('');
  const [customerCode, setCustomerCode] = useState('');
  const [iniAmount, setIniAmount] = useState('');
  const [koubuhinnKeisuu, setKobuhinKeisuu] = useState('');
  const [tsuikaKouteiTypes, setTsuikaKouteiTypes] = useState([]);

  // 追加工程の段取金額と作業金額
  const [setupAmount, setSetupAmount] = useState('');
  const [workAmount, setWorkAmount] = useState('');
  // 段取時間
  const [dantoriTime, setDantoriTime] = useState('00:00:00');
  const [workTime, setWorkTime] = useState(0);
  const [sagyouTime, setSagyouTime] = useState(0); // 作業時間（x要素数）

  const [area, setArea] = useState([]);
  const [weight, setWeight] = useState([]);
  const [volume, setVolume] = useState([]);
  const [sizesDetailsList, setSizeDetailsList] = useState([]);
  const [dantoriSizeDetailsList, setDantoriSizeDetailsList] = useState([]);

  const [kihonDantori, setKihonDantori] = useState('');
  // 段取を個別に持つ
  const [dantoriFlag, setDantoriFlag] = useState('');
  const [selectedDeviceData, setSelectedDeviceData] = useState([]);
  // 名称
  const [meishou, setMeishou] = useState([]);
  const [meishouList, setMeishouList] = useState([]);
  // 数量区分
  const [suuryouData, setSuuryouData] = useState([]);
  const [suuryouList, setSuuryouList] = useState([]);
  const [dantoriSetteiSuuryouList, setdantoriSetteiSuuryouList] = useState([]);

  // 要素数
  const [yousosuuData, setYousosuuData] = useState([]);
  const [sagyouKeisuuYousosuuList, setSagyouKeisuuYousosuuList] = useState([]);
  const [shokiDankaiJikanList, setShokiDankaiJikanList] = useState([]);
  const [kensaJikanKeisuuList, setKensaJikanKeisuuList] = useState([]);

  const [jikanCharge, setJikanChaji] = useState([]);
  const [customerModal, setCustomerModal] = useState(false);

  const [initialCustomerData, setInitialCustomerData] = useState([]); // 初期表示に表示する項目
  const [initialCustomerDataBk, setInitialCustomerDataBk] = useState([]);
  const [selectedCustomerData, setSelectedCustomerData] = useState([]);
  const [selectedCustomerRowKeys, setSelectedCustomerRowKeys] = useState([]);

  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [selectDisabled, setSelectDisabled] = useState(true);

  const [flagChecked, setFlagChecked] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(true);

  const [pitchItaatsuList, setPitchItaatsuList] = useState([]);

  const [tapWeldItaatsuList, setTapWeldItaatsuList] = useState([]);

  const [yousetsuNanidoItaatsuMasterData, setYousetsuNanidoItaatsuMasterData] = useState([]);
  const [yousetsuNanidoItaatsuList, setYousetsuNanidoItaatsuList] = useState([]);

  const [karitsukiTimeItaatsuMasterData, setKaritsukiTimeItaatsuMasterData] = useState([]);
  const [karitsukiTimeItaatsuList, setKaritsukiTimeItaatsuList] = useState([]);

  // 取付時間（サイズ、板厚）
  const [toritsukiTimeItaatsuMasterData, setToritsukiTimeItaatsuMasterData] = useState([]);
  const [toritsukiTimeItaatsuList, setToritsukiTimeItaatsuList] = useState([]);
  const [toritsukiTimeSizeMasterData, setToritsukiTimeSizeMasterData] = useState([]);
  const [toritsukiTimeSizeList, setToritsukiTimeSizeList] = useState([]);

  // 溶接線長
  const [detailsWeldLine, setWeldLine] = useState([]);
  const [yousetsuWeldLineList, setYousetsuWeldLineList] = useState([]);

  // 加工速度（溶接仕上線長）
  const [kakouSokudoSenchouMasterData, setKakouSokudoSenchouMasterData] = useState([]);
  const [kakouSokudoSenchouList, setKakouSokudoSenchouList] = useState([]);

  // 個数
  const [kosuu, setKosuu] = useState([]);
  const [kosuuList, setKousuuList] = useState([]);
  const [iq3KosuuList, setIQ3KosuuList] = useState([]);

  // iq3
  const [iq3SetupAmount, setiq3SetupAmount] = useState('');
  const [iq3WorkAmount, setiq3WorkAmount] = useState('');
  const [iq3ProcessInspection, setIQ3ProcessInspection] = useState('');
  const [secondProcessAmount, setSecondProcessAmount] = useState('');
  const [jointBarashiAmount, setJointBarashiAmount] = useState('');
  const [iq3ItaatsuMaster, setIQ3ItaatsuMaster] = useState([]);
  const [jointSizeMaster, setJointSizeMaster] = useState([]);
  const [iq3BendingTimeListData, setIQ3BendingTimeListData] = useState([]);
  const [gasTypeMaster, setGasTypeMaster] = useState([]);
  // 保有金型
  const [retainedMoldMaster, setRetainedMoldMaster] = useState([]);
  // ジョイントサイズ
  const [jointSizeList, setJointSizeList] = useState([]);
  // ガス種類
  const [gasTypeListData, setGasTypeListData] = useState([]);
  // ジョイント
  const [jointItaatsuListData, setJointItaatsuListData] = useState([]);
  // 加工速度係数
  const [blankKakouSokudoItaatsuList, setBlankKakouSokudoItaatsuList] = useState([]);
  // ガス係数
  const [gasKeisuuList, setGasKeisuuList] = useState([]);
  const [extractConditionList, setExtractConditionList] = useState([]);
  // 1ピアス加工時間
  const [piercingProcessItaatsuListData, setPiercingProcessItaatsuListData] = useState([]);
  // 難易度係数
  const [nanidoKeisuuList, setNanidoKeisuuList] = useState([]);
  // 1パンチ加工時間
  const [punchProcessItaatsuListData, setPunchProcessItaatsuListData] = useState([]);

  // 曲げ長さ係数
  const [length, setLength] = useState([]);
  const [bendingTimeFactorListData, setBendingTimeFactorListData] = useState([]);
  const [bendingCorrectionTimeFactorListData, setBendingCorrectionTimeFactorListData] = useState([]);
  // 補正時間係数
  const [correctionTimeFactorListData, setCorrectionTimeFactorListData] = useState([]);
  const [iq3BendingHonsuuList, setiQ3BendingHonsuuList] = useState([]);
  const [iq3BendingKosuuList, setIQ3BendingKosuuList] = useState([]);
  // 曲げ数
  const [iq3MageSuuMaster, setIQ3MageSuuMaster] = useState([]);
  const [iq3MageSuuListData, setIQ3MageSuuListData] = useState([]);
  // 曲げ個数
  const [iq3MageKosuuMaster, setIQ3MageKosuuMaster] = useState([]);
  const [iq3MageKosuuListData, setIQ3MageKosuuListData] = useState([]);
  // 子部品サイズ係数リスト
  // const [dantoriJuuryouMagechouList, setDantoriJuuryouMagechouList] = useState([]);
  // 曲げ長さ別段取時間
  const [magechouDantoriJikanListData, setMagechouDantoriJikanListData] = useState([]);
  // 面積
  const [iq3AreaMaster, setIQ3AreaMaster] = useState([]);
  const [iq3KakouJikanListData, setIQ3KakouJikanListData] = useState([]);
  // ブランク加工速度
  const [blankKakousokudolistData, setBlankKakousokudolistData] = useState([]);

  const [types, setTypes] = useState('');
  // 加工方法
  const [processMethod, setProcessMethod] = useState('');
  const [processMethods, setProcessMethods] = useState([]);
  const [processCode, setProcessCode] = useState([]);
  // 生産個数
  const [seisanKosuu, setSeisanKosuu] = useState([]);
  const [seisanKosuuList, setSeisanKosuuList] = useState([]);
  // 工程内検査の生産個数
  const [processInspectionKosuuList, setProcessInspectionKosuuList] = useState([]);

  // 本数
  const [honSuu, setHonsuu] = useState([]);
  const [honSuuList, setHonSuuList] = useState([]);
  // サイズ
  const [iq3SizeMaster, setIQ3SizeMaster] = useState([]);
  const [mmMaster, setMmMaster] = useState([]);
  const [iq3KaniListData, setIQ3KaniListData] = useState([]);
  const [iq3KaniAnaListData, setIQ3KaniAnaListData] = useState([]);
  const [itaatsu1, setItaatsu1] = useState([]);
  const [zaishitsu, setZaishitsu] = useState([]);
  // 製品重量係数
  const [iq3ProductSizeListData, setiq3ProductSizeListData] = useState([]);

  // 一部品あたり作業時間
  const [processTimeByUnit, setProcessTimeByUnit] = useState('');

  // マテリアルハンドリング時間
  const [materialHandlingTimeList, setMaterialHandlingTimeList] = useState([]);
  const [isMaterialHandling, setIsMaterialHandling] = useState(false);

  // 同一サイズ、同一形状をパターン化する
  const [programSameSizePatternValue, setProgramSameSizePatternValue] = useState([]);

  // 工程内検査
  const [processInspectionTime, setProcessInspectionTime] = useState('');

  // パンチ条件
  const [punchConditionList, setPunchConditionList] = useState('');

  const [drillingTime, setDrillingTime] = useState('');
  // 送り速度
  // const [forwardSpeed, setForwardSpeed] = useState('');
  // ローラー/ホイール/ケガキ金型　加工速度
  const [rollerSpeed, setRollerSpeed] = useState('');

  // 送り速度
  const [okuriSokudoVal, setOkuriSokudoVal] = useState('');
  // ケガキ速度
  const [kegakiSokudoVal, setKegakiSokudoVal] = useState('');

  const [kakosokudo_bari, setkakosokudo_bari] = useState('');
  const [naikei_bari, setNaikeibari] = useState('');
  const [naikei_min, setNaikeiMin] = useState('');
  const [naikei_max, setNaikeiMax] = useState('');
  const [ana_min, setAnaMin] = useState('');
  const [ana_max, setAnaMax] = useState('');

  const [additionalProcessId, setAdditionalProcessId] = useState(1);

  // One by one
  const [shirringflag, setShirringFlag] = useState(false);

  const [cutTime, setCutTime] = useState('00:00:00');

  // const [deviceTypes, setDeviceTypes] = useState('');

  // 手動バリ取りの加工速度
  const [iq3kakouchou, setIQ3Kakouchou] = useState([]);
  const [shudobariKakousokudoList, setShudoubariKakousokudoList] = useState([]);
  // チャージ金額の工程内検査
  const [kensaAmount, setKensaAmount] = useState('');

  // チャージ金額詳細
  const [isDetails, setIsDetails] = useState(false);
  // 溶接種類
  const [yousetsuTypes, setYousetsuTypes] = useState(false);
  const [shiageFlagList, setShiageFlagList] = useState([]);

  const [processMstRecord, setProcessMstRecord] = useState();

  // 工程マスタの種類リスト
  const [processTypesList, setProcessTypesList] = useState([]);

  // 材質区分データ取得
  const [materialTypes, setMaterialTypes] = useState([]);

  // IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
  const [isKakouJikan, setIsKakouJikan] = useState(false);
  const [itaatsuKouteiTypeList, setItaatsuKouteiTypeList] = useState([]);
  const [sizeKouteiTypeList, setSizeuKouteiTypeList] = useState([]);
  const [weldProcessMst, setWeldProcessMst] = useState([]);
  const [filterKeys, setFilterKeys] = useState([]);

  // 形鋼の加工設定、表示設定の表示・非表示設定
  const [isIq5ProcessSetting, setIsIq5ProcessSetting] = useState(false);
  const [isIq5DisplaySetting, setIsIq5DisplaySetting] = useState(false);

  useEffect(() => {
    let selectedRowData = JSON.parse(JSON.stringify(props.selectedData));
    setSelectedDeviceData(selectedRowData);
    setDetailsData(props.selectedData);
    let yousetsuMstRecord = props?.getProcessMstRecordByWorkType();
    // setYousetsuTypes(
    //   yousetsuMstRecord?.details.processDetailTypes?.filter((item) => item.group === 110 && item.isUsed === true)
    // );
    setYousetsuTypes(yousetsuMstRecord);

    let processMstRecord = props?.getProcessMstRecordById(selectedRowData?.processId);

    if (processMstRecord) setProcessMstRecord(processMstRecord);
    if (selectedRowData?.length != 0) {
      setMaterialTypes(props?.getMaterialTypes);

      // setDeviceTypes(selectedRowData.deviceTypes);
      // setkakosokudo_bari(selectedRowData.kakosokudo_bari);
      // setNaikeibari(selectedRowData.naikei_bari);
      // setNaikeiMin(selectedRowData.naikei_min);
      // setNaikeiMax(selectedRowData.naikei_max);
      // setAnaMin(selectedRowData.ana_min);
      // setAnaMin(selectedRowData.ana_min);
      // setAnaMax(selectedRowData.ana_max);
      // setShirringFlag(selectedRowData.shirringflag);
      // setCutTime(selectedRowData.shirringTime);
      // iq3
      // setIQ3BendingTimeListData(selectedRowData.iq3BendingTimeLstData);
      // setGasTypeListData(selectedRowData.gasTypeLstData);
      // setJointSizeList(selectedRowData.jointSizeListData);
      // setJointItaatsuListData(selectedRowData.jointItaatsuLstData);
      // setBlankKakouSokudoItaatsuList(selectedRowData.blankKakousokudoItaatsuList);
      // setPiercingProcessItaatsuListData(selectedRowData.piercingProcessItaatsuLstData);
      // setNanidoKeisuuList(selectedRowData.nanidoKeisuuLstData);
      // setPunchProcessItaatsuListData(selectedRowData.punchProcessItaatsuLstData);
      // setGasKeisuuList(selectedRowData.gasKeissuuLstData);
      // setExtractConditionList(selectedRowData.extractConditionList);
      // setIQ3ItaatsuMaster(selectedRowData.iq3ItaatsuMasterData);
      // setGasTypeMaster(selectedRowData.gasTypeMasterData);
      // setRetainedMoldMaster(selectedRowData.retrainedMoldMasterData);
      // setJointSizeMaster(selectedRowData.jointSizeMasterData);

      // 委託装置詳細
      setFlagChecked(selectedRowData?.details?.isManualInput);
      setInputDisabled(!selectedRowData?.details?.isManualInput);
      setCheckboxChecked(selectedRowData?.details?.isCommission);
      // setCustomerName(selectedRowData?.details.clientName);
      // setCustomerCode(selectedRowData?.details.clientCode);
      if (selectedRowData?.details?.clientId) {
        // IQX_WEBEST-380 パラメーター親部品、板金装置設定に追加工程の場合、取引先情報で新規作成と編集できません。
        const customers = props?.getCustomers?.data?.filter((item) => item.id === selectedRowData?.details?.clientId);

        if (customers?.length > 0) {
          setCustomerCode(customers[0].code); // Access the code from the first item in the filtered array
          setCustomerName(customers[0].name);
        }
      } else {
        setCustomerCode('');
        setCustomerName('');
      }

      setIniAmount(selectedRowData?.details?.initPrice);
      setSelectDisabled(!selectedRowData?.details?.isCommission);

      // setKosuu(selectedRowData.kosuuMasterData);
      // setKousuuList(selectedRowData.kosuuLstData);

      // 装置の詳細情報
      setDetailProcess(selectedRowData?.details);

      // 作業時間（x要素数）
      setSagyouTime(selectedRowData?.details?.workBasicTime);

      // setDantoriChange(selectedRowData.processCharge);
      setDeviceType(processMstRecord?.isAdditional ? processTypes.additional : processTypes.standard);

      setCode(processMstRecord?.code);
      setProcessName(processMstRecord?.name);
      setWorkType(processMstRecord?.workType);
      setProcessTypesList(processMstRecord?.details?.processDetailTypes);

      setDetailId(selectedRowData?.id);
      setDeviceCode(selectedRowData?.code);
      setDeviceName(selectedRowData?.name);
      setRemarks(selectedRowData?.info?.remarks);
      setIsUsed(selectedRowData?.info?.isUsed);
      setTypes(processMstRecord?.class);

      // 追加工程種類情報
      setAdditionalProcessId(selectedRowData?.details?.addProcessTypeId);
      let kouteiInfo = getAdditionalProcessInfo(processMstRecord, selectedRowData?.details?.addProcessTypeId);
      setKouteiName(kouteiInfo?.name);
      setKouteiCode(kouteiInfo?.code);

      // let worktime = secondsToHms(selectedRowData?.details.workBasicTime);

      // 1部品あたりの作業時間
      setWorkTime(selectedRowData?.details?.workBasicTime);
      // 溶接線長
      setWeldLine(selectedRowData?.details?.workSpeedThMaster);
      // setYousetsuWeldLineList(selectedRowData?.details.workSpeedThItems);
      setKakouSokudoSenchouList(selectedRowData?.details?.workSpeedThItems);

      // 加工速度（板厚）
      // setKakouSokudoSenchouMasterData(selectedRowData.yousetsuShiageSenchouMasterData);

      // setArea(selectedRowData.areaMasterData);
      // setWeight(selectedRowData.weightMasterData);
      // setSizeDetailsList(selectedRowData.sizeListData);
      // setVolume(selectedRowData.volumeMasterData);
      // setDantoriSizeDetailsList(selectedRowData.dantoriSizeListData);

      // setKihonDantori(selectedRowData.kihonDantoriTime);
      // setDantoriFlag(selectedRowData.dantoriFlag);
      // setProcessInspectionTime(selectedRowData.processInspectionTime);

      // 1検査時間
      setProcessTimeByUnit(selectedRowData?.details?.inspectionWorkTime);

      // 名称
      // setMeishou(selectedRowData.meishouDetails);
      // setMeishouList(selectedRowData.meishouLstData);
      // 数量区分
      // setSuuryouData(selectedRowData.kobuhinKeisuuMasterData);
      // setSuuryouList(selectedRowData.kobuhinKeisuuLstData);
      // setdantoriSetteiSuuryouList(selectedRowData.dantoriSetteiSuuryouLstData);

      // 要素数
      // setYousosuuData(selectedRowData.yousosuuMasterData);
      // setSagyouKeisuuYousosuuList(selectedRowData.sagyouJikanKeisuuLstData);
      // setShokiDankaiJikanList(selectedRowData.shokiDankaiJikanLstData);
      // setKensaJikanKeisuuList(selectedRowData.kensaJikanKeisuuLstData);

      // setJikanChaji(selectedRowData.jikanChajji);

      // setInitialCustomerData([]);
      // setInitialCustomerDataBk([]);

      // setKobuhinKeisuu(selectedRowData.kobuhinSuu);
      // setPitchItaatsuList(selectedRowData.pitchItaatsuLstData);
      // setTapWeldItaatsuList(selectedRowData.tapWeldingItaatsuLstData);

      // setYousetsuNanidoItaatsuMasterData(selectedRowData.yousetsuNanidoItaatsuMasterData);
      // setYousetsuNanidoItaatsuList(selectedRowData.yousetsuNanidoItaatsuLstData);

      // setKaritsukiTimeItaatsuMasterData(selectedRowData.karitsukiJikanItaatsuMasterData);
      // setKaritsukiTimeItaatsuList(selectedRowData.karitsukiJikanItaatsuLstData);

      // setToritsukiTimeItaatsuList(selectedRowData.toritsukiJikanItaatsuLstData); //別々テーブル
      // setToritsukiTimeItaatsuMasterData(selectedRowData.karitsukiJikanItaatsuMasterData);

      // setToritsukiTimeSizeMasterData(selectedRowData.toritsukiJikanSizeMasterData);
      // setToritsukiTimeSizeList(selectedRowData.toritsukiJikanSizeLstData);

      // setSetupAmount(selectedRowData.setupCharge);
      // setWorkAmount(selectedRowData.processCharge);
      // setDantoriTime(selectedRowData.setupTime);
      // setWorkTime(selectedRowData.workTime);
      // setTsuikaKouteiTypes(selectedRowData.tsuikaKouteiTypes);

      // setiq3SetupAmount(selectedRowData.iq3SetupAmount);
      // setiq3WorkAmount(selectedRowData.iq3WorkAmount);
      // setIQ3ProcessInspection(selectedRowData.iq3ProcessInspection);
      // setSecondProcessAmount(selectedRowData.secondProcessAmount);
      // setJointBarashiAmount(selectedRowData.jointBarashiAmount);
      // setIQ3KosuuList(selectedRowData.iq3DantoriJikanKosuuLstData);
      // setBendingTimeFactorListData(selectedRowData.bendingTimeFactorLstData);
      // setBendingCorrectionTimeFactorListData(selectedRowData.bendingCorrectionTimeFactorLstData);
      // setCorrectionTimeFactorListData(selectedRowData.correctionTimeFactorLstData);
      // setiq3ProductSizeListData(selectedRowData.iq3ProductSizeLstData);
      // setLength(selectedRowData?.lengthMasterData);
      // setiQ3BendingHonsuuList(selectedRowData.iq3BendingHonsuuLstData);
      // setIQ3BendingKosuuList(selectedRowData.iq3BendingkosuuLstData);
      // setIQ3MageSuuMaster(selectedRowData.mageSuuMasterData);
      // setIQ3MageSuuListData(selectedRowData.mageSuuLstData);
      // setIQ3MageKosuuMaster(selectedRowData.mageKosuuMasterData);
      // setIQ3MageKosuuListData(selectedRowData.mageKosuuLstData);

      // setDantoriJuuryouMagechouList(selectedRowData.dantoriSizeLstData);
      // setMagechouDantoriJikanListData(selectedRowData.iq3MagechouDantoriJikanListData);
      // setIQ3AreaMaster(selectedRowData.iq3AreaMasterData);
      // setIQ3KakouJikanListData(selectedRowData.iq3KakouJikanListData);
      // setBlankKakousokudolistData(selectedRowData.blankKakousokudoListData);
      // setProcessMethod(selectedRowData.kakouType);
      // setProcessMethods(selectedRowData.kakouMethods);
      // setProcessCode(selectedRowData.kakouCode);
      // setSeisanKosuu(selectedRowData.seisanKosuuMasterData);
      // setSeisanKosuuList(selectedRowData.seisanKosuuLstData);
      // setProcessInspectionKosuuList(selectedRowData.processInspectionKosuuLstData);
      // setHonsuu(selectedRowData.honsuuMasterData);
      // setHonSuuList(selectedRowData.honsuuLstData);
      // setIQ3SizeMaster(selectedRowData.iq3SizeMasterData);
      // setMmMaster(selectedRowData.iq3MmMasterData);

      // setIQ3KaniListData(selectedRowData.iq3KaninyuryokuListData);
      // setIQ3KaniAnaListData(selectedRowData.iq3KaninyuryokuAnaListData);
      // setItaatsu1(selectedRowData.itaatsu1MasterData);

      // setZaishitsu(selectedRowData.zaishitsuKubunn);
      // setMaterialHandlingTimeList(selectedRowData.materialHandlingTime);
      // setProgramSameSizePatternValue(selectedRowData.programSameSizePatternValue);

      // setPunchConditionList(selectedRowData.punchConditionList);
      // setDrillingTime(selectedRowData.drillingTime);
      // setForwardSpeed(selectedRowData.forwardSpeed);
      // setRollerSpeed(selectedRowData.rollerSpeed);
      // setOkuriSokudoVal(selectedRowData.okuriSokudoVal);
      // setKegakiSokudoVal(selectedRowData.kegakiSokudoVal);
      // setIQ3Kakouchou(selectedRowData.iq3KakouchouMasterData);
      // setShudoubariKakousokudoList(selectedRowData.iq3ShudouBariKakouSokudoListData);
      // setKensaAmount(selectedRowData.kouteinaiKensaAmount);

      // setShiageFlagList(selectedRowData.shiageFlagListData);
      // IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
      let weldProcessMstRecord = props?.getProcessMstRecordByWorkType(WorkType.SmWelding);
      setWeldProcessMst(weldProcessMstRecord);
      let itaatsuTypes = weldProcessMstRecord?.details?.processDetailTypes?.filter(
        (item) => item.group === WorkTypeGroup.SmInstThick
      );
      if (itaatsuTypes?.length > 0) setItaatsuKouteiTypeList(itaatsuTypes);
      let sizeTypes = weldProcessMstRecord?.details?.processDetailTypes?.filter(
        (item) => item.group === WorkTypeGroup.SmInstSize
      );
      if (sizeTypes?.length > 0) setSizeuKouteiTypeList(sizeTypes);
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      setFilterKeys(usedIds);
    } else {
      setProcessName('');
      setCode('');
      setDeviceCode('');
      setDeviceName('');
      setRemarks('');
      setIsUsed(true);
    }
  }, [props.selectedData, props.getMaterialTypes]);

  useEffect(() => {
    setIsCharge(props.flag);
  }, [props.flag]);

  useEffect(() => {
    setEditMode(props.editMode != undefined ? props.editMode : false);
  }, [props.editMode]);

  // const getClientInfoAPI = async (clientId) => {
  //   let result = await getClientInfo();
  //   const filterdData = result?.filter((item) => item.id === clientId);
  //   return filterdData;
  // };
  useImperativeHandle(ref, () => ({}));

  // 工程種別名を得る
  const getWorkTypeName = (value) => {
    return WorkTypes?.filter((item) => item?.value === value)?.[0]?.label;
  };

  // 追加工程種類名を得る
  const getAdditionalProcessInfo = (masterInfoRecord, id) => {
    return masterInfoRecord?.details?.processDetailTypes?.filter((item) => item.id === id)?.[0];
  };

  const chargeAmount = () => {
    if (isCharge == true) {
      setIsCharge(false);
      props.updatedFlag(false);
    } else {
      setIsCharge(true);
      props.updatedFlag(true);
    }
  };
  const baritoriShurui = () => {
    if (isBaritoriShurui == true) {
      setIsBaritoriShurui(false);
    } else {
      setIsBaritoriShurui(true);
    }
  };
  const dantoriJikan = () => {
    if (isDantoriJikan === true) {
      setIsDantoriJikan(false);
    } else {
      setIsDantoriJikan(true);
    }
  };
  const setupSetting = () => {
    if (isSetupSetting == true) {
      setIsSetupSetting(false);
    } else {
      setIsSetupSetting(true);
    }
  };
  const kouteiNaikensa = () => {
    if (isKouteiNaikensa == true) {
      setIsKouteiNaikensa(false);
    } else {
      setIsKouteiNaikensa(true);
    }
  };
  const magekakouJikan = () => {
    if (isMagekakouJikan === true) {
      setIsMagekakouJikan(false);
    } else {
      setIsMagekakouJikan(true);
    }
  };
  const arrangeMaterial = () => {
    if (isArrangeMaterial === true) {
      setIsArrangeMaterial(false);
    } else {
      setIsArrangeMaterial(true);
    }
  };
  const punch = () => {
    if (isPunch === true) {
      setIsPunch(false);
    } else {
      setIsPunch(true);
    }
  };
  const piercingProcess = () => {
    if (isPiercingProcess === true) {
      setIsPiercingProcess(false);
    } else {
      setIsPiercingProcess(true);
    }
  };
  const punchProcess = () => {
    if (isPunchProcess === true) {
      setIsPunchProcess(false);
    } else {
      setIsPunchProcess(true);
    }
  };
  const mageHoseiJikan = () => {
    if (isMageHoseiJikan === true) {
      setIsMageHoseiJikan(false);
    } else {
      setIsMageHoseiJikan(true);
    }
  };
  const mageHoseiJikanFactor = () => {
    if (isMageHoseiJikanFactor === true) {
      setIsMageHoseiJikanFactor(false);
    } else {
      setIsMageHoseiJikanFactor(true);
    }
  };
  const processSizeFactor = () => {
    if (isProcessSizeFactor === true) {
      setIsProcessSizeFactor(false);
    } else {
      setIsProcessSizeFactor(true);
    }
  };
  const bendingTimeFactor = () => {
    if (isBendingTimeFactor === true) {
      setIsBendingTimeFactor(false);
    } else {
      setIsBendingTimeFactor(true);
    }
  };
  const processSpeed = () => {
    if (isProcessSpeed == true) {
      setIsProcessSpeed(false);
    } else {
      setIsProcessSpeed(true);
    }
  };
  const sagyouSokudo = () => {
    if (isSagyouSokudo == true) {
      setIsSagyouSokudo(false);
    } else {
      setIsSagyouSokudo(true);
    }
  };
  const sagyouKeisuu = () => {
    if (isSagyouKeisuu == true) {
      setIsSagyouKeisuu(false);
    } else {
      setIsSagyouKeisuu(true);
    }
  };
  const iq3DantoriJikan = () => {
    if (isiq3DantoriJikan === true) {
      setIsiq3DantoriJikan(false);
    } else {
      setIsiq3DantoriJikan(true);
    }
  };
  const iq3KakouJikan = () => {
    if (isiq3KakouJikan === true) {
      setIsiq3KakouJikan(false);
    } else {
      setIsiq3KakouJikan(true);
    }
  };
  const blankKakouSokudo = () => {
    if (isBlankKakouSokudo === true) {
      setIsBlankKakouSokudo(false);
    } else {
      setIsBlankKakouSokudo(true);
    }
  };
  const blankKakouSokudoKeisuu = () => {
    if (isBlankKakouSokudoKeisuu === true) {
      setIsBlankKakouSokudoKeisuu(false);
    } else {
      setIsBlankKakouSokudoKeisuu(true);
    }
  };
  const blankGasuKeisuu = () => {
    if (isBlankGasuKeisuu === true) {
      setIsBlankGasuKeisuu(false);
    } else {
      setIsBlankGasuKeisuu(true);
    }
  };
  const extractCondition = () => {
    if (isExtractCondition === true) {
      setIsExtractCondition(false);
    } else {
      setIsExtractCondition(true);
    }
  };
  const blankGasuType = () => {
    if (isBlankGasuType === true) {
      setIsBlankGasuType(false);
    } else {
      setIsBlankGasuType(true);
    }
  };
  const blankDrillingTime = () => {
    if (isBlankDrillingTime === true) {
      setIsBlankDrillingTime(false);
    } else {
      setIsBlankDrillingTime(true);
    }
  };
  const okuriSokudo = () => {
    if (isOkuriSokudo === true) {
      setIsOkuriSokudo(false);
    } else {
      setIsOkuriSokudo(true);
    }
  };
  const rollerKakouSokudo = () => {
    if (isRollerKakouSokudo === true) {
      setIsRollerKakouSokudo(false);
    } else {
      setIsRollerKakouSokudo(true);
    }
  };
  const blankJoint = () => {
    if (isBlankJoint === true) {
      setIsBlankJoint(false);
    } else {
      setIsBlankJoint(true);
    }
  };
  const iq3KakouSokudo = () => {
    if (isiq3KakouSokudo === true) {
      setIsiq3KakouSokudo(false);
    } else {
      setIsiq3KakouSokudo(true);
    }
  };
  const iq3ManualBari = () => {
    if (isiq3ManualBari === true) {
      setIsiq3ManualBari(false);
    } else {
      setIsiq3ManualBari(true);
    }
  };
  const processTime = () => {
    if (isProcessTime == true) {
      setIsProcessTime(false);
    } else {
      setIsProcessTime(true);
    }
  };
  const attach = () => {
    if (isAttach == true) {
      setIsAttach(false);
    } else {
      setIsAttach(true);
    }
  };
  // IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
  const kakouJikan = () => {
    if (isKakouJikan === true) {
      setIsKakouJikan(false);
    } else {
      setIsKakouJikan(true);
    }
  };
  const toritsukiJikanItaatsu = () => {
    if (isToritsukiJikanItaatsu === true) {
      setIsToritsukiJikanItaatsu(false);
    } else {
      setIsToritsukiJikanItaatsu(true);
    }
  };
  const toritsukiJikanSize = () => {
    if (isToritsukiJikanSize === true) {
      setIsToritsukiJikanSize(false);
    } else {
      setIsToritsukiJikanSize(true);
    }
  };
  const welding = () => {
    if (isWelding == true) {
      setIsWelding(false);
    } else {
      setIsWelding(true);
    }
  };
  const deviceDetails = () => {
    if (isDeviceDetails === true) {
      setIsDeviceDetails(false);
    } else {
      setIsDeviceDetails(true);
    }
  };
  const tapWelding = () => {
    if (isTapWelding == true) {
      setIsTapWelding(false);
    } else {
      setIsTapWelding(true);
    }
  };
  const pitch = () => {
    if (isPitch == true) {
      setIsPitch(false);
    } else {
      setIsPitch(true);
    }
  };
  const productSize = () => {
    if (isProductSize == true) {
      setIsProductSize(false);
    } else {
      setIsProductSize(true);
    }
  };
  const productQuantity = () => {
    if (isProductQuantity == true) {
      setIsProductQuantity(false);
    } else {
      setIsProductQuantity(true);
    }
  };
  const childPart = () => {
    if (isChildPart == true) {
      setIsChildPart(false);
    } else {
      setIsChildPart(true);
    }
  };
  const difficultyFactor = () => {
    if (isDifficultyFactor == true) {
      setIsDifficultyFactor(false);
    } else {
      setIsDifficultyFactor(true);
    }
  };
  const shiageFlag = () => {
    if (isShiageFlag == true) {
      setIsShiageFlag(false);
    } else {
      setIsShiageFlag(true);
    }
  };
  const materialHandling = () => {
    if (isMaterialHandling == true) {
      setIsMaterialHandling(false);
    } else {
      setIsMaterialHandling(true);
    }
  };
  const editData = () => {
    setEditMode(true);
    props.updatedFlag(isCharge);
    props.updateEditMode(true);
  };
  const updateData = () => {
    //  setUpdateConfirm(true);
    setUpdateConfirm(props.showEdtConfirmOK);
    if (!props.showEdtConfirmOK) {
      updConfirmOk();
    }
  };

  const discardData = () => {
    // setCancelConfirm(true);

    setCancelConfirm(props.showEdtConfirmCancle);
    if (!props.showEdtConfirmCancle) {
      discardConfirmOk();
    }
  };

  const updConfirmOk = (e) => {
    setEditMode(false);
    props.updateEditMode(false);
    setUpdateConfirm(false);
    selectedDeviceData.name = deviceName;
    selectedDeviceData.code = deviceCode;
    selectedDeviceData.info.remarks = remarks;
    selectedDeviceData.info.isUsed = isUsed;
    selectedDeviceData.details = detailsProcess;
    selectedDeviceData.updateId = selectedDeviceData.id;
    // プログラムの場合、
    if (workType === WorkType.SmProgram) {
      selectedDeviceData.details.workBasicTime = sagyouTime; // 作業時間（x要素数）
    } else {
      selectedDeviceData.details.workBasicTime = workTime;
    }
    selectedDeviceData.details.isCommission = checkboxChecked;

    selectedDeviceData.details.clientId = customerId;
    selectedDeviceData.details.isManualInput = flagChecked;
    selectedDeviceData.details.initPrice = iniAmount;
    selectedDeviceData.details.inspectionWorkTime = processTimeByUnit; // 1検査時間
    selectedDeviceData.details.addProcessTypeId = additionalProcessId;

    props.updatedDetails(selectedDeviceData);
  };

  const updConfirmCancel = () => {
    setUpdateConfirm(false);
  };

  const discardConfirmOk = () => {
    props.updateEditMode(false);
    setCancelConfirm(false);
    setEditMode(false);
    setDeviceName(detailsData['name']);
    setDeviceCode(detailsData['code']);
    setRemarks(detailsData.info['remarks']);
    setIsUsed(detailsData.info['isUsed']);
    setDetailProcess(detailsData['details']);
  };

  const discardConfirmCancel = () => {
    setCancelConfirm(false);
    props.updateEditMode(true);
  };

  const updateShiageFlagList = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, difficultyCoeff: result }));
  };

  //　チャージ金額の値を入力した場合、
  const updatedChargeAmount = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, charges: updDetails }));
  };

  const updatedCharge = (result) => {
    setJikanChaji(result);
  };
  // 送り速度(mm/min)
  const updateForwardSpeed = (result) => {
    // setForwardSpeed(result);
    setDetailProcess((prevData) => ({ ...prevData, feedSpeed: result }));
  };
  // ローラー/ホイール/ケガキ金型　加工速度(mm/sec)加工速度(mm/分)
  const updateRollerSpeed = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeed: result }));
  };
  const updateDrillingTime = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, twoStepHoleworkTime: result }));
  };
  // パンチ条件データ更新
  const updatePunchList = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, punches: result }));
  };
  // 材料配置データ更新
  const updateMaterialArrangement = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, materialArrange: result }));
  };
  // 1ピアス加工時間の板厚マスタ値とリスト更新
  const updatePiercingTimeThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, piercingTimeThickThMaster: result }));
  };
  const updatePiercingTimeThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, piercingTimeThItems: result }));
  };
  const updateProcessMethod = (result) => {
    setProcessMethod(result);
  };
  const updateSetupAmount = (result) => {
    setiq3SetupAmount(result);
  };
  const updateWorkAmount = (result) => {
    setiq3WorkAmount(result);
  };
  const updateiq3ProcessInspection = (result) => {
    setIQ3ProcessInspection(result);
  };
  const updatesecondProcessAmount = (result) => {
    setSecondProcessAmount(result);
  };
  const updatejointBarashiAmount = (result) => {
    setJointBarashiAmount(result);
  };
  const updateKensaAmount = (result) => {
    setKensaAmount(result);
  };

  // 段取設定の値が入力された場合、
  const updatedDantori = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepSecs: updDetails }));
  };

  // 数量のマスタ値が入力された場合、
  const updateSuuryouMstData = (updDetails) => {
    // setSuuryouData(result);
    setDetailProcess((prevData) => ({ ...prevData, prepThQtyMaster: updDetails }));
  };

  // 子部品点数の値が入力された場合、
  const updatedSuuryouChildList = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepCoeffThChildQtyItems: updDetails }));
  };

  // 子部品種類数の値が入力された場合、
  const updatedSuuryouChildTypeList = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepCoeffThChildTypeQtyItems: updDetails }));
  };

  // 子部品点数又子部品種類数のチェックボタンが変更された場合、
  const updatedPreparationCoeffType = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepCoeffType: updDetails }));
  };

  // 重量マスタ値が入力された場合、
  const updatedWeightMstData = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepCoeffThWeightMaster: updDetails }));
  };

  // 重量リスト値が入力された場合、
  const updatedWeightListData = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prepCoeffThWeightItems: updDetails }));
  };

  // 形鋼の段取の重量マスタ値が入力された場合、
  const updatedWeightClassificationCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, weightClassificationCoeffThMaster: updDetails }));
  };

  // 形鋼の段取の重量マスタ値が入力された場合、
  const updatedWeightClassificationCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, weightClassificationCoeffThItems: updDetails }));
  };

  // 段取設定の形状区分係数が入力された場合、
  const updatedSetupShapeCoeff = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, setupShapeCoeff: updDetails }));
  };

  // 段取設定の材質区分係数が入力された場合、
  const updatedMaterialClassificationCoeff = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, materialClassificationCoeff: updDetails }));
  };

  // 加工設定の形状区分係数が入力された場合、
  const updatedProcessingShapeCoeff = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingShapeCoeff: updDetails }));
  };

  // 加工設定の材質区分係数が入力された場合、
  const updatedMachiningMaterialCoeff = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, machiningMaterialCoeff: updDetails }));
  };

  // 加工設定の一回加工時間(Sec)が入力された場合、
  const updatedSingleProcessTimeSec = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, singleProcessTimeSec: updDetails }));
  };

  // 加工設定の仮付け加工時間(Sec)が入力された場合、
  const updatedTempInstProcessTimeSec = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, tempInstProcessTimeSec: updDetails }));
  };

  // 形鋼の重量(Kg)加工時間(Sec)が入力された場合、
  const updatedKgProcessingTimeThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, kgProcessingTimeThMaster: updDetails }));
  };

  // 形鋼の重量(Kg)加工時間(Sec)マスタ値が入力された場合、
  const updatedKgProcessingTimeThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, kgProcessingTimeThItems: updDetails }));
  };

  // 形鋼の面積加工時間(Sec)が入力された場合、
  const updatedAreaProcessingTimeThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, areaProcessingTimeThMaster: updDetails }));
  };

  // 形鋼の面積加工時間(Sec)マスタ値が入力された場合、
  const updatedAreaProcessingTimeThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, areaProcessingTimeThItems: updDetails }));
  };

  // 形鋼のサイズ加工時間(Sec)が入力された場合、
  const updatedSizeProcessingTimeThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, sizeProcessingTimeThMaster: updDetails }));
  };

  // 形鋼のサイズ加工時間(Sec)マスタ値が入力された場合、
  const updatedSizeProcessingTimeThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, sizeProcessingTimeThItems: updDetails }));
  };

  // 形鋼の加工速度が入力された場合、
  const updatedProcessingSpeedThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingSpeedThMaster: updDetails }));
  };

  // 形鋼の加工速度が入力された場合、
  const updatedProcessingSpeedThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingSpeedThItems: updDetails }));
  };

  // 形鋼の加工の重量マスタ値が入力された場合、
  const updatedProcessingWeightCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingWeightCoeffThMaster: updDetails }));
  };

  // 形鋼の加工の重量マスタ値が入力された場合、
  const updatedProcessingWeightCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingWeightCoeffThItems: updDetails }));
  };

  // 形鋼のT1サイズ(mm)係数マスタが入力された場合、
  const updatedT1SizeCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, t1SizeCoeffThMaster: updDetails }));
  };

  // 形鋼のT1サイズ(mm)係数値が入力された場合、
  const updatedT1SizeCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, t1SizeCoeffThItems: updDetails }));
  };

  // 形鋼のAサイズ(mm)係数マスタが入力された場合、
  const updatedASizeCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, aSizeCoeffThMaster: updDetails }));
  };

  // 形鋼のAサイズ(mm)係数値が入力された場合、
  const updatedASizeCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, aSizeCoeffThItems: updDetails }));
  };

  // 形鋼のBサイズ(mm)係数マスタが入力された場合、
  const updatedBSizeCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, bSizeCoeffThMaster: updDetails }));
  };

  // 形鋼のBサイズ(mm)係数値が入力された場合、
  const updatedBSizeCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, bSizeCoeffThItems: updDetails }));
  };

  // 形鋼のCサイズ(mm)係数マスタが入力された場合、
  const updatedCSizeCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, cSizeCoeffThMaster: updDetails }));
  };

  // 形鋼のCサイズ(mm)係数値が入力された場合、
  const updatedCSizeCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, cSizeCoeffThItems: updDetails }));
  };

  // 形鋼のRサイズ(mm)係数マスタが入力された場合、
  const updatedRSizeCoeffThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, rSizeCoeffThMaster: updDetails }));
  };

  // 形鋼のRサイズ(mm)係数値が入力された場合、
  const updatedRSizeCoeffThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, rSizeCoeffThItems: updDetails }));
  };

  // 形鋼の加工指示種類が変更された場合、
  const updatedIQ5ManufactSizeInfo = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, iQ5ManufactSizeInfo: updDetails }));
  };

  // 形鋼の初期表示設定が変更された場合、
  const updatedInitialDisplay = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, initialDisplay: updDetails }));
  };

  // 切断の捨代が変更された場合
  const updatedDisposal = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, disposal: updDetails }));
  };

  // 切断の刃幅が変更された場合
  const updatedBladeWidth = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, bladeWidth: updDetails }));
  };

  // 切断の1カット加工時間（sec）が変更された場合
  const updatedSingleProcessTimeSecDec = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, singleProcessTimeSec: updDetails }));
  };

  // 切断の加工速度（mm/min）マスタが変更された場合
  const updatedProcessingSpeedMinThMaster = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingSpeedMinThMaster: updDetails }));
  };

  // 切断の加工速度（mm/min）値が変更された場合
  const updatedProcessingSpeedMinThItems = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, processingSpeedMinThItems: updDetails }));
  };

  const updatedantoriSetteiSuuryouList = (result) => {
    setdantoriSetteiSuuryouList(result);
  };

  // 基本段取時間が入力された場合、
  const updatedBasicTime = (updDetails) => {
    // setKihonDantori(result);
    setDetailProcess((prevData) => ({ ...prevData, prepBasicTime: updDetails }));
  };

  // 段取按分しないが変更された場合、
  const updateApportionSelect = (updDetails) => {
    // setDantoriFlag(result);
    setDetailProcess((prevData) => ({ ...prevData, apportionSelect: updDetails }));
  };

  const updateDantoriFlag = (result) => {
    setDantoriFlag(result);
  };
  // 加工速度の溶接線長マスタ値が入力された場合、
  const updatedYousetsuSenchouData = (result) => {
    // setWeldLine(result);
    setDetailProcess((prevData) => ({ ...prevData, workSpeedThMaster: result }));
  };

  const updateYousetsuSenchouList = (result) => {
    setYousetsuWeldLineList(result);
  };

  const updateKakousokudoSenchouList = (result) => {
    // setKakouSokudoSenchouList(result);
    setDetailProcess((prevData) => ({ ...prevData, workSpeedThItems: result }));
  };
  // 仮付き時間の板厚マスタ値が入力された場合、
  const upadateKaritsukiItaatsuData = (result) => {
    // setKaritsukiTimeItaatsuMasterData(result);
    setDetailProcess((prevData) => ({ ...prevData, tempInstThMaster: result }));
  };
  // 取付時間(板厚判断)の板厚マスタ値が入力された場合、
  const updateInstThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, instThickThMaster: result }));
  };
  // 仮付き時間の板厚マスタ値により、リスト更新
  const updateKaritsukiTimeList = (result) => {
    // setKaritsukiTimeItaatsuList(result);
    setDetailProcess((prevData) => ({ ...prevData, tempInstThItems: result }));
  };
  // 取付時間(板厚判断)の板厚マスタ値により、リスト更新
  const updateInstThickThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, instThickThItems: result }));
  };
  // IQX_WEBEST-271 加工時間(板厚判断)の板厚マスタ値が入力された場合、
  const updateKakouTimeInstThickThMaster = (result, kouteiTypeId) => {
    const data = { ...detailsProcess };
    data?.kakouTimeItems
      ?.filter((item) => Number(item.kouteiTypeId) === kouteiTypeId)
      ?.map((key) => {
        key.instThickThMaster = result;
      });
    setDetailProcess(data);
  };
  // IQX_WEBEST-271 加工時間(板厚判断)の値が入力された場合、
  const updateKakouTimeInstThickThItems = (result, kouteiTypeId) => {
    const data = { ...detailsProcess };
    data?.kakouTimeItems
      ?.filter((item) => Number(item.kouteiTypeId) === kouteiTypeId)
      ?.map((key) => {
        key.instThickThItems = result;
      });
    setDetailProcess(data);
  };
  // IQX_WEBEST-271 加工時間(サイズ判断)の板厚マスタ値が入力された場合、
  const updateKakouTimeInstSizeThMaster = (result, kouteiTypeId) => {
    const data = { ...detailsProcess };
    data?.kakouTimeItems
      ?.filter((item) => Number(item.kouteiTypeId) === kouteiTypeId)
      ?.map((key) => {
        key.instSizeThMaster = result;
      });
    setDetailProcess(data);
  };
  // IQX_WEBEST-271 加工時間(サイズ判断)の値が入力された場合、
  const updateKakouTimeInstSizeThItems = (result, kouteiTypeId) => {
    const data = { ...detailsProcess };
    data?.kakouTimeItems
      ?.filter((item) => Number(item.kouteiTypeId) === kouteiTypeId)
      ?.map((key) => {
        key.instSizeThItems = result;
      });
    setDetailProcess(data);
  };
  const updateSpotPitchThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, spotPitchThMaster: result }));
  };
  const updateSpotPitchThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, spotPitchThItems: result }));
  };
  // 溶接仕上の難易度係数更新
  const updateDiffFactorCoeff = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, diffFactorCoeff: result }));
  };

  // 曲げ補正時間の本数マスタ値更新
  const updateModifyTimeQtyThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, modifyTimeQtyThMaster: result }));
  };
  const updateModifyTimeItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, modifyTimeItems: result }));
  };
  // 曲げ補正時間のkgとmmマスタ値更新
  const updateModifyCoeffLenThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, modifyCoeffLenThMaster: result }));
  };
  const updateModifyCoeffWeightThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, modifyCoeffWeightThMaster: result }));
  };
  const updateMtWeightThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mtWeightThMaster: result }));
  };
  const updateModifyCoeffItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, modifyCoeffItems: result }));
  };
  // 加工補正時間係数
  const updatedworkCorrectionTimeListData = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mtTimeCoeffItems: result }));
  };
  const updateMtAreaThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mtAreaThMaster: result }));
  };
  // 手動バリ取対象サイズの内径最小丸穴径(mm)の値更新
  const updateRoundHoleDia = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, roundHoleDia: result }));
  };
  // 手動バリ取対象サイズの内径最小矩形周長(mm)の値更新
  const updateRectangleDia = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, rectangleDia: result }));
  };
  // 手動バリ取対象サイズの適応の値更新
  const updateRectangleBariOnFlg = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, rectangleBariOnFlg: result }));
  };
  const updatedLists = (result) => {
    setYousetsuNanidoItaatsuList(result);
  };

  const updateProductSizeArea = (result) => {
    setArea(result);
  };

  //
  const updateKosuu = (result) => {
    setKosuu(result);
  };

  // 生産個数マスタの値を変更した場合、
  const updateSeisanKosuu = (result) => {
    // setSeisanKosuu(result);
    setDetailProcess((prevData) => ({ ...prevData, prepQtyCoeffThMaster: result }));
  };

  // 本数マスタ値を更新
  const updateHonsuu = (result) => {
    // setHonsuu(result);
    if (workType === WorkType.SmBending) {
      setDetailProcess((prevData) => ({ ...prevData, programCreateTimeCountfThMaster: result }));
    } else {
      setDetailProcess((prevData) => ({ ...prevData, prepMoldQtyCoeffThMaster: result }));
    }
  };

  // 生産個数リストの値を変更した場合、
  const updateiq3SeisanKosuuList = (result) => {
    // setSeisanKosuuList(result);
    setDetailProcess((prevData) => ({ ...prevData, prepQtyCoeffItems: result }));
  };

  const updateProcessInspectionKosuuList = (result) => {
    setProcessInspectionKosuuList(result);
  };

  // 本数リスト値を更新
  const updateHonsuuList = (result) => {
    // setHonSuuList(result);
    if (workType === WorkType.SmBending) {
      setDetailProcess((prevData) => ({ ...prevData, programCreateTimeItems: result }));
    } else {
      setDetailProcess((prevData) => ({ ...prevData, prepMoldQtyCoeffItems: result }));
    }
  };

  // 基本段取時間
  const updateDantoriTime = (result) => {
    // setKihonDantori(result);
    setDetailProcess((prevData) => ({ ...prevData, prepBasicTime: result }));
  };

  const updateProcessInspectionTime = (result) => {
    setProcessInspectionTime(result);
  };
  const updateMageKosuu = (result) => {
    setIQ3MageKosuuMaster(result);
  };
  const updateMageKosuList = (result) => {
    setIQ3MageKosuuListData(result);
  };
  const updateiq3BendingHonsuuList = (result) => {
    setiQ3BendingHonsuuList(result);
  };
  const updateIQ3BendingKosuuList = (result) => {
    setIQ3BendingKosuuList(result);
  };
  const updateiq3KosuuList = (result) => {
    setSeisanKosuuList(result);
  };

  // 生産個数係数の個数マスタ値が入力された場合、
  const updateProductionQtyCoeffMst = (updDetails) => {
    // setKousuuList(result);
    setDetailProcess((prevData) => ({ ...prevData, productionQtyCoeffThMaster: updDetails }));
  };

  // 生産個数係数が入力された場合、
  const updateProductionQtyCoeffList = (updDetails) => {
    // setKousuuList(result);
    setDetailProcess((prevData) => ({ ...prevData, productionQtyCoeffThItems: updDetails }));
  };

  const updatename = (result) => {
    setMeishou(result);
  };
  const updateMeishouList = (result) => {
    setMeishouList(result);
  };

  // 重量マスタの値を変更した場合、
  const updateProductSizeWeight = (result) => {
    // setWeight(result);
    setDetailProcess((prevData) => ({ ...prevData, childPartsCoeffWeightThMaster: result }));
  };

  // 曲げ長さ係数のkgとmmマスタ値更新
  const updateBendTimeCoeffLenThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, bendTimeCoeffLenThMaster: result }));
  };

  const updateBendTimeCoeffWeightThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, bendTimeCoeffWeightThMaster: result }));
  };

  const updateBendingCorrectionTimeFactorListData = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, bendTimeCoeffWeightLenItems: result }));
  };

  // マテリアルハンドリング時間の重量と面積マスタ値更新
  const updateMhWeightThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mhWeightThMaster: result }));
  };
  const updateMhAreaThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mhAreaThMaster: result }));
  };

  // マテリアルハンドリング時間リスト更新
  const updateMhTimeItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mhTimeItems: result }));
  };

  // 面積マスタの値を変更した場合、
  const updateBendingTimeArea = (result) => {
    // setIQ3AreaMaster(result);
    setDetailProcess((prevData) => ({ ...prevData, childPartsCoeffAreaThMaster: result }));
  };

  // const updateDantoriJuuryoMagechouListData = (result) => {
  //   setDantoriJuuryouMagechouList(result);
  // };

  // 曲長リスト値を変更
  const updateMagechouDantoriJikanList = (result) => {
    // setMagechouDantoriJikanListData(result);
    setDetailProcess((prevData) => ({ ...prevData, prepBendTimeItems: result }));
  };

  const updateBendingTimeFactorListData = (result) => {
    setBendingTimeFactorListData(result);
  };

  // サイズ係数のリスト値を変更した場合、
  const updatecorrectionTimeFactorListData = (result) => {
    // setCorrectionTimeFactorListData(result);
    setDetailProcess((prevData) => ({ ...prevData, childPartsCoeff: result }));
  };

  // パンチ条件板厚マスタ更新
  const updatePunchConditionThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, punchConditionThickThMaster: result }));
  };
  const updatePunchConditionItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, punchConditionItems: result }));
  };

  // 1パンチ加工時間マスタ更新
  const updatePunchWorkTimeThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, punchWorkTimeThickThMaster: result }));
  };
  const updatePunchWorkTimeItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, punchWorkTimeItems: result }));
  };
  // サイズ係数の面積マスタ更新
  const updateProdSizeAreaThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, prodSizeAreaThMaster: result }));
  };

  // サイズ係数の重量マスタ更新
  const updateProdSizeWeightThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, prodSizeWeightThMaster: result }));
  };

  // サイズ係数の重量面積リスト情報を更新
  const updateProdSizeItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, prodSizeItems: result }));
  };

  const updateIQ3ProductSizeListData = (result) => {
    setiq3ProductSizeListData(result);
  };

  // 曲長マスタの値を更新
  const updateBendingTimeLength = (result) => {
    // setLength(result);
    setDetailProcess((prevData) => ({ ...prevData, prepBendTimeLengthMaster: result }));
  };

  const updateIQ3AreaMaster = (result) => {
    setIQ3AreaMaster(result);
  };
  // 自動バリ又は表面処理の加工時間のcm２マスタ値更新
  const updateAreaThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, areaThMaster: result }));
  };
  const updateWorkTimeThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workTimeThItems: result }));
  };

  const updateIQ3KakouJikanList = (result) => {
    setIQ3KakouJikanListData(result);
  };

  // サイズマスタの更新
  const updatediq3SizeMaster = (result) => {
    // setIQ3SizeMaster(result);
    setDetailProcess((prevData) => ({ ...prevData, sizeThMaster: result }));
  };

  // mmマスタの更新
  const updateSizeMmMaster = (result) => {
    // setMmMaster(result);
    setDetailProcess((prevData) => ({ ...prevData, mmThMaster: result }));
  };

  // mm多工程穴マスタの更新
  const updateSizeMmMultiProcHoleMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, mmMultiProcHoleThMaster: result }));
  };

  // サイズ簡易入力リストの更新
  const updatediq3KaniListData = (result) => {
    // setIQ3KaniListData(result);
    setDetailProcess((prevData) => ({ ...prevData, workTimeSizeThItems: result }));
  };

  // mm成形型穴リストの更新
  const updateiq3KaniAnaListData = (result) => {
    // [setIQ3KaniAnaListData(result)];
    setDetailProcess((prevData) => ({ ...prevData, workTimeSizeHoleThItems: result }));
  };

  // mm多工程穴リストの更新
  const updateiq3KaniMultiProcAnaListData = (result) => {
    // [setIQ3KaniAnaListData(result)];
    setDetailProcess((prevData) => ({ ...prevData, workTimeMmMultiProcHoleThItems: result }));
  };

  // サイズ板厚マスタの更新
  const updateSizeItaatsu = (result) => {
    // setItaatsu1(result);
    setDetailProcess((prevData) => ({ ...prevData, sizeThicknessThMaster: result }));
  };

  // mm成形型穴マスタの更新
  const updateMmItaatsu = (result) => {
    // setItaatsu1(result);
    setDetailProcess((prevData) => ({ ...prevData, mmThicknessThMaster: result }));
  };

  // mm多工程穴マスタの更新
  const updateMmMultiProcHole = (result) => {
    // setItaatsu1(result);
    setDetailProcess((prevData) => ({ ...prevData, mmThicknessMultiProcHoleThMaster: result }));
  };

  // 1カット時間
  const updateCutTime = (result) => {
    // setCutTime(result);
    setDetailProcess((prevData) => ({ ...prevData, cutTime: result }));
  };

  // one by one
  const updateShirringFlag = (result) => {
    // setShirringFlag(result);
    setDetailProcess((prevData) => ({ ...prevData, isOneCut: result }));
  };

  const updateVolume = (result) => {
    setVolume(result);
  };

  const updateDantoriSizeList = (result) => {
    setDantoriSizeDetailsList(result);
  };

  // 重量係数の個数マスタ値が入力された場合、
  const updateProductWeightCoeffMst = (updDetails) => {
    setDetailProcess((prevData) => ({ ...prevData, prodWeightCoeffThMaster: updDetails }));
  };

  // 重量係数の値が入力された場合、
  const updateProductWeightCoeffList = (updDetails) => {
    // setSizeDetailsList(result);
    setDetailProcess((prevData) => ({ ...prevData, prodWeightCoeffThItems: updDetails }));
  };

  const updateSuuryouDetails = (result) => {
    setSuuryouData(result);
  };

  const updateMagesuuData = (result) => {
    setIQ3MageSuuMaster(result);
  };

  // 曲げ種類リストの値を更新、
  const updateMagesuuList = (result) => {
    // setIQ3MageSuuListData(result);
    setDetailProcess((prevData) => ({ ...prevData, basicTimeThickItems: result }));
  };

  // 板厚マスタの値を更新
  const updateItaatsuMstData = (result) => {
    // setIQ3ItaatsuMaster(result);
    setDetailProcess((prevData) => ({ ...prevData, basicTimeThickThMaster: result }));
  };

  // 曲げ種類の板厚マスタを更新
  const updateIQ3Itaatsu = (result) => {
    // setIQ3ItaatsuMaster(result);
    setDetailProcess((prevData) => ({ ...prevData, workTimeThickThMaster: result }));
  };

  const updatedBlankKakousokudolistData = (result) => {
    setBlankKakousokudolistData(result);
  };
  const updateNaikeibari = (result) => {
    setNaikeibari(result);
  };
  const updateKakousokudobari = (result) => {
    setkakosokudo_bari(result);
  };
  // 手動バリの加工速度(mm/min)のマスタ値とリスト更新
  const updateWorkSpeedThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedThickThMaster: result }));
  };
  const updateWorkSpeedLenThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedLenThMaster: result }));
  };
  const updateWorkSpeedItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeed: result }));
  };
  const updateShudobariKakousokudoList = (result) => {
    setShudoubariKakousokudoList(result);
  };
  const updatedWorkSpeedItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedItems: result }));
  };
  // const updateNaikeiMin = (result) => {
  //   setNaikeiMin(result);
  // };
  // const updateNaikeiMax = (result) => {
  //   setNaikeiMax(result);
  // };
  // const updateAnaMax = (result) => {
  //   setAnaMax(result);
  // };
  // const updateAnaMin = (result) => {
  //   setAnaMin(result);
  // };
  // ガス係数のガス種類と板厚マスタ値更新
  const updateGasCoeffThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, gasCoeffThMaster: result }));
  };
  const updateGasCoeffListItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, gasCoeffListItems: result }));
  };
  const updateGasCoeffThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, gasCoeffThickThMaster: result }));
  };
  const updateGasCoeffThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, gasCoeffThItems: result }));
  };
  // 外形追抜条件の保有金型マスタ値更新
  const updatedRetainedMold = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, odOvertakeMoldMaster: result }));
  };
  const updateExtractConditionList = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, odOvertakeItems: result }));
  };

  // 曲げ種類の板厚リスト値を更新
  const updateBendingTimeList = (result) => {
    // setIQ3BendingTimeListData(result);
    setDetailProcess((prevData) => ({ ...prevData, workTimeThickItems: result }));
  };

  const updateGasTypeList = (result) => {
    setGasTypeListData(result);
  };

  const updatePiercingProcessList = (result) => {
    setPiercingProcessItaatsuListData(result);
  };

  const updatePunchProcessList = (result) => {
    setPunchProcessItaatsuListData(result);
  };
  // ジョイントバラシのcm2マスタ値更新
  const updateJointQtySizeThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, jointQtySizeThMaster: result }));
  };

  const updateJointQtyItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, jointQtyItems: result }));
  };
  // ジョイントバラシの板厚マスタ値更新
  const updateJointSeparateThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, jointSeparateThickThMaster: result }));
  };
  const updateJointSeparateItems = (result) => {
    const original = detailsProcess?.jointSeparateItems;
    const newArrayForFirstKey = result;

    if (original) {
      const firstKey = Object.keys(original)[0];

      const updated = {
        ...original,
        [firstKey]: newArrayForFirstKey,
      };
      setDetailProcess((prevData) => ({ ...prevData, jointSeparateItems: updated }));
    }
  };

  // 加工速度係数のマスタ値とリスト更新
  const updateWorkSpeedCoeffThickThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedCoeffLengthThMaster: result }));
  };
  const updateWorkSpeedCoeffInternalWorkItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedCoeffInternalWorkItems: result }));
  };
  const updateWorkSpeedCoeffExternalWorkItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, workSpeedCoeffExternalWorkItems: result }));
  };
  const updateJointItaatsuList = (result) => {
    setJointItaatsuListData(result);
  };
  const updateblankKakouSokudoItaatsuList = (result) => {
    setBlankKakouSokudoItaatsuList(result);
  };
  const updateOkuriSokudoVal = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, feedSpeed: result }));
  };
  const updateKegakiSokudoVal = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, scribingSpeed: result }));
  };
  const updateIsUsedEasyWorkSpeedVal = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, isUsedEasyWorkSpeed: result }));
  };
  // const updateYousosuu = (result) => {
  //   setYousosuuData(result);
  // };

  // 要素数マスタを変更した場合、
  const updateYousosuuMaster = (result) => {
    // setYousosuuData(result);
    setDetailProcess((prevData) => ({ ...prevData, prepElementThMaster: result }));
  };

  // 初期段取時間を変更した場合、
  const updateshokiDankaiJikanListData = (result) => {
    // setShokiDankaiJikanList(result);
    setDetailProcess((prevData) => ({ ...prevData, prepElementThItems: result }));
  };

  // 同一形状・サイズの上限を変更した場合、
  const updateProgramSameSizePatternValue = (result) => {
    // setProgramSameSizePatternValue(result);
    setDetailProcess((prevData) => ({ ...prevData, shapeGrouping: result }));
  };

  // const updateSuuryouListData = (result) => {
  //   setSuuryouList(result);
  // };

  const updateDantoriProductSizeWeight = (result) => {
    setWeight(result);
  };
  const updatKobuhinnKeisuu = (result) => {
    setKobuhinKeisuu(result);
  };

  const updateTapWeldItaatsuLst = (result) => {
    setTapWeldItaatsuList(result);
  };
  const updateInstSizeThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, instSizeThMaster: result }));
  };
  const updateInstSizeThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, instSizeThItems: result }));
  };

  // 溶接難易度の板厚マスタデータ更新
  const updateWeldDifficultyCoeffThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, weldDifficultyCoeffThMaster: result }));
  };
  const updatedWeldDifficultyCoeffThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, weldDifficultyCoeffThItems: result }));
  };
  // タップ溶接の板厚マスタデータ更新
  const updateTapRateThMaster = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, tapRateThMaster: result }));
  };
  const updateTapRateThItems = (result) => {
    setDetailProcess((prevData) => ({ ...prevData, tapRateThItems: result }));
  };
  const updateToritsukiItaatsuList = (result) => {
    setToritsukiTimeItaatsuList(result);
  };

  // 1検査時間を変更した場合、
  const changeTime = (e) => {
    setProcessTimeByUnit(setTimetoSec(e));
  };

  // マテリアルハンドリング時間更新
  const updateMaterialHandlingList = (result) => {
    setMaterialHandlingTimeList(result);
  };

  // 作業時間係数の要素数リストを変更した場合、
  const updateYousosuuListData = (result) => {
    // setSagyouKeisuuYousosuuList(result);
    setDetailProcess((prevData) => ({ ...prevData, workTimeElementCoeffThItems: result }));
  };

  // 作業時間係数の要素数マスタを変更した場合、
  const updateYousosuu = (result) => {
    // setYousosuuData(result);
    setDetailProcess((prevData) => ({ ...prevData, otherElementCoeffThMaster: result }));
  };

  const updateKensaJikanKeisuuList = (result) => {
    setKensaJikanKeisuuList(result);
  };

  // チャージ金額詳細
  const chargeDetailsModal = (event) => {
    event.stopPropagation();
    setIsDetails(true);
  };

  // バリ取種類
  const baritoriTypesContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={baritoriShurui}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>{processName === 'バリ取' ? 'バリ取' : 'ブランク'}種類</label>
            {isBaritoriShurui ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBaritoriShurui ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_ProcessType
              processMethods={processMethods}
              processMethod={processMethod}
              editMode={editMode}
              updatedProcessMethod={updateProcessMethod}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // チャージ金額
  const chargeAmountContent = (
    <>
      {/* <Row align="middle" className="oyabuhin-param oyabuhin-row" onClick={chargeAmount}> */}
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={chargeAmount}>
        <Col span={20} className="deli-col-param">
          <div style={{ verticalAlign: 'middle' }}>
            <label style={{ marginRight: 5 }}>チャージ金額(/h)</label>
            {isCharge ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}

            {/* <Button className="detailsButton" onClick={chargeDetailsModal} style={{ marginTop: -2 }}>
              詳細
            </Button> */}
          </div>
        </Col>
      </Row>
      <div style={{ display: isCharge ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            {/* チャージ金額 */}
            <ChargeAmount
              deviceType={deviceType}
              types={types}
              // setupAmount={setupAmount}
              // updateSetupAmount={updateSetupAmount}
              // workAmount ={workAmount}
              // updateWorkAmount={updateWorkAmount}
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              // chajiDetails={jikanCharge}
              processType={workType}
              processMethod={processMethod}
              editMode={editMode}
              updatedAmount={updatedChargeAmount}
              // updatedCharge={updatedCharge}
              // iq3SetupAmount={iq3SetupAmount}
              // updatediq3SetupAmount={updateSetupAmount}
              // iq3WorkAmount={iq3WorkAmount}
              // updatediq3WorkAmount={updateWorkAmount}
              // iq3ProcessInspection={iq3ProcessInspection} //工程内検査
              // updatediq3ProcessInspection={updateiq3ProcessInspection}
              // secondProcessAmount={secondProcessAmount} //２次加工
              // updatedsecondProcessAmount={updatesecondProcessAmount}
              // jointBarashiAmount={jointBarashiAmount}
              // updatedjointBarashiAmount={updatejointBarashiAmount}
              // チャージ金額の工程内検査
              // kensaAmount={kensaAmount}
              // updateKensaAmount={updateKensaAmount}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );

  // 段取設定
  const dantoriSettingContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={setupSetting}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>段取設定</label>
            {isSetupSetting ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isSetupSetting ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            {
              // プログラム
              workType === WorkType.SmProgram ||
              // ブランク
              workType === WorkType.SmBlankLaser ||
              workType === WorkType.SmBlankPunch ||
              workType === WorkType.SmBlankCombi ||
              // ベンディング
              workType === WorkType.SmBending ||
              // バリ取（自動・手動）
              workType === WorkType.SmDeburringAuto ||
              workType === WorkType.SmDeburringManual ||
              // 2次加工
              workType === WorkType.SmSecondaryWork ||
              // シャーリング
              workType === WorkType.SmShearing ||
              // 表面処理とiQ3
              (workType === WorkType.SmSurface && types === ServiceClass.SheetMetal) ||
              // 溶接とiQ3
              (workType === WorkType.SmWelding && types === ServiceClass.SheetMetal) ||
              // 溶接仕上とiQ3
              (workType === WorkType.SmWeldFinish && types === ServiceClass.SheetMetal) ||
              // 検査とiQ3
              (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) ||
              // カスタムとiQ3
              (workType === WorkType.SmCustom && types === ServiceClass.SheetMetal) ? (
                <>
                  <Device_SetupSetting
                    processType={workType}
                    detailsData={detailsProcess}
                    processMstRecord={processMstRecord}
                    processMethod={processMethod}
                    editMode={editMode}
                    // mageSuuData={iq3MageSuuMaster}
                    // updatedMagesuuData={updateMagesuuData}
                    itaatsuData={iq3ItaatsuMaster}
                    updatedItaatsuData={updateItaatsuMstData}
                    mageSuuLst={iq3MageSuuListData}
                    updatedMagesuuList={updateMagesuuList}
                    // 要素数
                    yousosuuMasterData={yousosuuData}
                    updatedYousosuuMasterData={updateYousosuuMaster}
                    // shokidankaiYousosuuList={shokiDankaiJikanList}
                    updatedYousosuuList={updateshokiDankaiJikanListData}
                    // 要素数により、作業係数のリスト更新
                    sagyouKeisuuYousosuuList={sagyouKeisuuYousosuuList}
                    updatedSagyouYousosuuList={updateYousosuuListData}
                    kensaJikanKeisuuList={kensaJikanKeisuuList}
                    updateKensaJikanKeisuuList={updateKensaJikanKeisuuList}
                    // 曲げ個数
                    mageKosuu={iq3MageKosuuMaster}
                    updatedMageKosuu={updateMageKosuu}
                    mageKosuuList={iq3MageKosuuListData}
                    updatedMageKosuuList={updateMageKosuList}
                    // 重量と曲げ長
                    length={length}
                    updatedLength={updateBendingTimeLength}
                    weight={weight}
                    updatedWeight={updateProductSizeWeight}
                    // dantoriJuuryouMagechouList={dantoriJuuryouMagechouList}
                    // updatedDantoriJuuryouMagechouList={updateDantoriJuuryoMagechouListData}
                    magechouDantoriJikanList={magechouDantoriJikanListData}
                    updatedmagechouDantoriJikanListData={updateMagechouDantoriJikanList}
                    // 二次加工

                    updatedDantoriSetting={updatedDantori} //段取 秒更新データ
                    // 生産個数
                    kosuu={seisanKosuu}
                    updatedKosuu={updateSeisanKosuu}
                    updatedKosuuList={updateiq3SeisanKosuuList}
                    kosuuList={seisanKosuuList}
                    processInspectionKosuuListosuuList={processInspectionKosuuList}
                    updatedProcessInspectionKosuuList={updateProcessInspectionKosuuList}
                    // 本数
                    honSuu={honSuu}
                    updateHonsuu={updateHonsuu}
                    honSuuList={honSuuList}
                    updateHonsuuList={updateHonsuuList}
                    // 基本段取時間
                    dantoriTime={kihonDantori}
                    updatedDantoriTime={updateDantoriTime}
                    // 段取を個別に持つ
                    dantoriFlag={dantoriFlag}
                    updateDantoriFlag={updateDantoriFlag}
                    area={iq3AreaMaster}
                    updatedArea={updateBendingTimeArea}
                    // 重量と面積
                    sizeKeisuuListData={correctionTimeFactorListData}
                    updatedsizeKeisuuListData={updatecorrectionTimeFactorListData}
                    // マテリアルハンドリング時間
                    materialHandlingTimeList={materialHandlingTimeList}
                    updateMaterialHandlingList={updateMaterialHandlingList}
                    // 製品重量係数
                    iq3SeihinSizeLst={iq3ProductSizeListData}
                    updatediq3ProductSizesList={updateIQ3ProductSizeListData}
                  />
                </>
              ) : (
                <>
                  {/* 段取設定 */}
                  <SetupSetting
                    editMode={editMode}
                    processType={workType}
                    detailsData={detailsProcess}
                    processMstRecord={processMstRecord}
                    updatedDantoriSetting={updatedDantori} //段取　秒更新データ
                    // kihonDantoriTime={kihonDantori} //基本段取時間
                    // updatedKihonDantoriTime={updatedTime}
                    // suuryouData={suuryouData} //数量Master
                    updatedSuuryouMstData={updateSuuryouMstData} // 個数マスタ値
                    updatedSuuryouChildList={updatedSuuryouChildList} // 子部品点数リスト値
                    updatedSuuryouChildTypeList={updatedSuuryouChildTypeList} // 子部品種類数リスト値
                    updatedPrepCoeffType={updatedPreparationCoeffType} // 子部品点数又子部品種類数のチェックボタン値
                    // dantoriSetteiSuuryouList={dantoriSetteiSuuryouList}
                    // updateddantoriSetteiSuuryouList={updatedantoriSetteiSuuryouList}
                    // 子部品数量
                    // kobuhinsuuryouList={suuryouList}
                    // updatedSuuryouList={updateSuuryouListData}
                    // 重量と体積
                    updatedWeightMstData={updatedWeightMstData} // 重量マスタ値
                    updatedWeightListData={updatedWeightListData} // 重量リスト値
                    updatedBasicTime={updatedBasicTime} //基本段取時間
                    // weight={weight}
                    // updatedWeight={updateDantoriProductSizeWeight}
                    // dantoriSizeList={dantoriSizeDetailsList}
                    // updatedDantoriSizeList={updateDantoriSizeList}
                    // sizeList={sizesDetailsList}
                    // updatedSizesList={updateProductSizeList}
                    // 段取を個別に持つ
                    // dantoriFlag={dantoriFlag}
                    updateDantoriFlag={updateApportionSelect} // 段取按分しない
                    materialTypes={materialTypes}
                    steelShapeData={props?.steelShapeData}
                    updatedWeightClassificationCoeffThMaster={updatedWeightClassificationCoeffThMaster}
                    updatedWeightClassificationCoeffThItems={updatedWeightClassificationCoeffThItems}
                    updatedSetupShapeCoeff={updatedSetupShapeCoeff}
                    updatedMaterialClassificationCoeff={updatedMaterialClassificationCoeff}
                  />
                </>
              )
            }
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 工程内検査
  const kouteiNaiKensaContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={kouteiNaikensa}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>工程内検査</label>
            {isKouteiNaikensa ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isKouteiNaikensa ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_ProcessInspection
              processName={getWorkTypeName(workType)}
              editMode={editMode}
              // 生産個数
              kosuu={seisanKosuu}
              updatedKosuu={updateSeisanKosuu}
              kosuuList={processInspectionKosuuList}
              updatedKosuuList={updateProcessInspectionKosuuList}
              // 段取設定の生産個数
              dantorikosuuList={seisanKosuuList}
              updatedDantorisKosuuList={updateiq3SeisanKosuuList}
              // 基本段取時間
              inspectionTime={processInspectionTime}
              updatedDantoriTime={updateProcessInspectionTime}
              // 要素数
              yousosuuMasterData={yousosuuData}
              updatedYousosuuMasterData={updateYousosuu}
              kensaJikanKeisuuList={kensaJikanKeisuuList}
              updateKensaJikanKeisuuList={updateKensaJikanKeisuuList}
              // 要素数により、リスト更新
              sagyouKeisuuYousosuuList={sagyouKeisuuYousosuuList}
              updatedYousosuuList={updateYousosuuListData}
              // 要素数により、リスト更新
              shokidankaiYousosuuList={shokiDankaiJikanList}
              updatedShokidankaiYousosuuList={updateshokiDankaiJikanListData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // マテリアルハンドリング時間
  const materialHandlingContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={materialHandling}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>マテリアルハンドリング時間</label>
            {isMaterialHandling ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isMaterialHandling ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_MaterialHandlingTime
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              processName={getWorkTypeName(workType)}
              editMode={editMode}
              // mageSuuData={iq3MageSuuMaster}
              // updatedMagesuuData={updateMagesuuData}
              // mageSuuLst={iq3MageSuuListData}
              // updatedMagesuuList={updateMagesuuList}
              // 重量と面積
              // length={length}
              // updatedLength={updateBendingTimeLength}
              // weight={weight}
              updatedWeight={updateMhWeightThMaster}
              // area={iq3AreaMaster}
              updatedArea={updateMhAreaThMaster}
              // dantoriJuuryouMagechouList={dantoriJuuryouMagechouList}
              // materialHandlingTimeList={materialHandlingTimeList}
              updateMaterialHandlingList={updateMhTimeItems}
              // 段取設定の曲げ係数
              // correctionTimeFactorListData={correctionTimeFactorListData}
              // updatedcorrectionTimeFactorListData={updatecorrectionTimeFactorListData}
              // 製品重量係数
              // iq3SeihinSizeLst={iq3ProductSizeListData}
              // updatediq3ProductSizesList={updateIQ3ProductSizeListData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );

  // 作業時間
  const sagyouJikanContent = (
    <>
      {/* 作業時間 */}
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={processTime}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>作業時間</label>
            {isProcessTime ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isProcessTime ? 'block' : 'none' }}>
        <Row style={{ marginLeft: 10 }} className="chargeAmount">
          <Col style={{ width: '20%' }}>
            <RTable>
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <td className="param-tbl-header">
                    {deviceType === processTypes.additional ? '1箇所あたりの作業時間' : '1部品あたりの作業時間'}{' '}
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: 'center' }}>
                  <td style={{ verticalAlign: 'middle' }}>
                    <Row style={{ marginLeft: 5 }} align="middle">
                      {!editMode ? (
                        <>
                          <Col span={24}>
                            <label>{secondsToHms(workTime)}</label>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col>
                            <TimeInputParameterScreen
                              value={secondsToHms(workTime)}
                              onBlur={(e) => {
                                setWorkTime(setTimetoSec(e.target.value));
                              }}
                            />
                          </Col>
                          {/* 2025-05-21 パラメータで複合機の二工程穴加工時間を編集する際に、
                              画面の横幅を狭くすると▲▼が2段になってしまう。
                              ▲▼が存在する部分は全てこの現象が起きると思う。
                              可能であれば画面の横幅の変更によって2段に別れたりしないようにしてほしい */}
                          <Col flex="1 1 auto">
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 1,
                                overflow: 'hidden',
                              }}
                            >
                              {[
                                ['10min', 'up'],
                                ['10min', 'down'],
                                ['min', 'up'],
                                ['min', 'down'],
                                ['sec', 'up'],
                                ['sec', 'down'],
                              ].map(([unit, dir], i) => {
                                const Icon = dir === 'up' ? CaretUpOutlined : CaretDownOutlined;
                                return (
                                  <Icon
                                    key={i}
                                    style={{
                                      fontSize: 'clamp(12px, 1.4vw, 16px)',
                                      color: '#000',
                                      pointerEvents: editMode ? 'auto' : 'none',
                                      flexShrink: 0,
                                    }}
                                    onClick={() => {
                                      const fn = dir === 'up' ? souchiHandleIncreaseTime : souchiHandleDecreaseTime;
                                      const editedTime = fn(secondsToHms(workTime), unit);
                                      // changeTime(setTimetoSec(editedTime));
                                      // 2025-06-30 IQX_WEBEST-435 時間の編集ができない
                                      setWorkTime(setTimetoSec(editedTime));
                                    }}
                                  />
                                );
                              })}
                            </div>
                          </Col>
                        </>
                      )}
                    </Row>
                  </td>
                </tr>
              </tbody>
            </RTable>
          </Col>
        </Row>
      </div>
    </>
  );
  // 曲げ加工時間
  const bendingTimeContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={magekakouJikan}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>1曲げ加工時間</label>
            {isMagekakouJikan ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isMagekakouJikan ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Bending
              editMode={editMode}
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateIQ3Itaatsu}
              itaatsuLst={iq3BendingTimeListData}
              updatedItaatsuList={updateBendingTimeList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 材料配置
  const materialArrangementContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={arrangeMaterial}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>材料配置</label>
            {isArrangeMaterial ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isArrangeMaterial ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_MaterialArrangement
              editMode={editMode}
              detailsData={detailsProcess}
              updateMaterialArrangement={updateMaterialArrangement}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // パンチ条件
  const punchConditionContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={punch}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>
              {workType === WorkType.SmBlankCombi ? 'パンチ条件丸穴径(mm)' : 'パンチ条件'}{' '}
              {/** IQX_WEBEST-294 パラメータ画面 > 板金 > 装置設定 > 複合機、”パンチ条件” の表記を "パンチ条件丸穴径(mm)" に変更 */}
            </label>
            {isPunch ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isPunch ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            {/* {workType === WorkType.SmBlankCombi ? (
              <Device_Blank_PunchProcessTime
                isPunchCondition={true}
                editMode={editMode}
                detailsData={detailsProcess}
                materialTypes={materialTypes}
                updatedItaatsu={updatePunchConditionThickThMaster}
                updatePunchProcessList={updatePunchConditionItems}
              />
            ) : ( */}
            <Device_Blank_PunchCondition
              editMode={editMode}
              detailsData={detailsProcess}
              updateList={updatePunchList}
              processType={workType}
            />
            {/* // )} */}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 1ピアス加工時間
  const piercingProcessTimeContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={piercingProcess}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>1ピアス加工時間(秒)</label> {/** IQX_WEBEST-264 */}
            {isPiercingProcess ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isPiercingProcess ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_PiercingProcessTime
              editMode={editMode}
              detailsData={detailsProcess}
              materialTypes={materialTypes}
              // itaatsuData={iq3ItaatsuMaster}
              updatePiercingTimeThickThMaster={updatePiercingTimeThickThMaster}
              // piercingProcessList={piercingProcessItaatsuListData}
              updatePiercingTimeThItems={updatePiercingTimeThItems}
              // // ガス種類
              // gasTypeList={gasTypeListData}
              // updatedGasTypeList={updateGasTypeList}
              // // ジョイント
              // jointItaatsuList={jointItaatsuListData}
              // updatedJointItaatsuList={updateJointItaatsuList}
              // // 加工速度係数
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              // updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}
              // // 加工速度
              // blankKakousokudolistData={blankKakousokudolistData}
              // updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 1パンチ加工時間
  const punchProcessTimeContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={punchProcess}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>1パンチ加工時間(秒)</label> {/** IQX_WEBEST-264 */}
            {isPunchProcess ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isPunchProcess ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_PunchProcessTime
              isPunchCondition={false}
              editMode={editMode}
              // itaatsuData={iq3ItaatsuMaster}
              // updatedItaatsuData={updateIQ3Itaatsu}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}

              detailsData={detailsProcess}
              materialTypes={materialTypes}
              updatedItaatsu={updatePunchWorkTimeThickThMaster}
              updatePunchProcessList={updatePunchWorkTimeItems}
              // // 1ピアス加工時間
              // piercingProcessList={piercingProcessItaatsuListData}
              // updatePiercingProcessList={updatePiercingProcessList}
              // // ガス種類
              // gasTypeList={gasTypeListData}
              // updatedGasTypeList={updateGasTypeList}
              // // ジョイント
              // jointItaatsuList={jointItaatsuListData}
              // updatedJointItaatsuList={updateJointItaatsuList}
              // // 加工速度係数
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              // updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 曲げ長さ係数
  const bendingTimeFactorContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={bendingTimeFactor}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>曲げ時間係数</label> {/** IQX_WEBEST-268 */}
            {isBendingTimeFactor ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBendingTimeFactor ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_BendingTimeFactor
              detailsData={detailsProcess}
              processName={workType}
              editMode={editMode}
              // length={length}
              updatedLength={updateBendTimeCoeffLenThMaster}
              // weight={weight}
              updatedWeight={updateBendTimeCoeffWeightThMaster}
              // 曲げ長さ係数リスト
              // bendingTimeFactorLst={bendingCorrectionTimeFactorListData}
              updatedSizesList={updateBendingCorrectionTimeFactorListData}
              // 曲げ補正時間係数
              // bendingCorrectionTimeFactorLst={bendingTimeFactorListData}
              // updatedbendingCorrectionTimeFactorLst={updateBendingTimeFactorListData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 曲げ補正時間
  const bendingCorrectionTimeContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={mageHoseiJikan}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>{workType === WorkType.SmBending ? '加工補正時間' : '補正時間'}</label>
            {isMageHoseiJikan ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isMageHoseiJikan ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_BendingCorrectionTime
              editMode={editMode}
              detailsData={detailsProcess}
              processName={workType}
              // honSuu={honSuu}
              updateHonsuu={updateModifyTimeQtyThMaster}
              // honsuuList={iq3BendingHonsuuList}
              updateHonsuuList={updateModifyTimeItems}
              // updatedSeisanKosuuList={updateKosuuList}
              //追加
              // processName={getWorkTypeName(workType)}
              // length={length}
              updatedLength={updateModifyCoeffLenThMaster}
              // weight={weight}
              updatedWeight={updateModifyCoeffWeightThMaster}
              updatedWorkWeight={updateMtWeightThMaster}
              // 曲げ補正リスト
              // bendingTimeFactorLst={bendingTimeFactorListData}
              updatedSizesList={updateModifyCoeffItems}
              // 補正リスト
              // area={iq3AreaMaster}
              updatedArea={updateMtAreaThMaster}
              // correctionTimeFactorListData={correctionTimeFactorListData}
              updatedworkCorrectionTimeListData={updatedworkCorrectionTimeListData}
              // 製品重量係数
              iq3SeihinSizeLst={iq3ProductSizeListData}
              updatediq3ProductSizesList={updateIQ3ProductSizeListData}
              // マテリアルハンドリング時間
              materialHandlingTimeList={materialHandlingTimeList}
              updateMaterialHandlingList={updateMaterialHandlingList}
              listData={iq3KakouJikanListData}
              updatedIQ3KakouJikanList={updateIQ3KakouJikanList}
              kosuu={kosuu}
              updatedKosuu={updateKosuu}
              iq3BendingKosuuList={iq3BendingKosuuList}
              updateIQ3BendingKosuuList={updateIQ3BendingKosuuList}
              seisanKosuuList={kosuuList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 曲げ補正時間係数
  const bendingCorrectionTimeFactorContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={mageHoseiJikanFactor}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>
              {/* 2次加工、バリ取 */}
              {workType === WorkType.SmSecondaryWork ||
              workType === WorkType.SmDeburringAuto ||
              workType === WorkType.SmDeburringManual
                ? '補正時間係数'
                : '曲げ補正時間係数'}
            </label>
            {isMageHoseiJikanFactor ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isMageHoseiJikanFactor ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_BendingCorrectionTimeFactor
              processName={getWorkTypeName(workType)}
              editMode={editMode}
              area={iq3AreaMaster}
              updatedArea={updateBendingTimeArea}
              length={length}
              updatedLength={updateBendingTimeLength}
              weight={weight}
              updatedWeight={updateProductSizeWeight}
              // 曲げ補正リスト
              bendingTimeFactorLst={bendingTimeFactorListData}
              updatedSizesList={updateBendingTimeFactorListData}
              // 補正リスト
              correctionTimeFactorListData={correctionTimeFactorListData}
              updatedcorrectionTimeFactorListData={updatecorrectionTimeFactorListData}
              // 製品重量係数
              iq3SeihinSizeLst={iq3ProductSizeListData}
              updatediq3ProductSizesList={updateIQ3ProductSizeListData}
              // マテリアルハンドリング時間
              materialHandlingTimeList={materialHandlingTimeList}
              updateMaterialHandlingList={updateMaterialHandlingList}
              listData={iq3KakouJikanListData}
              updatedIQ3KakouJikanList={updateIQ3KakouJikanList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 製品重量係数
  const productSizeFactorContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={processSizeFactor}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>
              {workType === WorkType.SmWelding || workType === WorkType.SmWeldFinish ? '製品サイズ係数' : 'サイズ係数'}
            </label>
            {isProcessSizeFactor ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isProcessSizeFactor ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_ProductSize
              detailsData={detailsProcess}
              editMode={editMode}
              // area={iq3AreaMaster}
              updatedArea={updateProdSizeAreaThMaster}
              // weight={weight}
              updatedWeight={updateProdSizeWeightThMaster}
              // iq3SeihinSizeLst={iq3ProductSizeListData}
              // updatediq3ProductSizesList={updateIQ3ProductSizeListData}
              updatediq3ProductSizesList={updateProdSizeItems}
              // 補正時間係数
              bendingTimeFactorLst={bendingTimeFactorListData}
              updatedSizesList={updateBendingTimeFactorListData}
              // bendingTimeFactorLst={correctionTimeFactorListData}
              // updatedSizesList={updatecorrectionTimeFactorListData}
              // 段取設定の曲げ係数
              correctionTimeFactorListData={correctionTimeFactorListData}
              updatedcorrectionTimeFactorListData={updatecorrectionTimeFactorListData}
              // マテリアルハンドリング時間
              materialHandlingTimeList={materialHandlingTimeList}
              updateMaterialHandlingList={updateMaterialHandlingList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 加工速度
  const machineSpeedContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={processSpeed}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工速度(mm/min)</label>
            {isProcessSpeed ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isProcessSpeed ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <MachineSpeed
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              // 工程タイプ
              processName={workType}
              // 工程マスタ種類
              processTypes={processTypesList}
              editMode={editMode}
              //　線長マスター更新
              detailsWeldLine={detailsWeldLine}
              updatedYousetsuSenchou={updatedYousetsuSenchouData}
              //溶接
              weldLineLst={yousetsuWeldLineList}
              updatedYousetsuSenchouList={updateYousetsuSenchouList}
              // 溶接仕上
              // senchouList={kakouSokudoSenchouList}
              updatedSenchouList={updateKakousokudoSenchouList}
              // detailsSenchou={detailsWeldLine}
              // updatedItaatsu={upadateKaritsukiItaatsuData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 作業速度
  const sagyouSokudoContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={sagyouSokudo}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工設定</label>
            {isSagyouSokudo ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isSagyouSokudo ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Row style={{ marginLeft: 10 }} className="chargeAmount">
              <Col style={{ width: '20%' }}>
                <RTable>
                  <thead>
                    <tr style={{ textAlign: 'center' }}>
                      <td className="param-tbl-header">作業時間（x要素数）</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>
                        <Row align="middle">
                          {!editMode ? (
                            <>
                              <Col span={24}>
                                <label>{secondsToHms(sagyouTime)}</label>
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col>
                                <TimeInputParameterScreen
                                  value={secondsToHms(sagyouTime)}
                                  onBlur={(e) => {
                                    setSagyouTime(setTimetoSec(e.target.value));
                                  }}
                                  onKeyPress={(e) => {
                                    handleKeyPress(e, false);
                                  }}
                                />
                              </Col>
                              {/* 2025-05-16 パラメータで複合機の二工程穴加工時間を編集する際に、
                              画面の横幅を狭くすると▲▼が2段になってしまう。
                              ▲▼が存在する部分は全てこの現象が起きると思う。
                              可能であれば画面の横幅の変更によって2段に別れたりしないようにしてほしい */}
                              <Col flex="1 1 auto">
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: 1,
                                    overflow: 'hidden',
                                  }}
                                >
                                  {[
                                    ['10min', 'up'],
                                    ['10min', 'down'],
                                    ['min', 'up'],
                                    ['min', 'down'],
                                    ['sec', 'up'],
                                    ['sec', 'down'],
                                  ].map(([unit, dir], i) => {
                                    const Icon = dir === 'up' ? CaretUpOutlined : CaretDownOutlined;
                                    return (
                                      <Icon
                                        key={i}
                                        style={{
                                          fontSize: 'clamp(12px, 1.4vw, 16px)',
                                          color: '#000',
                                          pointerEvents: editMode ? 'auto' : 'none',
                                          flexShrink: 0,
                                        }}
                                        onClick={() => {
                                          const fn = dir === 'up' ? souchiHandleIncreaseTime : souchiHandleDecreaseTime;
                                          const editedTime = fn(secondsToHms(sagyouTime), unit);
                                          setSagyouTime(setTimetoSec(editedTime));
                                        }}
                                      />
                                    );
                                  })}
                                </div>
                              </Col>
                            </>
                          )}
                        </Row>
                      </td>
                    </tr>
                  </tbody>
                </RTable>
              </Col>
            </Row>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 作業係数など
  const sagyouKeisuuContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={sagyouKeisuu}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>係数・その他 </label>
            {isSagyouKeisuu ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isSagyouKeisuu ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Sagyoukeisuu
              editMode={editMode}
              processType={workType}
              detailsData={detailsProcess}
              yousosuuMasterData={yousosuuData}
              updatedYousosuuMasterData={updateYousosuu}
              sagyouKeisuuYousosuuList={sagyouKeisuuYousosuuList}
              updatedYousosuuList={updateYousosuuListData}
              // 要素数により、リスト更新
              shokidankaiYousosuuList={shokiDankaiJikanList}
              updatedShokidankaiYousosuuList={updateshokiDankaiJikanListData}
              kensaJikanKeisuuList={kensaJikanKeisuuList}
              updateKensaJikanKeisuuList={updateKensaJikanKeisuuList}
              // 同一サイズ、同一形状をパターン化する
              programSameSizePatternValue={programSameSizePatternValue}
              updatedProgramSameSizePatternValue={updateProgramSameSizePatternValue}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // iq3段取時間
  const iq3DantoriJikanContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={iq3DantoriJikan}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>段取時間</label>
            {isiq3DantoriJikan ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
            <label style={{ marginLeft: 10 }}>(分)</label>
          </div>
        </Col>
      </Row>
      <div style={{ display: isiq3DantoriJikan ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_DantoriJikan
              editMode={editMode}
              kosuu={seisanKosuu}
              updatedKosuu={updateSeisanKosuu}
              kosuuList={seisanKosuuList}
              updatedKosuuList={updateiq3KosuuList}
              // 基本段取時間
              dantoriTime={kihonDantori}
              updatedDantoriTime={updateDantoriTime}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // iq3作業・加工時間
  const iq3KakouJikanContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={iq3KakouJikan}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>{workType === WorkType.SmShearing ? '作業・加工時間' : '加工時間'}</label>
            {isiq3KakouJikan ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isiq3KakouJikan ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_KakouJikan
              detailsData={detailsProcess}
              editMode={editMode}
              processType={workType}
              processMstRecord={processMstRecord}
              materialTypes={materialTypes}
              // area={iq3AreaMaster}
              updatedArea={updateAreaThMaster}
              // listData={iq3KakouJikanListData}
              updatedIQ3KakouJikanList={updateWorkTimeThItems}
              // processName={getWorkTypeName(workType)}
              area={iq3AreaMaster}
              // updatedArea={updateIQ3AreaMaster}
              listData={iq3KakouJikanListData}
              // updatedIQ3KakouJikanList={updateIQ3KakouJikanList}
              // 補正リスト
              // correctionTimeFactorListData={correctionTimeFactorListData}
              // updatedcorrectionTimeFactorListData={updatecorrectionTimeFactorListData}
              // 二次加工
              iq3SizeMaster={iq3SizeMaster}
              updatediq3SizeMaster={updatediq3SizeMaster}
              iq3KaniListData={iq3KaniListData}
              updatediq3KaniListData={updatediq3KaniListData}
              iq3KaniAnaListData={iq3KaniAnaListData}
              mmMaster={mmMaster}
              updateSizeMmMaster={updateSizeMmMaster}
              updateiq3KaniAnaListData={updateiq3KaniAnaListData}
              itaatsu1={itaatsu1}
              updatedSizeItaatsu={updateSizeItaatsu}
              updatedMmItaatsu={updateMmItaatsu}
              // zaishitsu={zaishitsu}
              shirringflag={shirringflag}
              updateShirringFlag={updateShirringFlag}
              updateCutTime={updateCutTime}
              cutTime={cutTime}
              selectedRowData={props.selectedData}
              updateIsUsedEasyWorkSpeedVal={updateIsUsedEasyWorkSpeedVal}
              updateMmMultiProcHole={updateMmMultiProcHole}
              updateiq3KaniMultiProcAnaListData={updateiq3KaniMultiProcAnaListData}
              updateSizeMmMultiProcHoleMaster={updateSizeMmMultiProcHoleMaster}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランク加工速度
  const BlankKakouSokudoContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={blankKakouSokudo}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工速度(mm/min)</label>
            {isBlankKakouSokudo ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankKakouSokudo ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_Kakousokudo
              editMode={editMode}
              processName={workType}
              detailsData={detailsProcess}
              materialTypes={materialTypes}
              // itaatsu={iq3ItaatsuMaster}
              updatedItaatsu={updateWorkSpeedThickThMaster}
              // blankKakousokudolistData={blankKakousokudolistData}
              updatedBlankKakousokudolistData={updatedWorkSpeedItems}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}
              // // 1ピアス加工時間
              // piercingProcessList={piercingProcessItaatsuListData}
              // updatePiercingProcessList={updatePiercingProcessList}
              // // ガス種類
              // gasTypeList={gasTypeListData}
              // updatedGasTypeList={updateGasTypeList}
              // // ジョイント
              // jointItaatsuList={jointItaatsuListData}
              // updatedJointItaatsuList={updateJointItaatsuList}
              // // 加工速度係数
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              // updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              okuriSokudoVal={okuriSokudoVal}
              updateOkuriSokudoVal={updateOkuriSokudoVal}
              kegakiSokudoVal={kegakiSokudoVal}
              updateKegakiSokudoVal={updateKegakiSokudoVal}
              selectedRowData={props.selectedData}
              updateIsUsedEasyWorkSpeedVal={updateIsUsedEasyWorkSpeedVal}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランク加工速度係数
  const BlankKakouSokudoKeisuuContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={blankKakouSokudoKeisuu}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工速度係数</label>
            {isBlankKakouSokudoKeisuu ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankKakouSokudoKeisuu ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_KakouSokudoKeisuu
              editMode={editMode}
              detailsData={detailsProcess}
              // itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateWorkSpeedCoeffThickThMaster}
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              updateWorkSpeedCoeffInternalWorkItems={updateWorkSpeedCoeffInternalWorkItems}
              updateWorkSpeedCoeffExternalWorkItems={updateWorkSpeedCoeffExternalWorkItems}
              // // ジョイント
              // jointItaatsuList={jointItaatsuListData}
              // updatedJointItaatsuList={updateJointItaatsuList}
              // // ガス種類
              // gasTypeList={gasTypeListData}
              // updatedGasTypeList={updateGasTypeList}
              // // 1ピアス加工時間
              // piercingProcessList={piercingProcessItaatsuListData}
              // updatePiercingProcessList={updatePiercingProcessList}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}
              // // 加工速度
              // blankKakousokudolistData={blankKakousokudolistData}
              // updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
              // // 手動バリの加工速度
              // shudobariKakousokudoList={shudobariKakousokudoList}
              // updateShudobariKakousokudoList={updateShudobariKakousokudoList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランクガス係数
  const BlankGasuKeisuuContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={blankGasuKeisuu}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>ガス係数・ガス種類</label>
            {isBlankGasuKeisuu ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankGasuKeisuu ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_GasKeisuu
              editMode={editMode}
              detailsData={detailsProcess}
              materialTypes={materialTypes}
              // gasTypeData={gasTypeMaster}
              updatedGasType={updateGasCoeffThMaster}
              // gasKeisuuList={gasKeisuuList}
              updateGasKeisuuList={updateGasCoeffListItems}
              // ガス種類
              // itaatsuData={iq3ItaatsuMaster}
              updateGasCoeffThickThMaster={updateGasCoeffThickThMaster}
              // gasTypeList={gasTypeListData}
              updateGasCoeffThItems={updateGasCoeffThItems}
              // // ジョイント
              // jointItaatsuList={jointItaatsuListData}
              // updatedJointItaatsuList={updateJointItaatsuList}
              // // 加工速度係数
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              // updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              // // 1ピアス加工時間
              // piercingProcessList={piercingProcessItaatsuListData}
              // updatePiercingProcessList={updatePiercingProcessList}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}
              // // 加工速度
              // blankKakousokudolistData={blankKakousokudolistData}
              // updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
            />
            {/* <Device_Blank_GasType
              editMode={editMode}
              itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateIQ3Itaatsu}
              gasTypeList={gasTypeListData}
              updatedGasTypeList={updateGasTypeList}
              // ジョイント
              jointItaatsuList={jointItaatsuListData}
              updatedJointItaatsuList={updateJointItaatsuList}
              // 加工速度係数
              kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              // 1ピアス加工時間
              piercingProcessList={piercingProcessItaatsuListData}
              updatePiercingProcessList={updatePiercingProcessList}
              // 1パンチ加工時間
              punchProcessItaatsuListData={punchProcessItaatsuListData}
              updatePunchProcessList={updatePunchProcessList}
              // 加工速度
              blankKakousokudolistData={blankKakousokudolistData}
              updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
            /> */}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランク外形追抜条件
  const extractConditionContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={extractCondition}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>追抜き条件</label>
            {isExtractCondition ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isExtractCondition ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_ExtractCondition
              editMode={editMode}
              detailsData={detailsProcess}
              // retainedMold={retainedMoldMaster}
              updatedRetainedMold={updatedRetainedMold}
              // extractConditionList={extractConditionList}
              updateExtractConditionList={updateExtractConditionList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランクガス種類
  const BlankGasuTypeContent = (
    <>
      <Row style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={blankGasuType}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>ガス種類</label>
            {isBlankGasuType ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankGasuType ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_GasType
              editMode={editMode}
              itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateIQ3Itaatsu}
              gasTypeList={gasTypeListData}
              updatedGasTypeList={updateGasTypeList}
              // ジョイント
              jointItaatsuList={jointItaatsuListData}
              updatedJointItaatsuList={updateJointItaatsuList}
              // 加工速度係数
              kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              // 1ピアス加工時間
              piercingProcessList={piercingProcessItaatsuListData}
              updatePiercingProcessList={updatePiercingProcessList}
              // 1パンチ加工時間
              punchProcessItaatsuListData={punchProcessItaatsuListData}
              updatePunchProcessList={updatePunchProcessList}
              // 加工速度
              blankKakousokudolistData={blankKakousokudolistData}
              updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランク2工程穴加工時間
  const BlankDrillingTimeContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={blankDrillingTime}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>2工程穴加工時間</label>
            {isBlankDrillingTime ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankDrillingTime ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_DrillingTime
              editMode={editMode}
              // drillingTime={drillingTime}
              detailsData={detailsProcess}
              updateDrillingTime={updateDrillingTime}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランク送り速度
  const okuriSokudoContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={okuriSokudo}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>送り速度(mm/min)</label>
            {isOkuriSokudo ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isOkuriSokudo ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_OkuriSokudo
              editMode={editMode}
              // forwardSpeed={forwardSpeed}
              detailsData={detailsProcess}
              updateForwardSpeed={updateForwardSpeed}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ローラー/ホイール/ケガキ金型　加工速度
  const rollerKakouSokudoContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={rollerKakouSokudo}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>ローラー/ホイール/ケガキ金型　加工速度(mm/sec)</label>
            {isRollerKakouSokudo ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isRollerKakouSokudo ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_RollerSpeed
              editMode={editMode}
              // rollerSpeed={rollerSpeed}
              detailsData={detailsProcess}
              updateRollerSpeed={updateRollerSpeed}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // ブランクジョイント
  const BlankJointContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={blankJoint}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>ジョイントバラシ(秒)</label> {/** IQX_WEBEST-264 */}
            {isBlankJoint ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isBlankJoint ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_Blank_Joint
              editMode={editMode}
              materialTypes={materialTypes}
              detailsData={detailsProcess}
              // itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateJointSeparateThickThMaster}
              // jointItaatsuList={jointItaatsuListData}
              updatedJointItaatsuList={updateJointSeparateItems}
              // サイズc
              // jointSizeMaster={jointSizeMaster}
              updateJointQtySizeThMaster={updateJointQtySizeThMaster}
              // jointSizeList={jointSizeList}
              updateJointQtyItems={updateJointQtyItems}
              // // ガス種類
              // gasTypeList={gasTypeListData}
              // updatedGasTypeList={updateGasTypeList}
              // // 加工速度係数
              // kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              // updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
              // // 1ピアス加工時間
              // piercingProcessList={piercingProcessItaatsuListData}
              // updatePiercingProcessList={updatePiercingProcessList}

              // // 加工速度
              // blankKakousokudolistData={blankKakousokudolistData}
              // updatedBlankKakousokudolistData={updatedBlankKakousokudolistData}
              // // 1パンチ加工時間
              // punchProcessItaatsuListData={punchProcessItaatsuListData}
              // updatePunchProcessList={updatePunchProcessList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // iq3加工速度
  const iq3KakousokudoContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={iq3KakouSokudo}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工速度(mm/min)</label>
            {isiq3KakouSokudo ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isiq3KakouSokudo ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_KakouSokudo
              editMode={editMode}
              detailsData={detailsProcess}
              // 手動バリの加工速度
              // itaatsuData={iq3ItaatsuMaster}
              updatedItaatsuData={updateWorkSpeedThickThMaster}
              // iq3kakouchou={iq3kakouchou}
              updateWorkSpeedLenThMaster={updateWorkSpeedLenThMaster}
              // shudobariKakousokudoList={shudobariKakousokudoList}
              updateShudobariKakousokudoList={updateWorkSpeedItems}
              // 加工速度係数
              kakouSokudoItaatsuList={blankKakouSokudoItaatsuList}
              updateblankKakouSokudoItaatsuList={updateblankKakouSokudoItaatsuList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // iq3手動バリ取対象サイズ
  const iq3ManualBariContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={iq3ManualBari}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>手動バリ取対象サイズ</label>
            {isiq3ManualBari ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isiq3ManualBari ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_ManualBari
              editMode={editMode}
              detailsData={detailsProcess}
              updateRoundHoleDia={updateRoundHoleDia}
              updateRectangleDia={updateRectangleDia}
              updateRectangleBariOnFlg={updateRectangleBariOnFlg}
              // naikei_min={naikei_min}
              // updateNaikeiMin={updateNaikeiMin}
              // naikei_max={naikei_max}
              // updateNaikeiMax={updateNaikeiMax}
              // ana_max={ana_max}
              // updateAnaMax={updateAnaMax}
              // ana_min={ana_min}
              // updateAnaMin={updateAnaMin}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 仮付時間
  const karitsukiTimeContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={attach}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>仮付時間</label>
            {isAttach ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isAttach ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <KaritsukiTime
              editMode={editMode}
              // 工程マスタ種類
              processTypes={processTypesList}
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              // detailsItaatsu={karitsukiTimeItaatsuMasterData}
              updatedItaatsu={upadateKaritsukiItaatsuData}
              // listData={karitsukiTimeItaatsuList}
              updatedListData={updateKaritsukiTimeList}
              // 板厚データにより、取付き時間の板厚リスト更新
              // itaatsuList={toritsukiTimeItaatsuList}
              // updatedItaatsuList={updateToritsukiItaatsuList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 溶接仕上（加工時間）IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい
  const yosetsuFinishKakoujikanContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={kakouJikan}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>加工時間</label>
            {isKakouJikan ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isKakouJikan ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <div className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
              <RTable
                style={{
                  width: '196px',
                }}
              >
                {detailsProcess?.kakouTimeItems
                  ?.filter((item) => filterKeys?.includes(parseInt(item.kouteiTypeId)))
                  ?.map((key) => (
                    <tr key={key.kouteiTypeId} style={{ textAlign: 'center' }}>
                      <td style={{ color: 'white', width: '196px' }} className="param-tbl-header fixedCol">
                        {processTypesList?.find((item) => item.id === key.kouteiTypeId)?.name}
                      </td>
                      <td>
                        <ToritsukiJikan_Itaatsu
                          editMode={editMode}
                          processTypes={itaatsuKouteiTypeList}
                          detailsData={key}
                          processMstRecord={weldProcessMst}
                          updatedItaatsu={updateKakouTimeInstThickThMaster}
                          updatedListData={updateKakouTimeInstThickThItems}
                          isYosetsuFinish={true}
                        />
                        <ToritsukiJikan_Size
                          editMode={editMode}
                          processTypes={sizeKouteiTypeList}
                          detailsData={key}
                          processMstRecord={weldProcessMst}
                          updatedSize={updateKakouTimeInstSizeThMaster}
                          updatedSizeList={updateKakouTimeInstSizeThItems}
                          isYosetsuFinish={true}
                        />
                      </td>
                    </tr>
                  ))}
              </RTable>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 取付＿板厚
  const toritsukiTimeItaatsuContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={toritsukiJikanItaatsu}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>取付時間(板厚判断)</label>
            {isToritsukiJikanItaatsu ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isToritsukiJikanItaatsu ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <div className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
              <Row>
                <ToritsukiJikan_Itaatsu
                  editMode={editMode}
                  // 工程マスタ種類
                  processTypes={processTypesList}
                  detailsData={detailsProcess}
                  processMstRecord={processMstRecord}
                  updatedItaatsu={updateInstThickThMaster}
                  updatedListData={updateInstThickThItems}
                />
              </Row>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 取付＿サイズ
  const toritsukiTimeSizeContent = (
    <>
      <Row
        align="middle"
        style={{ color: 'black' }}
        className="oyabuhin-param oyabuhin-row"
        onClick={toritsukiJikanSize}
      >
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>取付時間(サイズ判断)</label>
            {isToritsukiJikanSize ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isToritsukiJikanSize ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <div className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
              <Row>
                <ToritsukiJikan_Size
                  editMode={editMode}
                  processTypes={processTypesList}
                  detailsData={detailsProcess}
                  processMstRecord={processMstRecord}
                  updatedSize={updateInstSizeThMaster}
                  updatedSizeList={updateInstSizeThItems}
                />
              </Row>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 溶接難易度
  const yousetsuDifficultyContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={welding}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>溶接難易度</label>
            {isWelding ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isWelding ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <YousetsuDifficulty
              editMode={editMode}
              updatedItaatsu={updateWeldDifficultyCoeffThMaster}
              updatedListData={updatedWeldDifficultyCoeffThItems}
              detailsData={detailsProcess}
              materialTypes={materialTypes}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // タップ溶接
  const tappuYousetsuContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={tapWelding}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>タップ溶接(%/辺)</label>
            {isTapWelding ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isTapWelding ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <TapWelding
              editMode={editMode}
              detailsData={detailsProcess}
              materialTypes={materialTypes}
              updatedItaatsu={updateTapRateThMaster}
              updatedItaatsuList={updateTapRateThItems}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 点付、仮付ピッチ
  const pitchContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={pitch}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>点付、仮付ピッチ(mm/辺)</label>
            {isPitch ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isPitch ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Pitch
              editMode={editMode}
              updatedItaatsu={updateSpotPitchThMaster}
              updatedItaatsuList={updateSpotPitchThItems}
              detailsData={detailsProcess}
              // 材質区分データ
              materialTypes={materialTypes}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );

  // 製品重量係数
  const productSizeContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={productSize}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>重量係数</label>
            {isProductSize ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isProductSize ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            {/* 重量係数 */}
            <ProductSize
              detailsData={detailsProcess}
              editMode={editMode}
              // kosuu={kosuu}
              updatedMstJuuryouData={updateProductWeightCoeffMst}
              updatedJuuryouList={updateProductWeightCoeffList}
              // weight={weight}
              // updatedWeight={updateProductSizeWeight}
              // sizeList={sizesDetailsList}
              // updatedSizesList={updateKosuuList}
              // dantoriSizeList={dantoriSizeDetailsList}
              // updatedDantoriSizeList={updateDantoriSizeList}
              // 生産個数係数リスト更新
              // kosuuList={kosuuList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 生産個数係数
  const quantityContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={productQuantity}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>生産個数係数</label>
            {isProductQuantity ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isProductQuantity ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Quantity
              detailsData={detailsProcess}
              editMode={editMode}
              // kosuu={kosuu}
              updatedKosuu={updateProductionQtyCoeffMst}
              // kosuuList={kosuuList}
              updatedKosuuList={updateProductionQtyCoeffList}
              // ２次加工の補正時間
              // jikankosuuList={iq3BendingHonsuuList}
              // updatedJikanKosuuList={updateiq3BendingHonsuuList}
              // 重量係数
              // sizeList={sizesDetailsList}
              // updatedSizesList={updateProductSizeList}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );

  // 作業・加工時間
  const childPartContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={childPart}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>作業・加工時間</label>
            {isChildPart ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isChildPart ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Row className="chargeAmount" style={{ marginLeft: 10, marginRight: 10 }}>
              <RTable style={{ width: '20%' }}>
                <thead>
                  <tr style={{ textAlign: 'center' }}>
                    <td className="param-tbl-header">1検査時間 </td>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ textAlign: 'center', height: 35 }}>
                    <td>
                      <Row style={{ textAlign: 'center' }} align="middle">
                        {!editMode ? (
                          <>
                            <Col span={24}>
                              <label>{secondsToHms(processTimeByUnit)}</label>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col span={10}>
                              <TimeInputParameterScreen
                                value={secondsToHms(processTimeByUnit)}
                                onBlur={(event) => changeTime(event.target.value)}
                              />
                            </Col>
                            {/* 2025-05-21 パラメータで複合機の二工程穴加工時間を編集する際に、
                                画面の横幅を狭くすると▲▼が2段になってしまう。
                                ▲▼が存在する部分は全てこの現象が起きると思う。
                                可能であれば画面の横幅の変更によって2段に別れたりしないようにしてほしい */}
                            <Col flex="1 1 auto">
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'nowrap',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  gap: 1,
                                  overflow: 'hidden',
                                }}
                              >
                                {[
                                  ['10min', 'up'],
                                  ['10min', 'down'],
                                  ['min', 'up'],
                                  ['min', 'down'],
                                  ['sec', 'up'],
                                  ['sec', 'down'],
                                ].map(([unit, dir], i) => {
                                  const Icon = dir === 'up' ? CaretUpOutlined : CaretDownOutlined;
                                  return (
                                    <Icon
                                      key={i}
                                      style={{
                                        fontSize: 'clamp(12px, 1.4vw, 16px)',
                                        color: '#000',
                                        pointerEvents: editMode ? 'auto' : 'none',
                                        flexShrink: 0,
                                      }}
                                      onClick={() => {
                                        const fn = dir === 'up' ? souchiHandleIncreaseTime : souchiHandleDecreaseTime;
                                        const editedTime = fn(secondsToHms(processTimeByUnit), unit);
                                        changeTime(editedTime);
                                      }}
                                    />
                                  );
                                })}
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                    </td>
                  </tr>
                </tbody>
              </RTable>
            </Row>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
  // 難易度係数
  const difficultyFactorContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={difficultyFactor}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>難易度係数</label>
            {isDifficultyFactor ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isDifficultyFactor ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_YousetsuShiage_DifficultyFactor
              detailsData={detailsProcess}
              materialTypes={materialTypes}
              editMode={editMode}
              updateDiffFactorCoeff={updateDiffFactorCoeff}
            />
          </>
        ) : (
          <></>
        )}{' '}
      </div>
    </>
  );
  // 仕上有無　IQX_WEBEST-271 パラメータに現状持っている「仕上げ有無」（溶接種類ごとのチェックボックス）を取り除く。
  const shiageFlagContent = (
    <>
      <Row align="middle" style={{ color: 'black' }} className="oyabuhin-param oyabuhin-row" onClick={shiageFlag}>
        <Col span={20} className="deli-col-param">
          <div style={{ display: 'flex' }}>
            <label style={{ marginRight: 5 }}>仕上有無</label>
            {isShiageFlag ? (
              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
            ) : (
              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
            )}
          </div>
        </Col>
      </Row>
      <div style={{ display: isShiageFlag ? 'block' : 'none' }}>
        {selectedDeviceData?.length != 0 ? (
          <>
            <Device_ShiageFlag
              detailsData={detailsProcess}
              processMstRecord={processMstRecord}
              yousetsuTypes={yousetsuTypes}
              editMode={editMode}
              // shiageFlagList={shiageFlagList}
              updateShiageFlagList={updateShiageFlagList}
            />
          </>
        ) : (
          <></>
        )}{' '}
      </div>
    </>
  );

  // 形鋼の加工部分
  const iq5ProcessingTimeContent = (
    <>
      <IQ5_Device_ProcessTime
        editMode={editMode}
        detailsData={detailsProcess}
        materialTypes={materialTypes}
        updatePiercingTimeThickThMaster={updatePiercingTimeThickThMaster}
        updatePiercingTimeThItems={updatePiercingTimeThItems}
        processMstRecord={processMstRecord}
        steelShapeData={props?.steelShapeData}
        updatedProcessingShapeCoeff={updatedProcessingShapeCoeff}
        updatedMachiningMaterialCoeff={updatedMachiningMaterialCoeff}
        updatedSingleProcessTimeSec={updatedSingleProcessTimeSec}
        updatedKgProcessingTimeThMaster={updatedKgProcessingTimeThMaster}
        updatedKgProcessingTimeThItems={updatedKgProcessingTimeThItems}
        updatedAreaProcessingTimeThMaster={updatedAreaProcessingTimeThMaster}
        updatedAreaProcessingTimeThItems={updatedAreaProcessingTimeThItems}
        updatedSizeProcessingTimeThMaster={updatedSizeProcessingTimeThMaster}
        updatedSizeProcessingTimeThItems={updatedSizeProcessingTimeThItems}
        updatedProcessingSpeedThMaster={updatedProcessingSpeedThMaster}
        updatedProcessingSpeedThItems={updatedProcessingSpeedThItems}
        updatedProcessingWeightCoeffThMaster={updatedProcessingWeightCoeffThMaster}
        updatedProcessingWeightCoeffThItems={updatedProcessingWeightCoeffThItems}
        updatedT1SizeCoeffThMaster={updatedT1SizeCoeffThMaster}
        updatedT1SizeCoeffThItems={updatedT1SizeCoeffThItems}
        updatedASizeCoeffThMaster={updatedASizeCoeffThMaster}
        updatedASizeCoeffThItems={updatedASizeCoeffThItems}
        updatedBSizeCoeffThMaster={updatedBSizeCoeffThMaster}
        updatedBSizeCoeffThItems={updatedBSizeCoeffThItems}
        updatedCSizeCoeffThMaster={updatedCSizeCoeffThMaster}
        updatedCSizeCoeffThItems={updatedCSizeCoeffThItems}
        updateProductionQtyCoeffMst={updateProductionQtyCoeffMst}
        updateProductionQtyCoeffList={updateProductionQtyCoeffList}
        updatedTempInstProcessTimeSec={updatedTempInstProcessTimeSec}
        updatedDisposal={updatedDisposal}
        updatedBladeWidth={updatedBladeWidth}
        updatedSingleProcessTimeSecDec={updatedSingleProcessTimeSecDec}
        updatedProcessingSpeedMinThMaster={updatedProcessingSpeedMinThMaster}
        updatedProcessingSpeedMinThItems={updatedProcessingSpeedMinThItems}
        isIq5ProcessSetting={isIq5ProcessSetting}
        iq5WorkType={workType}
        updatedRSizeCoeffThMaster={updatedRSizeCoeffThMaster}
        updatedRSizeCoeffThItems={updatedRSizeCoeffThItems}
      />
    </>
  );

  // 形鋼の表示設定
  const iq5DisplaySettingContent = (
    <>
      <IQ5_Device_DisplaySetting
        editMode={editMode}
        detailsData={detailsProcess}
        updatedIQ5ManufactSizeInfo={updatedIQ5ManufactSizeInfo}
        updatedInitialDisplay={updatedInitialDisplay}
        isIq5DisplaySetting={isIq5DisplaySetting}
        iq5WorkType={workType}
      />
    </>
  );

  // 工程種類により、Propertiesの情報を判断する
  const content =
    // 溶接の場合、
    workType === WorkType.PaWelding || workType === WorkType.SmWelding ? (
      <>
        <div>
          {chargeAmountContent}
          {dantoriSettingContent}
          {/* {types === '親部品' ? '' : materialHandlingContent} */}
          {machineSpeedContent}
          {karitsukiTimeContent}
          {toritsukiTimeItaatsuContent}
          {toritsukiTimeSizeContent}
          {yousetsuDifficultyContent}
          {tappuYousetsuContent}
          {pitchContent}
          {/* iQ3 */}
          {types === ServiceClass.SheetMetal ? (
            <>
              {/* {materialHandlingContent} */}
              {productSizeFactorContent}
              {quantityContent}
              {/* {kouteiNaiKensaContent} */}
            </>
          ) : (
            <>
              {productSizeContent}
              {quantityContent}
            </>
          )}
        </div>
      </>
    ) : workType === WorkType.PaWeldFinish || workType === WorkType.SmWeldFinish ? (
      // 溶接仕上の場合、
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {/* iQ3 */}
        {types === ServiceClass.SheetMetal ? (
          <>
            {machineSpeedContent}
            {/* {yosetsuFinishKakoujikanContent} */}
            {/*IQX_WEBEST-271 サブ溶接にも溶接仕上を出来るようにしてほしい*/}
            {/* {difficultyFactorContent} */}
            {/** IQX_WEBEST-271 パラメータに現状持っている「仕上げ有無」（溶接種類ごとのチェックボックス）を取り除く。 */}
            {/* {shiageFlagContent} */}
            {/*  {materialHandlingContent} */}
            {productSizeFactorContent}
            {quantityContent}
            {/* {kouteiNaiKensaContent} */}
          </>
        ) : (
          <>
            {machineSpeedContent}
            {productSizeContent}
            {quantityContent}
          </>
        )}
      </div>
    ) : workType === WorkType.PaSurface ? (
      // 表面処理の場合、
      <>
        <div>
          {/* チャージ金額 */}
          {chargeAmountContent}
          {/* 段取設定 */}
          {/* {dantoriSettingContent} */}
          {/*  {types === ServiceClass.SheetMetal ? materialHandlingContent : ''} */}
          {/* 加工時間 */}
          {/* {iq3KakouJikanContent} */}
          {/* 製品重量係数 */}
          {/* {productSizeContent} */}
          {/* 生産個数係数 */}
          {quantityContent}
          {/* iQ3 */}
          {/* {types === ServiceClass.SheetMetal ? kouteiNaiKensaContent : ''} */}
        </div>
      </>
    ) : workType === WorkType.PaAssenble ||
      workType === WorkType.PaInspection ||
      workType === WorkType.PaPacking ||
      workType === WorkType.SmInspection ? (
      // 組立、検査、梱包の場合、
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {/* 親部品 */}
        {types === ServiceClass.Parent &&
        // 組立、検査、梱包の場合、
        (workType === WorkType.PaAssenble || workType === WorkType.PaPacking || workType === WorkType.PaInspection)
          ? sagyouJikanContent
          : childPartContent}
        {/* {childPartContent} */}
        {/* 検査とiQ3 */}
        {/*  {types === ServiceClass.SheetMetal && workType === WorkType.SmInspection ? materialHandlingContent : ''} */}
        {/* 検査とiQ3 */}
        {types === ServiceClass.SheetMetal && workType === WorkType.SmInspection
          ? productSizeFactorContent
          : productSizeContent}
        {/* {difficultyFactorContent} */}
        {quantityContent}
      </div>
    ) : workType === WorkType.SmProgram ? (
      // プログラム
      <>
        <div>
          {chargeAmountContent}
          {dantoriSettingContent}
          {sagyouSokudoContent}
          {/* {sagyouKeisuuContent} */} {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
          {/* {kouteiNaiKensaContent} */}
        </div>
      </>
    ) : workType === WorkType.SmShearing ? (
      // シャーリング
      <>
        <div>
          {chargeAmountContent}
          {dantoriSettingContent}
          {iq3KakouJikanContent}
          {/*  {materialHandlingContent} */}
          {/* {productSizeFactorContent}
          {quantityContent} */}
          {/* {kouteiNaiKensaContent} */}
        </div>
      </>
    ) : workType === WorkType.SmBending ? (
      // ベンディング
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {bendingTimeContent}
        {bendingTimeFactorContent}
        {bendingCorrectionTimeContent}
        {/* {bendingCorrectionTimeFactorContent} */}
        {/* {materialHandlingContent} */}
        {/* {productSizeFactorContent} */}
        {quantityContent}
        {/* {kouteiNaiKensaContent} */}
      </div>
    ) : workType === WorkType.SmSecondaryWork ? (
      // 2次加工
      <>
        <div>
          {chargeAmountContent}
          {dantoriSettingContent}
          {iq3KakouJikanContent}
          {bendingCorrectionTimeContent}
          {/* {bendingCorrectionTimeFactorContent} */}
          {/*  {materialHandlingContent} */}
          {/* {productSizeFactorContent} */}
          {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
          {quantityContent}
          {/* {kouteiNaiKensaContent} */}
        </div>
      </>
    ) : workType === WorkType.SmDeburringAuto ? (
      // 自動バリ
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {iq3KakouJikanContent}
        {/* {bendingCorrectionTimeContent} */} {/** IQX_WEBEST-270 */}
        {/*  {materialHandlingContent} */}
        {/* {productSizeFactorContent} */}
        {quantityContent}
        {/* {kouteiNaiKensaContent} */}
      </div>
    ) : workType === WorkType.SmDeburringManual ? (
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {iq3KakousokudoContent}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {/* {BlankKakouSokudoKeisuuContent}
        {bendingCorrectionTimeContent} */}
        {iq3ManualBariContent}
        {/*  {materialHandlingContent} */}
        {/* {productSizeFactorContent} */}
        {quantityContent}
        {/* {kouteiNaiKensaContent} */}
      </div>
    ) : workType === WorkType.SmBlankPunch ? (
      // ブランク（パンチ）
      <>
        {/* {baritoriTypesContent} */}
        {chargeAmountContent}
        {dantoriSettingContent}
        {materialArrangementContent}
        {punchConditionContent}
        {punchProcessTimeContent}
        {okuriSokudoContent}
        {/* {rollerKakouSokudoContent} */}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {extractConditionContent}
        {/* {productSizeFactorContent} */}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {quantityContent}
        {BlankDrillingTimeContent}
        {BlankJointContent}
        {/* {kouteiNaiKensaContent} */}
      </>
    ) : workType === WorkType.SmBlankCombi ? (
      // ブランク（複合機）
      <>
        {/* {baritoriTypesContent} */}
        {chargeAmountContent}
        {dantoriSettingContent}
        {materialArrangementContent}
        {punchConditionContent}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {punchProcessTimeContent}
        {piercingProcessTimeContent}
        {BlankKakouSokudoContent}
        {BlankKakouSokudoKeisuuContent}
        {BlankGasuKeisuuContent}
        {/* {productSizeFactorContent} */}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {quantityContent}
        {BlankDrillingTimeContent}
        {BlankJointContent}
        {/* {kouteiNaiKensaContent} */}
      </>
    ) : workType === WorkType.SmBlankLaser ? (
      // ブランク（レーザー）
      <>
        {/* {baritoriTypesContent} */}
        {chargeAmountContent}
        {dantoriSettingContent}
        {materialArrangementContent}
        {piercingProcessTimeContent}
        {BlankKakouSokudoContent}
        {BlankKakouSokudoKeisuuContent}
        {BlankGasuKeisuuContent}
        {/* {productSizeFactorContent} */}
        {/* IQX_WEBEST-454 計算式・パラメータを現行に揃えてほしい*/}
        {quantityContent}
        {BlankDrillingTimeContent}
        {BlankJointContent}
        {/* {kouteiNaiKensaContent} */}
      </>
    ) : workType === WorkType.SmSurface ? (
      // 表面処理の場合、
      <>
        <div>
          {/* チャージ金額 */}
          {chargeAmountContent}
          {quantityContent}
        </div>
      </>
    ) : workType === WorkType.PaSteelWeight ||
      workType === WorkType.PaSteelArea ||
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelHole ||
      workType === WorkType.PaSteelCut ? (
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {iq5ProcessingTimeContent}
        {iq5DisplaySettingContent}
      </div>
    ) : (
      <div>
        {chargeAmountContent}
        {dantoriSettingContent}
        {/* {machineSpeedContent}
        {karitsukiTimeContent}

        {toritsukiTimeItaatsuContent}
        {toritsukiTimeSizeContent}
        {yousetsuDifficultyContent}
        {tappuYousetsuContent}
        {pitchContent} */}
        {productSizeContent}
        {quantityContent}
      </div>
    );

  const searchCustomer = () => {
    setCustomerModal(true);
  };
  const getCustomerData = (selectedCustomerData) => {
    setCustomerId(selectedCustomerData.id);
    setCustomerCode(selectedCustomerData.code);
    setCustomerName(selectedCustomerData.name);
    setCustomerModal(false);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setCheckboxChecked(isChecked);
    setSelectDisabled(!isChecked);
  };
  const flagChange = (e) => {
    const isChecked = e.target.checked;
    setFlagChecked(isChecked);
    setInputDisabled(!isChecked);
  };
  const changeAmount = (name, e) => {
    // const regex = /^[0-9,¥]+$/;
    // if (regex.test(e)) {
    //   if (e.startsWith('¥', 0)) {
    //     e = e.replace('¥', '');
    //   }
    //   if (e.indexOf(',') > 0) {
    //     e = e.replace(/,/g, '');
    //   }
    // } else {
    //   e = 0;
    // }
    // if (name === 'dantori') {
    //   setSetupAmount(e);
    // } else if (name === 'kakou') {
    //   setWorkAmount(e);
    // } else {
    //   setIniAmount(e);
    // }
    setIniAmount(e);
  };
  const closeAll = () => {
    props.updatedFlag(false);
    setIsCharge(false);
    setIsSetupSetting(false);
    setIsProcessSpeed(false);
    setIsAttach(false);
    setIsToritsukiJikanItaatsu(false);
    setIsToritsukiJikanSize(false);
    setIsDifficultyFactor(false);
    setIsTapWelding(false);
    setIsPitch(false);
    setIsProductSize(false);
    setIsProductQuantity(false);
    setIsChildPart(false);
    setIsDifficultyFactor(false);
    setIsDantoriJikan(false);
    setIsDeviceDetails(false);
    setIsProcessTime(false);
    setIsWelding(false);
    setIsSagyouSokudo(false);
    setIsSagyouKeisuu(false);
    setIsiq3DantoriJikan(false);
    setIsiq3KakouJikan(false);
    setIsBendingTimeFactor(false);
    setIsMagekakouJikan(false);
    setIsMageHoseiJikanFactor(false);
    setIsMageHoseiJikan(false);
    setIsBaritoriShurui(false);
    setIsiq3KakouSokudo(false);
    setIsiq3ManualBari(false);
    setIsProcessSizeFactor(false);
    setIsKouteiNaikensa(false);
    setIsMaterialHandling(false);
    setIsArrangeMaterial(false);
    setIsPiercingProcess(false);
    setIsBlankKakouSokudo(false);
    setIsBlankKakouSokudoKeisuu(false);
    setIsBlankGasuKeisuu(false);
    setIsBlankGasuType(false);
    setIsBlankJoint(false);
    setIsBlankDrillingTime(false);
    setIsPunch(false);
    setIsOkuriSokudo(false);
    setIsRollerKakouSokudo(false);
    setIsExtractCondition(false);
    setIsPunchProcess(false);
    setIsShiageFlag(false);
    setIsIq5ProcessSetting(false);
    setIsIq5DisplaySetting(false);
  };
  const openAll = () => {
    props.updatedFlag(true);
    setIsCharge(true);
    setIsSetupSetting(true);
    setIsProcessSpeed(true);
    setIsAttach(true);
    setIsToritsukiJikanItaatsu(true);
    setIsToritsukiJikanSize(true);
    setIsDifficultyFactor(true);
    setIsTapWelding(true);
    setIsPitch(true);
    setIsProductSize(true);
    setIsProductQuantity(true);
    setIsChildPart(true);
    setIsDifficultyFactor(true);
    setIsDantoriJikan(true);
    setIsDeviceDetails(true);
    setIsProcessTime(true);
    setIsWelding(true);
    setIsSagyouSokudo(true);
    setIsSagyouKeisuu(true);
    setIsiq3DantoriJikan(true);
    setIsiq3KakouJikan(true);
    setIsBendingTimeFactor(true);
    setIsMagekakouJikan(true);
    setIsMageHoseiJikanFactor(true);
    setIsMageHoseiJikan(true);
    setIsBaritoriShurui(true);
    setIsiq3KakouSokudo(true);
    setIsiq3ManualBari(true);
    setIsProcessSizeFactor(true);
    setIsKouteiNaikensa(true);
    setIsMaterialHandling(true);
    setIsArrangeMaterial(true);
    setIsPiercingProcess(true);
    setIsBlankKakouSokudo(true);
    setIsBlankKakouSokudoKeisuu(true);
    setIsBlankGasuKeisuu(true);
    setIsBlankGasuType(true);
    setIsBlankJoint(true);
    setIsBlankDrillingTime(true);
    setIsPunch(true);
    setIsOkuriSokudo(true);
    setIsRollerKakouSokudo(true);
    setIsExtractCondition(true);
    setIsPunchProcess(true);
    setIsShiageFlag(true);
    setIsIq5ProcessSetting(true);
    setIsIq5DisplaySetting(true);
  };

  const addDetailsModalTitle = (
    <div
      style={{
        width: 1030,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>チャージ金額詳細</p>
    </div>
  );
  const closeModal = (result) => {
    setIsDetails(result);
  };
  const closeAddModal = () => {
    setIsDetails(false);
  };
  const addData = () => {};
  const addContent = (
    <>
      <ChargeDetails editMode={editMode} closeModal={closeModal} />
    </>
  );
  // 追加工程の種類更新
  const changeAdditionalKouteiType = (e) => {
    const option = processTypesList?.find((option) => option.id === e);
    setAdditionalProcessId(option.id);
    setKouteiCode(option.code);
    setKouteiName(option.name);
  };

  // CSVファイルのヘッダー情報
  const getCSVHeaderInfo = () => {
    return (
      'ID,コード,工程名,' +
      (workType === WorkType.PaCustom || workType === WorkType.SmCustom ? 'コード,工程名,' : '') +
      '装置コード,装置名,備考,表示'
    );
  };

  // CSV入力ボタンを押下した場合、
  const onClickCSVImport = () => {
    csvImportRef.current.click();
  };

  // CSV出力ボタンを押下した場合、
  const onClickCSVExport = () => {
    let name = '';
    let data = '';
    name = getCsvExportFileName();
    data = getCsvExportData();
    let link = csvExportRef.current.link;
    const BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([BOM, data], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', name);
    link.click();
  };

  // CSV入力ファイルを選択した場合、
  const handleCSVFileChange = (event) => {
    //FileReaderの定義
    const reader = new FileReader();
    let file = event.target.files[0];
    reader.onload = async () => {
      let result = await reader?.result?.split('\n');
      // IQX_WEBEST-301 パラメータ入出力機能において、エクセルで保存したCSVファイルも入力ファイルとして使用できるようにして欲しい。
      if (reader?.result?.includes('\r\n')) {
        // エクセル入力の場合
        result = await reader?.result?.split('\r\n');
      }
      // 空行または空白のみの行をフィルタリングする
      result = result.filter((line) => line.trim() !== '');
      submitCSVImportData(result);
    };
    reader.readAsText(file);
  };

  // 装置設定のプロパティビューのパンネル情報
  const getDetailMenuTab = () => {
    let detailMenuTab = [];
    // 表面処理の場合
    if (workType === WorkType.PaSurface || workType === WorkType.SmSurface) {
      if (types === ServiceClass.SheetMetal) {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '子部品サイズ係数',
          '段取個数係数',
          '加工時間',
          '重量係数',
          '生産個数係数',
        ];
      } else {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '段取係数1',
          '段取係数2',
          '加工時間',
          '重量係数',
          '生産個数係数',
        ];
      }
    } else if (workType === WorkType.PaInspection || workType === WorkType.SmInspection) {
      // 検査の場合、
      if (types === ServiceClass.SheetMetal) {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '子部品サイズ係数',
          '段取個数係数',
          '作業・加工時間',
          'サイズ係数',
          '生産個数係数',
        ];
      } else {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '段取係数1',
          '段取係数2',
          '作業時間',
          '重量係数',
          '生産個数係数',
        ];
      }
    } else if (workType === WorkType.PaCustom || workType === WorkType.SmCustom) {
      // 追加工程の場合、
      if (types === ServiceClass.SheetMetal) {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '子部品サイズ係数',
          '段取個数係数',
          '作業・加工時間',
          'サイズ係数',
          '生産個数係数',
          '委託装置詳細',
        ];
      } else {
        detailMenuTab = [
          'チャージ金額(/h)',
          '段取設定',
          '段取係数1',
          '段取係数2',
          '作業時間',
          '重量係数',
          '生産個数係数',
          '委託装置詳細',
        ];
      }
    } else if (workType === WorkType.PaAssenble || workType === WorkType.PaPacking) {
      // 組立の場合、// 梱包の場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '段取係数1',
        '段取係数2',
        '作業時間',
        '重量係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmProgram) {
      // プログラムの場合、
      detailMenuTab = ['チャージ金額(/h)', '段取設定', '加工設定', '係数・その他', '初期段取時間', '作業時間係数'];
    } else if (workType === WorkType.SmShearing) {
      // シャーリングの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '作業・加工時間',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmBending) {
      // ベンディングの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        'プログラム作成時間',
        '曲長段取時間',
        '子部品サイズ係数',
        '段取個数係数',
        '作業・加工時間',
        '曲げ長さ係数',
        '加工補正時間',
        '加工補正時間係数',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmDeburringAuto) {
      // 自動バリの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '加工時間',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmDeburringManual) {
      // 手動バリの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '加工速度(mm/min)',
        '加工速度係数',
        '加工補正時間',
        '加工補正時間係数',
        '手動バリ取対象サイズ',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmWelding) {
      // 溶接の場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '加工速度(mm/min)',
        '仮付時間',
        '取付時間(板厚判断)',
        '取付時間(サイズ判断)',
        '溶接難易度',
        'タップ溶接(%/辺)',
        '点付、仮付ピッチ(mm/辺)',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmWeldFinish) {
      // 溶接仕上の場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '加工速度(mm/min)',
        '難易度係数',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmSecondaryWork) {
      // ２次加工の場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '子部品サイズ係数',
        '段取個数係数',
        '加工時間',
        '加工種類/mm',
        '加工種類/mm(多工程穴)',
        '加工補正時間',
        '加工補正時間係数',
        'サイズ係数',
        '生産個数係数',
      ];
    } else if (workType === WorkType.SmBlankPunch) {
      // パンチの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '段取個数係数',
        '金型段取時間',
        '材料配置',
        'パンチ条件',
        '1パンチ加工時間',
        '送り速度(mm/min)',
        'ローラー/ホイール/ケガキ金型　加工速度(mm/sec)',
        '追抜き条件',
        'サイズ係数',
        '生産個数係数',
        '2工程穴加工時間',
        'ジョイントバラシ',
        'ジョイントバラシ(秒/個)',
      ];
    } else if (workType === WorkType.SmBlankLaser) {
      // レーザーの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '段取個数係数',
        '材料配置',
        '1ピアス加工時間',
        '加工速度(mm/min)',
        'ケガキ速度,送り速度',
        '加工速度係数',
        'ガス係数',
        'サイズ係数',
        '生産個数係数',
        '2工程穴加工時間',
        'ジョイントバラシ',
      ];
    } else if (workType === WorkType.SmBlankCombi) {
      // 複合機の場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '段取個数係数',
        '金型段取時間',
        '材料配置',
        'パンチ条件',
        '1パンチ加工時間',
        '1ピアス加工時間',
        '加工速度(mm/min)',
        'ケガキ速度,送り速度',
        '加工速度係数',
        'ガス係数',
        'サイズ係数',
        '生産個数係数',
        '2工程穴加工時間',
        'ジョイントバラシ',
      ];
    } else if (
      workType === WorkType.PaSteelWeight ||
      workType === WorkType.PaSteelArea ||
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelHole ||
      workType === WorkType.PaSteelCut
    ) {
      // 形鋼パラメータの場合、
      detailMenuTab = [
        'チャージ金額(/h)',
        '段取設定',
        '形状区分係数',
        '材質区分係数',
        '重量(Kg)区分係数',
        '加工設定',
        '一回加工時間(sec)',
        '重量(Kg)加工時間(sec)',
        '形状区分係数',
        '材質区分係数',
        'T1サイズ(mm)係数',
        'Aサイズ(mm)係数',
        'Bサイズ(mm)係数',
        'Cサイズ(mm)係数',
        '重量(Kg)区分係数',
        '生産個数係数',
      ];
    }
    return detailMenuTab;
  };

  // CSV出力情報
  const getCsvExportData = () => {
    let detailMenuTab = getDetailMenuTab();
    let str = getCSVHeaderInfo();
    // CSV内容
    str +=
      '\n' +
      detailId +
      ',' +
      code +
      ',' +
      processName +
      (workType === WorkType.PaCustom || workType === WorkType.SmCustom ? ',' + kouteiCode + ',' + kouteiName : '') +
      ',' +
      deviceCode +
      ',' +
      deviceName +
      ',' +
      remarks +
      ',' +
      isUsed;

    // 表面処理の場合
    if (workType === WorkType.PaSurface || workType === WorkType.SmSurface) {
      str = getSurfaceCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.PaInspection || workType === WorkType.SmInspection) {
      // 検査
      str = getKensaCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.PaCustom || workType === WorkType.SmCustom) {
      // 追加工程
      str = getCustomCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.PaAssenble || workType === WorkType.PaPacking) {
      // 組立 // 梱包
      str = getAssenblePackingCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmProgram) {
      // プログラム
      str = getProgramCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmShearing) {
      // シャーリング
      str = getShearingCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmBending) {
      //　ベンディング
      str = getBendingCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmDeburringAuto) {
      // 自動バリ
      str = getAutoDeburCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmDeburringManual) {
      // 手動バリ
      str = getManualDeburCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmWelding) {
      // 溶接
      str = getWeldCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmWeldFinish) {
      // 溶接仕上
      str = getWeldFinishCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmSecondaryWork) {
      // ２次加工
      str = getSecondaryWorkCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmBlankPunch) {
      // パンチ
      str = getPunchCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmBlankLaser) {
      // レーザー
      str = getLaserCSVExportData(str, detailMenuTab);
    } else if (workType === WorkType.SmBlankCombi) {
      // 複合機
      str = getCombiCSVExportData(str, detailMenuTab);
    } else if (
      workType === WorkType.PaSteelWeight ||
      workType === WorkType.PaSteelArea ||
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelHole ||
      workType === WorkType.PaSteelCut
    ) {
      // 形鋼
      str = getIQ5CSVExportData(str, detailMenuTab);
    }
    return str;
  };

  // 表面処理の情報をCSVファイル内容に変換する
  const getSurfaceCSVExportData = (str, detailMenuTab) => {
    // 工程種別の詳細情報を得る
    const groupDisplayList = getProcessDetailTypesInfo(detailsProcess?.charges, processMstRecord);
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        str += '\n';
        str += subItem?.name;
        getChargesDetailValues(subItem?.id, detailsProcess?.charges)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          str += '\n';
          str += '段取(￥/h)';
          str += ',' + (item?.unit === MaterialSurfaceBillingUnit.Work) + ',時間(￥/h)';
          str += ',' + (item?.unit === MaterialSurfaceBillingUnit.Weight) + ',重量(￥/kg)';
          str += ',' + (item?.unit === MaterialSurfaceBillingUnit.SquareMeter) + ',面積(￥/m2)';
          str += '\n';
          str += item.prep + ',,' + item.work + ',,' + item.weight + ',,' + item.squareMeter;
        });
      });
    });
    // 段取設定
    str += '\n' + detailMenuTab[1];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem, index) => {
        str += '\n';
        str += subItem?.name;
        getPrepSettingDetailValues(subItem?.id, detailsProcess?.prepSecs)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          str += '\n';
          str += secondsToHms(item);
        });
      });
    });
    if (workType === WorkType.SmSurface && types === ServiceClass.SheetMetal) {
      // 段取設定の子部品サイズ係数
      str += '\n' + detailMenuTab[2];
      str += '\n' + 'kg/cm2';
      //面積マスタ
      detailsProcess?.childPartsCoeffAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'cm2';
        });

      //重量マスタ
      detailsProcess?.childPartsCoeffWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += '\n';
          str += item.value + 'kg';
          //係数値
          let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
            (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
          )?.[0]?.areaCoeffList;
          areaCoeffLists?.map((row) => {
            str += ',';
            str += toDecimal(row.value, 2);
          });
        });

      // 段取設定の段取個数係数
      str += '\n' + detailMenuTab[3];
      str += '\n' + '個数';
      detailsProcess?.prepQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + detailMenuTab[3];
      detailsProcess?.prepQtyCoeffItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    } else if (workType === WorkType.PaSurface && types === ServiceClass.Parent) {
      // 段取係数1
      str += '\n' + detailMenuTab[2];
      str += '\n' + '種類/個数';
      detailsProcess?.prepThQtyMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + '子部品点数';
      detailsProcess?.prepCoeffThChildQtyItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });

      // 段取係数2
      str += '\n' + detailMenuTab[3];
      str += '\n' + '重量';
      detailsProcess?.prepCoeffThWeightMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'kg';
        });
      str += '\n' + '重量係数';
      detailsProcess?.prepCoeffThWeightItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    }

    // 加工時間
    str += '\n' + detailMenuTab[4];
    str += '\n' + '表面処理/cm2';
    //加工時間-面積マスタ
    detailsProcess?.areaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    //加工時間-値
    if (detailsProcess?.workTimeThItems) {
      Object.entries(detailsProcess?.workTimeThItems)?.map(([key, data]) => {
        let groupNm = processMstRecord?.details?.processDetailTypes?.filter(
          (subitem) => subitem.id === parseInt(key) && subitem.isUsed === true
        )?.[0]?.name;
        if (groupNm && groupNm !== '') {
          str += '\n';
          str += groupNm ? groupNm : '';
          str += ',';
          data?.map((row, index) => {
            if (index > 0) str += ',';
            str += secondsToHms(row?.value);
          });
        }
      });
    }
    // 重量係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + '重量';
    detailsProcess?.prodWeightCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'kg';
      });
    str += '\n' + detailMenuTab[5];
    detailsProcess?.prodWeightCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 検査処理の情報をCSVファイル内容に変換する
  const getKensaCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 基本段取時間
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      // 段取設定の子部品サイズ係数
      str += '\n' + detailMenuTab[2];
      str += '\n' + 'kg/cm2';
      //面積マスタ
      detailsProcess?.childPartsCoeffAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'cm2';
        });

      //重量マスタ
      detailsProcess?.childPartsCoeffWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += '\n';
          str += item.value + 'kg';
          //係数値
          let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
            (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
          )?.[0]?.areaCoeffList;
          areaCoeffLists?.map((row) => {
            str += ',';
            str += toDecimal(row.value, 2);
          });
        });

      // 段取設定の段取個数係数
      str += '\n' + detailMenuTab[3];
      str += '\n' + '個数';
      detailsProcess?.prepQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + detailMenuTab[3];
      detailsProcess?.prepQtyCoeffItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      // 段取係数1
      str += '\n' + detailMenuTab[2];
      str += '\n' + '種類/個数';
      detailsProcess?.prepThQtyMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + '子部品点数';
      detailsProcess?.prepCoeffThChildQtyItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });

      // 段取係数2
      str += '\n' + detailMenuTab[3];
      str += '\n' + '重量';
      detailsProcess?.prepCoeffThWeightMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'kg';
        });
      str += '\n' + '重量係数';
      detailsProcess?.prepCoeffThWeightItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    }

    // 加工時間
    str += '\n' + detailMenuTab[4];
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      str += '\n' + '1検査時間';
      str += '\n' + secondsToHms(detailsProcess?.inspectionWorkTime);
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      str += '\n' + '1部品あたりの作業時間';
      str += '\n' + secondsToHms(detailsProcess?.workBasicTime);
    }

    // 作業時間設定の子部品サイズ係数
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      str += '\n' + detailMenuTab[5];
      str += '\n' + 'kg/cm2';
      //面積マスタ
      detailsProcess?.prodSizeAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'cm2';
        });

      //重量マスタ
      detailsProcess?.prodSizeWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += '\n';
          str += item.value + 'kg';
          //係数値
          let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
            (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
          )?.[0]?.areaCoeffList;
          areaCoeffLists?.map((row) => {
            str += ',';
            str += toDecimal(row.value, 2);
          });
        });
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      // 重量係数
      str += '\n' + detailMenuTab[5];
      str += '\n' + '重量';
      detailsProcess?.prodWeightCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'kg';
        });
      str += '\n' + detailMenuTab[5];
      detailsProcess?.prodWeightCoeffThItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    }

    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 追加工程処理の情報をCSVファイル内容に変換する
  const getCustomCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 基本段取時間
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    if (workType === WorkType.SmCustom && types === ServiceClass.SheetMetal) {
      // 段取設定の子部品サイズ係数
      str += '\n' + detailMenuTab[2];
      str += '\n' + 'kg/cm2';
      //面積マスタ
      detailsProcess?.childPartsCoeffAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'cm2';
        });

      //重量マスタ
      detailsProcess?.childPartsCoeffWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += '\n';
          str += item.value + 'kg';
          //係数値
          let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
            (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
          )?.[0]?.areaCoeffList;
          areaCoeffLists?.map((row) => {
            str += ',';
            str += toDecimal(row.value, 2);
          });
        });

      // 段取設定の段取個数係数
      str += '\n' + detailMenuTab[3];
      str += '\n' + '個数';
      detailsProcess?.prepQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + detailMenuTab[3];
      detailsProcess?.prepQtyCoeffItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    } else if (workType === WorkType.PaCustom && types === ServiceClass.Parent) {
      // 段取係数1
      str += '\n' + detailMenuTab[2];
      str += '\n' + '種類/個数';
      detailsProcess?.prepThQtyMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
      str += '\n' + '子部品点数';
      detailsProcess?.prepCoeffThChildQtyItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });

      // 段取係数2
      str += '\n' + detailMenuTab[3];
      str += '\n' + '重量';
      detailsProcess?.prepCoeffThWeightMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'kg';
        });
      str += '\n' + '重量係数';
      detailsProcess?.prepCoeffThWeightItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    }

    // 加工時間
    str += '\n' + detailMenuTab[4];
    str += '\n' + '1箇所あたりの作業時間';
    str += '\n' + secondsToHms(detailsProcess?.workBasicTime);

    if (workType === WorkType.SmCustom && types === ServiceClass.SheetMetal) {
      // 作業時間設定の子部品サイズ係数
      str += '\n' + detailMenuTab[5];
      str += '\n' + 'kg/cm2';
      //面積マスタ
      detailsProcess?.prodSizeAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'cm2';
        });

      //重量マスタ
      detailsProcess?.prodSizeWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += '\n';
          str += item.value + 'kg';
          //係数値
          let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
            (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
          )?.[0]?.areaCoeffList;
          areaCoeffLists?.map((row) => {
            str += ',';
            str += toDecimal(row.value, 2);
          });
        });
    } else if (workType === WorkType.PaCustom && types === ServiceClass.Parent) {
      // 重量係数
      str += '\n' + detailMenuTab[5];
      str += '\n' + '重量';
      detailsProcess?.prodWeightCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + 'kg';
        });
      str += '\n' + detailMenuTab[5];
      detailsProcess?.prodWeightCoeffThItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
    }

    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    // 委託装置詳細
    const customers = props?.getCustomers?.data?.filter((item) => item.id === detailsProcess?.clientId);
    let code = customers?.[0]?.code ? customers?.[0]?.code : '';
    let name = customers?.[0]?.name ? customers?.[0]?.name : '';
    str += '\n' + detailMenuTab[7];
    str += '\n' + '委託工程,' + detailsProcess?.isCommission;
    str += '\n' + '取引先(委託先),' + name;
    str += '\n' + '取引先コード,' + code;
    str += '\n' + '手入力フラグ,' + detailsProcess?.isManualInput;
    str += '\n' + '初期金額(手入力時),' + detailsProcess?.initPrice;
    return str;
  };

  // 組立処理の情報をCSVファイル内容に変換する
  const getAssenblePackingCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 基本段取時間
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取係数1
    str += '\n' + detailMenuTab[2];
    str += '\n' + '種類/個数';
    detailsProcess?.prepThQtyMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + '子部品点数';
    detailsProcess?.prepCoeffThChildQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 段取係数2
    str += '\n' + detailMenuTab[3];
    str += '\n' + '重量';
    detailsProcess?.prepCoeffThWeightMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'kg';
      });
    str += '\n' + '重量係数';
    detailsProcess?.prepCoeffThWeightItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工時間
    str += '\n' + detailMenuTab[4];

    str += '\n' + '1部品あたりの作業時間';
    str += '\n' + secondsToHms(detailsProcess?.workBasicTime);

    // 作業時間設定の重量係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + '重量';
    detailsProcess?.prodWeightCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'kg';
      });
    str += '\n' + detailMenuTab[5];
    detailsProcess?.prodWeightCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // プログラムの情報をCSVファイル内容に変換する
  const getProgramCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,作業';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;
    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '要素数';
    detailsProcess?.prepElementThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value;
      });
    // 初期段取時間
    str += '\n' + detailMenuTab[4];
    detailsProcess?.prepElementThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + secondsToHms(item.value);
      });
    // 加工設定
    str += '\n' + detailMenuTab[2];
    str += '\n' + '作業時間（x要素数）';
    str += '\n' + secondsToHms(detailsProcess?.workBasicTime);
    // 係数・その他
    str += '\n' + detailMenuTab[3];
    str += '\n' + '要素数';
    detailsProcess?.otherElementCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value;
      });
    // 作業時間係数
    str += '\n' + detailMenuTab[5];
    detailsProcess?.workTimeElementCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + item.value;
      });
    str += '\n' + '同一形状・サイズの上限';
    str += '\n' + detailsProcess?.shapeGrouping;
    return str;
  };

  // シャーリングの情報をCSVファイル内容に変換する
  const getShearingCSVExportData = (str, detailMenuTab) => {
    let weightMst = detailsProcess?.childPartsCoeffWeightThMaster?.filter((item) => !item.isOutOfRange);
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;
    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);
    // 子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg / cm2';
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    detailsProcess?.childPartsCoeff
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += weightMst?.find((weight) => weight.no === item.weightId)?.value + 'kg';
        item?.areaCoeffList
          ?.filter((item) => !item.isOutOfRange)
          ?.map((area) => {
            str += ',' + area.value;
          });
      });
    // 段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + item.value;
      });
    // 作業・加工時間
    str += '\n' + detailMenuTab[4];
    str += '\n' + '1カット時間,One by one';
    str += '\n' + secondsToHms(detailsProcess?.cutTime) + ',' + detailsProcess?.isOneCut;
    // サイズ係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + 'kg / cm2';
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    detailsProcess?.prodSizeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += weightMst?.find((weight) => weight.no === item.weightId)?.value + 'kg';
        item?.areaCoeffList
          ?.filter((item) => !item.isOutOfRange)
          ?.map((area) => {
            str += ',' + area.value;
          });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + item.value;
      });
    return str;
  };

  // ベンディン処理の情報をCSVファイル内容に変換する
  const getBendingCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + '曲種別/曲数';
    //加工時間-板厚マスタ
    detailsProcess?.basicTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '曲';
      });
    Object.entries(detailsProcess?.basicTimeThickItems)
      ?.filter(([itemKey]) => getProcessDetailTypeName(parseInt(itemKey), processMstRecord) !== undefined)
      ?.map(([key, groupItem]) => {
        str += '\n';
        str += getProcessDetailTypeName(parseInt(key), processMstRecord);
        groupItem
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((col, index) => {
            str += ',';
            str += secondsToHms(col.value);
          });
      });

    // プログラム作成時間
    str += '\n' + detailMenuTab[2];
    str += '\n' + '本数';
    detailsProcess?.programCreateTimeCountfThMaster
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += item.value + '本';
      });
    str += '\n' + 'プログラム作成時間';
    detailsProcess?.programCreateTimeItems
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += item.value ? secondsToHms(item.value) : secondsToHms(0);
      });

    // 曲長段取時間
    str += '\n' + detailMenuTab[3];
    str += '\n' + 'mm(曲長)';
    detailsProcess?.prepBendTimeLengthMaster
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    str += '\n' + '曲長段取時間';
    detailsProcess?.prepBendTimeItems
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += item.value ? secondsToHms(item.value) : secondsToHms(0);
      });

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[4];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[5];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工時間
    str += '\n' + detailMenuTab[6];
    str += '\n' + '曲げ種類/板厚';
    //加工時間-板厚マスタ
    detailsProcess?.workTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    //加工時間-値
    if (detailsProcess?.workTimeThickItems) {
      Object.entries(detailsProcess?.workTimeThickItems)
        ?.filter(([itemKey]) => getProcessDetailTypeName(parseInt(itemKey), processMstRecord) !== undefined)
        ?.map(([key, groupItem]) => {
          str += '\n';
          str += getProcessDetailTypeName(parseInt(key), processMstRecord);
          groupItem
            ?.filter((subitem) => !subitem.isOutOfRange)
            ?.map((col, index) => {
              str += ',';
              str += secondsToHms(col.value);
            });
        });
    }

    // 曲げ長さ係数
    str += '\n' + detailMenuTab[7];
    str += '\n' + 'kg/mm';
    //面積マスタ
    detailsProcess?.bendTimeCoeffLenThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });

    //重量マスタ
    detailsProcess?.bendTimeCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.bendTimeCoeffWeightLenItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.lengthCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 加工補正時間
    str += '\n' + detailMenuTab[8];
    str += '\n' + '加工箇所数';
    detailsProcess?.modifyTimeQtyThMaster
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += item.value + '本';
      });
    str += '\n' + '補正時間';
    detailsProcess?.modifyTimeItems
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item, index) => {
        str += ',';
        str += item.value ? secondsToHms(item.value) : secondsToHms(0);
      });

    // 加工補正時間係数
    str += '\n' + detailMenuTab[9];
    str += '\n' + 'kg/mm';
    //面積マスタ
    detailsProcess?.modifyCoeffLenThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });

    //重量マスタ
    detailsProcess?.modifyCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.modifyCoeffItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.lengthCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // サイズ係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[11];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 自動バリ処理の情報をCSVファイル内容に変換する
  const getAutoDeburCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工時間
    str += '\n' + detailMenuTab[4];
    str += '\n' + '加工時間/cm2';
    //加工時間-板厚マスタ
    detailsProcess?.areaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    //加工時間-値
    str += '\n' + '加工時間';
    detailsProcess?.workTimeThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += secondsToHms(item.value);
      });

    // サイズ係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[6];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 手動バリ処理の情報をCSVファイル内容に変換する
  const getManualDeburCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工速度(mm/min)
    str += '\n' + detailMenuTab[4];
    str += '\n' + '加工速度(mm/分)';
    str += '\n' + secondsToHms(detailsProcess?.workSpeed);

    // //板厚マスタ
    // detailsProcess?.workSpeedThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item) => {
    //     str += ',';
    //     str += '～' + item.value + 't';
    //   });

    // //重量マスタ
    // detailsProcess?.workSpeedLenThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item) => {
    //     str += '\n';
    //     str += item.value + 'mm';
    //     //係数値
    //     let areaCoeffLists = detailsProcess?.workSpeedItems?.filter(
    //       (itemCoef) => !itemCoef.isOutOfRange && itemCoef.lengthId === item.no
    //     )?.[0]?.itaatsuCoeffList;
    //     areaCoeffLists?.map((row) => {
    //       str += ',';
    //       str += Number(row.value);
    //     });
    //   });

    // 加工速度係数
    str += '\n' + detailMenuTab[5];
    str += '\n' + '加工種別/加工長';
    //加工長マスタ
    detailsProcess?.workSpeedCoeffLengthThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    //内加工
    str += '\n' + '内加工';
    detailsProcess?.workSpeedCoeffInternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });
    //外加工
    str += '\n' + '外加工';
    detailsProcess?.workSpeedCoeffExternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });

    // 加工補正時間
    str += '\n' + detailMenuTab[6];
    str += '\n' + '加工箇所数';
    //加工補正時間
    detailsProcess?.modifyTimeQtyThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value;
      });
    //加工時間-値
    str += '\n' + '補正時間';
    detailsProcess?.modifyTimeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += secondsToHms(item.value);
      });

    // 加工補正時間係数
    str += '\n' + detailMenuTab[7];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.mtAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.mtWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.mtTimeCoeffItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 手動バリ取対象サイズ
    str += '\n' + detailMenuTab[8];
    str += '\n' + '内径最小丸穴径(mm)' + ',' + '内径最小矩形周長(mm)';
    str += '\n' + detailsProcess?.roundHoleDia + ',' + detailsProcess?.rectangleDia;

    // サイズ係数
    str += '\n' + detailMenuTab[9];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[10];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 溶接処理の情報をCSVファイル内容に変換する
  const getWeldCSVExportData = (str, detailMenuTab) => {
    // 工程種別の詳細情報を得る
    const groupDisplayList = getProcessDetailTypesInfo(detailsProcess?.charges, processMstRecord);
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        str += '\n';
        str += subItem?.name;
        getChargesDetailValues(subItem?.id, detailsProcess?.charges)?.map((item) => {
          if (parseInt(item) === subItem?.id) return;
          str += '\n';
          str += '段取,加工';
          str += '\n';
          str += item.prep + ',' + item.work;
        });
      });
    });
    // 段取設定
    str += '\n' + detailMenuTab[1];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem, index) => {
        str += '\n';
        str += subItem?.name;
        getPrepSettingDetailValues(subItem?.id, detailsProcess?.prepSecs)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          str += '\n';
          str += secondsToHms(item);
        });
      });
    });

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工速度(mm/min)
    str += '\n' + detailMenuTab[4];
    str += '\n' + '仕上種類/溶接線長';
    //溶接線長マスタ
    detailsProcess?.workSpeedThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });

    //加工速度
    if (detailsProcess?.workSpeedThItems) {
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workSpeedThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 仮付時間
    str += '\n' + detailMenuTab[5];
    str += '\n' + '溶接種類/板厚';
    //板厚マスタ
    detailsProcess?.tempInstThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    //仮付時間
    if (detailsProcess?.tempInstThItems) {
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      Object.keys(detailsProcess?.tempInstThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.tempInstThItems[key]?.map((item, index) => {
            str += ',';
            str += secondsToHms(item.value);
          });
        });
    }

    // 取付時間(板厚判断)
    str += '\n' + detailMenuTab[6];
    str += '\n' + '取付種類/板厚';
    //板厚マスタ
    detailsProcess?.instThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    //取付時間
    if (detailsProcess?.instThickThItems) {
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      Object.keys(detailsProcess?.instThickThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.instThickThItems[key]?.map((item, index) => {
            str += ',';
            str += secondsToHms(item.value);
          });
        });
    }

    // 取付時間(サイズ判断)
    str += '\n' + detailMenuTab[7];
    str += '\n' + '取付種類/サイズ';
    //サイズマスタ
    detailsProcess?.instSizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～M' + item.value;
      });
    //取付時間
    if (detailsProcess?.instSizeThItems) {
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      Object.keys(detailsProcess?.instSizeThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.instSizeThItems[key]?.map((item, index) => {
            str += ',';
            str += secondsToHms(item.value);
          });
        });
    }

    // 溶接難易度
    str += '\n' + detailMenuTab[8];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.weldDifficultyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    //溶接難易度
    if (detailsProcess?.weldDifficultyCoeffThItems) {
      // const usedIds = processMstRecord?.details?.processDetailTypes
      // ?.filter((item) => item.isUsed)
      //   ?.map((item) => item.id);
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);

      Object.keys(detailsProcess?.weldDifficultyCoeffThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.weldDifficultyCoeffThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // タップ溶接(%/辺)
    str += '\n' + detailMenuTab[9];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.tapRateThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    // タップ溶接(%/辺)
    if (detailsProcess?.tapRateThItems) {
      // const usedIds = processMstRecord?.details?.processDetailTypes
      // ?.filter((item) => item.isUsed)
      //   ?.map((item) => item.id);
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);

      Object.keys(detailsProcess?.tapRateThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.tapRateThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 点付、仮付ピッチ(mm/辺)
    str += '\n' + detailMenuTab[10];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.spotPitchThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    // 点付、仮付ピッチ(mm/辺)
    if (detailsProcess?.spotPitchThItems) {
      // const usedIds = processMstRecord?.details?.processDetailTypes
      // ?.filter((item) => item.isUsed)
      //   ?.map((item) => item.id);
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);

      Object.keys(detailsProcess?.spotPitchThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.spotPitchThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // サイズ係数
    str += '\n' + detailMenuTab[11];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[12];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[12];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // 溶接仕上処理の情報をCSVファイル内容に変換する
  const getWeldFinishCSVExportData = (str, detailMenuTab) => {
    // 工程種別の詳細情報を得る
    const groupDisplayList = getProcessDetailTypesInfo(detailsProcess?.charges, processMstRecord);
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        str += '\n';
        str += subItem?.name;
        getChargesDetailValues(subItem?.id, detailsProcess?.charges)?.map((item) => {
          if (parseInt(item) === subItem?.id) return;
          str += '\n';
          str += '段取,加工';
          str += '\n';
          str += item.prep + ',' + item.work;
        });
      });
    });
    // 段取設定
    str += '\n' + detailMenuTab[1];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem, index) => {
        str += '\n';
        str += subItem?.name;
        getPrepSettingDetailValues(subItem?.id, detailsProcess?.prepSecs)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          str += '\n';
          str += secondsToHms(item);
        });
      });
    });

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工速度(mm/min)
    str += '\n' + detailMenuTab[4];
    str += '\n' + '仕上種類/溶接線長';
    //溶接線長マスタ
    detailsProcess?.workSpeedThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });

    //加工速度
    if (detailsProcess?.workSpeedThItems) {
      const usedIds = processMstRecord?.details?.processDetailTypes
        ?.filter((item) => item.isUsed)
        ?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workSpeedThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 溶接難易度
    str += '\n' + detailMenuTab[5];
    str += '\n' + '材質区分';
    materialTypes?.map((item, index) => {
      str += ',';
      str += item.name;
    });
    //溶接難易度
    str += '\n' + '難易度係数';
    if (detailsProcess?.diffFactorCoeff) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.diffFactorCoeff)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          str += ',';
          str += Number(detailsProcess?.diffFactorCoeff[key]);
        });
    }

    // // 仕上有無 IQX_WEBEST-271 パラメータに現状持っている「仕上げ有無」（溶接種類ごとのチェックボックス）を取り除く。
    // str += '\n' + detailMenuTab[6];
    // str += '\n' + '溶接種類';
    // yousetsuTypes?.details.processDetailTypes
    //   ?.filter((item) => item.group === 10710 && item.isUsed === true)
    //   ?.map((item, index) => {
    //     str += ',';
    //     str += item?.name;
    //   });
    // str += '\n' + '難易度係数';
    // if (detailsProcess?.difficultyCoeff) {
    //   const usedIds = yousetsuTypes?.details?.processDetailTypes?.filter((item) => item.isUsed)?.map((item) => item.id);
    //   Object.keys(detailsProcess?.difficultyCoeff)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       str += ',';
    //       str += detailsProcess?.difficultyCoeff[key];
    //     });
    // }

    // サイズ係数
    str += '\n' + detailMenuTab[6];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[7];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[7];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // ２次加工処理の情報をCSVファイル内容に変換する
  const getSecondaryWorkCSVExportData = (str, detailMenuTab) => {
    // 工程種別の詳細情報を得る
    const groupDisplayList = getProcessDetailTypesInfo(detailsProcess?.charges, processMstRecord);
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        str += '\n';
        str += subItem?.name;
        getChargesDetailValues(subItem?.id, detailsProcess?.charges)?.map((item) => {
          if (parseInt(item) === subItem?.id) return;
          str += '\n';
          str += '段取,加工';
          str += '\n';
          str += item.prep + ',' + item.work;
        });
      });
    });
    // 段取設定
    str += '\n' + detailMenuTab[1];
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem, index) => {
        str += '\n';
        str += subItem?.name;
        getPrepSettingDetailValues(subItem?.id, detailsProcess?.prepSecs)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          str += '\n';
          str += secondsToHms(item);
        });
      });
    });

    // 段取設定の子部品サイズ係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.childPartsCoeff?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 加工時間(mm/min)
    str += '\n' + detailMenuTab[4];
    str += '\n' + '簡易入力';
    str += '\n' + '加工種類/サイズ';
    //サイズ
    detailsProcess?.sizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～M' + item.value;
      });
    if (detailsProcess?.workTimeSizeThItems) {
      Object.keys(detailsProcess?.workTimeSizeThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workTimeSizeThItems?.[parseInt(key)]?.map((time, index) => {
            str += ',';
            str += secondsToHms(time.value);
          });
        });
    }

    str += '\n' + '詳細入力';
    str += '\n' + '加工種類/サイズ';
    detailsProcess?.sizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～M' + item.value;
      });
    if (detailsProcess?.workTimeSizeThItems) {
      Object.keys(detailsProcess?.workTimeSizeThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          if (rowIndex === 0) {
            str += '\n';
            str += typeNm ? typeNm : '';
            str += ',' + '材質区分/板厚';
            detailsProcess?.sizeThicknessThMaster
              ?.filter((thickTh) => !thickTh.isOutOfRange)
              ?.map((thickThItem) => {
                str += ',';
                str += '～' + thickThItem.value + 't';
              });
          }
          const usedItems = materialTypes?.filter((item) => item.info.isUsed);
          usedItems?.map((materialTypeItem) => {
            detailsProcess?.workTimeSizeThItems[key]?.map((item, workTimeSizeIndex) => {
              if (item?.workTimeThickThItems) {
                Object.keys(item?.workTimeThickThItems)
                  ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
                  ?.map((key) => {
                    if (workTimeSizeIndex === 0) {
                      let materialTypeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
                      str += '\n';
                      str += typeNm ? typeNm : '';
                      str += ',';
                      str += materialTypeNm ? materialTypeNm : '';
                    }
                    item?.workTimeThickThItems[key]?.map((item, index) => {
                      str += ',';
                      str += secondsToHms(item.value);
                    });
                  });
              }
            });
          });
        });
    }

    str += '\n' + detailMenuTab[5];
    str += '\n' + '簡易入力';
    str += '\n' + '加工種類/mm';
    //mm
    detailsProcess?.mmThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    if (detailsProcess?.workTimeSizeHoleThItems) {
      Object.keys(detailsProcess?.workTimeSizeHoleThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workTimeSizeHoleThItems?.[parseInt(key)]?.map((time, index) => {
            str += ',';
            str += secondsToHms(time.value);
          });
        });
    }

    str += '\n' + '詳細入力(成形型穴)';
    str += '\n' + '加工種類/mm';
    detailsProcess?.mmThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    if (detailsProcess?.workTimeSizeHoleThItems) {
      Object.keys(detailsProcess?.workTimeSizeHoleThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          if (rowIndex === 0) {
            str += '\n';
            str += typeNm ? typeNm : '';
            str += ',' + '材質区分/板厚';
            detailsProcess?.mmThicknessThMaster
              ?.filter((thickTh) => !thickTh.isOutOfRange)
              ?.map((thickThItem) => {
                str += ',';
                str += '～' + thickThItem.value + 't';
              });
          }
          const usedItems = materialTypes?.filter((item) => item.info.isUsed);
          usedItems?.map((materialTypeItem) => {
            detailsProcess?.workTimeSizeHoleThItems[key]?.map((item, workTimeSizeIndex) => {
              if (item?.workTimeThickThItems) {
                Object.keys(item?.workTimeThickThItems)
                  ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
                  ?.map((key) => {
                    if (workTimeSizeIndex === 0) {
                      let materialTypeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
                      str += '\n';
                      str += typeNm ? typeNm : '';
                      str += ',';
                      str += materialTypeNm ? materialTypeNm : '';
                    }
                    item?.workTimeThickThItems[key]?.map((item, index) => {
                      str += ',';
                      str += secondsToHms(item.value);
                    });
                  });
              }
            });
          });
        });
    }

    str += '\n' + detailMenuTab[6];
    str += '\n' + '簡易入力';
    str += '\n' + '加工種類/mm';
    //mm
    detailsProcess?.mmMultiProcHoleThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    if (detailsProcess?.workTimeMmMultiProcHoleThItems) {
      Object.keys(detailsProcess?.workTimeMmMultiProcHoleThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workTimeMmMultiProcHoleThItems?.[parseInt(key)]?.map((time, index) => {
            str += ',';
            str += secondsToHms(time.value);
          });
        });
    }

    str += '\n' + '詳細入力(多工程穴)';
    str += '\n' + '加工種類/mm';
    detailsProcess?.mmMultiProcHoleThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    if (detailsProcess?.workTimeMmMultiProcHoleThItems) {
      Object.keys(detailsProcess?.workTimeMmMultiProcHoleThItems)
        .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
        ?.map(([key, item], rowIndex) => {
          let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
          if (rowIndex === 0) {
            str += '\n';
            str += typeNm ? typeNm : '';
            str += ',' + '材質区分/板厚';
            detailsProcess?.mmThicknessThMaster
              ?.filter((thickTh) => !thickTh.isOutOfRange)
              ?.map((thickThItem) => {
                str += ',';
                str += '～' + thickThItem.value + 't';
              });
          }
          const usedItems = materialTypes?.filter((item) => item.info.isUsed);
          usedItems?.map((materialTypeItem) => {
            detailsProcess?.workTimeMmMultiProcHoleThItems[key]?.map((item, workTimeSizeIndex) => {
              if (item?.workTimeThickThItems) {
                Object.keys(item?.workTimeThickThItems)
                  ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
                  ?.map((key) => {
                    if (workTimeSizeIndex === 0) {
                      let materialTypeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
                      str += '\n';
                      str += typeNm ? typeNm : '';
                      str += ',';
                      str += materialTypeNm ? materialTypeNm : '';
                    }
                    item?.workTimeThickThItems[key]?.map((item, index) => {
                      str += ',';
                      str += secondsToHms(item.value);
                    });
                  });
              }
            });
          });
        });
    }

    // 加工補正時間
    str += '\n' + detailMenuTab[7];
    str += '\n' + '加工箇所数';
    //加工補正時間
    detailsProcess?.modifyTimeQtyThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value;
      });
    //加工時間-値
    str += '\n' + '補正時間';
    detailsProcess?.modifyTimeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += secondsToHms(item.value);
      });

    // 加工補正時間係数
    str += '\n' + detailMenuTab[8];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.mtAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.mtWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.mtTimeCoeffItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });

    // サイズ係数
    str += '\n' + detailMenuTab[9];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[10];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });
    return str;
  };

  // パンチ処理の情報をCSVファイル内容に変換する
  const getPunchCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工,2工程穴,ジョイントバラシ';
    str +=
      '\n' +
      detailsProcess?.charges?.prep +
      ',' +
      detailsProcess?.charges?.work +
      ',' +
      detailsProcess?.charges?.twoStepHolework +
      ',' +
      detailsProcess?.charges?.jointSeparate;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[2];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 段取設定の金型段取時間
    str += '\n' + detailMenuTab[3];
    str += '\n' + '本数';
    detailsProcess?.prepMoldQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value + '本';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepMoldQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += secondsToHms(row.value);
      });

    // 材料配置
    str += '\n' + detailMenuTab[4];
    str += '\n' + '掴み代X,Y(mm)' + ',' + '桟幅X,Y(mm)' + ',' + '部品加工範囲X,Y(mm)' + '範囲超加算時間(sec)';
    str +=
      '\n' +
      detailsProcess?.materialArrange?.graspAllowanceX +
      ',' +
      detailsProcess?.materialArrange?.graspAllowanceY +
      ',' +
      detailsProcess?.materialArrange?.xWidth +
      ',' +
      detailsProcess?.materialArrange?.yWidth +
      ',' +
      detailsProcess?.materialArrange?.workRangeX +
      ',' +
      detailsProcess?.materialArrange?.workRangeY +
      ',' +
      detailsProcess?.materialArrange?.rangeAdditionalTime;

    // パンチ条件
    str += '\n' + detailMenuTab[5];
    str += '\n' + '1パンチ丸穴径' + ',' + '1パンチ矩形周長' + ',' + '二ブリングピッチ';
    str +=
      '\n' +
      detailsProcess?.punches?.punchHoleDia +
      ',' +
      detailsProcess?.punches?.punchRectanglePer +
      ',' +
      detailsProcess?.punches?.twoPitch;

    // 1パンチ加工時間
    str += '\n' + detailMenuTab[6];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.punchWorkTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });

    // 1パンチ加工時間
    if (detailsProcess?.punchWorkTimeItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.punchWorkTimeItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.punchWorkTimeItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 送り速度(mm/min)
    str += '\n' + detailMenuTab[7];
    str += '\n' + '送り速度';
    str += '\n' + detailsProcess?.feedSpeed;

    //ローラー/ホイール/ケガキ金型　加工速度(mm/sec)
    str += '\n' + detailMenuTab[8];
    str += '\n' + '加工速度(mm/分)';
    str += '\n' + detailsProcess?.workSpeed;

    // 追抜き条件
    str += '\n' + detailMenuTab[9];
    str += '\n' + '辺長/保有金型';
    detailsProcess?.odOvertakeMoldMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + item.name;
      });
    str += '\n' + '加工辺長';
    detailsProcess?.odOvertakeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',' + item.value;
      });

    // サイズ係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[11];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[11];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 2工程穴加工時間
    str += '\n' + detailMenuTab[12];
    str += '\n' + detailMenuTab[12];
    str += '\n' + secondsToHms(detailsProcess?.twoStepHoleworkTime);

    // ジョイントバラシ
    str += '\n' + detailMenuTab[13];
    str += '\n' + '個数/cm2';
    detailsProcess?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    str += '\n' + 'ジョイント個数';
    detailsProcess?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += Number(row.value);
      });
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.jointSeparateThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.jointSeparateItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.jointSeparateItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.jointSeparateItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    return str;
  };

  // レーザー処理の情報をCSVファイル内容に変換する
  const getLaserCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,加工,2工程穴,ジョイントバラシ';
    str +=
      '\n' +
      detailsProcess?.charges?.prep +
      ',' +
      detailsProcess?.charges?.work +
      ',' +
      detailsProcess?.charges?.twoStepHolework +
      ',' +
      detailsProcess?.charges?.jointSeparate;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[2];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 材料配置
    str += '\n' + detailMenuTab[3];
    str += '\n' + '掴み代X,Y(mm)' + ',' + '桟幅X,Y(mm)' + ',' + '部品加工範囲X,Y(mm)' + '範囲超加算時間(sec)';
    str +=
      '\n' +
      detailsProcess?.materialArrange?.graspAllowanceX + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.graspAllowanceY + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.xWidth + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.yWidth + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.workRangeX +
      ',' +
      detailsProcess?.materialArrange?.workRangeY +
      ',' +
      detailsProcess?.materialArrange?.rangeAdditionalTime;

    // 1ピアス加工時間
    str += '\n' + detailMenuTab[4];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.piercingTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });

    // 1パンチ加工時間
    if (detailsProcess?.piercingTimeThItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.piercingTimeThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.piercingTimeThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 加工速度(mm/min)
    str += '\n' + detailMenuTab[5];
    str += '\n' + '簡易入力';
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.workSpeedThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.workSpeedItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    str += '\n' + '詳細入力';
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.workSpeedThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.workSpeedItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '丸穴径(Φ) (≦)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.roundHoleDiaThItems?.map((roundItem, index) => {
              str += ',' + roundItem.value;
            });
          });
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '加工周長(mm)(≦)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.workLenThItems?.map((workLenItem, index) => {
              str += ',' + workLenItem.value;
            });
          });
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '速度(mm/分)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.lenThItems?.map((lenItem, index) => {
              str += ',' + lenItem.value;
            });
          });
        });
    }

    str += '\n' + detailMenuTab[6];
    str += '\n' + detailsProcess?.scribingSpeed;
    str += ',' + detailsProcess?.feedSpeed;

    // 加工速度係数
    str += '\n' + detailMenuTab[7];
    str += '\n' + '加工種別/加工長';
    //加工長マスタ
    detailsProcess?.workSpeedCoeffLengthThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    //内加工
    str += '\n' + '内加工';
    detailsProcess?.workSpeedCoeffInternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });
    //外加工
    str += '\n' + '外加工';
    detailsProcess?.workSpeedCoeffExternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });
    // ガス係数
    str += '\n' + detailMenuTab[8];
    str += '\n' + '係数/種類';
    detailsProcess?.gasCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.name;
      });
    str += '\n' + detailMenuTab[8];
    detailsProcess?.gasCoeffListItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += toDecimal(item.value, 2);
      });

    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.gasCoeffThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.gasCoeffThItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.gasCoeffThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.gasCoeffThItems[key]?.map((item, index) => {
            str += ',';
            let gasTypeNm = detailsProcess?.gasCoeffThMaster?.filter(
              (itemCoef) => !itemCoef.isOutOfRange && itemCoef.no === parseInt(item.value)
            );
            str += gasTypeNm?.length > 0 ? gasTypeNm[0].name : '';
          });
        });
    }

    // サイズ係数
    str += '\n' + detailMenuTab[9];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[10];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 2工程穴加工時間
    str += '\n' + detailMenuTab[11];
    str += '\n' + detailMenuTab[11];
    str += '\n' + secondsToHms(detailsProcess?.twoStepHoleworkTime);

    // ジョイントバラシ
    str += '\n' + detailMenuTab[12];
    str += '\n' + '個数/cm2';
    detailsProcess?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    str += '\n' + 'ジョイント個数';
    detailsProcess?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += Number(row.value);
      });
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.jointSeparateThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.jointSeparateItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.jointSeparateItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.jointSeparateItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    return str;
  };

  // 複合機処理の情報をCSVファイル内容に変換する
  const getCombiCSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取,パンチ加工、レーザー加工,2工程穴,ジョイントバラシ';
    str +=
      '\n' +
      detailsProcess?.charges?.prep +
      ',' +
      detailsProcess?.charges?.punchWork +
      ',' +
      detailsProcess?.charges?.laserWork +
      ',' +
      detailsProcess?.charges?.twoStepHolework +
      ',' +
      detailsProcess?.charges?.jointSeparate;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '基本段取時間';
    str += '\n' + secondsToHms(detailsProcess?.prepBasicTime);

    // 段取設定の段取個数係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + '個数';
    detailsProcess?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[2];
    detailsProcess?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 段取設定の金型段取時間
    str += '\n' + detailMenuTab[3];
    str += '\n' + '本数';
    detailsProcess?.prepMoldQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value + '本';
      });
    str += '\n' + detailMenuTab[3];
    detailsProcess?.prepMoldQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += secondsToHms(row.value);
      });

    // 材料配置
    str += '\n' + detailMenuTab[4];
    str += '\n' + '掴み代X,Y(mm)' + ',' + '桟幅X,Y(mm)' + ',' + '部品加工範囲X,Y(mm)' + '範囲超加算時間(sec)';
    str +=
      '\n' +
      detailsProcess?.materialArrange?.graspAllowanceX + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.graspAllowanceY + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.xWidth + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.yWidth + //IQX_WEBEST-298 パラメータのCSV出力時、レーザー工程と複合機の掴み代、桟幅の出力の修正
      ',' +
      detailsProcess?.materialArrange?.workRangeX +
      ',' +
      detailsProcess?.materialArrange?.workRangeY +
      ',' +
      detailsProcess?.materialArrange?.rangeAdditionalTime;

    // パンチ条件
    str += '\n' + detailMenuTab[5];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.punchConditionThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });

    // パンチ
    if (detailsProcess?.punchConditionItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.punchConditionItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.punchConditionItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 1パンチ加工時間
    str += '\n' + detailMenuTab[6];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.punchWorkTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });

    // 1パンチ加工時間
    if (detailsProcess?.punchWorkTimeItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.punchWorkTimeItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.punchWorkTimeItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 1ピアス加工時間
    str += '\n' + detailMenuTab[7];
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.piercingTimeThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });

    // 1パンチ加工時間
    if (detailsProcess?.piercingTimeThItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.piercingTimeThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.piercingTimeThItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    // 加工速度(mm/min)
    str += '\n' + detailMenuTab[8];
    str += '\n' + '簡易入力';
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.workSpeedThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.workSpeedItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    str += '\n' + '詳細入力';
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.workSpeedThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.workSpeedItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.workSpeedItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '丸穴径(Φ) (≦)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.roundHoleDiaThItems?.map((roundItem, index) => {
              str += ',' + roundItem.value;
            });
          });
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '加工周長(mm)(≦)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.workLenThItems?.map((workLenItem, index) => {
              str += ',' + workLenItem.value;
            });
          });
          str += '\n';
          str += typeNm ? typeNm : '';
          str += ',' + '速度(mm/分)';
          detailsProcess?.workSpeedItems[key]?.map((item, index) => {
            item?.lenThItems?.map((lenItem, index) => {
              str += ',' + lenItem.value;
            });
          });
        });
    }

    str += '\n' + detailMenuTab[9];
    str += '\n' + detailsProcess?.scribingSpeed;
    str += ',' + detailsProcess?.feedSpeed;

    // 加工速度係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + '加工種別/加工長';
    //加工長マスタ
    detailsProcess?.workSpeedCoeffLengthThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'mm';
      });
    //内加工
    str += '\n' + '内加工';
    detailsProcess?.workSpeedCoeffInternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });
    //外加工
    str += '\n' + '外加工';
    detailsProcess?.workSpeedCoeffExternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.value;
      });
    // ガス係数
    str += '\n' + detailMenuTab[11];
    str += '\n' + '係数/種類';
    detailsProcess?.gasCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += item.name;
      });
    str += '\n' + detailMenuTab[11];
    detailsProcess?.gasCoeffListItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += toDecimal(item.value, 2);
      });

    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.gasCoeffThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.gasCoeffThItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.gasCoeffThItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.gasCoeffThItems[key]?.map((item, index) => {
            str += ',';
            let gasTypeNm = detailsProcess?.gasCoeffThMaster?.filter(
              (itemCoef) => !itemCoef.isOutOfRange && itemCoef.no === parseInt(item.value)
            );
            str += gasTypeNm?.length > 0 ? gasTypeNm[0].name : '';
          });
        });
    }

    // サイズ係数
    str += '\n' + detailMenuTab[12];
    str += '\n' + 'kg/cm2';
    //面積マスタ
    detailsProcess?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });

    //重量マスタ
    detailsProcess?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += '\n';
        str += item.value + 'kg';
        //係数値
        let areaCoeffLists = detailsProcess?.prodSizeItems?.filter(
          (itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no
        )?.[0]?.areaCoeffList;
        areaCoeffLists?.map((row) => {
          str += ',';
          str += toDecimal(row.value, 2);
        });
      });
    // 生産個数係数
    str += '\n' + detailMenuTab[13];
    str += '\n' + '個数';
    detailsProcess?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + '個';
      });
    str += '\n' + detailMenuTab[13];
    detailsProcess?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += toDecimal(row.value, 2);
      });

    // 2工程穴加工時間
    str += '\n' + detailMenuTab[14];
    str += '\n' + detailMenuTab[14];
    str += '\n' + secondsToHms(detailsProcess?.twoStepHoleworkTime);

    // ジョイントバラシ
    str += '\n' + detailMenuTab[15];
    str += '\n' + '個数/cm2';
    detailsProcess?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 'cm2';
      });
    str += '\n' + 'ジョイント個数';
    detailsProcess?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row) => {
        str += ',';
        str += Number(row.value);
      });
    str += '\n' + '材質区分/板厚';
    //板厚マスタ
    detailsProcess?.jointSeparateThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item) => {
        str += ',';
        str += '～' + item.value + 't';
      });
    if (detailsProcess?.jointSeparateItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(detailsProcess?.jointSeparateItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n';
          str += typeNm ? typeNm : '';
          detailsProcess?.jointSeparateItems[key]?.map((item, index) => {
            str += ',';
            str += Number(item.value);
          });
        });
    }

    return str;
  };

  // 形鋼パラメータ情報をCSVファイル内容に変換する
  const getIQ5CSVExportData = (str, detailMenuTab) => {
    // チャージ金額(/h)
    str += '\n' + detailMenuTab[0];
    str += '\n' + '段取, 加工';
    str += '\n' + detailsProcess?.charges?.prep + ',' + detailsProcess?.charges?.work;

    // 段取設定
    str += '\n' + detailMenuTab[1];
    str += '\n' + '初期段取時間(sec)';
    str += '\n' + detailsProcess?.prepBasicTime;

    // 段取設定の形状区分係数
    str += '\n' + detailMenuTab[2];
    str += '\n' + '形状区分';
    if (detailsProcess?.setupShapeCoeff) {
      Object.entries(detailsProcess?.setupShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          str += getProcessingShapeCoeffNm(key, props?.steelShapeData);
        });
      str += '\n' + detailMenuTab[2];
      Object.entries(detailsProcess?.setupShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          let value = getIQ5CoeffDetailValues(key, detailsProcess?.setupShapeCoeff);
          str += value ? toDecimal(value, 2) : toDecimal(0, 2);
        });
    }

    // 段取設定の材質区分係数
    str += '\n' + detailMenuTab[3];
    str += '\n' + '材質区分';
    if (detailsProcess?.materialClassificationCoeff) {
      Object.entries(detailsProcess?.materialClassificationCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          str += getMaterialTypeIq5Nm(key, materialTypes);
        });
      str += '\n' + detailMenuTab[3];
      Object.entries(detailsProcess?.materialClassificationCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          let value = getIQ5CoeffDetailValues(key, detailsProcess?.materialClassificationCoeff);
          str += value ? toDecimal(value, 2) : toDecimal(0, 2);
        });
    }

    // 段取設定の重量(Kg)区分係数
    str += '\n' + detailMenuTab[4];
    str += '\n' + '重量(Kg)';
    if (detailsProcess?.weightClassificationCoeffThMaster) {
      detailsProcess?.weightClassificationCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'kg';
        });
    }
    str += '\n' + detailMenuTab[4];
    if (detailsProcess?.weightClassificationCoeffThItems) {
      detailsProcess?.weightClassificationCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定部分
    str += '\n' + detailMenuTab[5];
    if (workType === WorkType.PaSteelWeight) {
      str += '\n' + detailMenuTab[6];
    } else if (workType === WorkType.PaSteelArea) {
      str += '\n' + '1面加工時間(sec)';
    } else if (
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch
    ) {
      str += '\n' + '1箇所加工時間(sec)';
    }
    // 加工設定の一回加工時間(sec)
    if (workType !== WorkType.PaSteelMount && workType !== WorkType.PaSteelHole && workType !== WorkType.PaSteelCut) {
      str += '\n' + '種類';
      if (detailsProcess?.singleProcessTimeSec) {
        Object.entries(detailsProcess?.singleProcessTimeSec)
          ?.filter((item) => !item.isOutOfRange)
          ?.map(([key, data], index) => {
            str += ',';
            str += getWeightDetailNm(key, processMstRecord?.details?.processDetailTypes);
          });
        str += '\n' + detailMenuTab[6];
        Object.entries(detailsProcess?.singleProcessTimeSec)
          ?.filter((item) => !item.isOutOfRange)
          ?.map(([key, data], index) => {
            str += ',';
            let value = getIQ5CoeffDetailValues(key, detailsProcess?.singleProcessTimeSec);
            str += value;
          });
      }
    }

    // 仮付け加工時間(sec)
    if (workType === WorkType.PaSteelWeldFinish || workType === WorkType.PaSteelWeld) {
      str += '\n' + '仮付け加工時間(sec)';
      str += '\n' + '種類';
      if (detailsProcess?.tempInstProcessTimeSec) {
        Object.entries(detailsProcess?.tempInstProcessTimeSec)
          ?.filter((item) => !item.isOutOfRange)
          ?.map(([key, data], index) => {
            str += ',';
            str += getWeightDetailNm(key, processMstRecord?.details?.processDetailTypes);
          });
        str += '\n' + '仮付け加工時間(sec)';
        Object.entries(detailsProcess?.tempInstProcessTimeSec)
          ?.filter((item) => !item.isOutOfRange)
          ?.map(([key, data], index) => {
            str += ',';
            let value = getIQ5CoeffDetailValues(key, detailsProcess?.tempInstProcessTimeSec);
            str += value;
          });
      }
    }

    // 取付加工時間(sec) / 穴サイズ加工時間(sec)
    if (workType === WorkType.PaSteelMount || workType === WorkType.PaSteelHole) {
      str += '\n';
      str += workType === WorkType.PaSteelMount ? '取付サイズ加工時間(sec)' : '穴サイズ加工時間(sec)';
      str += '\n' + '種類/サイズ';
      if (detailsProcess?.sizeProcessingTimeThMaster) {
        detailsProcess?.sizeProcessingTimeThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value;
          });
      }
      if (detailsProcess?.sizeProcessingTimeThItems) {
        Object.keys(detailsProcess?.sizeProcessingTimeThItems)?.map((key) => {
          let typeNm = processMstRecord?.details?.processDetailTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n' + typeNm;
          detailsProcess?.sizeProcessingTimeThItems[key]?.map((item, index) => {
            str += ',';
            str += item.value;
          });
        });
      }
    }

    // 加工設定の重量(Kg)加工時間(sec)
    if (workType === WorkType.PaSteelWeight) {
      str += '\n' + detailMenuTab[7];
      str += '\n' + '種類/重量(kg)';
      if (detailsProcess?.kgProcessingTimeThMaster) {
        detailsProcess?.kgProcessingTimeThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value + 'kg';
          });
      }
      if (detailsProcess?.kgProcessingTimeThItems) {
        Object.keys(detailsProcess?.kgProcessingTimeThItems)?.map((key) => {
          let typeNm = processMstRecord?.details?.processDetailTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n' + typeNm;
          detailsProcess?.kgProcessingTimeThItems[key]?.map((item, index) => {
            str += ',';
            str += item.value;
          });
        });
      }
    }

    // 加工設定の面積(cm)加工時間(sec)
    if (workType === WorkType.PaSteelArea) {
      str += '\n' + '面積(cm2)加工時間(sec)';
      str += '\n' + '種類/面積(cm2)';
      if (detailsProcess?.areaProcessingTimeThMaster) {
        detailsProcess?.areaProcessingTimeThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value + 'cm2';
          });
      }
      if (detailsProcess?.areaProcessingTimeThItems) {
        Object.keys(detailsProcess?.areaProcessingTimeThItems)?.map((key) => {
          let typeNm = processMstRecord?.details?.processDetailTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n' + typeNm;
          detailsProcess?.areaProcessingTimeThItems[key]?.map((item, index) => {
            str += ',';
            str += item.value;
          });
        });
      }
    }

    // 加工速度(mm/min)
    if (
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelHole
    ) {
      str += '\n' + '加工速度(mm/min)';
      str += '\n' + '種類/mm';
      if (detailsProcess?.processingSpeedThMaster) {
        detailsProcess?.processingSpeedThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value + 'mm';
          });
      }
      if (detailsProcess?.processingSpeedThItems) {
        Object.keys(detailsProcess?.processingSpeedThItems)?.map((key) => {
          let typeNm = processMstRecord?.details?.processDetailTypes?.find((item) => item.id.toString() === key)?.name;
          str += '\n' + typeNm;
          detailsProcess?.processingSpeedThItems[key]?.map((item, index) => {
            str += ',';
            str += item.value;
          });
        });
      }
    }

    //切断の加工時間部分
    if (workType === WorkType.PaSteelCut) {
      // 捨代(mm)
      str += '\n' + '捨代(mm), 刃幅(mm), 1カット加工時間(sec)';
      str += '\n' + detailsProcess?.disposal;
      // 刃幅(mm)
      str += ',' + detailsProcess?.bladeWidth;
      // 1カット加工時間(sec)
      str += ',' + detailsProcess?.singleProcessTimeSec;
      // 加工速度(mm/min)
      str += '\n' + '加工速度(mm/min)';
      str += '\n' + 'サイズ(mm)';
      if (detailsProcess?.processingSpeedMinThMaster) {
        detailsProcess?.processingSpeedMinThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value + 'mm';
          });
      }
      str += '\n' + '加工速度(min)';
      if (detailsProcess?.processingSpeedMinThItems) {
        detailsProcess?.processingSpeedMinThItems
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += row.value;
          });
      }
    }

    // 加工設定の形状区分係数
    str += '\n' + detailMenuTab[8];
    str += '\n' + '形状区分';
    if (detailsProcess?.processingShapeCoeff) {
      Object.entries(detailsProcess?.processingShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          str += getProcessingShapeCoeffNm(key, props?.steelShapeData);
        });
      str += '\n' + detailMenuTab[8];
      Object.entries(detailsProcess?.processingShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          let value = getIQ5CoeffDetailValues(key, detailsProcess?.processingShapeCoeff);
          str += value ? toDecimal(value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定の材質区分係数
    str += '\n' + detailMenuTab[9];
    str += '\n' + '材質区分';
    if (detailsProcess?.machiningMaterialCoeff) {
      Object.entries(detailsProcess?.machiningMaterialCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          str += getMaterialTypeIq5Nm(key, materialTypes);
        });
      str += '\n' + detailMenuTab[9];
      Object.entries(detailsProcess?.machiningMaterialCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          str += ',';
          let value = getIQ5CoeffDetailValues(key, detailsProcess?.machiningMaterialCoeff);
          str += value ? toDecimal(value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定のT1サイズ(mm)係数
    str += '\n' + detailMenuTab[10];
    str += '\n' + 'サイズ(mm)';
    if (detailsProcess?.t1SizeCoeffThMaster) {
      detailsProcess?.t1SizeCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'mm';
        });
    }
    str += '\n' + detailMenuTab[10];
    if (detailsProcess?.t1SizeCoeffThItems) {
      detailsProcess?.t1SizeCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定のAサイズ(mm)係数
    str += '\n' + detailMenuTab[11];
    str += '\n' + 'サイズ(mm)';
    if (detailsProcess?.aSizeCoeffThMaster) {
      detailsProcess?.aSizeCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'mm';
        });
    }
    str += '\n' + detailMenuTab[11];
    if (detailsProcess?.aSizeCoeffThItems) {
      detailsProcess?.aSizeCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定のBサイズ(mm)係数
    str += '\n' + detailMenuTab[12];
    str += '\n' + 'サイズ(mm)';
    if (detailsProcess?.bSizeCoeffThMaster) {
      detailsProcess?.bSizeCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'mm';
        });
    }
    str += '\n' + detailMenuTab[12];
    if (detailsProcess?.bSizeCoeffThItems) {
      detailsProcess?.bSizeCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定のCサイズ(mm)係数
    str += '\n' + detailMenuTab[13];
    str += '\n' + 'サイズ(mm)';
    if (detailsProcess?.cSizeCoeffThMaster) {
      detailsProcess?.cSizeCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'mm';
        });
    }
    str += '\n' + detailMenuTab[13];
    if (detailsProcess?.cSizeCoeffThItems) {
      detailsProcess?.cSizeCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定の重量(Kg)区分係数
    str += '\n' + detailMenuTab[14];
    str += '\n' + '重量(Kg)';
    if (detailsProcess?.processingWeightCoeffThMaster) {
      detailsProcess?.processingWeightCoeffThMaster
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += '～' + row.value + 'kg';
        });
    }
    str += '\n' + detailMenuTab[14];
    if (detailsProcess?.processingWeightCoeffThItems) {
      detailsProcess?.processingWeightCoeffThItems
        ?.filter((subitem) => !subitem.isOutOfRange)
        ?.map((row, index) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    // 加工設定のRサイズ(mm)係数
    if (workType === WorkType.PaSteelBend) {
      str += '\n' + 'Rサイズ(mm)係数';
      str += '\n' + 'サイズ(mm)';
      if (detailsProcess?.rSizeCoeffThMaster) {
        detailsProcess?.rSizeCoeffThMaster
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += '～' + row.value + 'mm';
          });
      }
      str += '\n' + 'Rサイズ(mm)係数';
      if (detailsProcess?.rSizeCoeffThItems) {
        detailsProcess?.rSizeCoeffThItems
          ?.filter((subitem) => !subitem.isOutOfRange)
          ?.map((row, index) => {
            str += ',';
            str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
          });
      }
    }

    // 生産個数係数
    str += '\n' + detailMenuTab[15];
    str += '\n' + '個数';
    if (detailsProcess?.productionQtyCoeffThMaster) {
      detailsProcess?.productionQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item) => {
          str += ',';
          str += '～' + item.value + '個';
        });
    }
    str += '\n' + detailMenuTab[15];
    if (detailsProcess?.productionQtyCoeffThItems) {
      detailsProcess?.productionQtyCoeffThItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row) => {
          str += ',';
          str += row.value ? toDecimal(row.value, 2) : toDecimal(0, 2);
        });
    }

    return str;
  };

  // CSVファイル名称
  const getCsvExportFileName = () => {
    let fileName = '';
    let mstProcess = props?.getProcessMstRecordByWorkType(workType);
    let classType = ServiceClasses?.find((item) => item.value === mstProcess?.class)?.label;
    let workTypeName = mstProcess?.name;
    fileName = `装置設定_${classType}_${workTypeName}_${formatDateString(todayTime())}.csv`;
    return fileName;
  };

  const getCurrentServiceClass = () => {
    const currentRoute = location.pathname;
    if (currentRoute?.includes('parent')) {
      return ServiceClass.Parent;
    } else if (currentRoute?.includes('iq3')) {
      return ServiceClass.SheetMetal;
    } else if (currentRoute?.includes('iq5')) {
      return ServiceClass.Beams;
    }
  };

  // CSV入力データを登録
  const submitCSVImportData = async (dataList) => {
    messageRef.current = [];
    let detailMenuTab = getDetailMenuTab();

    const currentServiceClass = getCurrentServiceClass();

    // if (props.csvImportDataValidation(dataList, detailMenuTab, messageRef, workType)) {
    let deviceData = JSON.parse(JSON.stringify(selectedDeviceData));
    // タイトル部分
    let title = dataList[0];

    let titleList = dataList[1]?.split(',');

    let processName = titleList[2] !== undefined ? titleList[2] : '';

    let processCode = titleList[1] !== undefined ? titleList[1] : '';

    const processId = await getProcessId(processCode, processName, currentServiceClass);

    if (processId?.[0]?.id !== deviceData.processId) {
      error('工程名が合っていません。');
      return;
    }

    if (
      workType !== WorkType.PaCustom &&
      workType !== WorkType.SmCustom &&
      title.includes('ID,コード,工程名,装置コード,装置名,備考,表示')
    ) {
      title = dataList[1]?.split(',');
      // deviceData.updateId = title[0] !== undefined ? Number(title[0]) : deviceData?.id;
      // deviceData.code = title[3] !== undefined ? title[3] : deviceData?.code;
      // deviceData.name = title[4] !== undefined ? title[4] : deviceData?.name;

      deviceData.updateId = deviceData?.id;
      deviceData.code = deviceData?.code;
      deviceData.name = deviceData?.name;
      if (!deviceData.info) {
        deviceData.info = {};
      }
      deviceData.info.remarks = title[5] !== undefined ? title[5] : deviceData?.info.remarks;
      deviceData.info.isUsed = title[6] !== undefined ? JSON.parse(title[6]?.toLowerCase()) : deviceData?.info.isUsed; // IQX_WEBEST-301
    } else if (
      (workType === WorkType.PaCustom || workType === WorkType.SmCustom) &&
      title.includes('ID,コード,工程名,コード,工程名,装置コード,装置名,備考,表示')
    ) {
      title = dataList[1]?.split(',');
      // deviceData.updateId = title[0] !== undefined ? Number(title[0]) : deviceData?.id;
      // deviceData.code = title[5] !== undefined ? title[5] : deviceData?.code;
      // deviceData.name = title[6] !== undefined ? title[6] : deviceData?.name;

      deviceData.updateId = deviceData?.id;
      deviceData.code = deviceData?.code;
      deviceData.name = deviceData?.name;
      if (!deviceData.info) {
        deviceData.info = {};
      }
      deviceData.info.remarks = title[7] !== undefined ? title[7] : deviceData?.info.remarks;
      deviceData.info.isUsed = title[8] !== undefined ? JSON.parse(title[8]?.toLowerCase()) : deviceData?.info.isUsed; // IQX_WEBEST-301
    }
    // 表面処理の場合
    if (workType === WorkType.PaSurface || workType === WorkType.SmSurface) {
      deviceData = surfaceCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.PaInspection || workType === WorkType.SmInspection) {
      // 検査処理の場合
      deviceData = kensaCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.PaCustom || workType === WorkType.SmCustom) {
      // 追加工程処理の場合
      deviceData = customCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.PaAssenble || workType === WorkType.PaPacking) {
      // 組立 // 梱包
      deviceData = assenblePackingCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmProgram) {
      // プログラム
      deviceData = programCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmShearing) {
      // シャーリング
      deviceData = shearingCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmBending) {
      // ベンディング
      deviceData = bendingCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmDeburringAuto) {
      // 自動バリ
      deviceData = autoDeburCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmDeburringManual) {
      // 手動バリ
      deviceData = manualDeburCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmWelding) {
      // 溶接
      deviceData = weldCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmWeldFinish) {
      // 溶接仕上
      deviceData = weldFinishCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmSecondaryWork) {
      // ２次加工
      deviceData = secondaryWorkCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmBlankPunch) {
      // パンチ
      deviceData = punchCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmBlankLaser) {
      // レーザー
      deviceData = laserCSVImport(deviceData, dataList, detailMenuTab);
    } else if (workType === WorkType.SmBlankCombi) {
      // 複合機
      deviceData = combiCSVImport(deviceData, dataList, detailMenuTab);
    } else if (
      workType === WorkType.PaSteelWeight ||
      workType === WorkType.PaSteelArea ||
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelHole ||
      workType === WorkType.PaSteelCut
    ) {
      // 形鋼パラメータ情報をCSVで入力
      deviceData = iQ5CSVImport(deviceData, dataList, detailMenuTab);
    }
    props.updatedDetails(deviceData);
    // }
    Modal.success({
      width: 500,
      className: 'modal-complete csv-modal-complete',
      title: '完了',
      content: (
        <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>
          {'CSV入力のデータ更新処理は完了しました。'}
          {messageRef.current?.length > 0 ? (
            <>
              <br></br>
              {'下記の内容をご確認ください。'}
              <br></br>
              <ul>{messageRef.current}</ul>
            </>
          ) : (
            <></>
          )}
        </p>
      ),
    });
  };

  // 表面処理のCSV入力処理
  const surfaceCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let chargesItemIndex = chargesIndex + 1;
    let inputData = [];
    let index = 0;
    // 工程種別の詳細情報を得る
    const groupDisplayList = getProcessDetailTypesInfo(deviceData?.details?.charges, processMstRecord);
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        getChargesDetailValues(subItem?.id, deviceData?.details?.charges)?.map((item) => {
          if (parseInt(item) === subItem?.id) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 3;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 2]?.split(',');
            item.prep = inputData?.[0] ? parseInt(inputData?.[0]) : item.prep;
            item.work = inputData?.[2] ? parseInt(inputData?.[2]) : item.work;
            item.weight = inputData?.[4] ? parseInt(inputData?.[4]) : item.weight;
            item.squareMeter = inputData?.[6] ? parseInt(inputData?.[6]) : item.squareMeter;
          }
        });
        index++;
      });
    });

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    chargesItemIndex = chargesIndex + 1;
    inputData = [];
    index = 0;
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        let groupDetail = getChargesDetailValues(subItem?.id, deviceData?.details?.prepSecs);
        groupDetail?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 2;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 1];
            // IQX_WEBEST-301
            if (inputData?.split(',') !== undefined) {
              inputData = inputData?.split(',')?.[0];
            }
            deviceData.details.prepSecs[groupDetail[0]] = inputData !== undefined ? setTimetoSec(inputData) : item;
          }
        });
        index++;
      });
    });

    inputData = [];
    if (workType === WorkType.SmSurface && types === ServiceClass.SheetMetal) {
      let childPartAreaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );
      inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      //面積マスタ
      deviceData?.details?.childPartsCoeffAreaThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inVal = inputData[index + 1]?.replace('～', '');
          inVal = inVal?.replace('cm2', '');
          inVal = inVal !== undefined ? Number(inVal) : item.value;
          item.value = inVal !== undefined ? inVal : item.value;
        });

      //重量マスタ
      let childPartWeightIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );
      deviceData?.details?.childPartsCoeffWeightThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
          inVal = inputData[0]?.replace('kg', '');
          inVal = inVal !== undefined ? Number(inVal) : item.value;
          item.value = inVal !== undefined ? inVal : item.value;
          //係数値
          deviceData?.details?.childPartsCoeff
            ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
            ?.areaCoeffList?.map((area, i) => {
              inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
              area.value = inVal !== undefined ? inVal : area.value;
            });
        });

      // 段取設定の段取個数係数
      inputData = [];
      let dandoriQtyIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );
      inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
      deviceData?.details?.prepQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inVal = inputData[index + 1]?.replace('～', '');
          inVal = inVal?.replace('個', '');
          item.value = inVal !== undefined ? Number(inVal) : item.value;
        });
      inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
      deviceData?.details?.prepQtyCoeffItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row, index) => {
          inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
          row.value = inVal !== undefined ? inVal : row.value;
        });
    } else if (workType === WorkType.PaSurface && types === ServiceClass.Parent) {
      // 段取係数1
      let childPartAreaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );
      inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      deviceData?.details?.prepThQtyMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inVal = inputData[index + 1]?.replace('～', '');
          inVal = inVal?.replace('個', '');
          item.value = inVal !== undefined ? Number(inVal) : item.value;
        });
      inputData = dataList?.[childPartAreaIndex + 2]?.split(',');
      deviceData?.details?.prepCoeffThChildQtyItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row, index) => {
          inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
          row.value = inVal !== undefined ? inVal : row.value;
        });

      // 段取係数2
      let childPartWeightIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );
      inputData = dataList?.[childPartWeightIndex + 1]?.split(',');
      deviceData?.details?.prepCoeffThWeightMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inVal = inputData[index + 1]?.replace('～', '');
          inVal = inVal?.replace('kg', '');
          item.value = inVal !== undefined ? Number(inVal) : item.value;
        });
      inputData = dataList?.[childPartWeightIndex + 2]?.split(',');
      deviceData?.details?.prepCoeffThWeightItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row, index) => {
          inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
          row.value = inVal !== undefined ? inVal : row.value;
        });
    }

    // 加工時間
    //加工時間-面積マスタ
    inputData = [];
    let workIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    inputData = dataList?.[workIndex + 1]?.split(',');
    deviceData?.details?.areaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //加工時間-値
    inputData = [];
    let workTimeIndex = 0;
    if (deviceData?.details?.workTimeThItems) {
      Object.entries(deviceData?.details?.workTimeThItems)?.map(([key, data]) => {
        let groupNm = processMstRecord?.details?.processDetailTypes?.filter(
          (subitem) => subitem.id === parseInt(key) && subitem.isUsed === true
        )?.[0]?.name;
        if (groupNm && groupNm !== '') {
          inputData = dataList?.[workIndex + 2 + workTimeIndex]?.split(',');
          if (inputData && inputData[0] == groupNm) {
            data?.map((row, i) => {
              inVal = inputData[i + 1];
              inVal = inVal !== undefined ? setTimetoSec(inVal) : row.value;
              row.value = inVal;
            });
          }
          workTimeIndex++;
        }
      });
    }

    // 重量係数
    inputData = [];
    let weightCoeffIndex = 0;
    if (workType === WorkType.SmSurface && types === ServiceClass.SheetMetal) {
      weightCoeffIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      );
    } else if (workType === WorkType.PaSurface && types === ServiceClass.Parent) {
      weightCoeffIndex = dataList?.findIndex(
        (item, index) =>
          item === detailMenuTab[5] ||
          (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
            dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
      );
    }
    inputData = dataList?.[weightCoeffIndex + 1]?.split(',');
    deviceData?.details?.prodWeightCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    inputData = dataList?.[weightCoeffIndex + 2]?.split(',');
    deviceData?.details?.prodWeightCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        item.value = toDecimal(inputData[index + 1], 2);
      });

    // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        // CSVデータに基づいて新しい配列を完全に再構築する
        // inputDataMaster[0]はヘッダーなので、[1]から処理を開始
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('個', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null; // 不正な値はnullにする
          })
          .filter((item) => item !== null); // nullを取り除く

        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        // CSVデータに基づいて新しい配列を完全に再構築する
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 検査処理のCSV入力処理
  const kensaCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let timeData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (timeData?.split(',') !== undefined) {
      timeData = timeData?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.prepBasicTime;

    let inputData = [];
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      // // 段取設定の子部品サイズ係数
      // let childPartAreaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      // //面積マスタ
      // deviceData?.details?.childPartsCoeffAreaThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('cm2', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });

      // //重量マスタ
      // let childPartWeightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // deviceData?.details?.childPartsCoeffWeightThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
      //     inVal = inputData[0]?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //     //係数値
      //     deviceData?.details?.childPartsCoeff
      //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
      //       ?.areaCoeffList?.map((area, i) => {
      //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
      //         area.value = inVal !== undefined ? inVal : area.value;
      //       });
      //   });

      // 段取設定の子部品サイズ係数
      const childPartSizeIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );

      if (childPartSizeIndex > -1 && deviceData?.details) {
        // --- childPartsCoeffAreaThMasterの更新 ---
        const inputDataAreaMaster = dataList?.[childPartSizeIndex + 1]?.split(',');
        if (inputDataAreaMaster) {
          const newAreaMasterArray = inputDataAreaMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('cm2', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.childPartsCoeffAreaThMaster = newAreaMasterArray;
        }

        // --- childPartsCoeffWeightThMaster と childPartsCoeff の更新 ---
        if (deviceData.details.childPartsCoeffWeightThMaster && deviceData.details.childPartsCoeff) {
          const newWeightMasterArray = [];
          const newChildPartsCoeff = JSON.parse(JSON.stringify(deviceData.details.childPartsCoeff));

          deviceData.details.childPartsCoeffWeightThMaster.forEach((masterItem, index) => {
            const inputDataRow = dataList?.[childPartSizeIndex + 2 + index]?.split(',');
            if (inputDataRow && inputDataRow.length > 0) {
              const weightVal = inputDataRow[0]?.replace('kg', '');
              const weightNum = Number(weightVal);
              if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
                newWeightMasterArray.push({ ...masterItem, value: weightNum });

                const coeffItemToUpdate = newChildPartsCoeff.find((itemCoeff) => itemCoeff.weightId === masterItem.no);

                if (coeffItemToUpdate) {
                  const newAreaCoeffList = inputDataRow
                    .slice(1)
                    .map((val, i) => {
                      if (val !== undefined && val.trim() !== '') {
                        const decimalVal = toDecimal(val, 2);
                        if (decimalVal !== null && !isNaN(decimalVal)) {
                          return { no: i, value: decimalVal, isOutOfRange: false };
                        }
                      }
                      return null;
                    })
                    .filter((item) => item !== null);
                  coeffItemToUpdate.areaCoeffList = newAreaCoeffList;
                }
              }
            }
          });

          deviceData.details.childPartsCoeffWeightThMaster = newWeightMasterArray;
          deviceData.details.childPartsCoeff = newChildPartsCoeff;
        }
      }

      // 段取設定の段取個数係数
      inputData = [];
      let dandoriQtyIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );
      inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
      deviceData?.details?.prepQtyCoeffThMaster
        ?.filter((item) => !item.isOutOfRange)
        ?.map((item, index) => {
          inVal = inputData[index + 1]?.replace('～', '');
          inVal = inVal?.replace('個', '');
          item.value = inVal !== undefined ? Number(inVal) : item.value;
        });
      inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
      deviceData?.details?.prepQtyCoeffItems
        ?.filter((item) => !item.isOutOfRange)
        ?.map((row, index) => {
          inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
          row.value = inVal !== undefined ? inVal : row.value;
        });
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      // // 段取係数1
      // let childPartAreaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      // deviceData?.details?.prepThQtyMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('個', '');
      //     item.value = inVal !== undefined ? Number(inVal) : item.value;
      //   });
      // inputData = dataList?.[childPartAreaIndex + 2]?.split(',');
      // deviceData?.details?.prepCoeffThChildQtyItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((row, index) => {
      //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
      //     row.value = inVal !== undefined ? inVal : row.value;
      //   });

      // 段取係数1
      const childPartAreaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );

      if (childPartAreaIndex > -1 && deviceData?.details) {
        // --- prepThQtyMasterの更新 ---
        const inputDataMaster = dataList?.[childPartAreaIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('個', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepThQtyMaster = newMasterArray;
        }

        // --- prepCoeffThChildQtyItemsの更新 ---
        const inputDataItems = dataList?.[childPartAreaIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThChildQtyItems = newItemsArray;
        }
      }

      // // 段取係数2
      // let childPartWeightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      // );
      // inputData = dataList?.[childPartWeightIndex + 1]?.split(',');
      // deviceData?.details?.prepCoeffThWeightMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('kg', '');
      //     item.value = inVal !== undefined ? Number(inVal) : item.value;
      //   });
      // inputData = dataList?.[childPartWeightIndex + 2]?.split(',');
      // deviceData?.details?.prepCoeffThWeightItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((row, index) => {
      //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
      //     row.value = inVal !== undefined ? inVal : row.value;
      //   });

      // 段取係数2
      const childPartWeightIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );

      if (childPartWeightIndex > -1 && deviceData?.details) {
        // --- prepCoeffThWeightMasterの更新 ---
        const inputDataMaster = dataList?.[childPartWeightIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('kg', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThWeightMaster = newMasterArray;
        }

        // --- prepCoeffThWeightItemsの更新 ---
        const inputDataItems = dataList?.[childPartWeightIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThWeightItems = newItemsArray;
        }
      }
    }

    // 加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    dataTitle = dataList[chargesIndex + 1];
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      let timeData = dataList[chargesIndex + 2];
      // IQX_WEBEST-301
      if (timeData?.split(',') !== undefined) {
        timeData = timeData?.split(',')?.[0];
      }
      deviceData.details.inspectionWorkTime =
        timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.inspectionWorkTime;
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      let timeData = dataList[chargesIndex + 2];
      // IQX_WEBEST-301
      if (timeData?.split(',') !== undefined) {
        timeData = timeData?.split(',')?.[0];
      }
      deviceData.details.workBasicTime =
        timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.workBasicTime;
    }

    // 加工時間の子部品サイズ係数
    if (workType === WorkType.SmInspection && types === ServiceClass.SheetMetal) {
      // inputData = [];
      // let areaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      // );
      // inputData = dataList?.[areaIndex + 1]?.split(',');
      // //面積マスタ
      // deviceData?.details?.prodSizeAreaThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('cm2', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });

      // //重量マスタ
      // let weightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      // );
      // deviceData?.details?.prodSizeWeightThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inputData = dataList?.[weightIndex + 2 + index]?.split(',');
      //     inVal = inputData[0]?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //     //係数値
      //     deviceData?.details?.prodSizeItems
      //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
      //       ?.areaCoeffList?.map((area, i) => {
      //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
      //         area.value = inVal !== undefined ? inVal : area.value;
      //       });
      //   });

      // サイズ係数
      const sizeCoeffIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      );

      if (sizeCoeffIndex > -1 && deviceData?.details) {
        // --- prodSizeAreaThMasterの更新 ---
        const inputDataAreaMaster = dataList?.[sizeCoeffIndex + 1]?.split(',');
        if (inputDataAreaMaster) {
          const newAreaMasterArray = inputDataAreaMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('cm2', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.prodSizeAreaThMaster = newAreaMasterArray;
        }

        // --- prodSizeWeightThMaster と prodSizeItems の更新 ---
        if (deviceData.details.prodSizeWeightThMaster && deviceData.details.prodSizeItems) {
          const newWeightMasterArray = [];
          const newProdSizeItems = JSON.parse(JSON.stringify(deviceData.details.prodSizeItems));

          deviceData.details.prodSizeWeightThMaster.forEach((masterItem, index) => {
            const inputDataRow = dataList?.[sizeCoeffIndex + 2 + index]?.split(',');
            if (inputDataRow && inputDataRow.length > 0) {
              const weightVal = inputDataRow[0]?.replace('kg', '');
              const weightNum = Number(weightVal);
              if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
                newWeightMasterArray.push({ ...masterItem, value: weightNum });

                const coeffItemToUpdate = newProdSizeItems.find((itemCoeff) => itemCoeff.weightId === masterItem.no);

                if (coeffItemToUpdate) {
                  const newAreaCoeffList = inputDataRow
                    .slice(1)
                    .map((val, i) => {
                      if (val !== undefined && val.trim() !== '') {
                        const decimalVal = toDecimal(val, 2);
                        if (decimalVal !== null && !isNaN(decimalVal)) {
                          return { no: i, value: decimalVal, isOutOfRange: false };
                        }
                      }
                      return null;
                    })
                    .filter((item) => item !== null);
                  coeffItemToUpdate.areaCoeffList = newAreaCoeffList;
                }
              }
            }
          });

          deviceData.details.prodSizeWeightThMaster = newWeightMasterArray;
          deviceData.details.prodSizeItems = newProdSizeItems;
        }
      }
    } else if (workType === WorkType.PaInspection && types === ServiceClass.Parent) {
      // 重量係数
      // inputData = [];
      // let weightCoeffIndex = dataList?.findIndex(
      //   (item, index) =>
      //     item === detailMenuTab[5] ||
      //     (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
      //       dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
      // );
      // inputData = dataList?.[weightCoeffIndex + 1]?.split(',');
      // deviceData?.details?.prodWeightCoeffThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });
      // inputData = dataList?.[weightCoeffIndex + 2]?.split(',');
      // deviceData?.details?.prodWeightCoeffThItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     item.value = toDecimal(inputData[index + 1], 2);
      //   });

      // 重量係数
      const weightCoeffIndex = dataList?.findIndex(
        (item, index) =>
          item === detailMenuTab[5] ||
          (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
            dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
      );

      if (weightCoeffIndex > -1 && deviceData?.details) {
        // --- prodWeightCoeffThMasterの更新 ---
        const inputDataMaster = dataList?.[weightCoeffIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('kg', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prodWeightCoeffThMaster = newMasterArray;
        }

        // --- prodWeightCoeffThItemsの更新 ---
        const inputDataItems = dataList?.[weightCoeffIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prodWeightCoeffThItems = newItemsArray;
        }
      }
    }

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('個', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 追加工程処理のCSV入力処理
  const customCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];

    let timeData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (timeData?.split(',') !== undefined) {
      timeData = timeData?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.prepBasicTime;

    let inputData = [];
    if (workType === WorkType.SmCustom && types === ServiceClass.SheetMetal) {
      // // 段取設定の子部品サイズ係数
      // let childPartAreaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      // //面積マスタ
      // deviceData?.details?.childPartsCoeffAreaThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('cm2', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });

      // //重量マスタ
      // let childPartWeightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // deviceData?.details?.childPartsCoeffWeightThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
      //     inVal = inputData[0]?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //     //係数値
      //     deviceData?.details?.childPartsCoeff
      //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
      //       ?.areaCoeffList?.map((area, i) => {
      //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
      //         area.value = inVal !== undefined ? inVal : area.value;
      //       });
      //   });

      // 段取設定の子部品サイズ係数
      const childPartAreaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );

      if (childPartAreaIndex > -1 && deviceData?.details) {
        // --- childPartsCoeffAreaThMasterの更新 ---
        const inputDataAreaMaster = dataList?.[childPartAreaIndex + 1]?.split(',');
        if (inputDataAreaMaster) {
          const newAreaMasterArray = inputDataAreaMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('cm2', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.childPartsCoeffAreaThMaster = newAreaMasterArray;
        }

        // --- childPartsCoeffWeightThMaster と childPartsCoeff の更新 ---
        if (deviceData.details.childPartsCoeffWeightThMaster && deviceData.details.childPartsCoeff) {
          const newWeightMasterArray = [];
          const newChildPartsCoeff = JSON.parse(JSON.stringify(deviceData.details.childPartsCoeff));

          deviceData.details.childPartsCoeffWeightThMaster.forEach((masterItem, index) => {
            const inputDataRow = dataList?.[childPartAreaIndex + 2 + index]?.split(',');
            if (inputDataRow && inputDataRow.length > 0) {
              const weightVal = inputDataRow[0]?.replace('kg', '');
              const weightNum = Number(weightVal);
              if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
                newWeightMasterArray.push({ ...masterItem, value: weightNum });

                const coeffItemToUpdate = newChildPartsCoeff.find((itemCoeff) => itemCoeff.weightId === masterItem.no);

                if (coeffItemToUpdate) {
                  const newAreaCoeffList = inputDataRow
                    .slice(1)
                    .map((val, i) => {
                      if (val !== undefined && val.trim() !== '') {
                        const decimalVal = toDecimal(val, 2);
                        if (decimalVal !== null && !isNaN(decimalVal)) {
                          return { no: i, value: decimalVal, isOutOfRange: false };
                        }
                      }
                      return null;
                    })
                    .filter((item) => item !== null);
                  coeffItemToUpdate.areaCoeffList = newAreaCoeffList;
                }
              }
            }
          });

          deviceData.details.childPartsCoeffWeightThMaster = newWeightMasterArray;
          deviceData.details.childPartsCoeff = newChildPartsCoeff;
        }
      }

      // // 段取設定の段取個数係数
      // inputData = [];
      // let dandoriQtyIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      // );
      // inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
      // deviceData?.details?.prepQtyCoeffThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('個', '');
      //     item.value = inVal !== undefined ? Number(inVal) : item.value;
      //   });
      // inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
      // deviceData?.details?.prepQtyCoeffItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((row, index) => {
      //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
      //     row.value = inVal !== undefined ? inVal : row.value;
      //   });

      // 段取設定の段取個数係数
      const dandoriQtyIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );

      if (dandoriQtyIndex > -1 && deviceData?.details) {
        // --- prepQtyCoeffThMasterの更新 ---
        const inputDataMaster = dataList?.[dandoriQtyIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('個', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.prepQtyCoeffThMaster = newMasterArray;
        }

        // --- prepQtyCoeffItemsの更新 ---
        const inputDataItems = dataList?.[dandoriQtyIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const decimalVal = toDecimal(val, 2);
                if (decimalVal !== null && !isNaN(decimalVal)) {
                  return { no: i, value: decimalVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.prepQtyCoeffItems = newItemsArray;
        }
      }
    } else if (workType === WorkType.PaCustom && types === ServiceClass.Parent) {
      // // 段取係数1
      // let childPartAreaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      // );
      // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
      // deviceData?.details?.prepThQtyMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('個', '');
      //     item.value = inVal !== undefined ? Number(inVal) : item.value;
      //   });
      // inputData = dataList?.[childPartAreaIndex + 2]?.split(',');
      // deviceData?.details?.prepCoeffThChildQtyItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((row, index) => {
      //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
      //     row.value = inVal !== undefined ? inVal : row.value;
      //   });

      // 段取係数1
      const childPartAreaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
      );

      if (childPartAreaIndex > -1 && deviceData?.details) {
        // --- prepThQtyMasterの更新 ---
        const inputDataMaster = dataList?.[childPartAreaIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('個', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepThQtyMaster = newMasterArray;
        }

        // --- prepCoeffThChildQtyItemsの更新 ---
        const inputDataItems = dataList?.[childPartAreaIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThChildQtyItems = newItemsArray;
        }
      }

      // // 段取係数2
      // let childPartWeightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      // );
      // inputData = dataList?.[childPartWeightIndex + 1]?.split(',');
      // deviceData?.details?.prepCoeffThWeightMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('kg', '');
      //     item.value = inVal !== undefined ? Number(inVal) : item.value;
      //   });
      // inputData = dataList?.[childPartWeightIndex + 2]?.split(',');
      // deviceData?.details?.prepCoeffThWeightItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((row, index) => {
      //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
      //     row.value = inVal !== undefined ? inVal : row.value;
      //   });

      // 段取係数2
      const childPartWeightIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
      );

      if (childPartWeightIndex > -1 && deviceData?.details) {
        // --- prepCoeffThWeightMasterの更新 ---
        const inputDataMaster = dataList?.[childPartWeightIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('kg', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThWeightMaster = newMasterArray;
        }

        // --- prepCoeffThWeightItemsの更新 ---
        const inputDataItems = dataList?.[childPartWeightIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prepCoeffThWeightItems = newItemsArray;
        }
      }
    }

    // 加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    dataTitle = dataList[chargesIndex + 1];
    timeData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (timeData?.split(',') !== undefined) {
      timeData = timeData?.split(',')?.[0];
    }
    deviceData.details.workBasicTime =
      timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.workBasicTime;

    if (workType === WorkType.SmCustom && types === ServiceClass.SheetMetal) {
      // // 加工時間の子部品サイズ係数
      // inputData = [];
      // let areaIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      // );
      // inputData = dataList?.[areaIndex + 1]?.split(',');
      // //面積マスタ
      // deviceData?.details?.prodSizeAreaThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('cm2', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });

      // //重量マスタ
      // let weightIndex = dataList?.findIndex(
      //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      // );
      // deviceData?.details?.prodSizeWeightThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inputData = dataList?.[weightIndex + 2 + index]?.split(',');
      //     inVal = inputData[0]?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //     //係数値
      //     deviceData?.details?.prodSizeItems
      //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
      //       ?.areaCoeffList?.map((area, i) => {
      //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
      //         area.value = inVal !== undefined ? inVal : area.value;
      //       });
      //   });

      // 加工時間の子部品サイズ係数
      const areaIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
      );

      if (areaIndex > -1 && deviceData?.details) {
        // --- prodSizeAreaThMasterの更新 ---
        const inputDataAreaMaster = dataList?.[areaIndex + 1]?.split(',');
        if (inputDataAreaMaster) {
          const newAreaMasterArray = inputDataAreaMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('cm2', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.prodSizeAreaThMaster = newAreaMasterArray;
        }

        // --- prodSizeWeightThMaster と prodSizeItems の更新 ---
        if (deviceData.details.prodSizeWeightThMaster && deviceData.details.prodSizeItems) {
          const newWeightMasterArray = [];
          const newProdSizeItems = JSON.parse(JSON.stringify(deviceData.details.prodSizeItems));

          deviceData.details.prodSizeWeightThMaster.forEach((masterItem, index) => {
            const inputDataRow = dataList?.[areaIndex + 2 + index]?.split(',');
            if (inputDataRow && inputDataRow.length > 0) {
              const weightVal = inputDataRow[0]?.replace('kg', '');
              const weightNum = Number(weightVal);
              if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
                newWeightMasterArray.push({ ...masterItem, value: weightNum });

                const coeffItemToUpdate = newProdSizeItems.find((itemCoeff) => itemCoeff.weightId === masterItem.no);

                if (coeffItemToUpdate) {
                  const newAreaCoeffList = inputDataRow
                    .slice(1)
                    .map((val, i) => {
                      if (val !== undefined && val.trim() !== '') {
                        const decimalVal = toDecimal(val, 2);
                        if (decimalVal !== null && !isNaN(decimalVal)) {
                          return { no: i, value: decimalVal, isOutOfRange: false };
                        }
                      }
                      return null;
                    })
                    .filter((item) => item !== null);
                  coeffItemToUpdate.areaCoeffList = newAreaCoeffList;
                }
              }
            }
          });

          deviceData.details.prodSizeWeightThMaster = newWeightMasterArray;
          deviceData.details.prodSizeItems = newProdSizeItems;
        }
      }
    } else if (workType === WorkType.PaCustom && types === ServiceClass.Parent) {
      // // 重量係数
      // inputData = [];
      // let weightCoeffIndex = dataList?.findIndex(
      //   (item, index) =>
      //     item === detailMenuTab[5] ||
      //     (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
      //       dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
      // );
      // inputData = dataList?.[weightCoeffIndex + 1]?.split(',');
      // deviceData?.details?.prodWeightCoeffThMaster
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     inVal = inputData[index + 1]?.replace('～', '');
      //     inVal = inVal?.replace('kg', '');
      //     inVal = inVal !== undefined ? Number(inVal) : item.value;
      //     item.value = inVal !== undefined ? inVal : item.value;
      //   });
      // inputData = dataList?.[weightCoeffIndex + 2]?.split(',');
      // deviceData?.details?.prodWeightCoeffThItems
      //   ?.filter((item) => !item.isOutOfRange)
      //   ?.map((item, index) => {
      //     item.value = toDecimal(inputData[index + 1], 2);
      //   });

      // 重量係数
      const weightCoeffIndex = dataList?.findIndex(
        (item, index) =>
          item === detailMenuTab[5] ||
          (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
            dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
      );

      if (weightCoeffIndex > -1 && deviceData?.details) {
        // --- prodWeightCoeffThMasterの更新 ---
        const inputDataMaster = dataList?.[weightCoeffIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              const cleanedVal = val?.replace('～', '').replace('kg', '');
              if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
                return {
                  no: i,
                  value: Number(cleanedVal),
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prodWeightCoeffThMaster = newMasterArray;
        }

        // --- prodWeightCoeffThItemsの更新 ---
        const inputDataItems = dataList?.[weightCoeffIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              const newValue = toDecimal(val, 2);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
              return null;
            })
            .filter((item) => item !== null);

          deviceData.details.prodWeightCoeffThItems = newItemsArray;
        }
      }
    }

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('個', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    // 委託装置詳細
    inputData = [];
    let commissionIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );
    inputData = dataList?.[commissionIndex + 1]?.split(',');
    if (inputData?.[0] === '委託工程' || inputData?.[0]?.includes('委託工程')) {
      deviceData.details.isCommission =
        inputData?.[1] !== undefined ? JSON.parse(inputData?.[1]?.toLowerCase()) : deviceData?.details?.isCommission; // IQX_WEBEST-301
    }
    if (deviceData?.details?.isCommission) {
      inputData = dataList?.[commissionIndex + 2]?.split(',');
      let customerNm = '';
      let customers = [];
      if (inputData?.[0] === '取引先(委託先)' || inputData?.[0]?.includes('取引先(委託先)')) {
        customerNm = inputData?.[1];
      }
      inputData = dataList?.[commissionIndex + 3]?.split(',');
      if (inputData?.[0] === '取引先コード' || inputData?.[0]?.includes('取引先コード')) {
        // IQX_WEBEST-381 パラメーター親部品装置設定と板金装置設定のCSV出力処理ができていない。
        if (customerNm !== '' && inputData?.[1] !== '') {
          customers = props?.getCustomers?.data?.filter(
            (item) => item.code === inputData?.[1] && item.name === customerNm
          );
        } else if (customerNm !== '' && inputData?.[1] === '') {
          customers = props?.getCustomers?.data?.filter((item) => item.name === customerNm);
        } else if (customerNm === '' && inputData?.[1] !== '') {
          customers = props?.getCustomers?.data?.filter((item) => item.code === inputData?.[1]);
        }
        if (customers?.length > 0) {
          deviceData.details.clientId = customers?.[0]?.id;
        }
      }
    } else {
      deviceData.details.clientId = 0;
    }
    inputData = dataList?.[commissionIndex + 4]?.split(',');
    if (inputData?.[0] === '手入力フラグ' || inputData?.[0]?.includes('手入力フラグ')) {
      deviceData.details.isManualInput =
        inputData?.[1] !== undefined ? JSON.parse(inputData?.[1]?.toLowerCase()) : deviceData?.details?.isManualInput; // IQX_WEBEST-301
    }
    inputData = dataList?.[commissionIndex + 5]?.split(',');
    if (inputData?.[0] === '初期金額(手入力時)' || inputData?.[0]?.includes('初期金額(手入力時)')) {
      deviceData.details.initPrice =
        inputData?.[1] !== undefined ? Number(inputData?.[1]) : deviceData?.details?.initPrice;
    }
    return deviceData;
  };

  // 組立・梱包処理のCSV入力処理
  const assenblePackingCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let timeData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (timeData?.split(',') !== undefined) {
      timeData = timeData?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.prepBasicTime;

    let inputData = [];

    // // 段取係数1
    // let childPartAreaIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    // );
    // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    // deviceData?.details?.prepThQtyMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // inputData = dataList?.[childPartAreaIndex + 2]?.split(',');
    // deviceData?.details?.prepCoeffThChildQtyItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((row, index) => {
    //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
    //     row.value = inVal !== undefined ? inVal : row.value;
    //   });

    // 段取係数1
    const childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );

    if (childPartAreaIndex > -1 && deviceData?.details) {
      // --- prepThQtyMasterの更新 ---
      const inputDataMaster = dataList?.[childPartAreaIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('個', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepThQtyMaster = newMasterArray;
      }

      // --- prepCoeffThChildQtyItemsの更新 ---
      const inputDataItems = dataList?.[childPartAreaIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepCoeffThChildQtyItems = newItemsArray;
      }
    }

    // // 段取係数2
    // let childPartWeightIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    // );
    // inputData = dataList?.[childPartWeightIndex + 1]?.split(',');
    // deviceData?.details?.prepCoeffThWeightMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('kg', '');
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // inputData = dataList?.[childPartWeightIndex + 2]?.split(',');
    // deviceData?.details?.prepCoeffThWeightItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((row, index) => {
    //     inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
    //     row.value = inVal !== undefined ? inVal : row.value;
    //   });

    // 段取係数2
    const childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );

    if (childPartWeightIndex > -1 && deviceData?.details) {
      // --- prepCoeffThWeightMasterの更新 ---
      const inputDataMaster = dataList?.[childPartWeightIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('kg', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepCoeffThWeightMaster = newMasterArray;
      }

      // --- prepCoeffThWeightItemsの更新 ---
      const inputDataItems = dataList?.[childPartWeightIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepCoeffThWeightItems = newItemsArray;
      }
    }

    // 加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    dataTitle = dataList[chargesIndex + 1];

    timeData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (timeData?.split(',') !== undefined) {
      timeData = timeData?.split(',')?.[0];
    }
    deviceData.details.workBasicTime =
      timeData !== undefined ? setTimetoSec(timeData) : deviceData?.details?.workBasicTime;

    // // 加工時間の 重量係数
    // inputData = [];
    // let weightCoeffIndex = dataList?.findIndex(
    //   (item, index) =>
    //     item === detailMenuTab[5] ||
    //     (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
    //       dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
    // );
    // inputData = dataList?.[weightCoeffIndex + 1]?.split(',');
    // deviceData?.details?.prodWeightCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('kg', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[weightCoeffIndex + 2]?.split(',');
    // deviceData?.details?.prodWeightCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 加工時間の 重量係数
    const weightCoeffIndex = dataList?.findIndex(
      (item, index) =>
        item === detailMenuTab[5] ||
        (dataList?.[index]?.split(',')?.[0] === detailMenuTab[5] &&
          dataList?.[index + 3]?.split(',')?.[0] === detailMenuTab[6])
    );

    if (weightCoeffIndex > -1 && deviceData?.details) {
      // --- prodWeightCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[weightCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('kg', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prodWeightCoeffThMaster = newMasterArray;
      }

      // --- prodWeightCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[weightCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prodWeightCoeffThItems = newItemsArray;
      }
    }

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('個', '');
            if (cleanedVal !== undefined && cleanedVal.trim() !== '') {
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            const newValue = toDecimal(val, 2);
            if (newValue !== null && !isNaN(newValue)) {
              return {
                no: i,
                value: newValue,
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // プログラムのCSV入力処理
  const programCSVImport = (deviceData, dataList, detailMenuTab) => {
    // プログラムの場合
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    inputData = dataList?.[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = parseInt(inputData?.[0]);
    deviceData.details.charges.work = parseInt(inputData?.[1]);

    // // 段取設定
    // let dantoriIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    // );
    // inputData = [];
    // inputData = dataList?.[dantoriIndex + 2]?.split(',');
    // deviceData?.details?.prepElementThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = setTimetoSec(inputData[index + 1]);
    //   });

    // 段取設定
    const dantoriIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );

    if (dantoriIndex > -1 && deviceData?.details) {
      // --- prepElementThMasterの更新 ---
      const inputDataMaster = dataList?.[dantoriIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              // '～' を削除してから数値に変換
              const cleanedVal = val.replace('～', '');
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepElementThMaster = newMasterArray;
      }

      // --- prepElementThItemsの更新 ---
      const inputDataItems = dataList?.[dantoriIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const newValue = setTimetoSec(val);
              if (newValue !== null && !isNaN(newValue)) {
                return {
                  no: i,
                  value: newValue,
                  isOutOfRange: false,
                };
              }
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.prepElementThItems = newItemsArray;
      }
    }

    // 加工設定
    inputData = [];
    let workCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[workCoeffIndex + 2]?.split(',');
    deviceData.details.workBasicTime = setTimetoSec(inputData[0]);

    // 係数・その他
    inputData = [];
    let coeffOtherIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[coeffOtherIndex + 2]?.split(',');
    deviceData?.details?.workTimeElementCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        item.value = toDecimal(inputData[index + 1], 2);
      });

    // 同一形状・サイズの上限
    inputData = [];
    inputData = dataList?.[coeffOtherIndex + 4]?.split(',');
    deviceData.details.shapeGrouping = parseInt(inputData[0]);

    return deviceData;
  };

  // シャーリングのCSV入力処理
  const shearingCSVImport = (deviceData, dataList, detailMenuTab) => {
    // シャーリングの場合
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    inputData = dataList?.[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = parseInt(inputData?.[0]);
    deviceData.details.charges.work = parseInt(inputData?.[1]);

    // 段取設定
    let dantoriIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    inputData = [];
    inputData = dataList?.[dantoriIndex + 2]?.split(',');
    deviceData.details.prepBasicTime = setTimetoSec(inputData[0]);

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // 作業・加工時間
    inputData = [];
    let workCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    inputData = dataList?.[workCoeffIndex + 2]?.split(',');
    deviceData.details.cutTime = inputData[0] !== undefined ? setTimetoSec(inputData[0]) : deviceData?.details?.cutTime;
    deviceData.details.isOneCut =
      inputData[1] !== undefined ? JSON.parse(inputData[1]?.toLowerCase()) : deviceData?.details?.isOneCut; // IQX_WEBEST-301

    // サイズ係数
    inputData = [];
    childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 生産個数係数
    inputData = [];
    let productCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );
    inputData = dataList?.[productCoeffIndex + 1]?.split(',');
    deviceData?.details?.productionQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    inputData = dataList?.[productCoeffIndex + 2]?.split(',');
    deviceData?.details?.productionQtyCoeffThItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        item.value = toDecimal(inputData[index + 1], 2);
      });

    return deviceData;
  };

  // ベンディン処理のCSV入力処理
  const bendingCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // // 段取設定
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    // );
    // let chargesItemIndex = chargesIndex + 2;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // //板厚マスタ
    // deviceData?.details?.basicTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('曲', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // chargesItemIndex = chargesItemIndex + 1;
    // let index = 0;
    // if (deviceData?.details?.basicTimeThickItems) {
    //   Object.entries(deviceData?.details?.basicTimeThickItems)
    //     ?.filter(([itemKey]) => getProcessDetailTypeName(parseInt(itemKey), processMstRecord) !== undefined)
    //     ?.map(([key, groupItem]) => {
    //       inputData = dataList[chargesItemIndex + index]?.split(',');
    //       let groupNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //       if (groupNm === inputData?.[0]) {
    //         deviceData?.details?.basicTimeThickItems?.[parseInt(key)]
    //           ?.filter((subitem) => !subitem.isOutOfRange)
    //           ?.map((col, index) => {
    //             inVal = inputData[index + 1];
    //             col.value = inVal !== undefined ? setTimetoSec(inVal) : col.value;
    //           });
    //       }
    //       index++;
    //     });
    // }

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );

    if (chargesIndex > -1 && deviceData?.details) {
      // --- basicTimeThickThMasterの更新 ---
      const inputDataMaster = dataList?.[chargesIndex + 2]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('曲', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.basicTimeThickThMaster = newMasterArray;
      }

      // --- basicTimeThickItemsの更新 ---
      if (deviceData.details.basicTimeThickItems) {
        const newBasicTimeThickItems = { ...deviceData.details.basicTimeThickItems };
        let csvRowIndexOffset = 0;

        Object.keys(newBasicTimeThickItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const currentRowIndex = chargesIndex + 3 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');
            const groupName = getProcessDetailTypeName(parseInt(key), processMstRecord);

            if (inputDataItems && groupName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const timeInSec = setTimetoSec(val);
                    if (timeInSec !== null && !isNaN(timeInSec)) {
                      return { no: i, value: timeInSec, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newBasicTimeThickItems[key] = newItemsArray;
              csvRowIndexOffset++;
            }
          });
        deviceData.details.basicTimeThickItems = newBasicTimeThickItems;
      }
    }

    // プログラム作成時間
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    // );
    // inputData = dataList[chargesIndex + 1]?.split(',');
    // deviceData?.details?.programCreateTimeCountfThMaster
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('本', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList[chargesIndex + 2]?.split(',');
    // deviceData?.details?.programCreateTimeItems
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //   });

    // プログラム作成時間
    const programTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );

    if (programTimeIndex > -1 && deviceData?.details) {
      // --- programCreateTimeCountfThMasterの更新 ---
      const inputDataMaster = dataList?.[programTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('本', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.programCreateTimeCountfThMaster = newMasterArray;
      }

      // --- programCreateTimeItemsの更新 ---
      const inputDataItems = dataList?.[programTimeIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.programCreateTimeItems = newItemsArray;
      }
    }

    // // 曲長段取時間
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    // );
    // inputData = dataList[chargesIndex + 1]?.split(',');
    // deviceData?.details?.prepBendTimeLengthMaster
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList[chargesIndex + 2]?.split(',');
    // deviceData?.details?.prepBendTimeItems
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //   });

    // 曲長段取時間
    const bendTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );

    if (bendTimeIndex > -1 && deviceData?.details) {
      // --- prepBendTimeLengthMasterの更新 ---
      const inputDataMaster = dataList?.[bendTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepBendTimeLengthMaster = newMasterArray;
      }

      // --- prepBendTimeItemsの更新 ---
      const inputDataItems = dataList?.[bendTimeIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepBendTimeItems = newItemsArray;
      }
    }

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 加工時間
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // let chargesItemIndex = chargesIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // //板厚マスタ
    // deviceData?.details?.workTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // chargesItemIndex = chargesItemIndex + 1;
    // let index = 0;
    // if (deviceData?.details?.workTimeThickItems) {
    //   Object.entries(deviceData?.details?.workTimeThickItems)
    //     ?.filter(([itemKey]) => getProcessDetailTypeName(parseInt(itemKey), processMstRecord) !== undefined)
    //     ?.map(([key, groupItem]) => {
    //       inputData = dataList[chargesItemIndex + index]?.split(',');
    //       let groupNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //       if (groupNm === inputData?.[0] || inputData?.[0]?.includes(groupNm)) {
    //         deviceData?.details?.workTimeThickItems?.[parseInt(key)]
    //           ?.filter((subitem) => !subitem.isOutOfRange)
    //           ?.map((col, index) => {
    //             inVal = inputData[index + 1];
    //             col.value = inVal !== undefined ? setTimetoSec(inVal) : col.value;
    //           });
    //       }
    //       index++;
    //     });
    // }

    // 加工時間
    const workIndexCsv = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (workIndexCsv > -1 && deviceData?.details) {
      // --- workTimeThickThMasterの更新 ---
      const inputDataMaster = dataList?.[workIndexCsv + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workTimeThickThMaster = newMasterArray;
      }

      // --- workTimeThickItemsの更新 ---
      if (deviceData.details.workTimeThickItems) {
        const newWorkTimeThickItems = { ...deviceData.details.workTimeThickItems };
        let csvRowIndexOffset = 0;

        Object.keys(newWorkTimeThickItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const currentRowIndex = workIndexCsv + 2 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');
            const groupName = getProcessDetailTypeName(parseInt(key), processMstRecord);

            if (inputDataItems && (groupName === inputDataItems[0] || inputDataItems[0]?.includes(groupName))) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const timeInSec = setTimetoSec(val);
                    if (timeInSec !== null && !isNaN(timeInSec)) {
                      return { no: i, value: timeInSec, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newWorkTimeThickItems[key] = newItemsArray;
            }
            csvRowIndexOffset++;
          });
        deviceData.details.workTimeThickItems = newWorkTimeThickItems;
      }
    }

    // // 曲げ長さ係数
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // let chargesItemIndex = chargesIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // //面積マスタ
    // deviceData?.details?.bendTimeCoeffLenThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //重量マスタ
    // let index = 0;
    // chargesItemIndex = chargesItemIndex + 1;
    // deviceData?.details?.bendTimeCoeffWeightThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inputData = dataList[chargesItemIndex + index]?.split(',');
    //     inVal = inputData[0]?.replace('kg', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //     //係数値
    //     deviceData?.details?.bendTimeCoeffWeightLenItems
    //       ?.filter((itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no)?.[0]
    //       ?.lengthCoeffList?.map((row, i) => {
    //         inVal = inputData[i + 1];
    //         row.value = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       });
    //     index++;
    //   });

    // 曲げ長さ係数
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (chargesIndex > -1 && deviceData?.details) {
      // --- bendTimeCoeffLenThMasterの更新 ---
      const inputDataLenMaster = dataList?.[chargesIndex + 1]?.split(',');
      if (inputDataLenMaster) {
        const newLenMasterArray = inputDataLenMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.bendTimeCoeffLenThMaster = newLenMasterArray;
      }

      // --- bendTimeCoeffWeightThMaster and bendTimeCoeffWeightLenItemsの更新 ---
      if (deviceData.details.bendTimeCoeffWeightThMaster && deviceData.details.bendTimeCoeffWeightLenItems) {
        const newMasterArray = [];
        const newItemsArray = [];

        const originalMaster = deviceData.details.bendTimeCoeffWeightThMaster;
        const originalItems = deviceData.details.bendTimeCoeffWeightLenItems;

        let index = 0;

        while (true) {
          const inputDataRow = dataList?.[chargesIndex + 2 + index]?.split(',');

          const weightVal = inputDataRow?.[0]?.replace('kg', '');
          const numWeightVal = Number(weightVal);

          if (inputDataRow === undefined || weightVal === undefined || weightVal.trim() === '' || isNaN(numWeightVal)) {
            break;
          }

          const originalMasterItem = originalMaster[index];
          const itemNo = originalMasterItem?.no !== undefined ? originalMasterItem.no : index;

          newMasterArray.push({
            ...(originalMasterItem || {}),
            no: itemNo,
            value: numWeightVal,
          });

          const originalCoeffItem = originalItems.find((coeff) => coeff.weightId === itemNo);

          const coeffItemToUpdate = {
            ...(originalCoeffItem || {}),
            weightId: itemNo,
          };

          const newLengthCoeffList = inputDataRow
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const decimalVal = toDecimal(val, 2);
                if (decimalVal !== null && !isNaN(decimalVal)) {
                  return { no: i, value: decimalVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);

          coeffItemToUpdate.lengthCoeffList = newLengthCoeffList;
          newItemsArray.push(coeffItemToUpdate);

          index++;
        }

        deviceData.details.bendTimeCoeffWeightThMaster = newMasterArray;
        deviceData.details.bendTimeCoeffWeightLenItems = newItemsArray;
      }
    }

    // // 加工補正時間
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    // );
    // let chargesItemIndex = chargesIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // deviceData?.details?.modifyTimeQtyThMaster
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('本', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // inputData = dataList[chargesItemIndex + 1]?.split(',');
    // deviceData?.details?.modifyTimeItems
    //   ?.filter((subitem) => !subitem.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //   });

    // 加工補正時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );

    if (chargesIndex > -1 && deviceData?.details) {
      // --- modifyTimeQtyThMasterの更新 ---
      const inputDataMaster = dataList?.[chargesIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('本', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.modifyTimeQtyThMaster = newMasterArray;
      }

      // --- modifyTimeItemsの更新 ---
      const inputDataItems = dataList?.[chargesIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.modifyTimeItems = newItemsArray;
      }
    }

    // // 加工補正時間係数
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    // );
    // let chargesItemIndex = chargesIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // //面積マスタ
    // deviceData?.details?.modifyCoeffLenThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //重量マスタ
    // let index = 0;
    // chargesItemIndex = chargesItemIndex + 1;
    // deviceData?.details?.modifyCoeffWeightThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item) => {
    //     inputData = dataList[chargesItemIndex + index]?.split(',');
    //     inVal = inputData[0]?.replace('kg', '');
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //     //係数値
    //     deviceData?.details?.modifyCoeffItems
    //       ?.filter((itemCoef) => !itemCoef.isOutOfRange && itemCoef.weightId === item.no)?.[0]
    //       ?.lengthCoeffList?.map((row, i) => {
    //         inVal = inputData[i + 1];
    //         row.value = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       });
    //     index++;
    //   });

    // 加工補正時間係数
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );

    if (chargesIndex > -1 && deviceData?.details) {
      // --- modifyCoeffLenThMasterの更新 ---
      const inputDataLenMaster = dataList?.[chargesIndex + 1]?.split(',');
      if (inputDataLenMaster) {
        const newLenMasterArray = inputDataLenMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.modifyCoeffLenThMaster = newLenMasterArray;
      }

      // --- modifyCoeffWeightThMaster and modifyCoeffItemsの更新 ---
      if (deviceData.details.modifyCoeffWeightThMaster && deviceData.details.modifyCoeffItems) {
        const newMasterArray = [];
        const newItemsArray = [];

        const originalMaster = deviceData.details.modifyCoeffWeightThMaster;
        const originalItems = deviceData.details.modifyCoeffItems;

        let index = 0;

        while (true) {
          const inputDataRow = dataList?.[chargesIndex + 2 + index]?.split(',');

          const weightVal = inputDataRow?.[0]?.replace('kg', '');
          const numWeightVal = Number(weightVal);

          if (inputDataRow === undefined || weightVal === undefined || weightVal.trim() === '' || isNaN(numWeightVal)) {
            break;
          }

          const originalMasterItem = originalMaster[index];
          const itemNo = originalMasterItem?.no !== undefined ? originalMasterItem.no : index;

          newMasterArray.push({
            ...(originalMasterItem || {}),
            no: itemNo,
            value: numWeightVal,
          });

          const originalCoeffItem = originalItems.find((coeff) => coeff.weightId === itemNo);

          const coeffItemToUpdate = {
            ...(originalCoeffItem || {}),
            weightId: itemNo,
          };

          const newAreaCoeffList = inputDataRow
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const decimalVal = toDecimal(val, 2);
                if (decimalVal !== null && !isNaN(decimalVal)) {
                  const originalListItem = originalCoeffItem?.lengthCoeffList?.[i] || {};
                  return {
                    ...originalListItem,
                    no: i,
                    value: decimalVal,
                    isOutOfRange: false,
                  };
                }
              }
              return null;
            })
            .filter((item) => item !== null);

          coeffItemToUpdate.lengthCoeffList = newAreaCoeffList;

          newItemsArray.push(coeffItemToUpdate);

          index++;
        }

        deviceData.details.modifyCoeffWeightThMaster = newMasterArray;
        deviceData.details.modifyCoeffItems = newItemsArray;
      }
    }

    // サイズ係数
    inputData = [];
    childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 自動バリ処理のCSV入力処理
  const autoDeburCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.prepBasicTime;

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 加工時間
    // chargesIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // let chargesItemIndex = chargesIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // //面積マスタ
    // deviceData?.details?.areaThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('cm2', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // chargesItemIndex = chargesItemIndex + 1;
    // inputData = dataList[chargesItemIndex]?.split(',');
    // deviceData?.details?.workTimeThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     inVal = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // 加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (chargesIndex > -1 && deviceData?.details) {
      // --- areaThMasterの更新 ---
      const inputDataMaster = dataList?.[chargesIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('cm2', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.areaThMaster = newMasterArray;
      }

      // --- workTimeThItemsの更新 ---
      const inputDataItems = dataList?.[chargesIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workTimeThItems = newItemsArray;
      }
    }

    // サイズ係数
    inputData = [];
    childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? toDecimal(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = toDecimal(cleanedVal, 2);
              if (numVal !== null && !isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 手動バリ処理のCSV入力処理
  const manualDeburCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.prepBasicTime;

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // 加工速度(mm/min)
    inputData = [];
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    //板厚マスタ
    deviceData?.details?.workSpeedThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('t', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //加工速度
    let speedLenIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    // let workSpeed = dataList?.[speedLenIndex + 2];
    // deviceData.details.workSpeed = workSpeed !== undefined ? setTimetoSec(workSpeed) : deviceData?.details?.workSpeed;

    let workSpeedRow = dataList?.[speedLenIndex + 2];
    if (workSpeedRow) {
      // 行の文字列をカンマで分割し、最初の要素（時間部分）だけを取得します
      const timeValue = workSpeedRow.split(',')[0];
      deviceData.details.workSpeed = setTimetoSec(timeValue);
    }
    // deviceData?.details?.workSpeedLenThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //     inVal = inputData[0]?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;

    //     deviceData?.details?.workSpeedItems
    //       ?.filter((itemCoeff) => itemCoeff.lengthId === item.no)?.[0]
    //       ?.itaatsuCoeffList?.map((itaatsu, i) => {
    //         inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : itaatsu.value;
    //         itaatsu.value = inVal !== undefined ? inVal : itaatsu.value;
    //       });
    //   });

    // 加工速度係数
    //加工長マスタ
    inputData = [];
    let speedCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[speedCoeffIndex + 1]?.split(',');
    deviceData?.details?.workSpeedCoeffLengthThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('mm', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //内加工
    inputData = dataList?.[speedCoeffIndex + 2]?.split(',');
    deviceData?.details?.workSpeedCoeffInternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        inVal = inVal !== undefined ? toDecimal(inVal, 2) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //外加工
    inputData = dataList?.[speedCoeffIndex + 3]?.split(',');
    deviceData?.details?.workSpeedCoeffExternalWorkItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        inVal = inVal !== undefined ? toDecimal(inVal, 2) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    // 加工補正時間
    //加工長マスタ
    inputData = [];
    speedCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );
    inputData = dataList?.[speedCoeffIndex + 1]?.split(',');
    deviceData?.details?.modifyTimeQtyThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //加工時間-値
    inputData = dataList?.[speedCoeffIndex + 2]?.split(',');
    deviceData?.details?.modifyTimeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        inVal = inVal !== undefined ? setTimetoSec(inVal, 2) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    // 加工補正時間係数
    inputData = [];
    speedCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );
    inputData = dataList?.[speedCoeffIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.mtAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );
    deviceData?.details?.mtWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.mtTimeCoeffItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 手動バリ取対象サイズ
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );
    dataTitle = dataList[chargesIndex + 1];
    let sizeData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.roundHoleDia = sizeData?.[0] ? sizeData?.[0] : deviceData?.details?.roundHoleDia;
    deviceData.details.rectangleDia = sizeData?.[1] ? sizeData?.[1] : deviceData?.details?.rectangleDia;

    // サイズ係数
    inputData = [];
    childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = toDecimal(cleanedVal, 2); // Corrected from Number(inVal, 2)
              if (numVal !== null && !isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 溶接処理のCSV入力処理
  const weldCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    let index = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let chargesItemIndex = chargesIndex + 1;
    const groupDisplayList = getProcessDetailTypesInfo(deviceData?.details?.charges, processMstRecord);
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        getChargesDetailValues(subItem?.id, deviceData?.details?.charges)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 3;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 2]?.split(',');
            item.prep = inputData?.[0] ? parseInt(inputData?.[0]) : item.prep;
            item.work = inputData?.[1] ? parseInt(inputData?.[1]) : item.work;
          }
        });
        index++;
      });
    });

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    chargesItemIndex = chargesIndex + 1;
    inputData = [];
    index = 0;
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        let groupDetail = getPrepSettingDetailValues(subItem?.id, deviceData?.details?.prepSecs);
        groupDetail?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 2;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 1];
            // IQX_WEBEST-301
            if (inputData?.split(',') !== undefined) {
              inputData = inputData?.split(',')?.[0];
            }
            deviceData.details.prepSecs[groupDetail[0]] = inputData !== undefined ? setTimetoSec(inputData) : item;
          }
        });
        index++;
      });
    });

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 加工速度(mm/min)
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.workSpeedThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //加工速度
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // if (deviceData?.details?.workSpeedThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.workSpeedThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.workSpeedThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 加工速度(mm/min)
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (thickIndex > -1 && deviceData?.details) {
      // --- workSpeedThMasterの更新 ---
      const inputDataMaster = dataList?.[thickIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedThMaster = newMasterArray;
      }

      // --- workSpeedThItemsの更新 ---
      if (deviceData.details.workSpeedThItems) {
        const usedIds = processMstRecord?.details?.processDetailTypes
          ?.filter((item) => item.isUsed)
          ?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newWorkSpeedItems = { ...deviceData.details.workSpeedThItems }; // Create a copy to modify

          Object.keys(newWorkSpeedItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[thickIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const numVal = Number(val);
                      if (!isNaN(numVal)) {
                        return { no: i, value: numVal, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newWorkSpeedItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.workSpeedThItems = newWorkSpeedItems;
        }
      }
    }

    // // 仮付時間
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.tempInstThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // // 仮付時間
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    // );
    // if (deviceData?.details?.tempInstThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.tempInstThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.tempInstThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? setTimetoSec(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 仮付時間
    const tempInstIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );

    if (tempInstIndex > -1 && deviceData?.details) {
      // --- tempInstThMasterの更新 ---
      const inputDataMaster = dataList?.[tempInstIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.tempInstThMaster = newMasterArray;
      }

      // --- tempInstThItemsの更新 ---
      if (deviceData.details.tempInstThItems) {
        const usedIds = processMstRecord?.details?.processDetailTypes
          ?.filter((item) => item.isUsed)
          ?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newTempInstItems = { ...deviceData.details.tempInstThItems }; // Create a copy to modify

          Object.keys(newTempInstItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[tempInstIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const timeInSec = setTimetoSec(val);
                      if (timeInSec !== null && !isNaN(timeInSec)) {
                        return { no: i, value: timeInSec, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newTempInstItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.tempInstThItems = newTempInstItems;
        }
      }
    }

    // // 取付時間(板厚判断)
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.instThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // // 取付時間
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // if (deviceData?.details?.instThickThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.instThickThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.instThickThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? setTimetoSec(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 取付時間(板厚判断)
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (thickIndex > -1 && deviceData?.details) {
      // --- instThickThMasterの更新 ---
      const inputDataMaster = dataList?.[thickIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.instThickThMaster = newMasterArray;
      }

      // --- instThickThItemsの更新 ---
      if (deviceData.details.instThickThItems) {
        const usedIds = processMstRecord?.details?.processDetailTypes
          ?.filter((item) => item.isUsed)
          ?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newInstThickItems = { ...deviceData.details.instThickThItems }; // Create a copy to modify

          Object.keys(newInstThickItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[thickIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const timeInSec = setTimetoSec(val);
                      if (timeInSec !== null && !isNaN(timeInSec)) {
                        return { no: i, value: timeInSec, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newInstThickItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.instThickThItems = newInstThickItems;
        }
      }
    }

    // // 取付時間(サイズ判断)
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.instSizeThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('M', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // // 取付時間
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // if (deviceData?.details?.instSizeThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.instSizeThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.instSizeThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? setTimetoSec(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 取付時間(サイズ判断)
    const sizeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (sizeIndex > -1 && deviceData?.details) {
      // --- instSizeThMasterの更新 ---
      const inputDataMaster = dataList?.[sizeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('M', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.instSizeThMaster = newMasterArray;
      }

      // --- instSizeThItemsの更新 ---
      if (deviceData.details.instSizeThItems) {
        const usedIds = processMstRecord?.details?.processDetailTypes
          ?.filter((item) => item.isUsed)
          ?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newInstSizeItems = { ...deviceData.details.instSizeThItems }; // Create a copy to modify

          Object.keys(newInstSizeItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[sizeIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const timeInSec = setTimetoSec(val);
                      if (timeInSec !== null && !isNaN(timeInSec)) {
                        return { no: i, value: timeInSec, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newInstSizeItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.instSizeThItems = newInstSizeItems;
        }
      }
    }

    // // 溶接難易度
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.weldDifficultyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // // 溶接難易度
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    // );
    // if (deviceData?.details?.weldDifficultyCoeffThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.weldDifficultyCoeffThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.weldDifficultyCoeffThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 溶接難易度
    const weldDifficultyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );

    if (weldDifficultyIndex > -1 && deviceData?.details) {
      // --- weldDifficultyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[weldDifficultyIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.weldDifficultyCoeffThMaster = newMasterArray;
      }

      // --- weldDifficultyCoeffThItemsの更新 ---
      if (deviceData.details.weldDifficultyCoeffThItems) {
        const usedIds = materialTypes?.filter((item) => item.info.isUsed)?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newWeldDifficultyItems = { ...deviceData.details.weldDifficultyCoeffThItems };

          Object.keys(newWeldDifficultyItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[weldDifficultyIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const numVal = Number(val);
                      if (!isNaN(numVal)) {
                        return { no: i, value: numVal, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newWeldDifficultyItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.weldDifficultyCoeffThItems = newWeldDifficultyItems;
        }
      }
    }

    // タップ溶接(%/辺)
    const tapIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );

    if (tapIndex > -1 && deviceData?.details) {
      // --- tapRateThMaster ---
      const inputDataMaster = dataList?.[tapIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.tapRateThMaster = newMasterArray;
      }

      // --- tapRateThItemsの更新 ---
      if (deviceData.details.tapRateThItems) {
        const usedIds = materialTypes?.filter((item) => item.info.isUsed)?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newTapItems = { ...deviceData.details.tapRateThItems };

          Object.keys(newTapItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[tapIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const numVal = Number(val);
                      if (!isNaN(numVal)) {
                        return { no: i, value: numVal, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newTapItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.tapRateThItems = newTapItems;
        }
      }
    }

    // 点付、仮付ピッチ(mm/辺)
    const spotPitchIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (spotPitchIndex > -1 && deviceData?.details) {
      // --- spotPitchThMaster ---
      const inputDataMaster = dataList?.[spotPitchIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.spotPitchThMaster = newMasterArray;
      }

      // --- spotPitchThItemsの更新 ---
      if (deviceData.details.spotPitchThItems) {
        const usedIds = materialTypes?.filter((item) => item.info.isUsed)?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newTapItems = { ...deviceData.details.spotPitchThItems };

          Object.keys(newTapItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[spotPitchIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const numVal = Number(val);
                      if (!isNaN(numVal)) {
                        return { no: i, value: numVal, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newTapItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.spotPitchThItems = newTapItems;
        }
      }
    }

    // // サイズ係数
    // inputData = [];
    // childPartAreaIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    // );
    // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    // //面積マスタ
    // deviceData?.details?.prodSizeAreaThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('cm2', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //重量マスタ
    // childPartWeightIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    // );
    // deviceData?.details?.prodSizeWeightThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
    //     inVal = inputData[0]?.replace('kg', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //     //係数値
    //     deviceData?.details?.prodSizeItems
    //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
    //       ?.areaCoeffList?.map((area, i) => {
    //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
    //         area.value = inVal !== undefined ? inVal : area.value;
    //       });
    //   });

    // サイズ係数
    const sizeCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );

    if (sizeCoeffIndex > -1 && deviceData?.details) {
      // --- prodSizeAreaThMasterの更新 ---
      const inputDataAreaMaster = dataList?.[sizeCoeffIndex + 1]?.split(',');
      if (inputDataAreaMaster) {
        const newAreaMasterArray = inputDataAreaMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('cm2', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prodSizeAreaThMaster = newAreaMasterArray;
      }

      // --- prodSizeWeightThMaster と prodSizeItems の更新 ---
      if (deviceData.details.prodSizeWeightThMaster && deviceData.details.prodSizeItems) {
        const q = dataList?.findIndex(
          (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
        );
        const startIndex = sizeCoeffIndex + 2;
        const endIndex = q;

        const targetRows = dataList?.slice(startIndex, endIndex) || [];

        if (deviceData.details) {
          const newWeightMasterArray = [];
          const newProdSizeItems = [];

          targetRows.forEach((rowString, index) => {
            const inputDataRow = rowString?.split(',');

            if (inputDataRow && inputDataRow.length > 0) {
              const weightVal = inputDataRow[0]?.replace('kg', '');
              const weightNum = Number(weightVal);

              if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
                const newNo = index + 1;
                newWeightMasterArray.push({
                  no: newNo,
                  value: weightNum,
                });

                const newAreaCoeffList = inputDataRow
                  .slice(1)
                  .map((val, i) => {
                    const decimalVal = toDecimal(val, 2);
                    return decimalVal !== null ? { no: i, value: decimalVal, isOutOfRange: false } : null;
                  })
                  .filter(Boolean);

                newProdSizeItems.push({
                  weightId: newNo,
                  areaCoeffList: newAreaCoeffList,
                });
              }
            }
          });

          deviceData.details.prodSizeWeightThMaster = newWeightMasterArray;
          deviceData.details.prodSizeItems = newProdSizeItems;
        }
      }
    }

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // 溶接仕上処理のCSV入力処理
  const weldFinishCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    let index = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let chargesItemIndex = chargesIndex + 1;
    const groupDisplayList = getProcessDetailTypesInfo(deviceData?.details?.charges, processMstRecord);
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        getChargesDetailValues(subItem?.id, deviceData?.details?.charges)?.map((item) => {
          if (parseInt(item) === subItem?.id) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 3;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 2]?.split(',');
            item.prep = inputData?.[0] ? parseInt(inputData?.[0]) : item.prep;
            item.work = inputData?.[1] ? parseInt(inputData?.[1]) : item.work;
          }
        });
        index++;
      });
    });

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    chargesItemIndex = chargesIndex + 1;
    inputData = [];
    index = 0;
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        let groupDetail = getPrepSettingDetailValues(subItem?.id, deviceData?.details?.prepSecs);
        groupDetail?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 2;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 1];
            // IQX_WEBEST-301
            if (inputData?.split(',') !== undefined) {
              inputData = inputData?.split(',')?.[0];
            }
            deviceData.details.prepSecs[groupDetail[0]] = inputData !== undefined ? setTimetoSec(inputData) : item;
          }
        });
        index++;
      });
    });

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 加工速度(mm/min)
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.workSpeedThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //加工速度
    // index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // if (deviceData?.details?.workSpeedThItems) {
    //   const usedIds = processMstRecord?.details?.processDetailTypes
    //     ?.filter((item) => item.isUsed)
    //     ?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.workSpeedThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key, index) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.workSpeedThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 加工速度(mm/min)
    const workSpeedIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (workSpeedIndex > -1 && deviceData?.details) {
      // --- workSpeedThMasterの更新 ---
      const inputDataMaster = dataList?.[workSpeedIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedThMaster = newMasterArray;
      }

      // --- workSpeedThItemsの更新 ---
      if (deviceData.details.workSpeedThItems) {
        const usedIds = processMstRecord?.details?.processDetailTypes
          ?.filter((item) => item.isUsed)
          ?.map((item) => item.id);

        if (usedIds) {
          let csvRowIndex = 0;
          const newWorkSpeedItems = { ...deviceData.details.workSpeedThItems };

          Object.keys(newWorkSpeedItems)
            ?.filter((key) => usedIds.includes(parseInt(key)))
            ?.forEach((key) => {
              const inputDataItems = dataList?.[workSpeedIndex + 2 + csvRowIndex]?.split(',');
              const typeNm = processTypesList?.find((item) => item.id.toString() === key)?.name;

              if (inputDataItems && typeNm === inputDataItems[0]) {
                const newItemsArray = inputDataItems
                  .slice(1)
                  .map((val, i) => {
                    if (val !== undefined && val.trim() !== '') {
                      const numVal = Number(val);
                      if (!isNaN(numVal)) {
                        return { no: i, value: numVal, isOutOfRange: false };
                      }
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                newWorkSpeedItems[key] = newItemsArray;
              }
              csvRowIndex++;
            });
          deviceData.details.workSpeedThItems = newWorkSpeedItems;
        }
      }
    }

    // 溶接難易度
    inputData = [];
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[thickIndex + 2]?.split(',');
    index = 0;
    // 溶接難易度
    if (deviceData?.details?.diffFactorCoeff) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(deviceData?.details?.diffFactorCoeff)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          inVal = inputData[index + 1];
          inVal = inVal !== undefined ? Number(inVal) : deviceData?.details?.diffFactorCoeff[parseInt(key)];
          deviceData.details.diffFactorCoeff[parseInt(key)] = inVal
            ? inVal
            : deviceData?.details?.diffFactorCoeff[parseInt(key)];
          index++;
        });
    }

    // 仕上有無　IQX_WEBEST-271 パラメータに現状持っている「仕上げ有無」（溶接種類ごとのチェックボックス）を取り除く。
    // inputData = [];
    // index = 0;
    // speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // if (deviceData?.details?.difficultyCoeff) {
    //   const usedIds = yousetsuTypes?.details?.processDetailTypes?.filter((item) => item.isUsed)?.map((item) => item.id);
    //   inputData = dataList?.[speedLenIndex + 2]?.split(',');
    //   Object.keys(deviceData?.details?.difficultyCoeff)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inVal =
    //         inputData[index + 1] !== undefined
    //           ? JSON.parse(inputData[index + 1]?.toLowerCase()) // IQX_WEBEST-301
    //           : deviceData?.details?.difficultyCoeff[parseInt(key)];
    //       deviceData.details.difficultyCoeff[parseInt(key)] =
    //         inVal !== undefined ? inVal : deviceData?.details?.difficultyCoeff[parseInt(key)];
    //       index++;
    //     });
    // }

    // // サイズ係数
    // inputData = [];
    // childPartAreaIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    // //面積マスタ
    // deviceData?.details?.prodSizeAreaThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('cm2', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //重量マスタ
    // childPartWeightIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // deviceData?.details?.prodSizeWeightThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
    //     inVal = inputData[0]?.replace('kg', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //     //係数値
    //     deviceData?.details?.prodSizeItems
    //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
    //       ?.areaCoeffList?.map((area, i) => {
    //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
    //         area.value = inVal !== undefined ? inVal : area.value;
    //       });
    //   });

    // サイズ係数
    // const sizeCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );

    // if (sizeCoeffIndex > -1 && deviceData?.details) {
    //   // --- prodSizeAreaThMasterの更新 ---
    //   const inputDataAreaMaster = dataList?.[sizeCoeffIndex + 1]?.split(',');
    //   if (inputDataAreaMaster) {
    //     const newAreaMasterArray = inputDataAreaMaster
    //       .slice(1)
    //       .map((val, i) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('cm2', '');
    //           const numVal = Number(cleanedVal);
    //           if (!isNaN(numVal)) {
    //             return { no: i, value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.prodSizeAreaThMaster = newAreaMasterArray;
    //   }

    //   // --- prodSizeWeightThMaster と prodSizeItems の更新 ---
    //   if (deviceData.details.prodSizeWeightThMaster && deviceData.details.prodSizeItems) {
    //     const newWeightMasterArray = [];
    //     const newProdSizeItems = [...deviceData.details.prodSizeItems]; // Copy existing items

    //     // Loop based on number of master items to read from CSV
    //     deviceData.details.prodSizeWeightThMaster.forEach((masterItem, index) => {
    //       const inputDataRow = dataList?.[sizeCoeffIndex + 2 + index]?.split(',');

    //       if (inputDataRow && inputDataRow.length > 0) {
    //         // 1. Rebuild prodSizeWeightThMaster item
    //         const weightVal = inputDataRow[0]?.replace('kg', '');
    //         const weightNum = Number(weightVal);
    //         if (weightVal !== undefined && weightVal.trim() !== '' && !isNaN(weightNum)) {
    //           newWeightMasterArray.push({ ...masterItem, value: weightNum });

    //           // 2. Find and rebuild corresponding prodSizeItems' areaCoeffList
    //           const prodSizeItemToUpdate = newProdSizeItems.find((item) => item.weightId === masterItem.no);
    //           if (prodSizeItemToUpdate) {
    //             const newAreaCoeffList = inputDataRow
    //               .slice(1)
    //               .map((val, i) => {
    //                 if (val !== undefined && val.trim() !== '') {
    //                   const decimalVal = toDecimal(val, 2);
    //                   if (decimalVal !== null && !isNaN(decimalVal)) {
    //                     return { no: i, value: decimalVal, isOutOfRange: false };
    //                   }
    //                 }
    //                 return null;
    //               })
    //               .filter((item) => item !== null);

    //             prodSizeItemToUpdate.areaCoeffList = newAreaCoeffList;
    //           }
    //         }
    //       }
    //     });

    //     deviceData.details.prodSizeWeightThMaster = newWeightMasterArray;
    //     deviceData.details.prodSizeItems = newProdSizeItems;
    //   }
    // }

    const safeParseNumber = (val) => {
      if (val === undefined || val === null || val.trim() === '') {
        return null;
      }
      const num = Number(val);
      return !isNaN(num) ? num : null;
    };

    // ---
    // サイズ係数
    const sizeCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (sizeCoeffIndex > -1 && deviceData?.details) {
      // --- 1. prodSizeAreaThMasterの更新 ---
      // This is a single-row master array, so the original logic is fine,
      // just cleaned up with safeParseNumber.
      const inputDataAreaMaster = dataList?.[sizeCoeffIndex + 1]?.split(',');
      if (inputDataAreaMaster) {
        const newAreaMasterArray = inputDataAreaMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('cm2', '');
              const numVal = safeParseNumber(cleanedVal);
              if (numVal !== null) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prodSizeAreaThMaster = newAreaMasterArray;
      }

      // --- 2. prodSizeWeightThMaster と prodSizeItems の更新 ---
      // This part is multi-row and dynamic, so we apply the while-loop pattern.
      if (deviceData.details.prodSizeWeightThMaster && deviceData.details.prodSizeItems) {
        const newWeightMasterArray = [];
        const newProdSizeItemsArray = [];

        const originalMaster = deviceData.details.prodSizeWeightThMaster;
        const originalItems = deviceData.details.prodSizeItems;

        let index = 0;

        // Loop indefinitely until we run out of valid input data rows
        while (true) {
          // Data starts from the 3rd row after the header (sizeCoeffIndex + 2)
          const inputDataRow = dataList?.[sizeCoeffIndex + 2 + index]?.split(',');

          // --- Check for valid data ---
          const weightVal = inputDataRow?.[0]?.replace('kg', '');
          const numWeightVal = safeParseNumber(weightVal); // Use helper

          if (inputDataRow === undefined || numWeightVal === null) {
            break; // Stop processing, we've run out of valid rows
          }

          // --- Process Master Item ---
          const originalMasterItem = originalMaster[index];
          const itemNo = originalMasterItem?.no !== undefined ? originalMasterItem.no : index;

          newWeightMasterArray.push({
            ...(originalMasterItem || {}),
            no: itemNo,
            value: numWeightVal,
          });

          // --- Process Coeff Item ---
          const originalCoeffItem = originalItems.find((coeff) => coeff.weightId === itemNo);

          const coeffItemToUpdate = {
            ...(originalCoeffItem || {}),
            weightId: itemNo,
          };

          // Create the new inner list (areaCoeffList)
          const newAreaCoeffList = inputDataRow
            .slice(1) // Get all cells after the first one
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const decimalVal = toDecimal(val, 2); // Using toDecimal as in original
                if (decimalVal !== null && !isNaN(decimalVal)) {
                  const originalListItem = originalCoeffItem?.areaCoeffList?.[i] || {};
                  return {
                    ...originalListItem,
                    no: i,
                    value: decimalVal,
                    isOutOfRange: false,
                  };
                }
              }
              return null;
            })
            .filter((item) => item !== null);

          // Assign the new inner list
          coeffItemToUpdate.areaCoeffList = newAreaCoeffList;

          // Add the updated item to our new array
          newProdSizeItemsArray.push(coeffItemToUpdate);

          // Move to the next row
          index++;
        }

        // Replace the old arrays with the new, dynamically-sized arrays.
        deviceData.details.prodSizeWeightThMaster = newWeightMasterArray;
        deviceData.details.prodSizeItems = newProdSizeItemsArray;
      }
    }

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // ２次加工処理のCSV入力処理
  const secondaryWorkCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    let index = 0;
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let chargesItemIndex = chargesIndex + 1;
    const groupDisplayList = getProcessDetailTypesInfo(deviceData?.details?.charges, processMstRecord);
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        getChargesDetailValues(subItem?.id, deviceData?.details?.charges)?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 3;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 2]?.split(',');
            item.prep = inputData?.[0] ? parseInt(inputData?.[0]) : item?.prep;
            item.work = inputData?.[1] ? parseInt(inputData?.[1]) : item?.work;
          }
        });
        index++;
      });
    });

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    chargesItemIndex = chargesIndex + 1;
    inputData = [];
    index = 0;
    Object.entries(groupDisplayList)?.map(([_, groupItem]) => {
      groupItem?.map((subItem) => {
        let groupDetail = getPrepSettingDetailValues(subItem?.id, deviceData?.details?.prepSecs);
        groupDetail?.map((item, i) => {
          if (parseInt(item) === subItem?.id && i === 0) return;
          if (index > 0) {
            chargesItemIndex = chargesItemIndex + 2;
          }
          inputData = dataList?.[chargesItemIndex];
          if (inputData && (inputData == subItem?.name || inputData?.includes(subItem?.name))) {
            inputData = dataList?.[chargesItemIndex + 1];
            // IQX_WEBEST-301
            if (inputData?.split(',') !== undefined) {
              inputData = inputData?.split(',')?.[0];
            }
            deviceData.details.prepSecs[groupDetail[0]] = inputData !== undefined ? setTimetoSec(inputData) : item;
          }
        });
        index++;
      });
    });

    // 子部品サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.childPartsCoeffAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });

    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    deviceData?.details?.childPartsCoeffWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.childPartsCoeff
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 加工時間(mm/min)
    // // 加工種類/サイズ
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // // 簡易入力
    // //板厚マスタ
    // deviceData?.details?.sizeThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('M', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // index = 0;
    // if (deviceData?.details?.workTimeSizeThItems) {
    //   Object.keys(deviceData?.details?.workTimeSizeThItems)
    //     .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
    //     ?.map(([key, item], rowIndex) => {
    //       let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //       inputData = dataList?.[thickIndex + 3 + index]?.split(',');
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.workTimeSizeThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? setTimetoSec(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // // 詳細入力
    // //板厚マスタ
    // thickIndex = thickIndex + index + 3;
    // inputData = dataList?.[thickIndex];
    // let detailIndex = 0;
    // let materialTypeIndex = 0;
    // if (inputData === '詳細入力' || inputData?.includes('詳細入力')) {
    //   thickIndex = thickIndex + 3;
    //   if (deviceData?.details?.workTimeSizeThItems) {
    //     Object.keys(deviceData?.details?.workTimeSizeThItems)
    //       .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
    //       ?.map(([key, item], rowIndex) => {
    //         detailIndex = 2;
    //         const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //         let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //         inputData = dataList?.[thickIndex + materialTypeIndex]?.split(',');
    //         const detailRowIndex = thickIndex + materialTypeIndex;
    //         if (typeNm === inputData[0]) {
    //           let usedItemIndex = 0;
    //           usedItems?.map((materialTypeItem) => {
    //             inputData = dataList?.[detailRowIndex + usedItemIndex]?.split(',');
    //             deviceData?.details?.workTimeSizeThItems[key]?.map((item, workTimeSizeIndex) => {
    //               if (workTimeSizeIndex > 0)
    //                 detailIndex = item?.workTimeThickThItems[materialTypeItem.id]?.length + workTimeSizeIndex;
    //               if (item?.workTimeThickThItems) {
    //                 item?.workTimeThickThItems[materialTypeItem.id]?.map((item, index) => {
    //                   item.value =
    //                     inputData[detailIndex + index] !== undefined
    //                       ? setTimetoSec(inputData[detailIndex + index])
    //                       : item.value;
    //                 });
    //               }
    //             });
    //             usedItemIndex++;
    //             materialTypeIndex++;
    //           });
    //         }
    //       });
    //   }
    // }

    // // 加工時間(mm/min)
    // const workTimeIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );

    // if (workTimeIndex > -1 && deviceData?.details) {
    //   let currentIndex = workTimeIndex;

    //   // --- 簡易入力 ---

    //   // sizeThMasterの更新
    //   const inputDataMaster = dataList?.[currentIndex + 2]?.split(',');
    //   if (inputDataMaster) {
    //     const newMasterArray = inputDataMaster
    //       .slice(1)
    //       .map((val) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('M', '');
    //           const numVal = Number(cleanedVal);
    //           if (!isNaN(numVal)) {
    //             return { value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.sizeThMaster = newMasterArray;
    //   }
    //   currentIndex++;

    //   // workTimeSizeThItemsの簡易入力更新
    //   const newWorkTimeSizeThItems = { ...deviceData.details.workTimeSizeThItems };

    //   Object.keys(newWorkTimeSizeThItems)
    //     .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
    //     .forEach((key) => {
    //       currentIndex++; // Move to the next data row in CSV
    //       const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //       const inputDataItems = dataList?.[currentIndex + 1]?.split(',');

    //       if (inputDataItems && typeName === inputDataItems[0]) {
    //         const newItemsArray = inputDataItems
    //           .slice(1)
    //           .map((val) => {
    //             if (val !== undefined && val.trim() !== '') {
    //               const timeInSec = setTimetoSec(val);
    //               if (timeInSec !== null && !isNaN(timeInSec)) {
    //                 return { value: timeInSec, isOutOfRange: false };
    //               }
    //             }
    //             return null;
    //           })
    //           .filter((item) => item !== null);

    //         // CSVから読み込んだ有効なデータ数に合わせて配列を再構築します。
    //         // これにより、CSVの空のセルに対応する古いデータが残るのを防ぎます。
    //         const existingItems = newWorkTimeSizeThItems[key] || [];
    //         const updatedItems = newItemsArray.map((newItem, index) => {
    //           // 詳細入力など、既存の他のプロパティを保持するために元のアイテムを取得します。
    //           const existingItem = existingItems[index] || {};
    //           return {
    //             ...existingItem, // 既存のプロパティを保持
    //             value: newItem.value, // CSVからの新しい値で上書き
    //             isOutOfRange: newItem.isOutOfRange,
    //           };
    //         });
    //         newWorkTimeSizeThItems[key] = updatedItems;
    //       }
    //     });
    //   deviceData.details.workTimeSizeThItems = newWorkTimeSizeThItems;

    //   // --- 詳細入力 ---
    //   currentIndex++; // Move past the last simple input row
    //   const detailInputMarker = dataList?.[currentIndex + 1];

    //   if (
    //     (detailInputMarker === '詳細入力' || detailInputMarker?.includes('詳細入力')) &&
    //     deviceData.details.workTimeSizeThItems
    //   ) {
    //     currentIndex += 2; // Skip '詳細入力' and the header row
    //     const usedMaterialTypes = materialTypes?.filter((item) => item.info.isUsed);
    //     const newDetailedWorkTimeItems = JSON.parse(JSON.stringify(deviceData.details.workTimeSizeThItems));

    //     Object.keys(newDetailedWorkTimeItems)
    //       .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
    //       .forEach((key) => {
    //         const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //         const headerRow = dataList?.[currentIndex]?.split(',');

    //         if (headerRow && typeName === headerRow[0]) {
    //           usedMaterialTypes.forEach((material, materialIndex) => {
    //             const csvRowForMaterial = dataList?.[currentIndex + 1 + materialIndex]?.split(',');
    //             const materialKey = material.id.toString();

    //             if (csvRowForMaterial && material.name === csvRowForMaterial[1]) {
    //               const updatedSizeItems = newDetailedWorkTimeItems[key].map((sizeItem) => {
    //                 if (sizeItem.workTimeThickThItems && sizeItem.workTimeThickThItems[materialKey]) {
    //                   const updatedThickItems = sizeItem.workTimeThickThItems[materialKey].map(
    //                     (thickItem, thickIndex) => {
    //                       const csvColIndex = 2 + thickIndex;
    //                       const val = csvRowForMaterial[csvColIndex];
    //                       if (val !== undefined && val.trim() !== '') {
    //                         const timeInSec = setTimetoSec(val);
    //                         if (timeInSec !== null && !isNaN(timeInSec)) {
    //                           return { ...thickItem, value: timeInSec };
    //                         }
    //                       }
    //                       return thickItem;
    //                     }
    //                   );
    //                   const newWorkTimeThickThItems = {
    //                     ...sizeItem.workTimeThickThItems,
    //                     [materialKey]: updatedThickItems,
    //                   };
    //                   return { ...sizeItem, workTimeThickThItems: newWorkTimeThickThItems };
    //                 }
    //                 return sizeItem;
    //               });
    //               newDetailedWorkTimeItems[key] = updatedSizeItems;
    //             }
    //           });
    //           currentIndex += 1 + usedMaterialTypes.length;
    //         }
    //       });
    //     deviceData.details.workTimeSizeThItems = newDetailedWorkTimeItems;
    //   }
    // }

    // 加工時間(mm/min)
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (thickIndex > -1 && deviceData?.details) {
      let newMasterArray = []; // Define master array scope here
      // --- mmMultiProcHoleThMaster ---
      const inputDataMaster = dataList?.[thickIndex + 2]?.split(','); // マスタ行はインデックス+1のはず
      if (inputDataMaster) {
        newMasterArray = inputDataMaster // Assign to the outer scope variable
          .slice(1) // 最初の列（名称）をスキップ
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('M', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null; // 無効な値や空の場合はnullを返す
          })
          .filter((item) => item !== null); // nullの要素を配列から除去する
        deviceData.details.sizeThMaster = newMasterArray;
      }

      // --- workTimeMmMultiProcHoleThItems --- (簡易入力)
      if (deviceData.details.workTimeSizeThItems) {
        const processMst = Array.isArray(processMstRecord) ? processMstRecord : [];
        let csvRowIndex = 0;
        const newWorkTimeItems = { ...deviceData.details.workTimeSizeThItems };
        const masterLength = newMasterArray.length; // Use the length of the newly created master array

        Object.keys(newWorkTimeItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const inputDataItems = dataList?.[thickIndex + 3 + csvRowIndex]?.split(','); // 簡易入力データ行

            if (inputDataItems && typeName === inputDataItems[0]) {
              const itemsFromCsv = inputDataItems
                .slice(1) // 最初の列（名称）をスキップ
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const timeInSec = setTimetoSec(val);
                    if (timeInSec !== null && !isNaN(timeInSec)) {
                      return {
                        no: i,
                        value: timeInSec,
                        isOutOfRange: false,
                        workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                      };
                    }
                  }
                  return null; // 無効な値や空の場合はnullを返す
                })
                .filter((item) => item !== null); // nullの要素を配列から除去する

              // Ensure the array length matches the master array, padding with 0 if necessary
              const finalItemsArray = Array.from({ length: masterLength }, (_, i) =>
                itemsFromCsv[i] !== undefined
                  ? itemsFromCsv[i]
                  : {
                      no: i,
                      value: 0,
                      isOutOfRange: false,
                      workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                    }
              );

              newWorkTimeItems[key] = finalItemsArray;
            }
            csvRowIndex++;
          });
        deviceData.details.workTimeSizeThItems = newWorkTimeItems;
      }

      // 詳細入力
      const detailInputMarkerIndex = dataList?.findIndex(
        (item, index) => (item === '詳細入力' || item?.includes('詳細入力')) && index > thickIndex // '詳細入力'マーカーを探す
      );

      if (detailInputMarkerIndex > -1 && deviceData.details.workTimeSizeThItems) {
        let currentDetailCsvRow = detailInputMarkerIndex + 2; // 詳細入力のヘッダーの次の行から開始
        const masterLength = deviceData.details.mmThicknessThMaster.length; // Get length from potentially updated master

        Object.keys(deviceData.details.workTimeSizeThItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const detailHeaderRow = dataList?.[currentDetailCsvRow]?.split(',');

            if (detailHeaderRow && typeName === detailHeaderRow[0]) {
              const usedMaterialTypes = materialTypes?.filter((item) => item.info.isUsed);
              usedMaterialTypes.forEach((material, materialIndex) => {
                const materialDataRow = dataList?.[currentDetailCsvRow + 1 + materialIndex]?.split(',');
                const materialKey = material.id.toString();

                if (materialDataRow && material.name === materialDataRow[1]) {
                  const updatedSizeItems = deviceData.details.workTimeSizeThItems[key].map((sizeItem) => {
                    if (sizeItem.workTimeThickThItems && sizeItem.workTimeThickThItems[materialKey]) {
                      // Ensure the updatedThickItems array matches the master length
                      const updatedThickItems = Array.from({ length: masterLength }, (_, thickIndex) => {
                        const existingThickItem = sizeItem.workTimeThickThItems[materialKey][thickIndex] || {
                          value: 0,
                          isOutOfRange: false,
                        }; // Default if original is shorter
                        const csvColIndex = 2 + thickIndex;
                        const val = materialDataRow[csvColIndex];
                        if (val !== undefined && val.trim() !== '') {
                          const timeInSec = setTimetoSec(val);
                          if (timeInSec !== null && !isNaN(timeInSec)) {
                            return { ...existingThickItem, value: timeInSec };
                          }
                        }
                        // If CSV value is missing or invalid, keep existing or default to 0
                        return existingThickItem;
                      });

                      const newWorkTimeThickThItems = {
                        ...sizeItem.workTimeThickThItems,
                        [materialKey]: updatedThickItems,
                      };
                      return { ...sizeItem, workTimeThickThItems: newWorkTimeThickThItems };
                    }
                    return sizeItem;
                  });
                  deviceData.details.workTimeSizeThItems[key] = updatedSizeItems;
                }
              });
              currentDetailCsvRow += 1 + usedMaterialTypes.length; // 次の処理タイプのブロックへ移動
            }
          });
      }
    }

    // 加工時間(mm/min)
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );

    if (thickIndex > -1 && deviceData?.details) {
      let newMasterArray = []; // Define master array scope here
      // --- mmMultiProcHoleThMaster ---
      const inputDataMaster = dataList?.[thickIndex + 2]?.split(','); // マスタ行はインデックス+1のはず
      if (inputDataMaster) {
        newMasterArray = inputDataMaster // Assign to the outer scope variable
          .slice(1) // 最初の列（名称）をスキップ
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null; // 無効な値や空の場合はnullを返す
          })
          .filter((item) => item !== null); // nullの要素を配列から除去する
        deviceData.details.mmThMaster = newMasterArray;
      }

      // --- workTimeMmMultiProcHoleThItems --- (簡易入力)
      if (deviceData.details.workTimeSizeHoleThItems) {
        let csvRowIndex = 0;
        const newWorkTimeItems = { ...deviceData.details.workTimeSizeHoleThItems };
        const masterLength = newMasterArray.length; // Use the length of the newly created master array

        Object.keys(newWorkTimeItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const inputDataItems = dataList?.[thickIndex + 3 + csvRowIndex]?.split(','); // 簡易入力データ行

            if (inputDataItems && typeName === inputDataItems[0]) {
              const itemsFromCsv = inputDataItems
                .slice(1) // 最初の列（名称）をスキップ
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const timeInSec = setTimetoSec(val);
                    if (timeInSec !== null && !isNaN(timeInSec)) {
                      return {
                        no: i,
                        value: timeInSec,
                        isOutOfRange: false,
                        workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                      };
                    }
                  }
                  return null; // 無効な値や空の場合はnullを返す
                })
                .filter((item) => item !== null); // nullの要素を配列から除去する

              // Ensure the array length matches the master array, padding with 0 if necessary
              const finalItemsArray = Array.from({ length: masterLength }, (_, i) =>
                itemsFromCsv[i] !== undefined
                  ? itemsFromCsv[i]
                  : {
                      no: i,
                      value: 0,
                      isOutOfRange: false,
                      workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                    }
              );

              newWorkTimeItems[key] = finalItemsArray;
            }
            csvRowIndex++;
          });
        deviceData.details.workTimeSizeHoleThItems = newWorkTimeItems;
      }

      // 詳細入力
      const detailInputMarkerIndex = dataList?.findIndex(
        (item, index) => (item === '詳細入力(成形型穴)' || item?.includes('詳細入力(成形型穴)')) && index > thickIndex // '詳細入力'マーカーを探す
      );

      if (detailInputMarkerIndex > -1 && deviceData.details.workTimeSizeHoleThItems) {
        let currentDetailCsvRow = detailInputMarkerIndex + 2; // 詳細入力のヘッダーの次の行から開始
        const masterLength = deviceData.details.mmThicknessThMaster.length; // Get length from potentially updated master

        Object.keys(deviceData.details.workTimeSizeHoleThItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const detailHeaderRow = dataList?.[currentDetailCsvRow]?.split(',');

            if (detailHeaderRow && typeName === detailHeaderRow[0]) {
              const usedMaterialTypes = materialTypes?.filter((item) => item.info.isUsed);
              usedMaterialTypes.forEach((material, materialIndex) => {
                const materialDataRow = dataList?.[currentDetailCsvRow + 1 + materialIndex]?.split(',');
                const materialKey = material.id.toString();

                if (materialDataRow && material.name === materialDataRow[1]) {
                  const updatedSizeItems = deviceData.details.workTimeSizeHoleThItems[key].map((sizeItem) => {
                    if (sizeItem.workTimeThickThItems && sizeItem.workTimeThickThItems[materialKey]) {
                      // Ensure the updatedThickItems array matches the master length
                      const updatedThickItems = Array.from({ length: masterLength }, (_, thickIndex) => {
                        const existingThickItem = sizeItem.workTimeThickThItems[materialKey][thickIndex] || {
                          value: 0,
                          isOutOfRange: false,
                        }; // Default if original is shorter
                        const csvColIndex = 2 + thickIndex;
                        const val = materialDataRow[csvColIndex];
                        if (val !== undefined && val.trim() !== '') {
                          const timeInSec = setTimetoSec(val);
                          if (timeInSec !== null && !isNaN(timeInSec)) {
                            return { ...existingThickItem, value: timeInSec };
                          }
                        }
                        // If CSV value is missing or invalid, keep existing or default to 0
                        return existingThickItem;
                      });

                      const newWorkTimeThickThItems = {
                        ...sizeItem.workTimeThickThItems,
                        [materialKey]: updatedThickItems,
                      };
                      return { ...sizeItem, workTimeThickThItems: newWorkTimeThickThItems };
                    }
                    return sizeItem;
                  });
                  deviceData.details.workTimeSizeHoleThItems[key] = updatedSizeItems;
                }
              });
              currentDetailCsvRow += 1 + usedMaterialTypes.length; // 次の処理タイプのブロックへ移動
            }
          });
      }
    }

    // // 多工程穴
    // // 加工時間(mm/min) - 加工種類/mm
    //  thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );

    // if (thickIndex > -1 && deviceData?.details) {
    //   // --- mmMultiProcHoleThMaster ---
    //   const inputDataMaster = dataList?.[thickIndex + 2]?.split(',');
    //   if (inputDataMaster) {
    //     const newMasterArray = inputDataMaster
    //       .slice(1) // 最初の列（名称）をスキップ
    //       .map((val) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('mm', '');
    //           const numVal = Number(cleanedVal);
    //           if (!isNaN(numVal)) {
    //             return { value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null; // 無効な値や空の場合はnullを返す
    //       })
    //       .filter((item) => item !== null); // nullの要素を配列から除去する
    //     deviceData.details.mmMultiProcHoleThMaster = newMasterArray;
    //   }

    //   if (deviceData.details.workTimeMmMultiProcHoleThItems) {
    //     let csvRowIndex = 0;

    //     Object.keys(deviceData.details.workTimeMmMultiProcHoleThItems)
    //       .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
    //       .forEach((key) => {
    //         const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //         const inputDataItems = dataList?.[thickIndex + 3 + csvRowIndex]?.split(',');

    //         if (inputDataItems && typeName === inputDataItems[0]) {
    //           // CSVデータに基づいて新しい配列を構築し、古い配列を置き換えます
    //           const newItemsArray = inputDataItems
    //             .slice(1) // 最初の列（名称）をスキップ
    //             .map((val) => {
    //               if (val !== undefined && val.trim() !== '') {
    //                 const timeInSec = setTimetoSec(val);
    //                 if (timeInSec !== null && !isNaN(timeInSec)) {
    //                   return { value: timeInSec, isOutOfRange: false };
    //                 }
    //               }
    //               return null; // 無効な値や空の場合はnullを返す
    //             })
    //             .filter((item) => item !== null); // nullの要素を配列から除去する
    //           deviceData.details.workTimeMmMultiProcHoleThItems[key] = newItemsArray;
    //         }
    //         csvRowIndex++;
    //       });
    //   }
    // }

    // // 詳細入力
    // //板厚マスタ
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === '詳細入力(多工程穴)' || dataList?.[index]?.split(',')?.[0] === '詳細入力(多工程穴)'
    // );
    // inputData = dataList?.[thickIndex];
    // detailIndex = 0;
    // materialTypeIndex = 0;
    // if (inputData === '詳細入力' || inputData?.includes('詳細入力')) {
    //   thickIndex = thickIndex + 3;
    //   if (deviceData?.details?.workTimeMmMultiProcHoleThItems) {
    //     Object.keys(deviceData?.details?.workTimeMmMultiProcHoleThItems)
    //       .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
    //       ?.map(([key, item], rowIndex) => {
    //         detailIndex = 2;
    //         let typeNm = getProcessDetailTypeName(parseInt(key), processMstRecord);
    //         inputData = dataList?.[thickIndex + rowIndex]?.split(',');
    //         if (typeNm === inputData[0]) {
    //           const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //           usedItems?.map((materialTypeItem) => {
    //             inputData = dataList?.[thickIndex + materialTypeIndex + rowIndex]?.split(',');
    //             deviceData?.details?.workTimeMmMultiProcHoleThItems[key]?.map((item, workTimeSizeIndex) => {
    //               if (item?.workTimeThickThItems) {
    //                 Object.keys(item?.workTimeThickThItems)
    //                   ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
    //                   ?.map((key) => {
    //                     item?.workTimeThickThItems[key]?.map((item, index) => {
    //                       item.value =
    //                         inputData[detailIndex] !== undefined ? setTimetoSec(inputData[detailIndex]) : item.value;
    //                     });
    //                   });
    //               }
    //               detailIndex++;
    //             });
    //             materialTypeIndex++;
    //           });
    //         }
    //       });
    //   }
    // }

    // 多工程穴
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (thickIndex > -1 && deviceData?.details) {
      let newMasterArray = []; // Define master array scope here
      // --- mmMultiProcHoleThMaster ---
      const inputDataMaster = dataList?.[thickIndex + 2]?.split(','); // マスタ行はインデックス+1のはず
      if (inputDataMaster) {
        newMasterArray = inputDataMaster // Assign to the outer scope variable
          .slice(1) // 最初の列（名称）をスキップ
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null; // 無効な値や空の場合はnullを返す
          })
          .filter((item) => item !== null); // nullの要素を配列から除去する
        deviceData.details.mmMultiProcHoleThMaster = newMasterArray;
      }

      // --- workTimeMmMultiProcHoleThItems --- (簡易入力)
      if (deviceData.details.workTimeMmMultiProcHoleThItems) {
        const processMst = Array.isArray(processMstRecord) ? processMstRecord : [];
        let csvRowIndex = 0;
        const newWorkTimeItems = { ...deviceData.details.workTimeMmMultiProcHoleThItems };
        const masterLength = newMasterArray.length; // Use the length of the newly created master array

        Object.keys(newWorkTimeItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const inputDataItems = dataList?.[thickIndex + 3 + csvRowIndex]?.split(','); // 簡易入力データ行

            if (inputDataItems && typeName === inputDataItems[0]) {
              const itemsFromCsv = inputDataItems
                .slice(1) // 最初の列（名称）をスキップ
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const timeInSec = setTimetoSec(val);
                    if (timeInSec !== null && !isNaN(timeInSec)) {
                      return {
                        no: i,
                        value: timeInSec,
                        isOutOfRange: false,
                        workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                      };
                    }
                  }
                  return null; // 無効な値や空の場合はnullを返す
                })
                .filter((item) => item !== null); // nullの要素を配列から除去する

              // Ensure the array length matches the master array, padding with 0 if necessary
              const finalItemsArray = Array.from({ length: masterLength }, (_, i) =>
                itemsFromCsv[i] !== undefined
                  ? itemsFromCsv[i]
                  : {
                      no: i,
                      value: 0,
                      isOutOfRange: false,
                      workTimeThickThItems: newWorkTimeItems[key][0].workTimeThickThItems,
                    }
              );

              newWorkTimeItems[key] = finalItemsArray;
            }
            csvRowIndex++;
          });
        deviceData.details.workTimeMmMultiProcHoleThItems = newWorkTimeItems;
      }

      // 詳細入力
      const detailInputMarkerIndex = dataList?.findIndex(
        (item, index) => (item === '詳細入力(多工程穴)' || item?.includes('詳細入力(多工程穴)')) && index > thickIndex // '詳細入力'マーカーを探す
      );

      if (detailInputMarkerIndex > -1 && deviceData.details.workTimeMmMultiProcHoleThItems) {
        let currentDetailCsvRow = detailInputMarkerIndex + 2; // 詳細入力のヘッダーの次の行から開始
        const masterLength = deviceData.details.mmThicknessThMaster.length; // Get length from potentially updated master

        Object.keys(deviceData.details.workTimeMmMultiProcHoleThItems)
          .filter((key) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
          .forEach((key) => {
            const typeName = getProcessDetailTypeName(parseInt(key), processMstRecord);
            const detailHeaderRow = dataList?.[currentDetailCsvRow]?.split(',');

            if (detailHeaderRow && typeName === detailHeaderRow[0]) {
              const usedMaterialTypes = materialTypes?.filter((item) => item.info.isUsed);
              usedMaterialTypes.forEach((material, materialIndex) => {
                const materialDataRow = dataList?.[currentDetailCsvRow + 1 + materialIndex]?.split(',');
                const materialKey = material.id.toString();

                if (materialDataRow && material.name === materialDataRow[1]) {
                  const updatedSizeItems = deviceData.details.workTimeMmMultiProcHoleThItems[key].map((sizeItem) => {
                    if (sizeItem.workTimeThickThItems && sizeItem.workTimeThickThItems[materialKey]) {
                      // Ensure the updatedThickItems array matches the master length
                      const updatedThickItems = Array.from({ length: masterLength }, (_, thickIndex) => {
                        const existingThickItem = sizeItem.workTimeThickThItems[materialKey][thickIndex] || {
                          value: 0,
                          isOutOfRange: false,
                        }; // Default if original is shorter
                        const csvColIndex = 2 + thickIndex;
                        const val = materialDataRow[csvColIndex];
                        if (val !== undefined && val.trim() !== '') {
                          const timeInSec = setTimetoSec(val);
                          if (timeInSec !== null && !isNaN(timeInSec)) {
                            return { ...existingThickItem, value: timeInSec };
                          }
                        }
                        // If CSV value is missing or invalid, keep existing or default to 0
                        return existingThickItem;
                      });

                      const newWorkTimeThickThItems = {
                        ...sizeItem.workTimeThickThItems,
                        [materialKey]: updatedThickItems,
                      };
                      return { ...sizeItem, workTimeThickThItems: newWorkTimeThickThItems };
                    }
                    return sizeItem;
                  });
                  deviceData.details.workTimeMmMultiProcHoleThItems[key] = updatedSizeItems;
                }
              });
              currentDetailCsvRow += 1 + usedMaterialTypes.length; // 次の処理タイプのブロックへ移動
            }
          });
      }
    }

    // // 加工補正時間
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.modifyTimeQtyThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // // 加工補正時間-値
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // deviceData?.details?.modifyTimeItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     inVal = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // 加工補正時間
    const modifyTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (modifyTimeIndex > -1 && deviceData?.details) {
      // --- modifyTimeQtyThMasterの更新 ---
      const inputDataMaster = dataList?.[modifyTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.modifyTimeQtyThMaster = newMasterArray;
      }

      // --- modifyTimeItemsの更新 ---
      const inputDataItems = dataList?.[modifyTimeIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.modifyTimeItems = newItemsArray;
      }
    }

    // // 加工補正時間係数
    // childPartAreaIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    // //面積マスタ
    // deviceData?.details?.mtAreaThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('cm2', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // //重量マスタ
    // childPartWeightIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // deviceData?.details?.mtWeightThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
    //     inVal = inputData[index]?.replace('kg', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //     //係数値
    //     deviceData?.details?.mtTimeCoeffItems
    //       ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
    //       ?.areaCoeffList?.map((area, i) => {
    //         inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
    //         area.value = inVal !== undefined ? inVal : area.value;
    //       });
    //   });

    // 加工補正時間係数
    // const coeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    // );

    // if (coeffIndex > -1 && deviceData?.details) {
    //   // --- mtAreaThMasterの更新 ---
    //   const inputAreaMaster = dataList?.[coeffIndex + 1]?.split(',');
    //   if (inputAreaMaster) {
    //     const newAreaMaster = inputAreaMaster
    //       .slice(1)
    //       .map((val, i) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('cm2', '');
    //           const numVal = Number(cleanedVal);
    //           if (!isNaN(numVal)) {
    //             return { no: i, value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.mtAreaThMaster = newAreaMaster;
    //   }

    //   // --- mtWeightThMaster と mtTimeCoeffItems の更新 ---
    //   if (deviceData.details.mtWeightThMaster && deviceData.details.mtTimeCoeffItems) {
    //     const newWeightMaster = [];
    //     const newTimeCoeffItems = JSON.parse(JSON.stringify(deviceData.details.mtTimeCoeffItems));

    //     deviceData.details.mtWeightThMaster.forEach((masterItem, index) => {
    //       const inputDataRow = dataList?.[coeffIndex + 2 + index]?.split(',');
    //       if (inputDataRow && inputDataRow.length > 0) {
    //         const weightVal = inputDataRow[0]?.replace('kg', '');
    //         const numWeightVal = Number(weightVal);

    //         if (!isNaN(numWeightVal)) {
    //           newWeightMaster.push({ ...masterItem, value: numWeightVal });

    //           const timeCoeffItem = newTimeCoeffItems.find((coeff) => coeff.weightId === masterItem.no);

    //           if (timeCoeffItem) {
    //             const newAreaCoeffList = inputDataRow
    //               .slice(1)
    //               .map((val, i) => {
    //                 if (val !== undefined && val.trim() !== '') {
    //                   const decimalVal = toDecimal(val, 2);
    //                   if (decimalVal !== null && !isNaN(decimalVal)) {
    //                     return { no: i, value: decimalVal, isOutOfRange: false };
    //                   }
    //                 }
    //                 return null;
    //               })
    //               .filter((item) => item !== null);

    //             timeCoeffItem.areaCoeffList = newAreaCoeffList;
    //           }
    //         }
    //       }
    //     });
    //     deviceData.details.mtWeightThMaster = newWeightMaster;
    //     deviceData.details.mtTimeCoeffItems = newTimeCoeffItems;
    //   }
    // }

    const safeParseNumber = (val) => {
      if (val === undefined || val === null || val.trim() === '') {
        return null;
      }
      const num = Number(val);
      return !isNaN(num) ? num : null;
    };

    // ---
    // 加工補正時間係数
    const coeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );

    if (coeffIndex > -1 && deviceData?.details) {
      // --- 1. mtAreaThMasterの更新 ---
      // This is a single-row master array, refactored to use safeParseNumber.
      const inputAreaMaster = dataList?.[coeffIndex + 1]?.split(',');
      if (inputAreaMaster) {
        const newAreaMaster = inputAreaMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('cm2', '');
              const numVal = safeParseNumber(cleanedVal);
              if (numVal !== null) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.mtAreaThMaster = newAreaMaster;
      }

      // --- 2. mtWeightThMaster と mtTimeCoeffItems の更新 ---
      // This part is multi-row and dynamic, so we apply the while-loop pattern.
      if (deviceData.details.mtWeightThMaster && deviceData.details.mtTimeCoeffItems) {
        const newWeightMaster = [];
        const newTimeCoeffItems = [];

        const originalMaster = deviceData.details.mtWeightThMaster;
        const originalItems = deviceData.details.mtTimeCoeffItems;

        let index = 0;

        // Loop indefinitely until we run out of valid input data rows
        while (true) {
          // Data starts from the 3rd row after the header (coeffIndex + 2)
          const inputDataRow = dataList?.[coeffIndex + 2 + index]?.split(',');

          const weightVal = inputDataRow?.[0]?.replace('kg', '');
          const numWeightVal = safeParseNumber(weightVal);

          if (inputDataRow === undefined || numWeightVal === null) {
            break;
          }

          // --- Process Master Item ---
          const originalMasterItem = originalMaster[index];
          const itemNo = originalMasterItem?.no !== undefined ? originalMasterItem.no : index;

          newWeightMaster.push({
            ...(originalMasterItem || {}),
            no: itemNo,
            value: numWeightVal,
          });

          // --- Process Coeff Item ---
          const originalCoeffItem = originalItems.find((coeff) => coeff.weightId === itemNo);

          const coeffItemToUpdate = {
            ...(originalCoeffItem || {}),
            weightId: itemNo,
          };

          // Create the new inner list (areaCoeffList)
          const newAreaCoeffList = inputDataRow
            .slice(1) // Get all cells after the first one
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const decimalVal = toDecimal(val, 2); // Using toDecimal as in original
                if (decimalVal !== null && !isNaN(decimalVal)) {
                  const originalListItem = originalCoeffItem?.areaCoeffList?.[i] || {};
                  return {
                    ...originalListItem,
                    no: i,
                    value: decimalVal,
                    isOutOfRange: false,
                  };
                }
              }
              return null;
            })
            .filter((item) => item !== null);

          // Assign the new inner list
          coeffItemToUpdate.areaCoeffList = newAreaCoeffList;

          // Add the updated item to our new array
          newTimeCoeffItems.push(coeffItemToUpdate);

          // Move to the next row
          index++;
        }

        // Replace the old arrays with the new, dynamically-sized arrays.
        deviceData.details.mtWeightThMaster = newWeightMaster;
        deviceData.details.mtTimeCoeffItems = newTimeCoeffItems;
      }
    }

    // サイズ係数
    inputData = [];
    childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    return deviceData;
  };

  // パンチ処理のCSV入力処理
  const punchCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;
    deviceData.details.charges.twoStepHolework = amountData?.[2]
      ? amountData?.[2]
      : deviceData?.details?.charges?.twoStepHolework;
    deviceData.details.charges.jointSeparate = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.charges?.jointSeparate;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.prepBasicTime;

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 段取設定の金型段取時間
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.prepMoldQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('本', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // deviceData?.details?.prepMoldQtyCoeffItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     inVal = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // 段取設定の金型段取時間
    const moldPrepIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );

    if (moldPrepIndex > -1 && deviceData?.details) {
      // --- prepMoldQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[moldPrepIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('本', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepMoldQtyCoeffThMaster = newMasterArray;
      }

      // --- prepMoldQtyCoeffItemsの更新 ---
      const inputDataItems = dataList?.[moldPrepIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepMoldQtyCoeffItems = newItemsArray;
      }
    }

    // 材料配置
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.materialArrange.graspAllowanceX = amountData?.[0]
      ? amountData?.[0]
      : deviceData?.details?.materialArrange?.graspAllowanceX;
    deviceData.details.materialArrange.graspAllowanceY = amountData?.[1]
      ? amountData?.[1]
      : deviceData?.details?.materialArrange?.graspAllowanceY;
    deviceData.details.materialArrange.xWidth = amountData?.[2]
      ? amountData?.[2]
      : deviceData?.details?.materialArrange?.xWidth;
    deviceData.details.materialArrange.yWidth = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.materialArrange?.yWidth;
    deviceData.details.materialArrange.workRangeX = amountData?.[4]
      ? amountData?.[4]
      : deviceData?.details?.materialArrange?.workRangeX;
    deviceData.details.materialArrange.workRangeY = amountData?.[5]
      ? amountData?.[5]
      : deviceData?.details?.materialArrange?.workRangeY;
    deviceData.details.materialArrange.rangeAdditionalTime = amountData?.[6]
      ? amountData?.[6]
      : deviceData?.details?.materialArrange?.rangeAdditionalTime;

    // パンチ条件
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.punches.punchHoleDia = amountData?.[0]
      ? amountData?.[0]
      : deviceData?.details?.punches?.punchHoleDia;
    deviceData.details.punches.punchRectanglePer = amountData?.[1]
      ? amountData?.[1]
      : deviceData?.details?.punches?.punchRectanglePer;
    deviceData.details.punches.twoPitch = amountData?.[2] ? amountData?.[2] : deviceData?.details?.punches?.twoPitch;

    // // 1パンチ加工時間
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.punchWorkTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //1パンチ加工時間
    // let index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // if (deviceData?.details?.punchWorkTimeItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.punchWorkTimeItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.punchWorkTimeItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 1パンチ加工時間
    const punchWorkTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (punchWorkTimeIndex > -1 && deviceData?.details) {
      // --- punchWorkTimeThickThMasterの更新 (板厚ヘッダー) ---
      const inputDataMaster = dataList?.[punchWorkTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.punchWorkTimeThickThMaster = newMasterArray;
      }

      // --- punchWorkTimeItemsの更新 (材質ごとのデータ) ---
      if (deviceData.details.punchWorkTimeItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newPunchWorkTimeItems = { ...deviceData.details.punchWorkTimeItems };

        Object.keys(newPunchWorkTimeItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[punchWorkTimeIndex + 2 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newPunchWorkTimeItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.punchWorkTimeItems = newPunchWorkTimeItems;
      }
    }

    // 送り速度(mm/min)
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (amountData?.split(',') !== undefined) {
      amountData = amountData?.split(',')?.[0];
    }
    deviceData.details.feedSpeed = amountData !== undefined ? amountData : deviceData?.details?.feedSpeed;

    // ローラー/ホイール/ケガキ金型　加工速度(mm/sec)
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (amountData?.split(',') !== undefined) {
      amountData = amountData?.split(',')?.[0];
    }
    deviceData.details.workSpeed = amountData !== undefined ? amountData : deviceData?.details?.workSpeed;

    // 追抜き条件
    inputData = [];
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    inputData = dataList?.[thickIndex + 2]?.split(',');
    //マスタ
    deviceData?.details?.odOvertakeItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });

    // サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = toDecimal(cleanedVal, 2);
              if (numVal !== null && !isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const numVal = toDecimal(val, 2);
              if (numVal !== null && !isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    // 2工程穴加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );
    dataTitle = dataList[chargesIndex + 1];
    dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.twoStepHoleworkTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.twoStepHoleworkTime;

    // ジョイントバラシ
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[13] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[13]
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    //マスタ
    deviceData?.details?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        item.value = inVal !== undefined ? inVal : item.value;
      });
    inputData = dataList?.[thickIndex + 2]?.split(',');
    //マスタ
    deviceData?.details?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });

    // 材質区分/板厚
    // inputData = [];
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // //マスタ
    // deviceData?.details?.jointSeparateThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // let index = 0;
    // if (deviceData?.details?.jointSeparateItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.jointSeparateItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 4 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.jointSeparateItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    const safeParseNumber = (val) => {
      if (val === undefined || val === null || val.trim() === '') {
        return null; // Don't process empty, null, or undefined strings
      }
      const num = Number(val);
      return !isNaN(num) ? num : null;
    };

    // --- 1. 材質区分/板厚 (jointSeparateThickThMaster) ---
    // (thickIndex is assumed to be defined before this block)
    const inputDataMaster = dataList?.[thickIndex + 3]?.split(',');

    if (inputDataMaster && deviceData?.details) {
      // Create a new master array based on the input data
      const newMasterArray = inputDataMaster
        .slice(1) // Skip first (header) column
        .map((val, i) => {
          const cleanedVal = val?.replace('～', '').replace('t', '');
          const numVal = safeParseNumber(cleanedVal);

          if (numVal !== null) {
            // Return the object structure, similar to the reference code
            return { no: i, value: numVal, isOutOfRange: false };
          }
          return null; // Invalid or empty values
        })
        .filter((item) => item !== null); // Remove nulls

      // Replace the old array with the new one
      deviceData.details.jointSeparateThickThMaster = newMasterArray;
    }

    // --- 2. 材質区分/板厚 (jointSeparateItems) ---
    if (deviceData?.details?.jointSeparateItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);

      // Create a new object, inheriting all existing item arrays
      const newJointSeparateItems = { ...deviceData.details.jointSeparateItems };
      let index = 0; // Index for dataList rows

      // Iterate over the keys that are marked as 'used'
      Object.keys(newJointSeparateItems)
        .filter((listkey) => usedIds?.includes(parseInt(listkey)))
        .forEach((key) => {
          // Find the corresponding data line for this key
          const inputDataItems = dataList?.[thickIndex + 4 + index]?.split(',');
          const typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;

          // Check if dataList line exists and its header (col 0) matches the type name
          if (inputDataItems && typeNm === inputDataItems[0]) {
            // Create a new array for this item key
            const newItemsArray = inputDataItems
              .slice(1) // Skip first (header) column
              .map((val, i) => {
                const numVal = safeParseNumber(val);

                if (numVal !== null) {
                  // Return the object structure
                  return { no: i, value: numVal, isOutOfRange: false };
                }
                return null; // Invalid or empty values
              })
              .filter((item) => item !== null); // Remove nulls

            // Replace the array for this key in our new object
            newJointSeparateItems[key] = newItemsArray;
          }
          // If the check fails, newJointSeparateItems[key] retains its original array
          // from the spread operator, matching the original code's behavior of
          // only updating on a successful match.

          index++; // Increment index to read the next line in the next iteration
        });

      // Finally, replace the entire items object on deviceData
      deviceData.details.jointSeparateItems = newJointSeparateItems;
    }

    return deviceData;
  };

  // レーザ処理のCSV入力処理
  const laserCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.work = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.work;
    deviceData.details.charges.twoStepHolework = amountData?.[2]
      ? amountData?.[2]
      : deviceData?.details?.charges?.twoStepHolework;
    deviceData.details.charges.jointSeparate = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.charges?.jointSeparate;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.prepBasicTime;

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // 材料配置
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.materialArrange.graspAllowanceX = amountData?.[0]
      ? amountData?.[0]
      : deviceData?.details?.materialArrange?.graspAllowanceX;
    deviceData.details.materialArrange.graspAllowanceY = amountData?.[1]
      ? amountData?.[1]
      : deviceData?.details?.materialArrange?.graspAllowanceY;
    deviceData.details.materialArrange.xWidth = amountData?.[2]
      ? amountData?.[2]
      : deviceData?.details?.materialArrange?.xWidth;
    deviceData.details.materialArrange.yWidth = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.materialArrange?.yWidth;
    deviceData.details.materialArrange.workRangeX = amountData?.[4]
      ? amountData?.[4]
      : deviceData?.details?.materialArrange?.workRangeX;
    deviceData.details.materialArrange.workRangeY = amountData?.[5]
      ? amountData?.[5]
      : deviceData?.details?.materialArrange?.workRangeY;
    deviceData.details.materialArrange.rangeAdditionalTime = amountData?.[6]
      ? amountData?.[6]
      : deviceData?.details?.materialArrange?.rangeAdditionalTime;

    // // 1ピアス加工時間
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.piercingTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //1ピアス加工時間
    // let index = 0;
    // let speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // if (deviceData?.details?.piercingTimeThItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.piercingTimeThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.piercingTimeThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 1ピアス加工時間
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (thickIndex > -1 && deviceData?.details) {
      // --- piercingTimeThickThMasterの更新 ---
      const inputDataMaster = dataList?.[thickIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              return {
                no: i,
                value: Number(cleanedVal),
                isOutOfRange: false,
              };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.piercingTimeThickThMaster = newMasterArray;
      }

      // --- piercingTimeThItemsの更新 ---
      if (deviceData.details.piercingTimeThItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        Object.keys(deviceData.details.piercingTimeThItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[thickIndex + 2 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    return {
                      no: i,
                      value: Number(val),
                      isOutOfRange: false,
                    };
                  }
                  return null;
                })
                .filter((item) => item !== null);
              deviceData.details.piercingTimeThItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });
      }
    }

    // // 加工速度(mm/min)
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    // );
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // // 簡易入力
    // //板厚マスタ
    // deviceData?.details?.workSpeedThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // let index = 0;
    // if (deviceData?.details?.workSpeedItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.workSpeedItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 3 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.workSpeedItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }
    // // 詳細入力
    // //板厚マスタ
    // thickIndex = thickIndex + index + 3;
    // inputData = dataList?.[thickIndex];
    // let detailIndex = 0;
    // let materialTypeIndex = 0;
    // if (inputData === '詳細入力' || inputData?.includes('詳細入力')) {
    //   thickIndex = thickIndex + 2;
    //   if (deviceData?.details?.workSpeedItems) {
    //     const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //     const usedIds = usedItems?.map((item) => item.id);
    //     Object.keys(deviceData.details?.workSpeedItems)
    //       ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //       ?.map((key) => {
    //         let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //         for (let i = 0; i < 3; i++) {
    //           inputData = dataList?.[thickIndex + materialTypeIndex + i]?.split(',');
    //           if (typeNm === inputData[0]) {
    //             if (inputData[1] === '丸穴径(Φ) (≦)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.roundHoleDiaThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             } else if (inputData[1] === '加工周長(mm)(≦)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.workLenThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             } else if (inputData[1] === '速度(mm/分)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.lenThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             }
    //           }
    //           materialTypeIndex++;
    //         }
    //       });
    //   }
    // }

    // // 加工速度(mm/min)
    // let workSpeedIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    // );

    // if (workSpeedIndex > -1 && deviceData?.details) {
    //   // --- 簡易入力 ---

    //   // workSpeedThickThMasterの更新
    //   const inputDataMaster = dataList?.[workSpeedIndex + 2]?.split(',');
    //   if (inputDataMaster) {
    //     const newMasterArray = inputDataMaster
    //       .slice(1)
    //       .map((val) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('t', '');
    //           return { value: Number(cleanedVal), isOutOfRange: false };
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.workSpeedThickThMaster = newMasterArray;
    //   }

    //   // workSpeedItemsの簡易入力更新
    //   let simpleInputCsvRowCount = 0;
    //   if (deviceData.details.workSpeedItems) {
    //     const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //     const usedIds = usedItems?.map((item) => item.id);

    //     Object.keys(deviceData.details.workSpeedItems)
    //       .filter((key) => usedIds?.includes(parseInt(key)))
    //       .forEach((key) => {
    //         const inputDataItems = dataList?.[workSpeedIndex + 2 + simpleInputCsvRowCount]?.split(',');
    //         const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

    //         if (inputDataItems && typeName === inputDataItems[0]) {
    //           const newItemsArray = inputDataItems
    //             .slice(1)
    //             .map((val) => {
    //               if (val !== undefined && val.trim() !== '') {
    //                 return { value: Number(val), isOutOfRange: false };
    //               }
    //               return null;
    //             })
    //             .filter((item) => item !== null);
    //           // This is a simplified assumption. The original data structure might be more complex.
    //           // If `workSpeedItems[key]` items are objects, this needs adjustment.
    //           // For now, assuming it's a list of {value, isOutOfRange}.
    //           deviceData.details.workSpeedItems[key] = newItemsArray;
    //         }
    //         simpleInputCsvRowCount++;
    //       });
    //   }

    //   // --- 詳細入力 ---
    //   let detailInputStartIndex = workSpeedIndex + 3 + simpleInputCsvRowCount;
    //   const detailInputMarker = dataList?.[detailInputStartIndex];

    //   if (detailInputMarker === '詳細入力' || detailInputMarker?.includes('詳細入力')) {
    //     let detailCsvRowOffset = detailInputStartIndex + 2;
    //     const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //     const usedIds = usedItems?.map((item) => item.id);

    //     Object.keys(deviceData.details.workSpeedItems)
    //       .filter((key) => usedIds?.includes(parseInt(key)))
    //       .forEach((key) => {
    //         const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

    //         //
    //         for (let i = 0; i < 3; i++) {
    //           const inputData = dataList?.[detailCsvRowOffset + i]?.split(',');
    //           if (!inputData || typeName !== inputData[0]) continue;

    //           let detailValueIndex = 0;
    //           const newWorkSpeedItemsForKey = deviceData.details.workSpeedItems[key].map((item) => {
    //             if (inputData[1] === '丸穴径(Φ) (≦)') {
    //               const newRoundHoleDiaThItems = item.roundHoleDiaThItems.map((roundItem) => {
    //                 const newValue =
    //                   inputData[detailValueIndex + 2] !== undefined
    //                     ? Number(inputData[detailValueIndex + 2])
    //                     : roundItem.value;
    //                 detailValueIndex++;
    //                 return { ...roundItem, value: newValue };
    //               });
    //               return { ...item, roundHoleDiaThItems: newRoundHoleDiaThItems };
    //             }
    //             if (inputData[1] === '加工周長(mm)(≦)') {
    //               const newWorkLenThItems = item.workLenThItems.map((workLenItem) => {
    //                 const newValue =
    //                   inputData[detailValueIndex + 2] !== undefined
    //                     ? Number(inputData[detailValueIndex + 2])
    //                     : workLenItem.value;
    //                 detailValueIndex++;
    //                 return { ...workLenItem, value: newValue };
    //               });
    //               return { ...item, workLenThItems: newWorkLenThItems };
    //             }
    //             if (inputData[1] === '速度(mm/分)') {
    //               const newLenThItems = item.lenThItems.map((lenItem) => {
    //                 const newValue =
    //                   inputData[detailValueIndex + 2] !== undefined
    //                     ? Number(inputData[detailValueIndex + 2])
    //                     : lenItem.value;
    //                 detailValueIndex++;
    //                 return { ...lenItem, value: newValue };
    //               });
    //               return { ...item, lenThItems: newLenThItems };
    //             }
    //             return item;
    //           });
    //           deviceData.details.workSpeedItems[key] = newWorkSpeedItemsForKey;
    //         }
    //         detailCsvRowOffset += 3; //
    //       });
    //   }
    // }

    // 加工速度(mm/min)
    const safeParseNumber = (val) => {
      if (val === undefined || val === null || val.trim() === '') {
        return null;
      }
      const num = Number(val);
      return !isNaN(num) ? num : null;
    };

    // ---
    // 加工速度(mm/min)
    let workSpeedIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );

    if (workSpeedIndex > -1 && deviceData?.details) {
      // --- 1. workSpeedThickThMasterの更新 (Master Array) ---
      const inputDataMaster = dataList?.[workSpeedIndex + 2]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            const cleanedVal = val?.replace('～', '').replace('t', '');
            const numVal = safeParseNumber(cleanedVal);

            if (numVal !== null) {
              return { no: i, value: numVal, isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);

        deviceData.details.workSpeedThickThMaster = newMasterArray;
      }

      const newWorkSpeedItems = { ...deviceData.details.workSpeedItems };
      let simpleInputCsvRowCount = 0;

      // --- Pass 1: 簡易入力 (Simple Input) ---
      if (deviceData.details.workSpeedItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        const masterLength = deviceData.details.workSpeedThickThMaster.length;

        Object.keys(newWorkSpeedItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[workSpeedIndex + 3 + simpleInputCsvRowCount]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const rawData = inputDataItems.slice(1);

              const newItemsArray = Array.from({ length: masterLength }, (_, i) => {
                const numVal = safeParseNumber(rawData[i]);
                return { no: i, value: numVal !== null ? numVal : 0, isOutOfRange: false };
              });

              newWorkSpeedItems[key] = newItemsArray;
            }
            simpleInputCsvRowCount++;
          });
      }

      // --- Pass 2: 詳細入力 (Detailed Input) ---
      let detailInputStartIndex = workSpeedIndex + 2 + simpleInputCsvRowCount;
      const detailInputMarker = dataList?.[detailInputStartIndex];

      if (detailInputMarker === '詳細入力' || detailInputMarker?.includes('詳細入力')) {
        let detailCsvRowOffset = detailInputStartIndex + 2;
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);

        Object.keys(newWorkSpeedItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            for (let i = 0; i < 3; i++) {
              const inputData = dataList?.[detailCsvRowOffset + i]?.split(',');
              if (!inputData || typeName !== inputData[0]) continue;

              let detailValueIndex = 0;

              const newWorkSpeedItemsForKey = newWorkSpeedItems[key].map((item) => {
                if (inputData[1] === '丸穴径(Φ) (≦)') {
                  const newRoundHoleDiaThItems = item.roundHoleDiaThItems.map((roundItem, i) => {
                    const numVal = safeParseNumber(inputData[detailValueIndex + 2]);
                    const newValue = numVal !== null ? numVal : roundItem.value;
                    detailValueIndex++;
                    return { ...roundItem, no: i, value: newValue };
                  });
                  return { ...item, roundHoleDiaThItems: newRoundHoleDiaThItems };
                }
                if (inputData[1] === '加工周長(mm)(≦)') {
                  const newWorkLenThItems = item.workLenThItems.map((workLenItem, i) => {
                    const numVal = safeParseNumber(inputData[detailValueIndex + 2]);
                    const newValue = numVal !== null ? numVal : workLenItem.value;
                    detailValueIndex++;
                    return { ...workLenItem, no: i, value: newValue };
                  });
                  return { ...item, workLenThItems: newWorkLenThItems };
                }
                if (inputData[1] === '速度(mm/分)') {
                  const newLenThItems = item.lenThItems.map((lenItem, i) => {
                    const numVal = safeParseNumber(inputData[detailValueIndex + 2]);
                    const newValue = numVal !== null ? numVal : lenItem.value;
                    detailValueIndex++;
                    return { ...lenItem, no: i, value: newValue };
                  });
                  return { ...item, lenThItems: newLenThItems };
                }
                return item;
              });

              newWorkSpeedItems[key] = newWorkSpeedItemsForKey;
            }
            detailCsvRowOffset += 3;
          });
      }

      deviceData.details.workSpeedItems = newWorkSpeedItems;
    }

    // ケガキ速度,送り速度
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) =>
        item === detailMenuTab[6] ||
        (dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]?.split(',')?.[0] &&
          dataList?.[index]?.split(',')?.[1] === detailMenuTab[6]?.split(',')?.[1])
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    deviceData.details.scribingSpeed =
      inputData[0] !== undefined ? Number(inputData[0]) : deviceData?.details?.scribingSpeed;
    deviceData.details.feedSpeed = inputData[1] !== undefined ? Number(inputData[1]) : deviceData?.details?.feedSpeed;

    // // 加工速度係数
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.workSpeedCoeffLengthThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // //内加工
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // deviceData?.details?.workSpeedCoeffInternalWorkItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // //外加工
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // deviceData?.details?.workSpeedCoeffExternalWorkItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });

    // 加工速度係数
    const coeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (coeffIndex > -1 && deviceData?.details) {
      // --- workSpeedCoeffLengthThMasterの更新 ---
      const inputDataMaster = dataList?.[coeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              return { no: i, value: Number(cleanedVal), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffLengthThMaster = newMasterArray;
      }

      // --- workSpeedCoeffInternalWorkItemsの更新 (内加工) ---
      const inputDataInternal = dataList?.[coeffIndex + 2]?.split(',');
      if (inputDataInternal) {
        const newInternalArray = inputDataInternal
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              return { no: i, value: Number(val), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffInternalWorkItems = newInternalArray;
      }

      // --- workSpeedCoeffExternalWorkItemsの更新 (外加工) ---
      const inputDataExternal = dataList?.[coeffIndex + 3]?.split(',');
      if (inputDataExternal) {
        const newExternalArray = inputDataExternal
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              return { no: i, value: Number(val), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffExternalWorkItems = newExternalArray;
      }
    }

    // ガス係数
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );
    inputData = dataList?.[thickIndex + 2]?.split(',');
    deviceData?.details?.gasCoeffListItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? toDecimal(inVal, 2) : item.value;
      });

    // // 材質区分/板厚
    // inputData = [];
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // //マスタ
    // deviceData?.details?.gasCoeffThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // let index = 0;
    // if (deviceData?.details?.gasCoeffThItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.gasCoeffThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 4 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.gasCoeffThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? inputData[i + 1] : '';
    //           let gasType = deviceData?.details?.gasCoeffThMaster?.filter(
    //             (item) => !item.isOutOfRange && item.name === inVal
    //           );
    //           if (gasType?.length > 0) {
    //             item.value = gasType[0].no;
    //           }
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 材質区分/板厚
    const gasCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );

    if (gasCoeffIndex > -1 && deviceData?.details) {
      // --- gasCoeffThickThMasterの更新 (板厚ヘッダー) ---
      const inputDataMaster = dataList?.[gasCoeffIndex + 3]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              return { no: i, value: Number(cleanedVal), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.gasCoeffThickThMaster = newMasterArray;
      }

      // --- gasCoeffThItemsの更新 (材質ごとのガス種データ) ---
      if (deviceData.details.gasCoeffThItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newGasCoeffThItems = { ...deviceData.details.gasCoeffThItems };

        Object.keys(newGasCoeffThItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[gasCoeffIndex + 4 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((gasName, i) => {
                  if (gasName !== undefined && gasName.trim() !== '') {
                    // `gasCoeffThMaster` (ガス種のマスタ) から対応する `no` を検索
                    const gasType = deviceData.details.gasCoeffThMaster?.find(
                      (item) => !item.isOutOfRange && item.name === gasName.trim()
                    );
                    if (gasType) {
                      return { no: i, value: gasType.no, isOutOfRange: false };
                    }
                  }
                  // 対応するガス種が見つからない場合や、CSVセルが空の場合はnullを返す
                  return null;
                })
                .filter((item) => item !== null); // nullの要素を配列から除去
              newGasCoeffThItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.gasCoeffThItems = newGasCoeffThItems;
      }
    }

    // サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[9] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? toDecimal(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              return { no: i, value: toDecimal(cleanedVal, 2), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              return { no: i, value: toDecimal(val, 2), isOutOfRange: false };
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    // 2工程穴加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );
    dataTitle = dataList[chargesIndex + 1];
    dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.twoStepHoleworkTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.twoStepHoleworkTime;

    // ジョイントバラシ
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    //マスタ
    deviceData?.details?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        item.value = inVal !== undefined ? inVal : item.value;
      });
    inputData = dataList?.[thickIndex + 2]?.split(',');
    //マスタ
    deviceData?.details?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });

    // // ジョイントバラシ
    // const jointIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    // );

    // if (jointIndex > -1 && deviceData?.details) {
    //   // --- jointQtySizeThMasterの更新 ---
    //   const inputDataMaster = dataList?.[jointIndex + 1]?.split(',');
    //   if (inputDataMaster) {
    //     const newMasterArray = inputDataMaster
    //       .slice(1)
    //       .map((val) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const cleanedVal = val.replace('～', '').replace('cm2', '');
    //           const numVal = Number(cleanedVal);
    //           if (!isNaN(numVal)) {
    //             return { value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.jointQtySizeThMaster = newMasterArray;
    //   }

    //   // --- jointQtyItemsの更新 ---
    //   const inputDataItems = dataList?.[jointIndex + 2]?.split(',');
    //   if (inputDataItems) {
    //     const newItemsArray = inputDataItems
    //       .slice(1)
    //       .map((val) => {
    //         if (val !== undefined && val.trim() !== '') {
    //           const numVal = Number(val);
    //           if (!isNaN(numVal)) {
    //             return { value: numVal, isOutOfRange: false };
    //           }
    //         }
    //         return null;
    //       })
    //       .filter((item) => item !== null);
    //     deviceData.details.jointQtyItems = newItemsArray;
    //   }
    // }

    // // 材質区分/板厚
    // inputData = [];
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // //マスタ
    // deviceData?.details?.jointSeparateThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // let index = 0;
    // if (deviceData?.details?.jointSeparateItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.jointSeparateItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 4 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.jointSeparateItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 材質区分/板厚 (jointSeparate)
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );

    if (thickIndex > -1 && deviceData?.details) {
      // --- jointSeparateThickThMasterの更新 (板厚ヘッダー) ---
      const inputDataMaster = dataList?.[thickIndex + 3]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.jointSeparateThickThMaster = newMasterArray;
      }

      // --- jointSeparateItemsの更新 (材質ごとのデータ) ---
      if (deviceData.details.jointSeparateItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newJointSeparateItems = { ...deviceData.details.jointSeparateItems };

        Object.keys(newJointSeparateItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[thickIndex + 4 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newJointSeparateItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.jointSeparateItems = newJointSeparateItems;
      }
    }

    return deviceData;
  };

  // 複合機処理のCSV入力処理
  const combiCSVImport = (deviceData, dataList, detailMenuTab) => {
    let inVal = '';
    let inputData = [];
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    let dataTitle = dataList[chargesIndex + 1];
    let amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = amountData?.[0] ? amountData?.[0] : deviceData?.details?.charges?.prep;
    deviceData.details.charges.punchWork = amountData?.[1] ? amountData?.[1] : deviceData?.details?.charges?.punchWork;
    deviceData.details.charges.laserWork = amountData?.[2] ? amountData?.[2] : deviceData?.details?.charges?.laserWork;
    deviceData.details.charges.twoStepHolework = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.charges?.twoStepHolework;
    deviceData.details.charges.jointSeparate = amountData?.[4]
      ? amountData?.[4]
      : deviceData?.details?.charges?.jointSeparate;

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    dataTitle = dataList[chargesIndex + 1];
    let dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.prepBasicTime;

    // 段取設定の段取個数係数
    inputData = [];
    let dandoriQtyIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputData = dataList?.[dandoriQtyIndex + 1]?.split(',');
    deviceData?.details?.prepQtyCoeffThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('個', '');
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });
    inputData = dataList?.[dandoriQtyIndex + 2]?.split(',');
    deviceData?.details?.prepQtyCoeffItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((row, index) => {
        inVal = inputData[index + 1] !== undefined ? toDecimal(inputData[index + 1], 2) : row.value;
        row.value = inVal !== undefined ? inVal : row.value;
      });

    // // 段取設定の金型段取時間
    // inputData = [];
    // let thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.prepMoldQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('本', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // deviceData?.details?.prepMoldQtyCoeffItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     inVal = inVal !== undefined ? setTimetoSec(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });

    // 段取設定の金型段取時間
    const moldPrepIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );

    if (moldPrepIndex > -1 && deviceData?.details) {
      // --- prepMoldQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[moldPrepIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('本', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepMoldQtyCoeffThMaster = newMasterArray;
      }

      // --- prepMoldQtyCoeffItemsの更新 ---
      const inputDataItems = dataList?.[moldPrepIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const timeInSec = setTimetoSec(val);
              if (timeInSec !== null && !isNaN(timeInSec)) {
                return { no: i, value: timeInSec, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.prepMoldQtyCoeffItems = newItemsArray;
      }
    }

    // 材料配置
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );
    dataTitle = dataList[chargesIndex + 1];
    amountData = dataList[chargesIndex + 2]?.split(',');
    deviceData.details.materialArrange.graspAllowanceX = amountData?.[0]
      ? amountData?.[0]
      : deviceData?.details?.materialArrange?.graspAllowanceX;
    deviceData.details.materialArrange.graspAllowanceY = amountData?.[1]
      ? amountData?.[1]
      : deviceData?.details?.materialArrange?.graspAllowanceY;
    deviceData.details.materialArrange.xWidth = amountData?.[2]
      ? amountData?.[2]
      : deviceData?.details?.materialArrange?.xWidth;
    deviceData.details.materialArrange.yWidth = amountData?.[3]
      ? amountData?.[3]
      : deviceData?.details?.materialArrange?.yWidth;
    deviceData.details.materialArrange.workRangeX = amountData?.[4]
      ? amountData?.[4]
      : deviceData?.details?.materialArrange?.workRangeX;
    deviceData.details.materialArrange.workRangeY = amountData?.[5]
      ? amountData?.[5]
      : deviceData?.details?.materialArrange?.workRangeY;
    deviceData.details.materialArrange.rangeAdditionalTime = amountData?.[6]
      ? amountData?.[6]
      : deviceData?.details?.materialArrange?.rangeAdditionalTime;

    // パンチ条件マスター
    inputData = [];
    let thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    //マスタ
    deviceData?.details?.punchConditionThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('t', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    // パンチ条件
    let index = 0;
    let speedLenIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[5] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[5]
    );
    if (deviceData?.details?.punchConditionItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(deviceData?.details?.punchConditionItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          if (typeNm === inputData[0]) {
            deviceData?.details?.punchConditionItems[key]?.map((item, i) => {
              inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
              item.value = inVal !== undefined ? inVal : item.value;
            });
          }
          index++;
        });
    }

    // // 1パンチ加工時間
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.punchWorkTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //1パンチ加工時間
    // index = 0;
    // speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    // );
    // if (deviceData?.details?.punchWorkTimeItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.punchWorkTimeItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.punchWorkTimeItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 1パンチ加工時間
    const punchWorkTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
    );

    if (punchWorkTimeIndex > -1 && deviceData?.details) {
      // --- punchWorkTimeThickThMasterの更新 (板厚ヘッダー) ---
      const inputDataMaster = dataList?.[punchWorkTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.punchWorkTimeThickThMaster = newMasterArray;
      }

      // --- punchWorkTimeItemsの更新 (材質ごとのデータ) ---
      if (deviceData.details.punchWorkTimeItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newPunchWorkTimeItems = { ...deviceData.details.punchWorkTimeItems };

        Object.keys(newPunchWorkTimeItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[punchWorkTimeIndex + 2 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newPunchWorkTimeItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.punchWorkTimeItems = newPunchWorkTimeItems;
      }
    }

    // // 1ピアス加工時間
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.piercingTimeThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // //1ピアス加工時間
    // index = 0;
    // speedLenIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    // );
    // if (deviceData?.details?.piercingTimeThItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.piercingTimeThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[speedLenIndex + 2 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.piercingTimeThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 1ピアス加工時間
    const piercingTimeIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[7] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[7]
    );

    if (piercingTimeIndex > -1 && deviceData?.details) {
      // --- piercingTimeThickThMasterの更新 (板厚ヘッダー) ---
      const inputDataMaster = dataList?.[piercingTimeIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.piercingTimeThickThMaster = newMasterArray;
      }

      // --- piercingTimeThItemsの更新 (材質ごとのデータ) ---
      if (deviceData.details.piercingTimeThItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newPiercingTimeItems = { ...deviceData.details.piercingTimeThItems };

        Object.keys(newPiercingTimeItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[piercingTimeIndex + 2 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newPiercingTimeItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.piercingTimeThItems = newPiercingTimeItems;
      }
    }

    // // 加工速度(mm/min)
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    // );
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // // 簡易入力
    // //板厚マスタ
    // deviceData?.details?.workSpeedThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // index = 0;
    // if (deviceData?.details?.workSpeedItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.workSpeedItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 3 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.workSpeedItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
    //           item.value = inVal !== undefined ? inVal : item.value;
    //         });
    //       }
    //       index++;
    //     });
    // }
    // // 詳細入力
    // //板厚マスタ
    // thickIndex = thickIndex + index + 3;
    // inputData = dataList?.[thickIndex];
    // let detailIndex = 0;
    // let materialTypeIndex = 0;
    // if (inputData === '詳細入力' || inputData?.includes('詳細入力')) {
    //   thickIndex = thickIndex + 2;
    //   if (deviceData?.details?.workSpeedItems) {
    //     const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //     const usedIds = usedItems?.map((item) => item.id);
    //     Object.keys(deviceData.details?.workSpeedItems)
    //       ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //       ?.map((key) => {
    //         let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //         for (let i = 0; i < 3; i++) {
    //           inputData = dataList?.[thickIndex + materialTypeIndex + i]?.split(',');
    //           if (typeNm === inputData[0]) {
    //             if (inputData[1] === '丸穴径(Φ) (≦)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.roundHoleDiaThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             } else if (inputData[1] === '加工周長(mm)(≦)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.workLenThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             } else if (inputData[1] === '速度(mm/分)') {
    //               detailIndex = 0;
    //               deviceData.details?.workSpeedItems[key]?.map((item, index) => {
    //                 item?.lenThItems?.map((roundItem, i) => {
    //                   roundItem.value =
    //                     inputData[detailIndex + 2] !== undefined ? Number(inputData[detailIndex + 2]) : roundItem.value;
    //                   detailIndex++;
    //                 });
    //               });
    //             }
    //           }
    //           materialTypeIndex++;
    //         }
    //       });
    //   }
    // }

    // 加工速度(mm/min)
    let workSpeedIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[8] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[8]
    );

    if (workSpeedIndex > -1 && deviceData?.details) {
      // --- 簡易入力 ---

      // workSpeedThickThMasterの更新
      const inputDataMaster = dataList?.[workSpeedIndex + 2]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedThickThMaster = newMasterArray;
      }

      // workSpeedItemsの簡易入力更新
      let simpleInputCsvRowCount = 0;
      if (deviceData.details.workSpeedItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);

        Object.keys(deviceData.details.workSpeedItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            const inputDataItems = dataList?.[workSpeedIndex + 3 + simpleInputCsvRowCount]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              // This assumes the items in workSpeedItems[key] are objects like {value, isOutOfRange}
              // and don't contain the nested detail arrays yet.
              // If the structure is more complex, this needs to preserve other properties.
              const existingItems = deviceData.details.workSpeedItems[key] || [];
              const updatedItems = newItemsArray.map((newItem, index) => ({
                ...(existingItems[index] || {}), // Preserve nested detail arrays if they exist
                ...newItem,
              }));
              deviceData.details.workSpeedItems[key] = updatedItems;
            }
            simpleInputCsvRowCount++;
          });
      }

      // --- 詳細入力 ---
      let detailInputStartIndex = workSpeedIndex + 2 + simpleInputCsvRowCount;
      const detailInputMarker = dataList?.[detailInputStartIndex];

      if (
        (detailInputMarker === '詳細入力' || detailInputMarker?.includes('詳細入力')) &&
        deviceData.details.workSpeedItems
      ) {
        let detailCsvRowOffset = detailInputStartIndex + 2;
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);

        usedIds.forEach((id) => {
          const key = id.toString();
          if (!deviceData.details.workSpeedItems[key]) return;

          const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

          // 각 material type에 대해 3줄의 상세 데이터를 처리
          for (let i = 0; i < 3; i++) {
            const inputData = dataList?.[detailCsvRowOffset + i]?.split(',');
            if (!inputData || typeName !== inputData[0]) continue;

            let detailValueIndex = 0;
            const newWorkSpeedItemsForKey = deviceData.details.workSpeedItems[key].map((item) => {
              if (inputData[1] === '丸穴径(Φ) (≦)') {
                const newRoundHoleDiaThItems = item.roundHoleDiaThItems.map((roundItem) => {
                  const newValue =
                    inputData[detailValueIndex + 2] !== undefined
                      ? Number(inputData[detailValueIndex + 2])
                      : roundItem.value;
                  detailValueIndex++;
                  return { ...roundItem, value: !isNaN(newValue) ? newValue : roundItem.value };
                });
                return { ...item, roundHoleDiaThItems: newRoundHoleDiaThItems };
              }
              if (inputData[1] === '加工周長(mm)(≦)') {
                const newWorkLenThItems = item.workLenThItems.map((workLenItem) => {
                  const newValue =
                    inputData[detailValueIndex + 2] !== undefined
                      ? Number(inputData[detailValueIndex + 2])
                      : workLenItem.value;
                  detailValueIndex++;
                  return { ...workLenItem, value: !isNaN(newValue) ? newValue : workLenItem.value };
                });
                return { ...item, workLenThItems: newWorkLenThItems };
              }
              if (inputData[1] === '速度(mm/分)') {
                const newLenThItems = item.lenThItems.map((lenItem) => {
                  const newValue =
                    inputData[detailValueIndex + 2] !== undefined
                      ? Number(inputData[detailValueIndex + 2])
                      : lenItem.value;
                  detailValueIndex++;
                  return { ...lenItem, value: !isNaN(newValue) ? newValue : lenItem.value };
                });
                return { ...item, lenThItems: newLenThItems };
              }
              return item;
            });
            deviceData.details.workSpeedItems[key] = newWorkSpeedItemsForKey;
          }
          detailCsvRowOffset += 3;
        });
      }
    }

    // ケガキ速度,送り速度
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) =>
        item === detailMenuTab[9] ||
        (dataList?.[index]?.split(',')?.[0] === detailMenuTab[9]?.split(',')?.[0] &&
          dataList?.[index]?.split(',')?.[1] === detailMenuTab[9]?.split(',')?.[1])
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    deviceData.details.scribingSpeed =
      inputData[0] !== undefined ? Number(inputData[0]) : deviceData?.details?.scribingSpeed;
    deviceData.details.feedSpeed = inputData[1] !== undefined ? Number(inputData[1]) : deviceData?.details?.feedSpeed;

    // // 加工速度係数
    // inputData = [];
    // thickIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    // );
    // inputData = dataList?.[thickIndex + 1]?.split(',');
    // //マスタ
    // deviceData?.details?.workSpeedCoeffLengthThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('mm', '');
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // //内加工
    // inputData = dataList?.[thickIndex + 2]?.split(',');
    // deviceData?.details?.workSpeedCoeffInternalWorkItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });
    // //外加工
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // deviceData?.details?.workSpeedCoeffExternalWorkItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1];
    //     item.value = inVal !== undefined ? Number(inVal) : item.value;
    //   });

    // 加工速度係数
    const workSpeedCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (workSpeedCoeffIndex > -1 && deviceData?.details) {
      // --- workSpeedCoeffLengthThMasterの更新 ---
      const inputDataMaster = dataList?.[workSpeedCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffLengthThMaster = newMasterArray;
      }

      // --- workSpeedCoeffInternalWorkItemsの更新 (内加工) ---
      const inputDataInternal = dataList?.[workSpeedCoeffIndex + 2]?.split(',');
      if (inputDataInternal) {
        const newInternalItemsArray = inputDataInternal
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const numVal = Number(val);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffInternalWorkItems = newInternalItemsArray;
      }

      // --- workSpeedCoeffExternalWorkItemsの更新 (外加工) ---
      const inputDataExternal = dataList?.[workSpeedCoeffIndex + 3]?.split(',');
      if (inputDataExternal) {
        const newExternalItemsArray = inputDataExternal
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const numVal = Number(val);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.workSpeedCoeffExternalWorkItems = newExternalItemsArray;
      }
    }

    // ガス係数
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );
    inputData = dataList?.[thickIndex + 2]?.split(',');
    deviceData?.details?.gasCoeffListItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });

    // // 材質区分/板厚
    // inputData = [];
    // inputData = dataList?.[thickIndex + 3]?.split(',');
    // //マスタ
    // deviceData?.details?.gasCoeffThickThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('t', '');
    //     inVal = inVal !== undefined ? Number(inVal) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // index = 0;
    // if (deviceData?.details?.gasCoeffThItems) {
    //   const usedItems = materialTypes?.filter((item) => item.info.isUsed);
    //   const usedIds = usedItems?.map((item) => item.id);
    //   Object.keys(deviceData?.details?.gasCoeffThItems)
    //     ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
    //     ?.map((key) => {
    //       inputData = dataList?.[thickIndex + 4 + index]?.split(',');
    //       let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
    //       if (typeNm === inputData[0]) {
    //         deviceData?.details?.gasCoeffThItems[key]?.map((item, i) => {
    //           inVal = inputData[i + 1] !== undefined ? inputData[i + 1] : '';
    //           let gasType = deviceData?.details?.gasCoeffThMaster?.filter(
    //             (item) => !item.isOutOfRange && item.name === inVal
    //           );
    //           if (gasType?.length > 0) {
    //             item.value = gasType[0].no;
    //           }
    //         });
    //       }
    //       index++;
    //     });
    // }

    // 材質区分/板厚
    const gasCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    );

    if (gasCoeffIndex > -1 && deviceData?.details) {
      // --- gasCoeffThickThMasterの更新 (板厚ヘッダー) ---
      // The user provided logic uses thickIndex + 3, which might be an error.
      // Following the established pattern of using the line right after the header.
      const inputDataMaster = dataList?.[gasCoeffIndex + 3]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('t', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.gasCoeffThickThMaster = newMasterArray;
      }

      // --- gasCoeffThItemsの更新 (材質ごとのガス種データ) ---
      if (deviceData.details.gasCoeffThItems) {
        const usedItems = materialTypes?.filter((item) => item.info.isUsed);
        const usedIds = usedItems?.map((item) => item.id);
        let csvRowIndex = 0;

        const newGasCoeffThItems = { ...deviceData.details.gasCoeffThItems };

        Object.keys(newGasCoeffThItems)
          .filter((key) => usedIds?.includes(parseInt(key)))
          .forEach((key) => {
            // The user provided logic uses thickIndex + 4, adapting to the established pattern.
            const inputDataItems = dataList?.[gasCoeffIndex + 4 + csvRowIndex]?.split(',');
            const typeName = materialTypes?.find((item) => item.id.toString() === key)?.name;

            if (inputDataItems && typeName === inputDataItems[0]) {
              const newItemsArray = inputDataItems
                .slice(1)
                .map((gasName, i) => {
                  if (gasName !== undefined && gasName.trim() !== '') {
                    const gasType = deviceData.details.gasCoeffThMaster?.find(
                      (item) => !item.isOutOfRange && item.name === gasName.trim()
                    );
                    if (gasType) {
                      return { no: i, value: gasType.no, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newGasCoeffThItems[key] = newItemsArray;
            }
            csvRowIndex++;
          });

        deviceData.details.gasCoeffThItems = newGasCoeffThItems;
      }
    }

    // サイズ係数
    inputData = [];
    let childPartAreaIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );
    inputData = dataList?.[childPartAreaIndex + 1]?.split(',');
    //面積マスタ
    deviceData?.details?.prodSizeAreaThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    //重量マスタ
    let childPartWeightIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    );
    deviceData?.details?.prodSizeWeightThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inputData = dataList?.[childPartWeightIndex + 2 + index]?.split(',');
        inVal = inputData[0]?.replace('kg', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
        //係数値
        deviceData?.details?.prodSizeItems
          ?.filter((itemCoeff) => itemCoeff.weightId === item.no)?.[0]
          ?.areaCoeffList?.map((area, i) => {
            inVal = inputData[i + 1] !== undefined ? toDecimal(inputData[i + 1], 2) : area.value;
            area.value = inVal !== undefined ? inVal : area.value;
          });
      });

    // // 生産個数係数
    // inputData = [];
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[13] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[13]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // deviceData?.details?.productionQtyCoeffThMaster
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     inVal = inputData[index + 1]?.replace('～', '');
    //     inVal = inVal?.replace('個', '');
    //     inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //     item.value = inVal !== undefined ? inVal : item.value;
    //   });
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // deviceData?.details?.productionQtyCoeffThItems
    //   ?.filter((item) => !item.isOutOfRange)
    //   ?.map((item, index) => {
    //     item.value = toDecimal(inputData[index + 1], 2);
    //   });

    // 生産個数係数
    const quantityCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[13] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[13]
    );

    if (quantityCoeffIndex > -1 && deviceData?.details) {
      // --- productionQtyCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[quantityCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('個', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThMaster = newMasterArray;
      }

      // --- productionQtyCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[quantityCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.productionQtyCoeffThItems = newItemsArray;
      }
    }

    // 2工程穴加工時間
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[14] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[14]
    );
    dataTitle = dataList[chargesIndex + 1];
    dandoriTime = dataList[chargesIndex + 2];
    // IQX_WEBEST-301
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.twoStepHoleworkTime =
      dandoriTime !== undefined ? setTimetoSec(dandoriTime) : deviceData?.details?.twoStepHoleworkTime;

    // ジョイントバラシ
    inputData = [];
    thickIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[15] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[15]
    );
    inputData = dataList?.[thickIndex + 1]?.split(',');
    //マスタ
    deviceData?.details?.jointQtySizeThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('cm2', '');
        item.value = inVal !== undefined ? inVal : item.value;
      });
    inputData = dataList?.[thickIndex + 2]?.split(',');
    //マスタ
    deviceData?.details?.jointQtyItems
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1];
        item.value = inVal !== undefined ? Number(inVal) : item.value;
      });

    // 材質区分/板厚
    inputData = [];
    inputData = dataList?.[thickIndex + 3]?.split(',');
    //マスタ
    deviceData?.details?.jointSeparateThickThMaster
      ?.filter((item) => !item.isOutOfRange)
      ?.map((item, index) => {
        inVal = inputData[index + 1]?.replace('～', '');
        inVal = inVal?.replace('t', '');
        inVal = inVal !== undefined ? Number(inVal) : item.value;
        item.value = inVal !== undefined ? inVal : item.value;
      });
    index = 0;
    if (deviceData?.details?.jointSeparateItems) {
      const usedItems = materialTypes?.filter((item) => item.info.isUsed);
      const usedIds = usedItems?.map((item) => item.id);
      Object.keys(deviceData?.details?.jointSeparateItems)
        ?.filter((listkey) => usedIds?.includes(parseInt(listkey)))
        ?.map((key) => {
          inputData = dataList?.[thickIndex + 4 + index]?.split(',');
          let typeNm = materialTypes?.find((item) => item.id.toString() === key)?.name;
          if (typeNm === inputData[0]) {
            deviceData?.details?.jointSeparateItems[key]?.map((item, i) => {
              inVal = inputData[i + 1] !== undefined ? Number(inputData[i + 1]) : item.value;
              item.value = inVal !== undefined ? inVal : item.value;
            });
          }
          index++;
        });
    }

    return deviceData;
  };

  // 形鋼パラメータ情報をCSVで入力処理
  const iQ5CSVImport = (deviceData, dataList, detailMenuTab) => {
    let inputData = [];
    let inputDataTitle = [];
    let inVal = '';
    let titleNm = '';
    // チャージ金額(/h)
    let chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[0] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[0]
    );
    inputData = dataList?.[chargesIndex + 2]?.split(',');
    deviceData.details.charges.prep = parseInt(inputData?.[0]);
    deviceData.details.charges.work = parseInt(inputData?.[1]);

    // 段取設定
    chargesIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[1] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[1]
    );
    let dandoriTime = dataList[chargesIndex + 2];
    if (dandoriTime?.split(',') !== undefined) {
      dandoriTime = dandoriTime?.split(',')?.[0];
    }
    deviceData.details.prepBasicTime = dandoriTime !== undefined ? dandoriTime : deviceData?.details?.prepBasicTime;

    // 段取設定の形状区分係数
    let setupShapeCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[2] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[2]
    );
    inputDataTitle = dataList?.[setupShapeCoeffIndex + 1]?.split(',');
    inputData = dataList?.[setupShapeCoeffIndex + 2]?.split(',');
    if (deviceData?.details?.setupShapeCoeff) {
      Object.entries(deviceData?.details?.setupShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          if (getProcessingShapeCoeffShapeNo(inputDataTitle[index + 1], props?.steelShapeData) === parseInt(key)) {
            deviceData.details.setupShapeCoeff[key] = inputData[index + 1];
          }
        });
    }

    // 段取設定の材質区分係数
    let materialClassificationCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[3] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[3]
    );
    inputDataTitle = dataList?.[materialClassificationCoeffIndex + 1]?.split(',');
    inputData = dataList?.[materialClassificationCoeffIndex + 2]?.split(',');
    if (deviceData?.details?.materialClassificationCoeff) {
      Object.entries(deviceData?.details?.materialClassificationCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          if (getIQ5IdByName(inputDataTitle[index + 1], materialTypes) === parseInt(key)) {
            deviceData.details.materialClassificationCoeff[key] = inputData[index + 1];
          }
        });
    }

    // // 段取設定の重量(Kg)区分係数
    // let weightClassificationCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    // );
    // inputDataTitle = dataList?.[weightClassificationCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.weightClassificationCoeffThMaster) {
    //   deviceData?.details?.weightClassificationCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('kg', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[weightClassificationCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.weightClassificationCoeffThItems) {
    //   deviceData?.details?.weightClassificationCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // Helper function to create new array from CSV row
    const createArrayFromCsv = (inputRow, valueParser, unit) => {
      if (!inputRow) return null;
      return inputRow
        .slice(1)
        .map((val, i) => {
          if (val !== undefined && val.trim() !== '') {
            const cleanedVal = unit ? val.replace('～', '').replace(unit, '') : val;
            const parsedVal = valueParser(cleanedVal);
            if (parsedVal !== null && !isNaN(parsedVal)) {
              return { no: i, value: parsedVal, isOutOfRange: false };
            }
          }
          return null;
        })
        .filter((item) => item !== null);
    };

    // 段取設定の重量(Kg)区分係数
    let weightClassificationCoeffThMasterIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[4] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[4]
    );

    if (weightClassificationCoeffThMasterIndex > -1 && deviceData?.details) {
      // --- weightClassificationCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[weightClassificationCoeffThMasterIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('kg', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.weightClassificationCoeffThMaster = newMasterArray;
      }

      // --- weightClassificationCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[weightClassificationCoeffThMasterIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.weightClassificationCoeffThItems = newItemsArray;
      }
    }

    // 加工設定部分
    let singleProcessTimeSecIndex = 0;
    if (workType === WorkType.PaSteelWeight) {
      singleProcessTimeSecIndex = dataList?.findIndex(
        (item, index) => item === detailMenuTab[6] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[6]
      );
    } else if (workType === WorkType.PaSteelArea) {
      singleProcessTimeSecIndex = dataList?.findIndex(
        (item, index) => item === '1面加工時間(sec)' || dataList?.[index]?.split(',')?.[0] === '1面加工時間(sec)'
      );
    } else if (
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch
    ) {
      singleProcessTimeSecIndex = dataList?.findIndex(
        (item, index) => item === '1箇所加工時間(sec)' || dataList?.[index]?.split(',')?.[0] === '1箇所加工時間(sec)'
      );
    }
    // 加工設定の一回加工時間(sec)
    if (workType !== WorkType.PaSteelMount && workType !== WorkType.PaSteelHole && workType !== WorkType.PaSteelCut) {
      inputDataTitle = dataList?.[singleProcessTimeSecIndex + 1]?.split(',');
      inputData = dataList?.[singleProcessTimeSecIndex + 2]?.split(',');
      if (deviceData?.details?.singleProcessTimeSec) {
        Object.entries(deviceData?.details?.singleProcessTimeSec)?.map(([key, data], index) => {
          if (
            getIQ5IdByName(inputDataTitle[index + 1], processMstRecord?.details?.processDetailTypes) === parseInt(key)
          ) {
            deviceData.details.singleProcessTimeSec[key] = inputData[index + 1];
          }
        });
      }
    }

    // 仮付け加工時間(sec)
    if (workType === WorkType.PaSteelWeldFinish || workType === WorkType.PaSteelWeld) {
      let tempInstProcessTimeSecIndex = dataList?.findIndex(
        (item, index) => item === '仮付け加工時間(sec)' || dataList?.[index]?.split(',')?.[0] === '仮付け加工時間(sec)'
      );
      inputDataTitle = dataList?.[tempInstProcessTimeSecIndex + 1]?.split(',');
      inputData = dataList?.[tempInstProcessTimeSecIndex + 2]?.split(',');
      if (deviceData?.details?.tempInstProcessTimeSec) {
        Object.entries(deviceData?.details?.tempInstProcessTimeSec)?.map(([key, data], index) => {
          if (
            getIQ5IdByName(inputDataTitle[index + 1], processMstRecord?.details?.processDetailTypes) === parseInt(key)
          ) {
            deviceData.details.tempInstProcessTimeSec[key] = inputData[index + 1];
          }
        });
      }
    }

    // 取付加工時間(sec) / 穴サイズ加工時間(sec)
    if (workType === WorkType.PaSteelMount || workType === WorkType.PaSteelHole) {
      // titleNm = workType === WorkType.PaSteelMount ? '取付サイズ加工時間(sec)' : '穴サイズ加工時間(sec)';
      // let sizeProcessingTimeThMasterIndex = dataList?.findIndex(
      //   (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      // );
      // inputDataTitle = dataList?.[sizeProcessingTimeThMasterIndex + 1]?.split(',');
      // if (deviceData?.details?.sizeProcessingTimeThMaster) {
      //   deviceData?.details?.sizeProcessingTimeThMaster
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputDataTitle[index + 1]?.replace('～', '');
      //       inVal = inVal !== undefined ? Number(inVal) : row.value;
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }
      // if (deviceData?.details?.sizeProcessingTimeThItems) {
      //   Object.keys(deviceData?.details?.sizeProcessingTimeThItems)?.map((key, index) => {
      //     inputData = dataList?.[sizeProcessingTimeThMasterIndex + index + 2]?.split(',');
      //     let detailNm = inputData[0];
      //     let typeId = processMstRecord?.details?.processDetailTypes?.find((item) => item.name === detailNm)?.id;
      //     typeId = typeId ? parseInt(typeId) : typeId;
      //     if (typeId !== undefined) {
      //       deviceData?.details?.sizeProcessingTimeThItems[key]?.map((item, index) => {
      //         inVal = inputData[index + 1] !== undefined ? Number(inputData[index + 1]) : item.value;
      //         item.value = inVal;
      //       });
      //     }
      //   });
      // }

      // 取付サイズ加工時間(sec) or 穴サイズ加工時間(sec)
      titleNm = workType === WorkType.PaSteelMount ? '取付サイズ加工時間(sec)' : '穴サイズ加工時間(sec)';
      let sizeProcessingTimeIndex = dataList?.findIndex(
        (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      );

      if (sizeProcessingTimeIndex > -1 && deviceData?.details) {
        // --- sizeProcessingTimeThMasterの更新 ---
        const inputDataMaster = dataList?.[sizeProcessingTimeIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.sizeProcessingTimeThMaster = newMasterArray;
        }

        // --- sizeProcessingTimeThItemsの更新 ---
        if (deviceData.details.sizeProcessingTimeThItems) {
          const newSizeProcessingTimeItems = {};
          const usedProcessTypes = processMstRecord?.details?.processDetailTypes?.filter((item) => item.isUsed) || [];
          let csvRowIndexOffset = 0;

          usedProcessTypes.forEach((procType) => {
            const currentRowIndex = sizeProcessingTimeIndex + 2 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');

            if (inputDataItems && procType.name === inputDataItems[0]) {
              const key = procType.id.toString();
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newSizeProcessingTimeItems[key] = newItemsArray;
              csvRowIndexOffset++;
            }
          });
          deviceData.details.sizeProcessingTimeThItems = newSizeProcessingTimeItems;
        }
      }
    }

    // 加工設定の重量(Kg)加工時間(sec)
    if (workType === WorkType.PaSteelWeight) {
      // titleNm = detailMenuTab[7];
      // let kgProcessingTimeThMasterIndex = dataList?.findIndex(
      //   (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      // );
      // inputDataTitle = dataList?.[kgProcessingTimeThMasterIndex + 1]?.split(',');
      // if (deviceData?.details?.kgProcessingTimeThMaster) {
      //   deviceData?.details?.kgProcessingTimeThMaster
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputDataTitle[index + 1]?.replace('～', '');
      //       inVal = inVal?.replace('kg', '');
      //       inVal = inVal !== undefined ? Number(inVal) : row.value;
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }
      // if (deviceData?.details?.kgProcessingTimeThItems) {
      //   Object.keys(deviceData?.details?.kgProcessingTimeThItems)?.map((key, index) => {
      //     inputData = dataList?.[kgProcessingTimeThMasterIndex + index + 2]?.split(',');
      //     let detailNm = inputData[0];
      //     let typeId = processMstRecord?.details?.processDetailTypes?.find((item) => item.name === detailNm)?.id;
      //     typeId = typeId ? parseInt(typeId) : typeId;
      //     if (typeId !== undefined) {
      //       deviceData?.details?.kgProcessingTimeThItems[key]?.map((item, index) => {
      //         inVal = inputData[index + 1] !== undefined ? Number(inputData[index + 1]) : item.value;
      //         item.value = inVal;
      //       });
      //     }
      //   });
      // }

      // 重量(kg)加工時間(sec)
      titleNm = detailMenuTab[7];
      let kgProcessingTimeIndex = dataList?.findIndex(
        (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      );

      if (kgProcessingTimeIndex > -1 && deviceData?.details) {
        // --- kgProcessingTimeThMasterの更新 ---
        const inputDataMaster = dataList?.[kgProcessingTimeIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('kg', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.kgProcessingTimeThMaster = newMasterArray;
        }

        // --- kgProcessingTimeThItemsの更新 ---
        if (deviceData.details.kgProcessingTimeThItems) {
          const newKgProcessingTimeItems = {};
          const usedProcessTypes = processMstRecord?.details?.processDetailTypes?.filter((item) => item.isUsed) || [];
          let csvRowIndexOffset = 0;

          usedProcessTypes.forEach((procType) => {
            const currentRowIndex = kgProcessingTimeIndex + 2 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');

            if (inputDataItems && procType.name === inputDataItems[0]) {
              const key = procType.id.toString();
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newKgProcessingTimeItems[key] = newItemsArray;
              csvRowIndexOffset++;
            }
          });
          deviceData.details.kgProcessingTimeThItems = newKgProcessingTimeItems;
        }
      }
    }

    // 加工設定の面積(cm)加工時間(sec)
    if (workType === WorkType.PaSteelArea) {
      // titleNm = '面積(cm2)加工時間(sec)';
      // let areaProcessingTimeThMasterIndex = dataList?.findIndex(
      //   (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      // );
      // inputDataTitle = dataList?.[areaProcessingTimeThMasterIndex + 1]?.split(',');
      // if (deviceData?.details?.areaProcessingTimeThMaster) {
      //   deviceData?.details?.areaProcessingTimeThMaster
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputDataTitle[index + 1]?.replace('～', '');
      //       inVal = inVal?.replace('cm2', '');
      //       inVal = inVal !== undefined ? Number(inVal) : row.value;
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }
      // if (deviceData?.details?.areaProcessingTimeThItems) {
      //   Object.keys(deviceData?.details?.areaProcessingTimeThItems)?.map((key, index) => {
      //     inputData = dataList?.[areaProcessingTimeThMasterIndex + index + 2]?.split(',');
      //     let detailNm = inputData[0];
      //     let typeId = processMstRecord?.details?.processDetailTypes?.find((item) => item.name === detailNm)?.id;
      //     typeId = typeId ? parseInt(typeId) : typeId;
      //     if (typeId !== undefined) {
      //       deviceData?.details?.areaProcessingTimeThItems[key]?.map((item, index) => {
      //         inVal = inputData[index + 1] !== undefined ? Number(inputData[index + 1]) : item.value;
      //         item.value = inVal;
      //       });
      //     }
      //   });
      // }

      // 面積(cm2)加工時間(sec)
      titleNm = '面積(cm2)加工時間(sec)';
      let areaProcessingTimeIndex = dataList?.findIndex(
        (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      );

      if (areaProcessingTimeIndex > -1 && deviceData?.details) {
        // --- areaProcessingTimeThMasterの更新 ---
        const inputDataMaster = dataList?.[areaProcessingTimeIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('cm2', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.areaProcessingTimeThMaster = newMasterArray;
        }

        // --- areaProcessingTimeThItemsの更新 ---
        if (deviceData.details.areaProcessingTimeThItems) {
          const newAreaProcessingTimeItems = {};
          const usedProcessTypes = processMstRecord?.details?.processDetailTypes?.filter((item) => item.isUsed) || [];
          let csvRowIndexOffset = 0;

          usedProcessTypes.forEach((procType) => {
            const currentRowIndex = areaProcessingTimeIndex + 2 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');

            if (inputDataItems && procType.name === inputDataItems[0]) {
              const key = procType.id.toString();
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newAreaProcessingTimeItems[key] = newItemsArray;
              csvRowIndexOffset++;
            }
          });
          deviceData.details.areaProcessingTimeThItems = newAreaProcessingTimeItems;
        }
      }
    }

    // 加工速度(mm/min)
    if (
      workType === WorkType.PaSteelWeldFinish ||
      workType === WorkType.PaSteelWeld ||
      workType === WorkType.PaSteelDebbur ||
      workType === WorkType.PaSteelGroove ||
      workType === WorkType.PaSteelBend ||
      workType === WorkType.PaSteelNotch ||
      workType === WorkType.PaSteelMount ||
      workType === WorkType.PaSteelHole
    ) {
      // titleNm = '加工速度(mm/min)';
      // let processingSpeedThMasterIndex = dataList?.findIndex(
      //   (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      // );
      // inputDataTitle = dataList?.[processingSpeedThMasterIndex + 1]?.split(',');
      // if (deviceData?.details?.processingSpeedThMaster) {
      //   deviceData?.details?.processingSpeedThMaster
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputDataTitle[index + 1]?.replace('～', '');
      //       inVal = inVal?.replace('mm', '');
      //       inVal = inVal !== undefined ? Number(inVal) : row.value;
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }
      // if (deviceData?.details?.processingSpeedThItems) {
      //   Object.keys(deviceData?.details?.processingSpeedThItems)?.map((key, index) => {
      //     inputData = dataList?.[processingSpeedThMasterIndex + index + 2]?.split(',');
      //     let detailNm = inputData[0];
      //     let typeId = processMstRecord?.details?.processDetailTypes?.find((item) => item.name === detailNm)?.id;
      //     typeId = typeId ? parseInt(typeId) : typeId;
      //     if (typeId !== undefined) {
      //       deviceData?.details?.processingSpeedThItems[key]?.map((item, index) => {
      //         inVal = inputData[index + 1] !== undefined ? Number(inputData[index + 1]) : item.value;
      //         item.value = inVal;
      //       });
      //     }
      //   });
      // }

      // 加工速度(mm/min)
      titleNm = '加工速度(mm/min)';
      let processingSpeedIndex = dataList?.findIndex(
        (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      );

      if (processingSpeedIndex > -1 && deviceData?.details) {
        // --- processingSpeedThMasterの更新 ---
        const inputDataMaster = dataList?.[processingSpeedIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('mm', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.processingSpeedThMaster = newMasterArray;
        }

        // --- processingSpeedThItemsの更新 ---
        if (deviceData.details.processingSpeedThItems) {
          const newProcessingSpeedItems = {};
          const usedProcessTypes = processMstRecord?.details?.processDetailTypes?.filter((item) => item.isUsed) || [];
          let csvRowIndexOffset = 0;

          usedProcessTypes.forEach((procType) => {
            const currentRowIndex = processingSpeedIndex + 2 + csvRowIndexOffset;
            const inputDataItems = dataList?.[currentRowIndex]?.split(',');

            if (inputDataItems && procType.name === inputDataItems[0]) {
              const key = procType.id.toString();
              const newItemsArray = inputDataItems
                .slice(1)
                .map((val, i) => {
                  if (val !== undefined && val.trim() !== '') {
                    const numVal = Number(val);
                    if (!isNaN(numVal)) {
                      return { no: i, value: numVal, isOutOfRange: false };
                    }
                  }
                  return null;
                })
                .filter((item) => item !== null);
              newProcessingSpeedItems[key] = newItemsArray;
              csvRowIndexOffset++;
            }
          });
          deviceData.details.processingSpeedThItems = newProcessingSpeedItems;
        }
      }
    }

    //切断の加工時間部分
    if (workType === WorkType.PaSteelCut) {
      // 捨代(mm)
      titleNm = '捨代(mm), 刃幅(mm), 1カット加工時間(sec)';
      let disposalIndex = dataList?.findIndex(
        (item, index) =>
          item === titleNm ||
          dataList?.[index]?.split(',')?.[0] === '捨代(mm)' ||
          dataList?.[index]?.split(',')?.[1] === '刃幅(mm)' ||
          dataList?.[index]?.split(',')?.[2] === '1カット加工時間(sec)'
      );
      inputData = dataList?.[disposalIndex + 1]?.split(',');
      deviceData.details.disposal = inputData[0];
      // 刃幅(mm)
      deviceData.details.bladeWidth = inputData[1];
      // 1カット加工時間(sec)
      deviceData.details.singleProcessTimeSec = inputData[2];
      // // 加工速度(mm/min)
      // titleNm = '加工速度(mm/min)';
      // let processingSpeedMinThMasterIndex = dataList?.findIndex(
      //   (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      // );
      // inputDataTitle = dataList?.[processingSpeedMinThMasterIndex + 1]?.split(',');
      // if (deviceData?.details?.processingSpeedMinThMaster) {
      //   deviceData?.details?.processingSpeedMinThMaster
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputDataTitle[index + 1]?.replace('～', '');
      //       inVal = inVal?.replace('mm', '');
      //       inVal = inVal !== undefined ? Number(inVal) : row.value;
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }
      // inputData = dataList?.[processingSpeedMinThMasterIndex + 2]?.split(',');
      // if (deviceData?.details?.processingSpeedMinThItems) {
      //   deviceData?.details?.processingSpeedMinThItems
      //     ?.filter((subitem) => !subitem.isOutOfRange)
      //     ?.map((row, index) => {
      //       inVal = inputData[index + 1];
      //       row.value = inVal !== undefined ? inVal : row.value;
      //     });
      // }

      // 加工速度(mm/min)
      titleNm = '加工速度(mm/min)';
      const processingSpeedIndex = dataList?.findIndex(
        (item, index) => item === titleNm || dataList?.[index]?.split(',')?.[0] === titleNm
      );

      if (processingSpeedIndex > -1 && deviceData?.details) {
        // --- processingSpeedMinThMasterの更新 ---
        const inputDataMaster = dataList?.[processingSpeedIndex + 1]?.split(',');
        if (inputDataMaster) {
          const newMasterArray = inputDataMaster
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const cleanedVal = val.replace('～', '').replace('mm', '');
                const numVal = Number(cleanedVal);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.processingSpeedMinThMaster = newMasterArray;
        }

        // --- processingSpeedMinThItemsの更新 ---
        const inputDataItems = dataList?.[processingSpeedIndex + 2]?.split(',');
        if (inputDataItems) {
          const newItemsArray = inputDataItems
            .slice(1)
            .map((val, i) => {
              if (val !== undefined && val.trim() !== '') {
                const numVal = Number(val);
                if (!isNaN(numVal)) {
                  return { no: i, value: numVal, isOutOfRange: false };
                }
              }
              return null;
            })
            .filter((item) => item !== null);
          deviceData.details.processingSpeedMinThItems = newItemsArray;
        }
      }
    }

    // 加工設定の形状区分係数
    let processingShapeCoeffIndex = dataList?.findIndex(
      (item, index) =>
        (item === detailMenuTab[8] && index > setupShapeCoeffIndex) ||
        (dataList?.[index]?.split(',')?.[0] === detailMenuTab[8] &&
          dataList?.[index]?.split(',')?.[1] === '' &&
          index > setupShapeCoeffIndex)
    );
    inputDataTitle = dataList?.[processingShapeCoeffIndex + 1]?.split(',');
    inputData = dataList?.[processingShapeCoeffIndex + 2]?.split(',');
    if (deviceData?.details?.processingShapeCoeff) {
      Object.entries(deviceData?.details?.processingShapeCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          if (getProcessingShapeCoeffShapeNo(inputDataTitle[index + 1], props?.steelShapeData) === parseInt(key)) {
            deviceData.details.processingShapeCoeff[key] = inputData[index + 1];
          }
        });
    }

    // 加工設定の材質区分係数
    let machiningMaterialCoeffIndex = dataList?.findIndex(
      (item, index) =>
        (item === detailMenuTab[9] && index > materialClassificationCoeffIndex) ||
        (dataList?.[index]?.split(',')?.[0] === detailMenuTab[9] &&
          dataList?.[index]?.split(',')?.[1] === '' &&
          index > materialClassificationCoeffIndex)
    );
    inputDataTitle = dataList?.[machiningMaterialCoeffIndex + 1]?.split(',');
    inputData = dataList?.[machiningMaterialCoeffIndex + 2]?.split(',');
    if (deviceData?.details?.machiningMaterialCoeff) {
      Object.entries(deviceData?.details?.machiningMaterialCoeff)
        ?.filter((item) => !item.isOutOfRange)
        ?.map(([key, data], index) => {
          if (getIQ5IdByName(inputDataTitle[index + 1], materialTypes) === parseInt(key)) {
            deviceData.details.machiningMaterialCoeff[key] = inputData[index + 1];
          }
        });
    }

    // // 加工設定のT1サイズ(mm)係数
    // let t1SizeCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    // );
    // inputDataTitle = dataList?.[t1SizeCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.t1SizeCoeffThMaster) {
    //   deviceData?.details?.t1SizeCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('mm', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[t1SizeCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.t1SizeCoeffThItems) {
    //   deviceData?.details?.t1SizeCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // 加工設定のT1サイズ(mm)係数
    const t1SizeCoeffIndex = dataList?.findIndex(
      (item, index) => item === detailMenuTab[10] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[10]
    );

    if (t1SizeCoeffIndex > -1 && deviceData?.details) {
      // --- t1SizeCoeffThMasterの更新 ---
      const inputDataMaster = dataList?.[t1SizeCoeffIndex + 1]?.split(',');
      if (inputDataMaster) {
        const newMasterArray = inputDataMaster
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const cleanedVal = val.replace('～', '').replace('mm', '');
              const numVal = Number(cleanedVal);
              if (!isNaN(numVal)) {
                return { no: i, value: numVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.t1SizeCoeffThMaster = newMasterArray;
      }

      // --- t1SizeCoeffThItemsの更新 ---
      const inputDataItems = dataList?.[t1SizeCoeffIndex + 2]?.split(',');
      if (inputDataItems) {
        const newItemsArray = inputDataItems
          .slice(1)
          .map((val, i) => {
            if (val !== undefined && val.trim() !== '') {
              const decimalVal = toDecimal(val, 2);
              if (decimalVal !== null && !isNaN(decimalVal)) {
                return { no: i, value: decimalVal, isOutOfRange: false };
              }
            }
            return null;
          })
          .filter((item) => item !== null);
        deviceData.details.t1SizeCoeffThItems = newItemsArray;
      }
    }

    // // 加工設定のAサイズ(mm)係数
    // let aSizeCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[11] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[11]
    // );
    // inputDataTitle = dataList?.[aSizeCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.aSizeCoeffThMaster) {
    //   deviceData?.details?.aSizeCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('mm', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[aSizeCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.aSizeCoeffThItems) {
    //   deviceData?.details?.aSizeCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // // 加工設定のBサイズ(mm)係数
    // let bSizeCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[12] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[12]
    // );
    // inputDataTitle = dataList?.[bSizeCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.bSizeCoeffThMaster) {
    //   deviceData?.details?.bSizeCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('mm', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[bSizeCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.bSizeCoeffThItems) {
    //   deviceData?.details?.bSizeCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // // 加工設定のCサイズ(mm)係数
    // let cSizeCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[13] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[13]
    // );
    // inputDataTitle = dataList?.[cSizeCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.cSizeCoeffThMaster) {
    //   deviceData?.details?.cSizeCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('mm', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[cSizeCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.cSizeCoeffThItems) {
    //   deviceData?.details?.cSizeCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // // 加工設定の重量(Kg)区分係数
    // let processingWeightCoeffThMasterIndex = dataList?.findIndex(
    //   (item, index) =>
    //     (item === detailMenuTab[14] && index > weightClassificationCoeffThMasterIndex) ||
    //     (dataList?.[index]?.split(',')?.[0] === detailMenuTab[14] &&
    //       dataList?.[index]?.split(',')?.[1] === '' &&
    //       index > weightClassificationCoeffThMasterIndex)
    // );
    // inputDataTitle = dataList?.[processingWeightCoeffThMasterIndex + 1]?.split(',');
    // if (deviceData?.details?.processingWeightCoeffThMaster) {
    //   deviceData?.details?.processingWeightCoeffThMaster
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputDataTitle[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('kg', '');
    //       inVal = inVal !== undefined ? Number(inVal) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }
    // inputData = dataList?.[processingWeightCoeffThMasterIndex + 2]?.split(',');
    // if (deviceData?.details?.processingWeightCoeffThItems) {
    //   deviceData?.details?.processingWeightCoeffThItems
    //     ?.filter((subitem) => !subitem.isOutOfRange)
    //     ?.map((row, index) => {
    //       inVal = inputData[index + 1];
    //       inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //       row.value = inVal !== undefined ? inVal : row.value;
    //     });
    // }

    // // 加工設定のRサイズ(mm)係数
    // if (workType === WorkType.PaSteelBend) {
    //   let rSizeCoeffThMasterIndex = dataList?.findIndex(
    //     (item, index) => item === 'Rサイズ(mm)係数' || dataList?.[index]?.split(',')?.[0] === 'Rサイズ(mm)係数'
    //   );
    //   inputDataTitle = dataList?.[rSizeCoeffThMasterIndex + 1]?.split(',');
    //   if (deviceData?.details?.rSizeCoeffThMaster) {
    //     deviceData?.details?.rSizeCoeffThMaster
    //       ?.filter((subitem) => !subitem.isOutOfRange)
    //       ?.map((row, index) => {
    //         inVal = inputDataTitle[index + 1]?.replace('～', '');
    //         inVal = inVal?.replace('mm', '');
    //         inVal = inVal !== undefined ? Number(inVal) : row.value;
    //         row.value = inVal !== undefined ? inVal : row.value;
    //       });
    //   }
    //   inputData = dataList?.[rSizeCoeffThMasterIndex + 2]?.split(',');
    //   if (deviceData?.details?.rSizeCoeffThItems) {
    //     deviceData?.details?.rSizeCoeffThItems
    //       ?.filter((subitem) => !subitem.isOutOfRange)
    //       ?.map((row, index) => {
    //         inVal = inputData[index + 1];
    //         inVal = inVal !== undefined ? toDecimal(inVal, 2) : row.value;
    //         row.value = inVal !== undefined ? inVal : row.value;
    //       });
    //   }
    // }

    // // 生産個数係数
    // let quantityCoeffIndex = dataList?.findIndex(
    //   (item, index) => item === detailMenuTab[15] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[15]
    // );
    // inputData = dataList?.[quantityCoeffIndex + 1]?.split(',');
    // if (deviceData?.details?.productionQtyCoeffThMaster) {
    //   deviceData?.details?.productionQtyCoeffThMaster
    //     ?.filter((item) => !item.isOutOfRange)
    //     ?.map((item, index) => {
    //       inVal = inputData[index + 1]?.replace('～', '');
    //       inVal = inVal?.replace('個', '');
    //       inVal = inVal !== undefined ? Number(inVal, 2) : item.value;
    //       item.value = inVal !== undefined ? inVal : item.value;
    //     });
    // }
    // inputData = dataList?.[quantityCoeffIndex + 2]?.split(',');
    // if (deviceData?.details?.productionQtyCoeffThItems) {
    //   deviceData?.details?.productionQtyCoeffThItems
    //     ?.filter((item) => !item.isOutOfRange)
    //     ?.map((item, index) => {
    //       item.value = toDecimal(inputData[index + 1], 2);
    //     });
    // }

    // 汎用係数処理関数
    const processCoeffSection = (tabIndex, masterProp, itemsProp, masterUnit, itemsParser) => {
      const sectionIndex = dataList?.findIndex(
        (item, index) =>
          item === detailMenuTab[tabIndex] || dataList?.[index]?.split(',')?.[0] === detailMenuTab[tabIndex]
      );
      if (sectionIndex > -1 && deviceData?.details) {
        const inputDataMaster = dataList?.[sectionIndex + 1]?.split(',');
        const newMasterArray = createArrayFromCsv(inputDataMaster, Number, masterUnit);
        if (newMasterArray) {
          deviceData.details[masterProp] = newMasterArray;
        }

        const inputDataItems = dataList?.[sectionIndex + 2]?.split(',');
        const newItemsArray = createArrayFromCsv(inputDataItems, itemsParser);
        if (newItemsArray) {
          deviceData.details[itemsProp] = newItemsArray;
        }
      }
    };

    // A, B, C サイズ係数
    processCoeffSection(11, 'aSizeCoeffThMaster', 'aSizeCoeffThItems', 'mm', (val) => toDecimal(val, 2));
    processCoeffSection(12, 'bSizeCoeffThMaster', 'bSizeCoeffThItems', 'mm', (val) => toDecimal(val, 2));
    processCoeffSection(13, 'cSizeCoeffThMaster', 'cSizeCoeffThItems', 'mm', (val) => toDecimal(val, 2));

    // 加工設定の重量(Kg)区分係数
    processCoeffSection(14, 'processingWeightCoeffThMaster', 'processingWeightCoeffThItems', 'kg', (val) =>
      toDecimal(val, 2)
    );

    // Rサイズ(mm)係数 (workTypeによる条件付き)
    if (workType === WorkType.PaSteelBend) {
      const rSizeIndex = dataList?.findIndex(
        (item, index) => item === 'Rサイズ(mm)係数' || dataList?.[index]?.split(',')?.[0] === 'Rサイズ(mm)係数'
      );
      if (rSizeIndex > -1 && deviceData?.details) {
        const inputDataMaster = dataList?.[rSizeIndex + 1]?.split(',');
        const newMasterArray = createArrayFromCsv(inputDataMaster, Number, 'mm');
        if (newMasterArray) {
          deviceData.details.rSizeCoeffThMaster = newMasterArray;
        }

        const inputDataItems = dataList?.[rSizeIndex + 2]?.split(',');
        const newItemsArray = createArrayFromCsv(inputDataItems, (val) => toDecimal(val, 2));
        if (newItemsArray) {
          deviceData.details.rSizeCoeffThItems = newItemsArray;
        }
      }
    }

    // 生産個数係数
    processCoeffSection(15, 'productionQtyCoeffThMaster', 'productionQtyCoeffThItems', '個', (val) =>
      toDecimal(val, 2)
    );

    return deviceData;
  };

  return (
    <>
      <Form>
        <div className="d-flex" style={{ marginTop: 7 }}>
          <div style={{ marginLeft: 20, display: editMode ? 'none' : 'block' }}>
            <Tooltip title="CSV出力" placement="bottom" overlayClassName="tooltip-text">
              <CSVLink ref={csvExportRef} data={''} preview={true} style={{ display: 'none' }}></CSVLink>
              <Image
                preview={false}
                width={iconWidth}
                src={export_csv_icon}
                style={{ marginLeft: '0px' }}
                onClick={onClickCSVExport}
              />
            </Tooltip>
          </div>
          <div style={{ marginLeft: 10, display: editMode ? 'none' : 'block' }}>
            <Tooltip title="CSV入力" placement="bottom" overlayClassName="tooltip-text">
              <input
                type="file"
                accept=".csv"
                ref={csvImportRef}
                style={{ display: 'none' }}
                onChange={handleCSVFileChange}
                onClick={(e) => (e.target.value = null)}
              />
              <Image
                preview={false}
                width={iconWidth}
                src={import_csv_icon}
                style={{ marginLeft: '0px' }}
                onClick={onClickCSVImport}
              />
            </Tooltip>
          </div>
          <div>
            <Button
              style={{
                marginLeft: 10,
                display: editMode ? 'block' : 'none',
              }}
              className="mainButton"
              id="update"
              onClick={updateData}
            >
              更新
            </Button>
          </div>
          <div>
            <Button
              style={{
                marginLeft: 10,
                display: editMode ? 'block' : 'none',
              }}
              className="cancelButton"
              id="discard"
              onClick={discardData}
            >
              {/*　2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
              戻る
            </Button>
          </div>
          <div className="ms-auto">
            <Button
              style={{
                marginRight: 10,
                display: 'none',
                display: editMode ? 'none' : 'block',
                pointerEvents: selectedDeviceData?.length != 0 ? 'auto' : 'none',
              }}
              className="mainButton"
              id="edit"
              onClick={editData}
            >
              編集
            </Button>
          </div>
        </div>
        <div className="overflow-auto kouteical timecharge registerModal" style={{ height: '77.1vh', marginTop: 22 }}>
          <div className="upperDeviceTbl">
            <Row className=" chargeAmount ">
              {/* workType：カスタム、ブランクの場合、 */}
              <Col
                style={{
                  width: workType === WorkType.PaCustom || workType === WorkType.SmCustom ? '100%' : '75%',
                }}
              >
                <RTable>
                  <thead className="table-light">
                    <tr style={{ textAlign: 'center' }}>
                      <th style={{ width: '10%' }}>コード</th>
                      <th style={{ width: '15%' }}>工程名</th>
                      {/* workType：カスタム、ブランクの場合、 */}
                      {workType === WorkType.PaCustom || workType === WorkType.SmCustom ? (
                        <>
                          <th style={{ width: '10%' }}>コード</th>
                          <th style={{ width: '15%' }}>工程名</th>
                        </>
                      ) : (
                        <></>
                      )}
                      <th style={{ width: '10%' }}>装置コード</th>
                      <th style={{ width: '15%' }}>装置名</th>
                      <th style={{ width: '12.5%' }}>備考</th>
                      <th style={{ width: '12.5%' }}>表示</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ textAlign: 'center' }}>
                      <td style={{ verticalAlign: 'middle' }}>{code}</td>
                      <td style={{ verticalAlign: 'middle' }}>{processName}</td>
                      {/* workType：ブランクの場合、 */}
                      {workType === WorkType.PaCustom || workType === WorkType.SmCustom ? (
                        // workType：カスタムの場合、
                        <>
                          <td style={{ verticalAlign: 'middle' }}>
                            {/* {kouteiCode} */}
                            {editMode ? (
                              <>
                                <Select
                                  id="koutei"
                                  name="koutei"
                                  placeholder="選択"
                                  value={additionalProcessId}
                                  style={{
                                    fontSize: 11,
                                    width: '97%',
                                  }}
                                  onChange={changeAdditionalKouteiType}
                                >
                                  {processTypesList
                                    ?.filter((i) => i.isUsed === true)
                                    ?.map((item, index) => (
                                      <Select.Option key={index} value={item.id}>
                                        {item.code}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </>
                            ) : (
                              <>{kouteiCode}</>
                            )}
                          </td>
                          <td style={{ verticalAlign: 'middle' }}>
                            {/* {kouteiName} */}
                            {editMode ? (
                              <>
                                <Select
                                  id="koutei"
                                  name="koutei"
                                  placeholder="選択"
                                  value={additionalProcessId}
                                  style={{
                                    fontSize: 11,
                                    width: '97%',
                                  }}
                                  onChange={changeAdditionalKouteiType}
                                >
                                  {processTypesList
                                    ?.filter((i) => i.isUsed === true)
                                    ?.map((item, index) => (
                                      <Select.Option key={index} value={item.id}>
                                        {item.name}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </>
                            ) : (
                              <>{kouteiName}</>
                            )}
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                      <td style={{ verticalAlign: 'middle' }}>
                        <Input
                          style={{ padding: 3, width: '98.2%', textAlign: 'center', height: 26 }}
                          className={editMode ? 'input-editable ' : 'input-non-editable '}
                          name="deviceCode"
                          id="deviceCode"
                          value={deviceCode}
                          type="text"
                          onChange={(e) => {
                            setDeviceCode(e.target.value);
                          }}
                        />
                      </td>
                      {/* <td style={{ verticalAlign: 'middle' }}>
                        <Input
                          style={{ padding: 3, width: '98.2%', textAlign: 'center', height: 26 }}
                          className={editMode ? 'input-editable ' : 'input-non-editable '}
                          name="deviceName"
                          id="deviceName"
                          value={deviceName}
                          type="text"
                          onChange={(e) => {
                            setDeviceName(e.target.value);
                          }}
                        />
                      </td> */}
                      {/* 2025-07-22 IQX_WEBEST-447 板金パラメータ装置設定の装置編集画面で、装置名が長いと見切れてしまう */}
                      <td style={{ verticalAlign: 'middle', width: 150, padding: 0 }}>
                        {editMode ? (
                          <Input
                            style={{
                              padding: 3,
                              width: '100%',
                              textAlign: 'center',
                              height: 26,
                            }}
                            className="input-editable"
                            name="deviceName"
                            id="deviceName"
                            value={deviceName}
                            type="text"
                            maxLength={50} // Prevents typing more than 50 chars
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value.length <= 50) {
                                setDeviceName(value);
                              }
                            }}
                          />
                        ) : (
                          <Typography.Text
                            id="typographyTxt"
                            ellipsis={{ tooltip: deviceName }}
                            style={{
                              display: 'inline-block',
                              width: '100%',
                              maxWidth: 140,
                              textAlign: 'center',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                            }}
                          >
                            {deviceName || '－'}
                          </Typography.Text>
                        )}
                      </td>

                      <td style={{ verticalAlign: 'middle' }}>
                        <Input
                          style={{ padding: 3, width: '98.2%', textAlign: 'center', height: 26 }}
                          className={editMode ? 'input-editable ' : 'input-non-editable '}
                          value={remarks}
                          type="text"
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                        />
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        {editMode ? (
                          <RadioGroup
                            name="isUsed"
                            defaultValue={isUsed}
                            className="radioCustomerGpEdit"
                            onChange={(e) => setIsUsed(e.target.value)}
                            value={isUsed}
                          >
                            <Radio value={true}>オン</Radio>
                            <Radio value={false}>オフ</Radio>
                          </RadioGroup>
                        ) : isUsed ? (
                          <Image preview={false} width={13} src={checked} id="imgOutsourcingFg" />
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </RTable>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <Space>
                  <DownSquareFilled style={{ fontSize: 25, color: '#1063aa' }} onClick={openAll} />
                  <UpSquareFilled style={{ fontSize: 25, color: '#1063aa' }} onClick={closeAll} />
                </Space>
              </Col>
            </Row>
          </div>
          <Row>
            <Col span={24}>
              {/* 標準の場合、 */}
              {selectedDeviceData?.length != 0 ? (
                <>
                  {deviceType === processTypes.standard ? (
                    <>{content}</>
                  ) : (
                    // 追加の場合、
                    <>
                      {/* チャージ金額 */}
                      {chargeAmountContent}
                      {/* 段取時間 */}
                      {dantoriSettingContent}
                      {sagyouJikanContent}
                      {/* 親部品 */}
                      {types === ServiceClass.Parent ? (
                        productSizeContent
                      ) : (
                        <>
                          {/*  {materialHandlingContent} */}
                          {productSizeFactorContent}
                        </>
                      )}
                      {quantityContent}
                      {/* 委託装置詳細 */}
                      <Row
                        align="middle"
                        style={{ color: 'black' }}
                        className="oyabuhin-param oyabuhin-row"
                        onClick={deviceDetails}
                      >
                        <Col span={20} className="deli-col-param">
                          <div style={{ display: 'flex' }}>
                            <label style={{ marginRight: 5 }}>委託装置詳細</label>
                            {isDeviceDetails ? (
                              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            ) : (
                              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            )}
                          </div>
                        </Col>
                      </Row>
                      <div style={{ display: isDeviceDetails ? 'block' : 'none' }}>
                        <Row style={{ marginLeft: 10 }} className="chargeAmount">
                          <Col style={{ width: '70%' }}>
                            <RTable className="tsuikakoutei">
                              <thead>
                                <tr>
                                  <td className="device-detail-tbl-tsuika-detail">
                                    <label className="detail-tbl-val-title-label">委託工程</label>
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }} colSpan={2}>
                                    <Checkbox
                                      style={{ marginLeft: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                                      onChange={handleCheckboxChange}
                                      checked={checkboxChecked}
                                    ></Checkbox>
                                  </td>
                                </tr>
                                <tr className={selectDisabled ? 'souchi' : ''}>
                                  <td className="device-detail-tbl-tsuika-detail">
                                    <label className="detail-tbl-val-title-label">取引先(委託先)</label>
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }} colSpan={2}>
                                    <Row style={{ marginLeft: 10 }}>
                                      <Col span={16}>{customerName}</Col>
                                      <Col span={7} style={{ textAlign: 'end' }}>
                                        <SearchOutlined
                                          style={{
                                            fontSize: '18px',
                                            pointerEvents: selectDisabled || !editMode ? 'none' : 'auto',
                                          }}
                                          onClick={searchCustomer}
                                        />
                                      </Col>
                                    </Row>
                                  </td>
                                </tr>
                                <tr className={selectDisabled ? 'souchi' : ''}>
                                  <td className="device-detail-tbl-tsuika-detail">
                                    <label className="detail-tbl-val-title-label">取引先コード</label>
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }} colSpan={2}>
                                    <label style={{ marginLeft: 10 }}>{customerCode}</label>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="device-detail-tbl-tsuika-detail">
                                    <label className="detail-tbl-val-title-label">手入力フラグ</label>
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }} colSpan={2}>
                                    <Checkbox
                                      style={{ marginLeft: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                                      onChange={flagChange}
                                      checked={flagChecked}
                                    ></Checkbox>
                                  </td>
                                </tr>
                                <tr className={inputDisabled ? 'souchi' : ''}>
                                  <td className="device-detail-tbl-tsuika-detail">
                                    <label className="detail-tbl-val-title-label">初期金額(手入力時)</label>
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }} colSpan={2}>
                                    <CurrencyInput
                                      name="iniAmount"
                                      id="iniAmount"
                                      value={iniAmount}
                                      defaultValue={0}
                                      style={{
                                        padding: 3,
                                        width: '97%',
                                        pointerEvents: inputDisabled || !editMode ? 'none' : 'auto',
                                      }}
                                      className={
                                        editMode
                                          ? 'currencyInputCost input-editable'
                                          : 'currencyInputCost input-non-editable'
                                      }
                                      prefix="¥"
                                      decimalsLimit={100}
                                      onValueChange={(e) => changeAmount('iniAmount', e)}
                                    />
                                    {/* <Input
                                  value={JPYs.format(iniAmount)}
                                  onChange={(e) => changeAmount('iniAmount', e.target.value)}
                                  type="text"
                                  style={{
                                    padding: 5,
                                    marginLeft: 5,
                                    width: '97%',
                                    pointerEvents: inputDisabled || !editMode ? 'none' : 'auto',
                                  }}
                                  className="input-editable"
                                ></Input> */}
                                  </td>
                                </tr>
                              </thead>
                            </RTable>
                          </Col>
                        </Row>
                      </div>
                      {/* 親部品 */}
                      {/* {types === ServiceClass.Parent ? '' : kouteiNaiKensaContent} */}
                    </>
                  )}
                </>
              ) : (
                <>
                  {chargeAmountContent}
                  {dantoriSettingContent}

                  {productSizeContent}
                  {quantityContent}
                </>
              )}
            </Col>
          </Row>
        </div>
      </Form>
      {/** 更新の確認メッセージ */}
      {updateConfirm
        ? commonResponsiveConfirmModal(
            updateConfirm,
            confirmModalTitle,
            commonFooter(updConfirmOk, updConfirmCancel),
            null,
            600,
            updConfirmOk,
            updConfirmCancel,
            confirmUpdateContent,
            null,
            null,
            false
          )
        : ''}
      {/** 破棄の確認メッセージ */}
      {cancelConfirm
        ? commonResponsiveConfirmModal(
            cancelConfirm,
            confirmModalTitle,
            commonFooter(discardConfirmOk, discardConfirmCancel),
            null,
            400,
            discardConfirmOk,
            discardConfirmCancel,
            confirmDiscardContent,
            null,
            null,
            false
          )
        : ''}

      {/* チャージ金額詳細 */}
      {isDetails
        ? commonModal(
            isDetails,
            addDetailsModalTitle,
            null,
            null,
            1030,
            addData,
            closeAddModal,
            addContent,
            null,
            null,
            true
          )
        : ''}
      {customerModal ? (
        <SearchAndGetCustomerData
          customerModal={customerModal}
          selectedCustomerData={getCustomerData}
          title={Customer}
          clientType={ClientType.Contractor}
        />
      ) : (
        ''
      )}
    </>
  );
});

export default DevicesDetails;
